(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.d5.bT === region.eP.bT)
	{
		return 'on line ' + region.d5.bT;
	}
	return 'on lines ' + region.d5.bT + ' through ' + region.eP.bT;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.iP,
		impl.lI,
		impl.k4,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		js: func(record.js),
		d6: record.d6,
		d_: record.d_
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		var n = _VirtualDom_doc.createTextNode(vNode.a);
		n.created_by_elm = true;
		return n
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);
	domNode.created_by_elm = true;

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.js;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.d6;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.d_) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0, k = 0; j < Math.max(vKids.length, childNodes.length); j++, k++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);

		// 1. if unknown nodes have been inserted
		if(childNodes.length > vKids.length)
		{
			// skip them
			while(!childNodes[k].created_by_elm)
			{
				console.log("INFO 1: skipping DOM")
				k++
			}
		}
		// 2. if existing node has been removed
		if(childNodes.length < vKids.length)
		{
			if(childNodes[k])
			{
				// replace tha node using the old vdom
				console.log("WARN 1: redrawing DOM")
				_VirtualDom_applyPatchRedraw(childNodes[k], vKids[j], eventNode)
			}
			else
			{
				console.log("WARN 2: redrawing DOM")
				domNode.appendChild(_VirtualDom_render(vKids[j], eventNode));
			}
		}
		// 3. if existing node has been replaced with unknown node
		if(childNodes.length === vKids.length)
		{
			if(!childNodes[k].created_by_elm)
			{
				// replace tha node using the old vdom
				console.log("WARN 3: redrawing DOM")
				_VirtualDom_applyPatchRedraw(childNodes[k], vKids[j], eventNode)
			}
		}
		// 4. this is needed for some edge cases
		if(vKids[j].$ === 1 && (childNodes[k].tagName || "").toLowerCase() !== vKids[j].c)
		{
			console.log("WARN 4: redrawing DOM")
			_VirtualDom_applyPatchRedraw(childNodes[k], vKids[j], eventNode)
		}

		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[k], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			
			// patch for extension
			if(domNode.childNodes.length !== data.i + data.v)
			{
				console.log("INFO 0: using another logic")
				var removed = 0;
				var index = domNode.childNodes.length - 1;
				while (removed < data.i)
				{
					var childNode = domNode.childNodes[index];
					if(childNode.created_by_elm)
					{
						domNode.removeChild(childNode);
						removed++;
					}
					index--;
				}
				return domNode;
			}

			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	node.created_by_elm = true;
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.iP,
		impl.lI,
		impl.k4,
		function(sendToApp, initialModel) {
			var view = impl.lL;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.iP,
		impl.lI,
		impl.k4,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.d2 && impl.d2(sendToApp)
			var view = impl.lL;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.ch);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.ls) && (_VirtualDom_doc.title = title = doc.ls);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.jK;
	var onUrlRequest = impl.jL;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		d2: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.fO === next.fO
							&& curr.e6 === next.e6
							&& curr.fF.a === next.fF.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		iP: function(flags)
		{
			return A3(impl.iP, flags, _Browser_getUrl(), key);
		},
		lL: impl.lL,
		lI: impl.lI,
		k4: impl.k4
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { iE: 'hidden', hr: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { iE: 'mozHidden', hr: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { iE: 'msHidden', hr: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { iE: 'webkitHidden', hr: 'webkitvisibilitychange' }
		: { iE: 'hidden', hr: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		f1: _Browser_getScene(),
		gn: {
			gt: _Browser_window.pageXOffset,
			gu: _Browser_window.pageYOffset,
			a8: _Browser_doc.documentElement.clientWidth,
			aR: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		a8: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		aR: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			f1: {
				a8: node.scrollWidth,
				aR: node.scrollHeight
			},
			gn: {
				gt: node.scrollLeft,
				gu: node.scrollTop,
				a8: node.clientWidth,
				aR: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			f1: _Browser_getScene(),
			gn: {
				gt: x,
				gu: y,
				a8: _Browser_doc.documentElement.clientWidth,
				aR: _Browser_doc.documentElement.clientHeight
			},
			h6: {
				gt: x + rect.left,
				gu: y + rect.top,
				a8: rect.width,
				aR: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.jx) { flags += 'm'; }
	if (options.hp) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.dA.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.dA.b, xhr)); });
		$elm$core$Maybe$isJust(request.d9) && _Http_track(router, xhr, request.d9.a);

		try {
			xhr.open(request.dU, request.Q, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.Q));
		}

		_Http_configureRequest(xhr, request);

		request.ch.a && xhr.setRequestHeader('Content-Type', request.ch.a);
		xhr.send(request.ch.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.dJ; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.d8.a || 0;
	xhr.responseType = request.dA.d;
	xhr.withCredentials = request.gO;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		Q: xhr.responseURL,
		kZ: xhr.status,
		k_: xhr.statusText,
		dJ: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			kI: event.loaded,
			kQ: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			j7: event.loaded,
			kQ: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}





// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$MsgUrlChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$MsgUrlRequested = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.x) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.y),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.y);
		} else {
			var treeLen = builder.x * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.z) : builder.z;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.x);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.y) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.y);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{z: nodeList, x: (len / $elm$core$Array$branchFactor) | 0, y: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {e0: fragment, e6: host, fB: path, fF: port_, fO: protocol, j6: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$getNotificationsFromLocalStorage = _Platform_outgoingPort(
	'getNotificationsFromLocalStorage',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$TT$BubbleAlertsWrapper$Danger = 3;
var $author$project$TT$ToastWrapper$Danger = 3;
var $author$project$TT$BubbleAlertsWrapper$Success = 0;
var $author$project$TT$ToastWrapper$Success = 0;
var $author$project$TT$Alerts$TkRecruiterAlertMessageEmptyResponse = {$: 3};
var $author$project$TT$Alerts$TkRecruiterBubbleMessageResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$TT$Alerts$TkRecruiterToastMessageResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$TT$ToastWrapper$Warning = 2;
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {iN: index, jq: match, jD: number, k2: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{hp: false, jx: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$core$String$cons = _String_cons;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $elm_community$string_extra$String$Extra$toTitleCase = function (ws) {
	var uppercaseMatch = A2(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('\\w+'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.jq;
			},
			$elm_community$string_extra$String$Extra$toSentenceCase));
	return A3(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('^([a-z])|\\s+([a-z])'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.jq;
			},
			uppercaseMatch),
		ws);
};
var $author$project$TT$Alerts$processUrlParamAlert = F3(
	function (recruiterLoggedInInfo, candidateLoggedInInfo, _v0) {
		var urlParamName = _v0.a;
		var urlParamValuesList = _v0.b;
		var urlParamValueHeadOption = $elm$core$List$head(urlParamValuesList);
		if (urlParamName === 'msg') {
			if (!urlParamValueHeadOption.$) {
				switch (urlParamValueHeadOption.a) {
					case 'candidate_login_success':
						return candidateLoggedInInfo.eu ? $author$project$TT$Alerts$TkRecruiterToastMessageResponse(
							{
								iJ: 'candidate_login_success',
								js: 'has accedido a tu cuenta' + (': <strong>' + (A2($elm$core$Maybe$withDefault, '', candidateLoggedInInfo.hk) + ('</strong>' + ' satisfactoriamente.'))),
								n: 0,
								ls: 'Hola ' + $elm_community$string_extra$String$Extra$toTitleCase(
									A2($elm$core$Maybe$withDefault, '', candidateLoggedInInfo.hl))
							}) : $author$project$TT$Alerts$TkRecruiterAlertMessageEmptyResponse;
					case 'candidate_logged_in':
						return candidateLoggedInInfo.eu ? $author$project$TT$Alerts$TkRecruiterToastMessageResponse(
							{
								iJ: 'candidate_logged_in',
								js: 'has ingresado como' + (': <strong>' + (A2($elm$core$Maybe$withDefault, '', candidateLoggedInInfo.hk) + ('</strong>' + '. Si deseas hacerlo con otra cuenta, cierra esta sesión y dirígete a la pantalla de acceder'))),
								n: 2,
								ls: 'Hola ' + $elm_community$string_extra$String$Extra$toTitleCase(
									A2($elm$core$Maybe$withDefault, '', candidateLoggedInInfo.hl))
							}) : $author$project$TT$Alerts$TkRecruiterAlertMessageEmptyResponse;
					case 'recruiter_account_created':
						return $author$project$TT$Alerts$TkRecruiterToastMessageResponse(
							{
								iJ: 'recruiter_account_created',
								js: 'Tu cuenta ha sido creada con éxito.',
								n: 0,
								ls: 'Hola ' + A2($elm$core$Maybe$withDefault, '', recruiterLoggedInInfo.kh)
							});
					case 'candidate_logout':
						return $author$project$TT$Alerts$TkRecruiterToastMessageResponse(
							{iJ: 'candidate_logout', js: 'Has cerrado tu sesión satisfactoriamente', n: 0, ls: 'Talenteca'});
					case 'recruiter_logout':
						return $author$project$TT$Alerts$TkRecruiterToastMessageResponse(
							{iJ: 'recruiter_logout', js: 'Has cerrado tu sesión satisfactoriamente', n: 0, ls: 'Talenteca'});
					case 'blocked_account':
						return $author$project$TT$Alerts$TkRecruiterBubbleMessageResponse(
							{iJ: 'blocked_account', js: 'Tu cuenta de usuario ha sido bloqueada y por el momento no podrás publicar o republicar vacantes. Escríbenos a soporte@talenteca.com para obtener más información.', n: 3});
					case 'cv_received':
						return $author$project$TT$Alerts$TkRecruiterBubbleMessageResponse(
							{iJ: 'cv_received', js: '¡Tu CV ha sido recibido, aquí puedes encontrar más empleos!', n: 0});
					case 'account_validated':
						return $author$project$TT$Alerts$TkRecruiterToastMessageResponse(
							{iJ: 'account_validated', js: 'Muchas gracias por validar tu cuenta', n: 0, ls: 'Talenteca'});
					case 'account_validation_error':
						return $author$project$TT$Alerts$TkRecruiterToastMessageResponse(
							{iJ: 'account_validation_error', js: 'Ha ocurrido un error, disculpa las molestias, por favor intenta más tarde', n: 3, ls: 'Talenteca'});
					case 'candidate_password_changed':
						return $author$project$TT$Alerts$TkRecruiterBubbleMessageResponse(
							{iJ: 'candidate_password_changed', js: '¡Has actualizado tu contraseña correctamente!', n: 0});
					case 'cand_p_ch':
						return $author$project$TT$Alerts$TkRecruiterBubbleMessageResponse(
							{iJ: 'cand_p_ch', js: '¡Has actualizado tu contraseña correctamente!', n: 0});
					case 'invalid_merge':
						return $author$project$TT$Alerts$TkRecruiterToastMessageResponse(
							{iJ: 'recruiter_logout', js: 'Hubo un problema al validar la fusión de tus cuentas. Por favor, comunícate con nosotros a: soporte@talenteca.com', n: 3, ls: 'Talenteca'});
					case 'success_merge_email':
						return $author$project$TT$Alerts$TkRecruiterToastMessageResponse(
							{iJ: 'recruiter_logout', js: 'Tus cuentas han sido fusionadas correctamente, ahora puedes ingresar normalmente para continuar.', n: 0, ls: 'Talenteca'});
					case 'failed_redirect':
						return $author$project$TT$Alerts$TkRecruiterToastMessageResponse(
							{iJ: 'recruiter_logout', js: 'Ha ocurrido un error y hemos tenido que cerrar tu sesión. Por favor, inicia sesión nuevamente', n: 3, ls: 'Talenteca'});
					case 'interview_confirmation_success':
						return $author$project$TT$Alerts$TkRecruiterBubbleMessageResponse(
							{iJ: 'interview_confirmation', js: 'Se ha confirmado tu asistencia a la entrevista.', n: 0});
					case 'interview_confirmation_error':
						return $author$project$TT$Alerts$TkRecruiterBubbleMessageResponse(
							{iJ: 'interview_confirmation', js: 'Ha ocurrido un error al confirmar tu asistencia a la entrevista. Por favor, intenta nuevamente', n: 3});
					case 'interview_cancel_success':
						return $author$project$TT$Alerts$TkRecruiterBubbleMessageResponse(
							{iJ: 'interview_confirmation', js: 'Se ha cancelado tu asistencia a la entrevista.', n: 0});
					case 'interview_cancel_error':
						return $author$project$TT$Alerts$TkRecruiterBubbleMessageResponse(
							{iJ: 'interview_confirmation', js: 'Ha ocurrido un error al cancelar tu asistencia a la entrevista. Por favor, intenta nuevamente', n: 3});
					default:
						return $author$project$TT$Alerts$TkRecruiterAlertMessageEmptyResponse;
				}
			} else {
				return $author$project$TT$Alerts$TkRecruiterAlertMessageEmptyResponse;
			}
		} else {
			return $author$project$TT$Alerts$TkRecruiterAlertMessageEmptyResponse;
		}
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $author$project$TT$Util$queryParameters = function (url) {
	var toTuples = function (str) {
		var _v2 = A2($elm$core$String$split, '=', str);
		if (_v2.b) {
			var key = _v2.a;
			var value = _v2.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					key,
					A2($elm$core$String$join, '=', value))
				]);
		} else {
			return _List_Nil;
		}
	};
	var addParam = F2(
		function (value, maybeValues) {
			if (!maybeValues.$) {
				var values = maybeValues.a;
				return $elm$core$Maybe$Just(
					A2($elm$core$List$cons, value, values));
			} else {
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[value]));
			}
		});
	var toDict = function (parameters) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, dict) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(
						$elm$core$Dict$update,
						k,
						addParam(v),
						dict);
				}),
			$elm$core$Dict$empty,
			parameters);
	};
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Dict$empty,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$split('&'),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$concatMap(toTuples),
					toDict)),
			A2($elm$core$Maybe$andThen, $elm$url$Url$percentDecode, url.j6)));
};
var $author$project$TT$Alerts$getPublicAlertMessagesToShow = F3(
	function (recruiterLoggedInInfo, candidateLoggedInInfo, url) {
		var queryParams = $elm$core$Dict$toList(
			$author$project$TT$Util$queryParameters(url));
		var alertMessagesList = A2(
			$elm$core$List$map,
			function (_v3) {
				var urlParamName = _v3.a;
				var urlParamValuesList = _v3.b;
				return A3(
					$author$project$TT$Alerts$processUrlParamAlert,
					recruiterLoggedInInfo,
					candidateLoggedInInfo,
					_Utils_Tuple2(urlParamName, urlParamValuesList));
			},
			queryParams);
		var bannerAlertMessages = $elm$core$Dict$fromList(
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (alert) {
						if (!alert.$) {
							var tkRecruiterAlertMessageResponse = alert.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(tkRecruiterAlertMessageResponse.iJ, tkRecruiterAlertMessageResponse)
								]);
						} else {
							return _List_Nil;
						}
					},
					alertMessagesList)));
		var bubbleAlertMessages = $elm$core$Dict$fromList(
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (alert) {
						if (alert.$ === 2) {
							var tkRecruiterBubbleMessageResponse = alert.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(tkRecruiterBubbleMessageResponse.iJ, tkRecruiterBubbleMessageResponse)
								]);
						} else {
							return _List_Nil;
						}
					},
					alertMessagesList)));
		var toastAlertMessages = $elm$core$Dict$fromList(
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (alert) {
						if (alert.$ === 1) {
							var tkRecruiterToastMessageResponse = alert.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(tkRecruiterToastMessageResponse.iJ, tkRecruiterToastMessageResponse)
								]);
						} else {
							return _List_Nil;
						}
					},
					alertMessagesList)));
		return {g0: bannerAlertMessages, he: bubbleAlertMessages, f9: 'ok', lx: toastAlertMessages};
	});
var $author$project$TT$Legacy = 2;
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$TT$LargeScreen = 2;
var $author$project$TT$LargeXScreen = 3;
var $author$project$TT$MediumScreen = 1;
var $author$project$TT$SmallScreen = 0;
var $author$project$TT$Util$classifyScreen = function (width) {
	return (width <= 599) ? 0 : ((width <= 1135) ? 1 : ((width <= 1440) ? 2 : 3));
};
var $author$project$TT$ApiModel$defaultNotificationFromLocalStorage = {gD: _List_Nil, fP: _List_Nil};
var $author$project$TT$ApiModel$defaultTkNotificationsFromLocalStorage = {eC: 0, dE: $author$project$TT$ApiModel$defaultNotificationFromLocalStorage, gd: false};
var $author$project$Route$RouteHome = {$: 0};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {aN: frag, a_: params, aK: unvisited, g: value, a5: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.aK;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.g);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.g);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.fB),
					$elm$url$Url$Parser$prepareQuery(url.j6),
					url.e0,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$baseSegment = 'postular';
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.a5;
		var unvisited = _v0.aK;
		var params = _v0.a_;
		var frag = _v0.aN;
		var value = _v0.g;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $author$project$Route$homeParser = $elm$url$Url$Parser$s($author$project$Route$baseSegment);
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.a5;
		var unvisited = _v0.aK;
		var params = _v0.a_;
		var frag = _v0.aN;
		var value = _v0.g;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.a5;
			var unvisited = _v1.aK;
			var params = _v1.a_;
			var frag = _v1.aN;
			var value = _v1.g;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Route$routeParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Route$RouteHome, $author$project$Route$homeParser)
		]));
var $author$project$Route$fromUrl = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Route$RouteHome,
		A2($elm$url$Url$Parser$parse, $author$project$Route$routeParser, url));
};
var $author$project$TT$Util$getCommonModel = function (commonFlags) {
	return {
		dt: commonFlags.dt,
		hU: commonFlags.hU,
		i_: commonFlags.i_,
		i3: commonFlags.i3,
		i4: commonFlags.i4,
		i5: commonFlags.i5,
		i6: commonFlags.i6,
		jb: commonFlags.jb,
		cV: commonFlags.cV,
		dS: commonFlags.i_ ? 12000 : 10000,
		jp: commonFlags.i_ ? 60000 : 120000,
		fQ: commonFlags.fQ,
		c5: commonFlags.c5,
		f$: commonFlags.i_ ? 'development' : (commonFlags.i3 ? 'production' : 'unknown-run-mode'),
		kJ: commonFlags.kJ,
		f6: commonFlags.f6,
		ly: commonFlags.ly,
		gl: commonFlags.gl
	};
};
var $author$project$TT$Dropdown$Above = 0;
var $author$project$TT$Dropdown$Below = 1;
var $author$project$Model$EmailStep = 0;
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$Model$WelcomeStep = 0;
var $author$project$Model$categoryItemsList = _List_fromArray(
	[
		{h: 'Comercial /      Ventas', g: 'Comercial / Ventas'},
		{h: 'Atención al cliente (incluye meseros, recepcionistas, etc)', g: 'Atención al cliente'},
		{h: 'Manufactura / Operaciones', g: 'Manufactura / Operaciones'},
		{h: 'Mantenimiento y reparaciones', g: 'Mantenimiento y reparaciones'},
		{h: 'Logística / Transporte', g: 'Logística / Transporte'},
		{h: 'Contabilidad / Finanzas', g: 'Contabilidad / Finanzas'},
		{h: 'Tecnología / Internet', g: 'Tecnología / Internet'},
		{h: 'Administrativo / Secretarial', g: 'Administrativo / Secretarial'},
		{h: 'Recursos humanos', g: 'Recursos humanos'},
		{h: 'Marketing / RRPP / Comunicación', g: 'Marketing / RRPP / Comunicación'},
		{h: 'Turismo / Hotelería', g: 'Turismo / Hotelería'},
		{h: 'Medicina / Salud', g: 'Medicina / Salud'},
		{h: 'Construcción', g: 'Construcción'},
		{h: 'Legal', g: 'Legal'},
		{h: 'Educación', g: 'Educación'},
		{h: 'Arte / Diseño / Creativo', g: 'Arte / Diseño / Creativo'},
		{h: 'Arquitectura', g: 'Arquitectura'},
		{h: 'Dirección de empresas', g: 'Dirección de empresas'},
		{h: 'Recursos naturales', g: 'Recursos naturales'},
		{h: 'ONGs', g: 'ONGs'},
		{h: 'Estatal / Ministerios', g: 'Estatal / Ministerios'},
		{h: 'Minas / Petroleo', g: 'Minas / Petroleo'}
	]);
var $truqu$elm_base64$Base64$Decode$pad = function (input) {
	var _v0 = $elm$core$String$length(input) % 4;
	switch (_v0) {
		case 3:
			return input + '=';
		case 2:
			return input + '==';
		default:
			return input;
	}
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $truqu$elm_base64$Base64$Decode$charToInt = function (_char) {
	switch (_char) {
		case 'A':
			return 0;
		case 'B':
			return 1;
		case 'C':
			return 2;
		case 'D':
			return 3;
		case 'E':
			return 4;
		case 'F':
			return 5;
		case 'G':
			return 6;
		case 'H':
			return 7;
		case 'I':
			return 8;
		case 'J':
			return 9;
		case 'K':
			return 10;
		case 'L':
			return 11;
		case 'M':
			return 12;
		case 'N':
			return 13;
		case 'O':
			return 14;
		case 'P':
			return 15;
		case 'Q':
			return 16;
		case 'R':
			return 17;
		case 'S':
			return 18;
		case 'T':
			return 19;
		case 'U':
			return 20;
		case 'V':
			return 21;
		case 'W':
			return 22;
		case 'X':
			return 23;
		case 'Y':
			return 24;
		case 'Z':
			return 25;
		case 'a':
			return 26;
		case 'b':
			return 27;
		case 'c':
			return 28;
		case 'd':
			return 29;
		case 'e':
			return 30;
		case 'f':
			return 31;
		case 'g':
			return 32;
		case 'h':
			return 33;
		case 'i':
			return 34;
		case 'j':
			return 35;
		case 'k':
			return 36;
		case 'l':
			return 37;
		case 'm':
			return 38;
		case 'n':
			return 39;
		case 'o':
			return 40;
		case 'p':
			return 41;
		case 'q':
			return 42;
		case 'r':
			return 43;
		case 's':
			return 44;
		case 't':
			return 45;
		case 'u':
			return 46;
		case 'v':
			return 47;
		case 'w':
			return 48;
		case 'x':
			return 49;
		case 'y':
			return 50;
		case 'z':
			return 51;
		case '0':
			return 52;
		case '1':
			return 53;
		case '2':
			return 54;
		case '3':
			return 55;
		case '4':
			return 56;
		case '5':
			return 57;
		case '6':
			return 58;
		case '7':
			return 59;
		case '8':
			return 60;
		case '9':
			return 61;
		case '+':
			return 62;
		case '/':
			return 63;
		default:
			return 0;
	}
};
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Char$fromCode = _Char_fromCode;
var $truqu$elm_base64$Base64$Decode$intToString = A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar);
var $truqu$elm_base64$Base64$Decode$add = F2(
	function (_char, _v0) {
		var curr = _v0.a;
		var need = _v0.b;
		var res = _v0.c;
		var shiftAndAdd = function (_int) {
			return (63 & _int) | (curr << 6);
		};
		return (!need) ? ((!(128 & _char)) ? _Utils_Tuple3(
			0,
			0,
			_Utils_ap(
				res,
				$truqu$elm_base64$Base64$Decode$intToString(_char))) : (((224 & _char) === 192) ? _Utils_Tuple3(31 & _char, 1, res) : (((240 & _char) === 224) ? _Utils_Tuple3(15 & _char, 2, res) : _Utils_Tuple3(7 & _char, 3, res)))) : ((need === 1) ? _Utils_Tuple3(
			0,
			0,
			_Utils_ap(
				res,
				$truqu$elm_base64$Base64$Decode$intToString(
					shiftAndAdd(_char)))) : _Utils_Tuple3(
			shiftAndAdd(_char),
			need - 1,
			res));
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $truqu$elm_base64$Base64$Decode$toUTF16 = F2(
	function (_char, acc) {
		return _Utils_Tuple3(
			0,
			0,
			A2(
				$truqu$elm_base64$Base64$Decode$add,
				255 & (_char >>> 0),
				A2(
					$truqu$elm_base64$Base64$Decode$add,
					255 & (_char >>> 8),
					A2($truqu$elm_base64$Base64$Decode$add, 255 & (_char >>> 16), acc))));
	});
var $truqu$elm_base64$Base64$Decode$chomp = F2(
	function (char_, _v0) {
		var curr = _v0.a;
		var cnt = _v0.b;
		var utf8ToUtf16 = _v0.c;
		var _char = $truqu$elm_base64$Base64$Decode$charToInt(char_);
		if (cnt === 3) {
			return A2($truqu$elm_base64$Base64$Decode$toUTF16, curr | _char, utf8ToUtf16);
		} else {
			return _Utils_Tuple3((_char << ((3 - cnt) * 6)) | curr, cnt + 1, utf8ToUtf16);
		}
	});
var $elm$core$String$foldl = _String_foldl;
var $truqu$elm_base64$Base64$Decode$initial = _Utils_Tuple3(
	0,
	0,
	_Utils_Tuple3(0, 0, ''));
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $truqu$elm_base64$Base64$Decode$stripNulls = F2(
	function (input, output) {
		return A2($elm$core$String$endsWith, '==', input) ? A2($elm$core$String$dropRight, 2, output) : (A2($elm$core$String$endsWith, '=', input) ? A2($elm$core$String$dropRight, 1, output) : output);
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $truqu$elm_base64$Base64$Decode$validBase64Regex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([A-Za-z0-9\\/+]{4})*([A-Za-z0-9\\/+]{2}[A-Za-z0-9\\/+=]{2})?$'));
var $truqu$elm_base64$Base64$Decode$validate = function (input) {
	return A2($elm$regex$Regex$contains, $truqu$elm_base64$Base64$Decode$validBase64Regex, input) ? $elm$core$Result$Ok(input) : $elm$core$Result$Err('Invalid base64');
};
var $truqu$elm_base64$Base64$Decode$wrapUp = function (_v0) {
	var _v1 = _v0.c;
	var need = _v1.b;
	var res = _v1.c;
	return (need > 0) ? $elm$core$Result$Err('Invalid UTF-16') : $elm$core$Result$Ok(res);
};
var $truqu$elm_base64$Base64$Decode$validateAndDecode = function (input) {
	return A2(
		$elm$core$Result$map,
		$truqu$elm_base64$Base64$Decode$stripNulls(input),
		A2(
			$elm$core$Result$andThen,
			A2(
				$elm$core$Basics$composeR,
				A2($elm$core$String$foldl, $truqu$elm_base64$Base64$Decode$chomp, $truqu$elm_base64$Base64$Decode$initial),
				$truqu$elm_base64$Base64$Decode$wrapUp),
			$truqu$elm_base64$Base64$Decode$validate(input)));
};
var $truqu$elm_base64$Base64$Decode$decode = A2($elm$core$Basics$composeR, $truqu$elm_base64$Base64$Decode$pad, $truqu$elm_base64$Base64$Decode$validateAndDecode);
var $truqu$elm_base64$Base64$decode = $truqu$elm_base64$Base64$Decode$decode;
var $author$project$Model$defaultTkCommonField = {bM: $elm$core$Maybe$Nothing, cE: false, cO: '', g: $elm$core$Maybe$Nothing};
var $author$project$Model$defaultTkLocationField = {bM: $elm$core$Maybe$Nothing, cE: false, cO: '', f3: $elm$core$Maybe$Nothing, g: $elm$core$Maybe$Nothing};
var $author$project$Model$educationLevelItems = _List_fromArray(
	[
		{h: 'Básica', g: 'Básica'},
		{h: 'Media Superior', g: 'Media Superior'},
		{h: 'Superior - trunco', g: 'Superior - trunco'},
		{h: 'Superior - cursando', g: 'Superior - cursando'},
		{h: 'Superior - titulado', g: 'Superior - titulado'},
		{h: 'Maestría', g: 'Maestría'},
		{h: 'Doctorado', g: 'Doctorado'}
	]);
var $author$project$Model$experienceLevelItemsList = _List_fromArray(
	[
		{h: 'Practicantes', g: 'Practicantes'},
		{h: 'Nivel Inicial', g: 'Nivel Inicial'},
		{h: 'Nivel Medio', g: 'Nivel Medio'},
		{h: 'Nivel Experto', g: 'Nivel Experto'},
		{h: 'Nivel Gerencial', g: 'Nivel Gerencial'},
		{h: 'Nivel Alto Directivo', g: 'Nivel Alto Directivo'}
	]);
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.a5;
		var unvisited = _v1.aK;
		var params = _v1.a_;
		var frag = _v1.aN;
		var value = _v1.g;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$TT$Util$getUrlParam = F2(
	function (url, paramName) {
		var flattenUrl = _Utils_update(
			url,
			{fB: ''});
		return A2(
			$elm$core$Maybe$andThen,
			function (value) {
				return (value === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value);
			},
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$url$Url$Parser$parse,
					$elm$url$Url$Parser$query(
						$elm$url$Url$Parser$Query$string(paramName)),
					flattenUrl)));
	});
var $author$project$TT$Util$extractSearchArgument = F2(
	function (key, location) {
		return A2($author$project$TT$Util$getUrlParam, location, key);
	});
var $author$project$Page$Home$extractEmailFromUrl = function (url) {
	return A2($author$project$TT$Util$extractSearchArgument, 'email', url);
};
var $author$project$Page$Home$extractExternalRedirectFromUrl = function (url) {
	return A2($author$project$TT$Util$extractSearchArgument, 'external_apply', url);
};
var $author$project$Page$Home$extractJobAdIdFromUrl = function (url) {
	return A2($author$project$TT$Util$extractSearchArgument, 'j_id', url);
};
var $author$project$Page$Home$extractProviderFromUrl = function (url) {
	return A2($author$project$TT$Util$extractSearchArgument, 'provider', url);
};
var $author$project$Page$Home$extractSourceFromUrl = function (url) {
	return A2($author$project$TT$Util$extractSearchArgument, 'source', url);
};
var $author$project$Page$Home$extractTkUtmSourceFromUrl = function (url) {
	return A2($author$project$TT$Util$extractSearchArgument, 'tk_utm_source', url);
};
var $author$project$TT$Dropdown$State = $elm$core$Basics$identity;
var $author$project$TT$Dropdown$init = function (id) {
	return {ad: -1, iJ: id, L: false, bX: $elm$core$Maybe$Nothing, Z: _List_Nil, jP: _List_Nil, c0: 1};
};
var $author$project$TT$Dropdown$Option = function (a) {
	return {$: 0, a: a};
};
var $author$project$TT$Dropdown$withOptions = F3(
	function (accessorFunc, options_, _v0) {
		var state = _v0;
		var options__ = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, option) {
					return $author$project$TT$Dropdown$Option(
						_Utils_Tuple3(
							index,
							accessorFunc(option),
							option));
				}),
			options_);
		return _Utils_update(
			state,
			{jP: options__});
	});
var $author$project$Model$initSelectDropdownList = F2(
	function (itemsList, dropdownState) {
		return A3(
			$author$project$TT$Dropdown$withOptions,
			function ($) {
				return $.h;
			},
			itemsList,
			dropdownState);
	});
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $author$project$TT$Dropdown$withMatchFunction = F2(
	function (matchFunction, _v0) {
		var state = _v0;
		return _Utils_update(
			state,
			{
				bX: $elm$core$Maybe$Just(matchFunction)
			});
	});
var $author$project$TT$Dropdown$withPlacement = F2(
	function (placement, _v0) {
		var state = _v0;
		return _Utils_update(
			state,
			{c0: placement});
	});
var $author$project$Page$Home$initModel = F5(
	function (windowSize, commonModel, url, navigationKey, applyScreenStep) {
		var source = function () {
			var _v6 = $author$project$Page$Home$extractSourceFromUrl(url);
			if (!_v6.$) {
				var value = _v6.a;
				return value;
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					'talenteca',
					$author$project$Page$Home$extractTkUtmSourceFromUrl(url));
			}
		}();
		var provider = A2(
			$elm$core$Maybe$withDefault,
			'talenteca',
			$author$project$Page$Home$extractProviderFromUrl(url));
		var jobAdId = $author$project$Page$Home$extractJobAdIdFromUrl(url);
		var isUploadCv = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (e) {
					return e === '000000000000000000000000';
				},
				jobAdId));
		var isDesktop = windowSize.a8 > 600;
		var externalApplyRedirect = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (e) {
					return e === 'true';
				},
				$author$project$Page$Home$extractExternalRedirectFromUrl(url)));
		var _v0 = function () {
			var _v1 = $author$project$Page$Home$extractEmailFromUrl(url);
			if (!_v1.$) {
				var emailEncoded = _v1.a;
				var _v2 = $truqu$elm_base64$Base64$decode(emailEncoded);
				if (!_v2.$) {
					var emailDecoded = _v2.a;
					return _Utils_Tuple2(emailDecoded, true);
				} else {
					return _Utils_Tuple2('', false);
				}
			} else {
				return _Utils_Tuple2('', false);
			}
		}();
		var email = _v0.a;
		var isLinkToCompleteApplication = _v0.b;
		return {
			e: {
				d: {
					du: {bM: $elm$core$Maybe$Nothing, g: $elm$core$Maybe$Nothing},
					dz: {bM: $elm$core$Maybe$Nothing, g: $elm$core$Maybe$Nothing},
					dB: {bM: $elm$core$Maybe$Nothing, g: $elm$core$Maybe$Nothing},
					dC: {bM: $elm$core$Maybe$Nothing, g: ''},
					kS: A2(
						$elm$core$Array$repeat,
						2,
						{bM: $elm$core$Maybe$Nothing, g: ''})
				},
				cn: A2(
					$author$project$Model$initSelectDropdownList,
					$author$project$Model$categoryItemsList,
					A2(
						$author$project$TT$Dropdown$withPlacement,
						1,
						$author$project$TT$Dropdown$init('category'))),
				cA: A2(
					$author$project$Model$initSelectDropdownList,
					$author$project$Model$educationLevelItems,
					A2(
						$author$project$TT$Dropdown$withPlacement,
						1,
						$author$project$TT$Dropdown$init('education_level'))),
				cD: A2(
					$author$project$Model$initSelectDropdownList,
					$author$project$Model$experienceLevelItemsList,
					A2(
						$author$project$TT$Dropdown$withPlacement,
						1,
						$author$project$TT$Dropdown$init('experience_level'))),
				bP: false,
				G: $elm$core$Maybe$Nothing
			},
			gV: A2($elm$core$Maybe$withDefault, 0, applyScreenStep),
			k: {
				u: {hg: $elm$core$Maybe$Nothing, hm: $elm$core$Maybe$Nothing, js: '', j1: true, k3: true},
				bm: false,
				br: false,
				aJ: $elm$core$Maybe$Nothing
			},
			a: {
				l: 0,
				b: {
					hT: {bM: $elm$core$Maybe$Nothing, g: $elm$core$Maybe$Nothing},
					cB: $author$project$Model$defaultTkCommonField,
					dG: $author$project$Model$defaultTkCommonField,
					dK: $author$project$Model$defaultTkCommonField,
					cU: $author$project$Model$defaultTkLocationField,
					jT: _Utils_update(
						$author$project$Model$defaultTkCommonField,
						{cO: ''})
				},
				ak: A2(
					$author$project$TT$Dropdown$withMatchFunction,
					F3(
						function (_v3, _v4, _v5) {
							return true;
						}),
					A2(
						$author$project$TT$Dropdown$withPlacement,
						0,
						$author$project$TT$Dropdown$init('cities'))),
				be: A2(
					$author$project$TT$Dropdown$withPlacement,
					0,
					$author$project$TT$Dropdown$init('countries')),
				s: false,
				bQ: false,
				aq: 0,
				b3: false,
				G: $elm$core$Maybe$Nothing
			},
			J: commonModel,
			hU: $elm$core$Maybe$Nothing,
			X: $elm$core$Maybe$Nothing,
			cx: 0,
			cy: false,
			ac: $elm$core$Array$empty,
			C: {cB: email, $9: $elm$core$Maybe$Nothing, ix: false, iB: false, e3: false},
			bi: false,
			dD: externalApplyRedirect,
			o: {gS: $elm$core$Dict$empty, bR: false, G: $elm$core$Maybe$Nothing},
			ae: 64,
			ap: false,
			p: isDesktop,
			K: isLinkToCompleteApplication,
			aC: isUploadCv,
			aD: _List_Nil,
			fl: jobAdId,
			bS: $krisajenkins$remotedata$RemoteData$Loading,
			bn: 0,
			f: {cw: 0, t: false, af: $elm$core$Maybe$Nothing, V: false, W: false, b4: false},
			c: {cJ: false, t: false, aS: '', aT: '', aU: '', aV: '', aW: '', aX: '', aI: false, bz: 0},
			cW: navigationKey,
			bY: $elm$core$Maybe$Nothing,
			d$: provider,
			c5: commonModel.c5,
			a0: false,
			i: {
				cB: {bM: $elm$core$Maybe$Nothing, g: ''},
				an: {bM: $elm$core$Maybe$Nothing, g: ''},
				ao: {bM: $elm$core$Maybe$Nothing, g: ''},
				t: false,
				at: {bM: $elm$core$Maybe$Nothing, g: ''},
				db: '',
				G: $elm$core$Maybe$Nothing,
				de: false
			},
			b2: false,
			bs: false,
			b5: false,
			b6: false,
			M: source,
			dd: $elm$core$Array$empty,
			Q: url,
			by: false,
			a6: 0,
			a7: $elm$core$Array$empty,
			q: windowSize
		};
	});
var $author$project$Main$initModel = F3(
	function (commonFlags, url, navigationKey) {
		var screenSize = $author$project$TT$Util$classifyScreen(commonFlags.q.a8);
		var currentRoute = $author$project$Route$fromUrl(url);
		var commonModel = $author$project$TT$Util$getCommonModel(commonFlags);
		return {
			J: commonModel,
			bI: {kC: screenSize, lo: 2, q: commonFlags.q},
			eR: '',
			cH: $elm$core$Dict$empty,
			aB: $elm$core$Dict$empty,
			aO: $elm$core$Dict$empty,
			as: A5($author$project$Page$Home$initModel, commonFlags.q, commonModel, url, navigationKey, $elm$core$Maybe$Nothing),
			cW: navigationKey,
			c5: commonFlags.c5,
			b0: currentRoute,
			da: $krisajenkins$remotedata$RemoteData$NotAsked,
			a1: {kM: false, d3: false, kN: false},
			dd: $elm$core$Array$empty,
			bw: $author$project$TT$ApiModel$defaultTkNotificationsFromLocalStorage,
			Q: url,
			a6: 0,
			q: commonFlags.q
		};
	});
var $author$project$Main$MsgHome = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Home$MsgGlobalGotServerLoadMessageResult = function (a) {
	return {$: 113, a: a};
};
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.kZ));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {fV: reqs, gc: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.d9;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.fV));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.gc)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					gO: r.gO,
					ch: r.ch,
					dA: A2(_Http_mapExpect, func, r.dA),
					dJ: r.dJ,
					dU: r.dU,
					d8: r.d8,
					d9: r.d9,
					Q: r.Q
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{gO: true, ch: r.ch, dA: r.dA, dJ: r.dJ, dU: r.dU, d8: r.d8, d9: r.d9, Q: r.Q}));
};
var $author$project$Model$ServerLoadMessageResponse = F5(
	function (status, message, expirationTimestamp, expirationHumanReadable, errors) {
		return {h8: errors, h9: expirationHumanReadable, ia: expirationTimestamp, js: message, f9: status};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$TT$ApiModel$TkApiErrorVo = F4(
	function (target, errorCode, errorMessage, extraInfo) {
		return {eQ: errorCode, bM: errorMessage, eX: extraInfo, gf: target};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$TT$ApiModel$TkApiErrorExtraInfoVo = F2(
	function (key, value) {
		return {fm: key, g: value};
	});
var $author$project$TT$ApiModel$tkApiErrorExtraInfoVoDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$TT$ApiModel$TkApiErrorExtraInfoVo,
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string));
var $author$project$TT$ApiModel$tkApiErrorVoDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$TT$ApiModel$TkApiErrorVo,
	A2($elm$json$Json$Decode$field, 'target', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'error_code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'error_message', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'extra_info',
		$elm$json$Json$Decode$list($author$project$TT$ApiModel$tkApiErrorExtraInfoVoDecoder)));
var $author$project$Model$serverLoadMessageResponseDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'errors',
	$elm$json$Json$Decode$maybe(
		$elm$json$Json$Decode$list($author$project$TT$ApiModel$tkApiErrorVoDecoder)),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'expiration_human_readable',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'expiration_timestamp',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'message',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$ServerLoadMessageResponse))))));
var $author$project$Page$Home$cmdBannerNotificationGlobalLoad = function (model) {
	return $elm$http$Http$riskyRequest(
		{
			ch: $elm$http$Http$emptyBody,
			dA: A2($elm$http$Http$expectJson, $author$project$Page$Home$MsgGlobalGotServerLoadMessageResult, $author$project$Model$serverLoadMessageResponseDecoder),
			dJ: _List_Nil,
			dU: 'POST',
			d8: $elm$core$Maybe$Just(model.J.dS),
			d9: $elm$core$Maybe$Nothing,
			Q: model.J.cV + '/v1/admin/banner-notification/global/get-public'
		});
};
var $author$project$Page$Home$MsgGotCurrentYear = function (a) {
	return {$: 40, a: a};
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.d5, posixMinutes) < 0) {
					return posixMinutes + era.jE;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		eI: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		fu: month,
		gv: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).gv;
	});
var $author$project$Page$Home$getCurrentYear = A2(
	$elm$core$Task$perform,
	$author$project$Page$Home$MsgGotCurrentYear,
	A3($elm$core$Task$map2, $elm$time$Time$toYear, $elm$time$Time$here, $elm$time$Time$now));
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Model$TkJobAdSummaryDo = function (id) {
	return function (isActive) {
		return function (position) {
			return function (location) {
				return function (salary) {
					return function (description) {
						return function (publishDate) {
							return function (jobAdLink) {
								return function (skillsList) {
									return function (companyName) {
										return function (recruiterId) {
											return function (recruiterPlanType) {
												return function (recruiterPlanIsPaid) {
													return function (countryCode) {
														return function (contryJsonUrl) {
															return function (externalApplyUrl) {
																return function (hostname) {
																	return function (googleClientId) {
																		return function (companyId) {
																			return {hJ: companyId, hK: companyName, hQ: contryJsonUrl, hU: countryCode, h3: description, ic: externalApplyUrl, is: googleClientId, iF: hostname, iJ: id, iX: isActive, jd: jobAdLink, cU: location, jY: position, j4: publishDate, kb: recruiterId, kj: recruiterPlanIsPaid, kk: recruiterPlanType, kx: salary, d4: skillsList};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$tkJobAdSummaryJsonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'company_id',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'google_client_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hostname',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'external_apply_url',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'country_json_url',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'country_code',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'recruiter_plan_is_paid',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'recruiter_plan_type',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'recruiter_id',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'company_name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'skills_list',
											$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'job_ad_link',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'publish_date',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'description_plain_text',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'salary',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'location',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'position',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'is_active',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$elm$json$Json$Decode$string,
																			$elm$json$Json$Decode$succeed($author$project$Model$TkJobAdSummaryDo))))))))))))))))))));
var $author$project$Page$Home$MsgServerGotJobAdSummaryResponse = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $author$project$Page$Home$upgradeMsgGotJobAdInfoResult = function (result) {
	return $author$project$Page$Home$MsgServerGotJobAdSummaryResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$getJobAdSummary = function (model) {
	var _v0 = model.fl;
	if (!_v0.$) {
		var jobAdId = _v0.a;
		return $elm$http$Http$riskyRequest(
			{
				ch: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(jobAdId)),
								_Utils_Tuple2(
								'source',
								$elm$json$Json$Encode$string(model.M))
							]))),
				dA: A2($elm$http$Http$expectJson, $author$project$Page$Home$upgradeMsgGotJobAdInfoResult, $author$project$Model$tkJobAdSummaryJsonDecoder),
				dJ: _List_Nil,
				dU: 'POST',
				d8: $elm$core$Maybe$Just(model.J.dS),
				d9: $elm$core$Maybe$Nothing,
				Q: model.J.cV + '/v1/apply/job-ad'
			});
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Page$Home$cmds = function (model) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Page$Home$getJobAdSummary(model),
				$author$project$Page$Home$getCurrentYear,
				$author$project$Page$Home$cmdBannerNotificationGlobalLoad(model)
			]));
};
var $author$project$Page$Home$initCmd = function (model) {
	return $author$project$Page$Home$cmds(model);
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Main$initPageCmds = function (model) {
	var _v0 = model.b0;
	if (!_v0.$) {
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Main$MsgHome,
			$author$project$Page$Home$initCmd(model.as));
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Main$MsgServerSidebarMenuItemsResult = function (a) {
	return {$: 6, a: a};
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$TT$SideBarMenu$TkSidebarMenuItemsResponse = F5(
	function (mainMenuItems, loggedInMenuItems, footerMenuItems, accountInfo, headerSlogan) {
		return {a9: accountInfo, cG: footerMenuItems, cK: headerSlogan, bU: loggedInMenuItems, bV: mainMenuItems};
	});
var $author$project$TT$SideBarMenu$TkAccountInfo = F4(
	function (fullname, email, actionItems, candidateDefaultProfileIconUrl) {
		return {dj: actionItems, et: candidateDefaultProfileIconUrl, cB: email, dG: fullname};
	});
var $author$project$TT$SideBarMenu$TkAccountInfoActionItem = F2(
	function (label, uri) {
		return {dQ: label, ec: uri};
	});
var $author$project$TT$SideBarMenu$tkAccountInfoActionItemDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uri',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$TT$SideBarMenu$TkAccountInfoActionItem)));
var $author$project$TT$SideBarMenu$tkAccountInfoDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'candidate_default_profile_icon_url',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'action_items',
		$elm$json$Json$Decode$list($author$project$TT$SideBarMenu$tkAccountInfoActionItemDecoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'email',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'fullname',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$TT$SideBarMenu$TkAccountInfo)))));
var $author$project$TT$SideBarMenu$TkSidebarMenuItem = F4(
	function (id, label, logo, url) {
		return {iJ: id, dQ: label, fq: logo, Q: url};
	});
var $author$project$TT$SideBarMenu$tkSidebarMenuItemDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'logo',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'id',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$TT$SideBarMenu$TkSidebarMenuItem)))));
var $author$project$TT$SideBarMenu$tkSidebarMenuItemsResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'header_slogan',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'account_info',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$TT$SideBarMenu$tkAccountInfoDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'footer_menu_items',
			$elm$json$Json$Decode$list($author$project$TT$SideBarMenu$tkSidebarMenuItemDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'logged_in_menu_items',
				$elm$json$Json$Decode$list($author$project$TT$SideBarMenu$tkSidebarMenuItemDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'main_menu_items',
					$elm$json$Json$Decode$list($author$project$TT$SideBarMenu$tkSidebarMenuItemDecoder),
					$elm$json$Json$Decode$succeed($author$project$TT$SideBarMenu$TkSidebarMenuItemsResponse))))));
var $author$project$Main$fetchSidebarMenuItems = function (model) {
	var toMsgConverter = function (result) {
		return $author$project$Main$MsgServerSidebarMenuItemsResult(
			$krisajenkins$remotedata$RemoteData$fromResult(result));
	};
	var endpointUrl = A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			['v1', 'get-sidebar-items']),
		_List_Nil);
	return $elm$http$Http$riskyRequest(
		{
			ch: $elm$http$Http$emptyBody,
			dA: A2($elm$http$Http$expectJson, toMsgConverter, $author$project$TT$SideBarMenu$tkSidebarMenuItemsResponseDecoder),
			dJ: _List_Nil,
			dU: 'POST',
			d8: $elm$core$Maybe$Just(model.J.dS),
			d9: $elm$core$Maybe$Nothing,
			Q: _Utils_ap(model.J.cV, endpointUrl)
		});
};
var $author$project$TT$Util$isMediumScreenOrLarger = function (windowSize) {
	return windowSize.a8 > 640;
};
var $author$project$Main$sidebarMenuItemsCmd = function (model) {
	return $author$project$TT$Util$isMediumScreenOrLarger(model.q) ? $author$project$Main$fetchSidebarMenuItems(model) : $elm$core$Platform$Cmd$none;
};
var $author$project$Main$PassThrough = {$: 13};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Basics$not = _Basics_not;
var $author$project$Model$removeQueryParam = F2(
	function (param, query) {
		var queryParams = function () {
			if (!query.$) {
				var queryString = query.a;
				return A2(
					$elm$core$List$filter,
					function (q) {
						return !A2($elm$core$String$startsWith, param + '=', q);
					},
					A2($elm$core$String$split, '&', queryString));
			} else {
				return _List_Nil;
			}
		}();
		return $elm$core$List$isEmpty(queryParams) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2($elm$core$String$join, '&', queryParams));
	});
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Main$trackUtmInfo = function (model) {
	var queryParamsFromUrl = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'',
		function (uq) {
			return '?' + uq;
		},
		A2($author$project$Model$removeQueryParam, 'ci', model.Q.j6));
	return $elm$http$Http$riskyRequest(
		{
			ch: $elm$http$Http$emptyBody,
			dA: $elm$http$Http$expectWhatever(
				function (_v0) {
					return $author$project$Main$PassThrough;
				}),
			dJ: _List_Nil,
			dU: 'POST',
			d8: $elm$core$Maybe$Just(model.J.dS),
			d9: $elm$core$Maybe$Nothing,
			Q: model.J.cV + ('/v1/utm/track' + queryParamsFromUrl)
		});
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $author$project$Main$init = F3(
	function (commonFlags, url, navigationKey) {
		var initialModel = A3($author$project$Main$initModel, commonFlags, url, navigationKey);
		var alertsResponse = A3($author$project$TT$Alerts$getPublicAlertMessagesToShow, initialModel.J.fQ, initialModel.J.dt, initialModel.Q);
		var initialModelWithAlerts = _Utils_update(
			initialModel,
			{
				cH: A2($elm$core$Dict$union, initialModel.cH, alertsResponse.g0),
				aB: A2($elm$core$Dict$union, initialModel.aB, alertsResponse.he),
				aO: A2($elm$core$Dict$union, initialModel.aO, alertsResponse.lx)
			});
		return _Utils_Tuple2(
			initialModelWithAlerts,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Main$sidebarMenuItemsCmd(initialModelWithAlerts),
						$author$project$Main$initPageCmds(initialModelWithAlerts),
						$author$project$Main$trackUtmInfo(initialModelWithAlerts),
						$author$project$Ports$getNotificationsFromLocalStorage(0)
					])));
	});
var $author$project$Main$MsgChangeWindowSize = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Main$MsgGotVisualViewportHeight = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$MsgSubscriptionReceiveNotificationsFromLocalStorage = function (a) {
	return {$: 11, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {fE: pids, gc: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {eS: event, fm: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.fE,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.fm;
		var event = _v0.eS;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.gc);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Ports$receiveNotificationsFromLocalStorage = _Platform_incomingPort('receiveNotificationsFromLocalStorage', $elm$json$Json$Decode$value);
var $author$project$Ports$receiveVisualViewportHeight = _Platform_incomingPort('receiveVisualViewportHeight', $elm$json$Json$Decode$value);
var $author$project$Page$Home$MsgCvFileFromCandidateApplyRead = function (a) {
	return {$: 102, a: a};
};
var $author$project$Page$Home$MsgGotGoogleSignInError = function (a) {
	return {$: 74, a: a};
};
var $author$project$Page$Home$MsgGotShowGoogleSignInButton = function (a) {
	return {$: 73, a: a};
};
var $author$project$Page$Home$MsgServerNavigateToSuccessUrl = function (a) {
	return {$: 100, a: a};
};
var $author$project$Page$Home$MsgTrackGoogleSignInButtonClick = function (a) {
	return {$: 110, a: a};
};
var $author$project$Page$Home$MsgUserPressedCancelButtonWhenUploadingCv = function (a) {
	return {$: 104, a: a};
};
var $author$project$Ports$fileContentRead = _Platform_incomingPort(
	'fileContentRead',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$json$Json$Decode$andThen,
					function (fileUrl) {
						return A2(
							$elm$json$Json$Decode$andThen,
							function (fileType) {
								return A2(
									$elm$json$Json$Decode$andThen,
									function (fileSize) {
										return A2(
											$elm$json$Json$Decode$andThen,
											function (fileName) {
												return A2(
													$elm$json$Json$Decode$andThen,
													function (contents) {
														return $elm$json$Json$Decode$succeed(
															{dv: contents, ie: fileName, $8: fileSize, eY: fileType, ig: fileUrl});
													},
													A2($elm$json$Json$Decode$field, 'contents', $elm$json$Json$Decode$string));
											},
											A2($elm$json$Json$Decode$field, 'fileName', $elm$json$Json$Decode$string));
									},
									A2($elm$json$Json$Decode$field, 'fileSize', $elm$json$Json$Decode$int));
							},
							A2($elm$json$Json$Decode$field, 'fileType', $elm$json$Json$Decode$string));
					},
					A2($elm$json$Json$Decode$field, 'fileUrl', $elm$json$Json$Decode$string)))
			])));
var $author$project$Ports$receiveGoogleSignInError = _Platform_incomingPort(
	'receiveGoogleSignInError',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$receiveGoogleSignInShowButton = _Platform_incomingPort(
	'receiveGoogleSignInShowButton',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$receiveRefreshCandidateSessionFinished = _Platform_incomingPort('receiveRefreshCandidateSessionFinished', $elm$json$Json$Decode$value);
var $author$project$Ports$trackGoogleSignInButtonClick = _Platform_incomingPort(
	'trackGoogleSignInButtonClick',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$userPressedCancelButtonWhenUploadingCv = _Platform_incomingPort('userPressedCancelButtonWhenUploadingCv', $elm$json$Json$Decode$bool);
var $author$project$Page$Home$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$receiveGoogleSignInShowButton($author$project$Page$Home$MsgGotShowGoogleSignInButton),
				$author$project$Ports$receiveGoogleSignInError($author$project$Page$Home$MsgGotGoogleSignInError),
				$author$project$Ports$receiveRefreshCandidateSessionFinished($author$project$Page$Home$MsgServerNavigateToSuccessUrl),
				$author$project$Ports$fileContentRead($author$project$Page$Home$MsgCvFileFromCandidateApplyRead),
				$author$project$Ports$userPressedCancelButtonWhenUploadingCv($author$project$Page$Home$MsgUserPressedCancelButtonWhenUploadingCv),
				$author$project$Ports$trackGoogleSignInButtonClick($author$project$Page$Home$MsgTrackGoogleSignInButtonClick)
			]));
};
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$MsgHome,
				$author$project$Page$Home$subscriptions(model.as)),
				$elm$browser$Browser$Events$onResize($author$project$Main$MsgChangeWindowSize),
				$author$project$Ports$receiveVisualViewportHeight($author$project$Main$MsgGotVisualViewportHeight),
				$author$project$Ports$receiveNotificationsFromLocalStorage($author$project$Main$MsgSubscriptionReceiveNotificationsFromLocalStorage)
			]));
};
var $author$project$Main$MsgBrowserHideToast = function (a) {
	return {$: 10, a: a};
};
var $author$project$TT$ApiModel$TkApiSimpleStatusResponse = function (status) {
	return {f9: status};
};
var $author$project$TT$ApiModel$apiResponseSimpleStatusJsonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$TT$ApiModel$TkApiSimpleStatusResponse));
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Main$delayHideNotification = function (msg) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return msg;
		},
		$elm$core$Process$sleep(5000 * 3));
};
var $author$project$TT$Log$error = _Platform_outgoingPort(
	'error',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string($.js))
				]));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{z: nodeList, x: nodeListSize, y: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Array$filter = F2(
	function (isGood, array) {
		return $elm$core$Array$fromList(
			A3(
				$elm$core$Array$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				array));
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Main$MsgSavedJobAdsSynchronizedWithLocalStorageResponse = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$getMsgSavedJobAdsSynchronizedWithLocalStorageResponseDo = function (result) {
	return $author$project$Main$MsgSavedJobAdsSynchronizedWithLocalStorageResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Ports$getVisualViewportHeight = _Platform_outgoingPort(
	'getVisualViewportHeight',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$goToTonkeanUrl = _Platform_outgoingPort('goToTonkeanUrl', $elm$json$Json$Encode$string);
var $author$project$Route$isTonkeanUrl = function (url) {
	return A2($elm$core$String$startsWith, '/', url.fB);
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Ports$scrollToChatBottom = _Platform_outgoingPort(
	'scrollToChatBottom',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$scrollToDocumentTop = _Platform_outgoingPort(
	'scrollToDocumentTop',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$setNotificationsAsSynchronizedWithLoggedInCandidate = _Platform_outgoingPort(
	'setNotificationsAsSynchronizedWithLoggedInCandidate',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Page$Home$MsgVisualViewportHeightOffsetChanged = function (a) {
	return {$: 75, a: a};
};
var $author$project$TT$Util$msgToCmd = function (msg) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return msg;
		},
		$elm$core$Task$succeed(0));
};
var $author$project$Page$Home$syncViewportHeightOffset = function (visualViewportHeightOffset) {
	return $author$project$TT$Util$msgToCmd(
		$author$project$Page$Home$MsgVisualViewportHeightOffsetChanged(visualViewportHeightOffset));
};
var $author$project$Main$syncViewportHeightOffset = F2(
	function (url, visualViewportHeightOffset) {
		var _v0 = $author$project$Route$fromUrl(url);
		if (!_v0.$) {
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Main$MsgHome,
				$author$project$Page$Home$syncViewportHeightOffset(visualViewportHeightOffset));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Page$Home$MsgChangeWindowSize = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Home$syncWindowSize = function (windowSize) {
	return $author$project$TT$Util$msgToCmd(
		$author$project$Page$Home$MsgChangeWindowSize(windowSize));
};
var $author$project$Main$syncWindowSize = F2(
	function (url, windowSize) {
		var _v0 = $author$project$Route$fromUrl(url);
		if (!_v0.$) {
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Main$MsgHome,
				$author$project$Page$Home$syncWindowSize(windowSize));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$TT$ApiModel$TkNotificationsFromLocalStorage = F3(
	function (favorites, counterRecentNotifications, synchronizedWithLoggedInCandidate) {
		return {eC: counterRecentNotifications, dE: favorites, gd: synchronizedWithLoggedInCandidate};
	});
var $author$project$TT$ApiModel$TkFavoriteNotificationFromLocalStorage = F3(
	function (id, position, savedAtMillis) {
		return {iJ: id, jY: position, kA: savedAtMillis};
	});
var $author$project$TT$ApiModel$tkFavoriteNotificationFromLocalStorageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'savedAtMillis',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'position',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$TT$ApiModel$TkFavoriteNotificationFromLocalStorage))));
var $author$project$TT$ApiModel$TkNotificationFromLocalStorage = F2(
	function (added, recentlyAdded) {
		return {gD: added, fP: recentlyAdded};
	});
var $author$project$TT$ApiModel$tkNotificationFromLocalStorageDecoder = function (decoderForSpecificNotification) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'recentlyAdded',
		$elm$json$Json$Decode$list(decoderForSpecificNotification),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'added',
			$elm$json$Json$Decode$list(decoderForSpecificNotification),
			_List_Nil,
			$elm$json$Json$Decode$succeed($author$project$TT$ApiModel$TkNotificationFromLocalStorage)));
};
var $author$project$TT$ApiModel$tkNotificationsFromLocalStorageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'synchronizedWithLoggedInCandidate',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'counterRecentNotifications',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'favorites',
			$author$project$TT$ApiModel$tkNotificationFromLocalStorageDecoder($author$project$TT$ApiModel$tkFavoriteNotificationFromLocalStorageDecoder),
			$author$project$TT$ApiModel$defaultNotificationFromLocalStorage,
			$elm$json$Json$Decode$succeed($author$project$TT$ApiModel$TkNotificationsFromLocalStorage))));
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.fO;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.e0,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.j6,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.fF,
					_Utils_ap(http, url.e6)),
				url.fB)));
};
var $krisajenkins$remotedata$RemoteData$unwrap = F3(
	function (_default, _function, remoteData) {
		if (remoteData.$ === 3) {
			var data = remoteData.a;
			return _function(data);
		} else {
			return _default;
		}
	});
var $author$project$Model$ApplyQuestionsStep = 4;
var $author$project$Model$CandidateCvStep = 5;
var $author$project$Model$CandidateInfoStep = 1;
var $author$project$Model$CountryStepOptional = 3;
var $author$project$Model$EmptyScreenStep = 7;
var $author$project$Model$ExternalApplyStep = 2;
var $author$project$Model$FilterQuestionsStep = 3;
var $author$project$Model$FinalStep = 6;
var $author$project$Model$FullnameStep = 1;
var $author$project$Model$HeadlineStep = 5;
var $author$project$Model$LocationStep = 4;
var $author$project$Page$Home$MsgBrowserGetContinueWithTalentecaWidthResult = function (a) {
	return {$: 97, a: a};
};
var $author$project$Page$Home$MsgBrowserHideErrorMessage = function (a) {
	return {$: 108, a: a};
};
var $author$project$Page$Home$MsgBrowserHideSuccessMessage = function (a) {
	return {$: 107, a: a};
};
var $author$project$Page$Home$MsgCategoryDropdownChanged = function (a) {
	return {$: 30, a: a};
};
var $author$project$Page$Home$MsgCategoryDropdownSelectChanged = function (a) {
	return {$: 31, a: a};
};
var $author$project$Page$Home$MsgCountryDropdownChanged = function (a) {
	return {$: 118, a: a};
};
var $author$project$Page$Home$MsgCountryDropdownSelectChanged = function (a) {
	return {$: 119, a: a};
};
var $author$project$Page$Home$MsgEducationLevelDropdownChanged = function (a) {
	return {$: 34, a: a};
};
var $author$project$Page$Home$MsgEducationLevelDropdownSelectChanged = function (a) {
	return {$: 35, a: a};
};
var $author$project$Page$Home$MsgExperienceDropdownChanged = function (a) {
	return {$: 32, a: a};
};
var $author$project$Page$Home$MsgExperienceDropdownSelectChanged = function (a) {
	return {$: 33, a: a};
};
var $author$project$Page$Home$MsgHideApplyQuestionsStageErrorMessage = {$: 50};
var $author$project$Page$Home$MsgHideCandidateCVStageErrorMessage = {$: 48};
var $author$project$Page$Home$MsgHideCandidateInfoStageErrorMessage = {$: 49};
var $author$project$Page$Home$MsgHideFilterQuestionsStageErrorMessage = {$: 29};
var $author$project$Page$Home$MsgLoadCandidateInfo = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Page$Home$MsgRedirectToExternalUrl = function (a) {
	return {$: 76, a: a};
};
var $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputFive = function (a) {
	return {$: 92, a: a};
};
var $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputFour = function (a) {
	return {$: 90, a: a};
};
var $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputSix = function (a) {
	return {$: 94, a: a};
};
var $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputThree = function (a) {
	return {$: 88, a: a};
};
var $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputTwo = function (a) {
	return {$: 86, a: a};
};
var $author$project$Page$Home$MsgUserChangedOpenFilterQuestionAnswer = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Page$Home$MsgUserClickedSendMagicLink = function (a) {
	return {$: 70, a: a};
};
var $author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton = {$: 98};
var $author$project$Page$Home$MsgUserPressedValidateMagicLinkCodeButton = {$: 96};
var $author$project$TT$Dropdown$OnReceivedMatches = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Home$PassThrough = {$: 126};
var $author$project$Model$PhoneStep = 2;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var tailLen = $elm$core$Elm$JsArray$length(tail);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.y)) - tailLen;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.y, tail);
		return (notAppended < 0) ? {
			z: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.z),
			x: builder.x + 1,
			y: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
		} : ((!notAppended) ? {
			z: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.z),
			x: builder.x + 1,
			y: $elm$core$Elm$JsArray$empty
		} : {z: builder.z, x: builder.x, y: appended});
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!value.$) {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$appendHelpTree = F2(
	function (toAppend, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		var itemsToAppend = $elm$core$Elm$JsArray$length(toAppend);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(tail)) - itemsToAppend;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, tail, toAppend);
		var newArray = A2($elm$core$Array$unsafeReplaceTail, appended, array);
		if (notAppended < 0) {
			var nextTail = A3($elm$core$Elm$JsArray$slice, notAppended, itemsToAppend, toAppend);
			return A2($elm$core$Array$unsafeReplaceTail, nextTail, newArray);
		} else {
			return newArray;
		}
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$builderFromArray = function (_v0) {
	var len = _v0.a;
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = F2(
		function (node, acc) {
			if (!node.$) {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
			} else {
				return A2($elm$core$List$cons, node, acc);
			}
		});
	return {
		z: A3($elm$core$Elm$JsArray$foldl, helper, _List_Nil, tree),
		x: (len / $elm$core$Array$branchFactor) | 0,
		y: tail
	};
};
var $elm$core$Array$append = F2(
	function (a, _v0) {
		var aTail = a.d;
		var bLen = _v0.a;
		var bTree = _v0.c;
		var bTail = _v0.d;
		if (_Utils_cmp(bLen, $elm$core$Array$branchFactor * 4) < 1) {
			var foldHelper = F2(
				function (node, array) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, array, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpTree, leaf, array);
					}
				});
			return A2(
				$elm$core$Array$appendHelpTree,
				bTail,
				A3($elm$core$Elm$JsArray$foldl, foldHelper, a, bTree));
		} else {
			var foldHelper = F2(
				function (node, builder) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, builder, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpBuilder, leaf, builder);
					}
				});
			return A2(
				$elm$core$Array$builderToArray,
				true,
				A2(
					$elm$core$Array$appendHelpBuilder,
					bTail,
					A3(
						$elm$core$Elm$JsArray$foldl,
						foldHelper,
						$elm$core$Array$builderFromArray(a),
						bTree)));
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Navigation$back = F2(
	function (key, n) {
		return A2(_Browser_go, key, -n);
	});
var $mdgriffith$elm_ui$Internal$Model$Rgba = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Element$rgba = $mdgriffith$elm_ui$Internal$Model$Rgba;
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {$7: a, ds: b, dH: g, d0: r};
};
var $author$project$TT$Color$Extra$fromColor = function (elementColor) {
	var cl = $avh4$elm_color$Color$toRgba(elementColor);
	return A4($mdgriffith$elm_ui$Element$rgba, cl.d0, cl.dH, cl.ds, cl.$7);
};
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $elm$core$String$fromList = _String_fromList;
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $fredcy$elm_parseint$ParseInt$InvalidRadix = function (a) {
	return {$: 2, a: a};
};
var $fredcy$elm_parseint$ParseInt$InvalidChar = function (a) {
	return {$: 0, a: a};
};
var $fredcy$elm_parseint$ParseInt$OutOfRange = function (a) {
	return {$: 1, a: a};
};
var $fredcy$elm_parseint$ParseInt$charOffset = F2(
	function (basis, c) {
		return $elm$core$Char$toCode(c) - $elm$core$Char$toCode(basis);
	});
var $fredcy$elm_parseint$ParseInt$isBetween = F3(
	function (lower, upper, c) {
		var ci = $elm$core$Char$toCode(c);
		return (_Utils_cmp(
			$elm$core$Char$toCode(lower),
			ci) < 1) && (_Utils_cmp(
			ci,
			$elm$core$Char$toCode(upper)) < 1);
	});
var $fredcy$elm_parseint$ParseInt$intFromChar = F2(
	function (radix, c) {
		var validInt = function (i) {
			return (_Utils_cmp(i, radix) < 0) ? $elm$core$Result$Ok(i) : $elm$core$Result$Err(
				$fredcy$elm_parseint$ParseInt$OutOfRange(c));
		};
		var toInt = A3($fredcy$elm_parseint$ParseInt$isBetween, '0', '9', c) ? $elm$core$Result$Ok(
			A2($fredcy$elm_parseint$ParseInt$charOffset, '0', c)) : (A3($fredcy$elm_parseint$ParseInt$isBetween, 'a', 'z', c) ? $elm$core$Result$Ok(
			10 + A2($fredcy$elm_parseint$ParseInt$charOffset, 'a', c)) : (A3($fredcy$elm_parseint$ParseInt$isBetween, 'A', 'Z', c) ? $elm$core$Result$Ok(
			10 + A2($fredcy$elm_parseint$ParseInt$charOffset, 'A', c)) : $elm$core$Result$Err(
			$fredcy$elm_parseint$ParseInt$InvalidChar(c))));
		return A2($elm$core$Result$andThen, validInt, toInt);
	});
var $fredcy$elm_parseint$ParseInt$parseIntR = F2(
	function (radix, rstring) {
		var _v0 = $elm$core$String$uncons(rstring);
		if (_v0.$ === 1) {
			return $elm$core$Result$Ok(0);
		} else {
			var _v1 = _v0.a;
			var c = _v1.a;
			var rest = _v1.b;
			return A2(
				$elm$core$Result$andThen,
				function (ci) {
					return A2(
						$elm$core$Result$andThen,
						function (ri) {
							return $elm$core$Result$Ok(ci + (ri * radix));
						},
						A2($fredcy$elm_parseint$ParseInt$parseIntR, radix, rest));
				},
				A2($fredcy$elm_parseint$ParseInt$intFromChar, radix, c));
		}
	});
var $elm$core$String$reverse = _String_reverse;
var $fredcy$elm_parseint$ParseInt$parseIntRadix = F2(
	function (radix, string) {
		return ((2 <= radix) && (radix <= 36)) ? A2(
			$fredcy$elm_parseint$ParseInt$parseIntR,
			radix,
			$elm$core$String$reverse(string)) : $elm$core$Result$Err(
			$fredcy$elm_parseint$ParseInt$InvalidRadix(radix));
	});
var $fredcy$elm_parseint$ParseInt$parseIntHex = $fredcy$elm_parseint$ParseInt$parseIntRadix(16);
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$rgb = F3(
	function (r, g, b) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, 1.0);
	});
var $avh4$elm_color$Color$rgba = F4(
	function (r, g, b, a) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, a);
	});
var $elm$core$Basics$pow = _Basics_pow;
var $elm$core$Basics$round = _Basics_round;
var $noahzgordon$elm_color_extra$Color$Convert$roundToPlaces = F2(
	function (places, number) {
		var multiplier = A2($elm$core$Basics$pow, 10, places);
		return $elm$core$Basics$round(number * multiplier) / multiplier;
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $elm$core$String$toLower = _String_toLower;
var $noahzgordon$elm_color_extra$Color$Convert$hexToColor = function () {
	var pattern = '' + ('^' + ('#?' + ('(?:' + ('(?:([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2}))' + ('|' + ('(?:([a-f\\d])([a-f\\d])([a-f\\d]))' + ('|' + ('(?:([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2}))' + ('|' + ('(?:([a-f\\d])([a-f\\d])([a-f\\d])([a-f\\d]))' + (')' + '$')))))))))));
	var extend = function (token) {
		var _v6 = $elm$core$String$toList(token);
		if (_v6.b && (!_v6.b.b)) {
			var token_ = _v6.a;
			return $elm$core$String$fromList(
				_List_fromArray(
					[token_, token_]));
		} else {
			return token;
		}
	};
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toLower,
		A2(
			$elm$core$Basics$composeR,
			function (str) {
				return A2(
					$elm$core$Maybe$map,
					function (regex) {
						return A3($elm$regex$Regex$findAtMost, 1, regex, str);
					},
					$elm$regex$Regex$fromString(pattern));
			},
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen($elm$core$List$head),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(
						function ($) {
							return $.k2;
						}),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$elm$core$List$filterMap($elm$core$Basics$identity)),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Result$fromMaybe('Parsing hex regex failed'),
							$elm$core$Result$andThen(
								function (colors) {
									var _v0 = A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											extend,
											A2(
												$elm$core$Basics$composeR,
												$fredcy$elm_parseint$ParseInt$parseIntHex,
												$elm$core$Result$map($elm$core$Basics$toFloat))),
										colors);
									_v0$2:
									while (true) {
										if (((((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) && _v0.b.b.b) && (!_v0.b.b.a.$)) {
											if (_v0.b.b.b.b) {
												if ((!_v0.b.b.b.a.$) && (!_v0.b.b.b.b.b)) {
													var r = _v0.a.a;
													var _v1 = _v0.b;
													var g = _v1.a.a;
													var _v2 = _v1.b;
													var b = _v2.a.a;
													var _v3 = _v2.b;
													var a = _v3.a.a;
													return $elm$core$Result$Ok(
														A4(
															$avh4$elm_color$Color$rgba,
															r / 255,
															g / 255,
															b / 255,
															A2($noahzgordon$elm_color_extra$Color$Convert$roundToPlaces, 2, a / 255)));
												} else {
													break _v0$2;
												}
											} else {
												var r = _v0.a.a;
												var _v4 = _v0.b;
												var g = _v4.a.a;
												var _v5 = _v4.b;
												var b = _v5.a.a;
												return $elm$core$Result$Ok(
													A3($avh4$elm_color$Color$rgb, r / 255, g / 255, b / 255));
											}
										} else {
											break _v0$2;
										}
									}
									return $elm$core$Result$Err('Parsing ints from hex failed');
								})))))));
}();
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$TT$Color$Extra$hexToColor = function (string) {
	var cl = $noahzgordon$elm_color_extra$Color$Convert$hexToColor(string);
	return $author$project$TT$Color$Extra$fromColor(
		A2(
			$elm$core$Result$withDefault,
			A3($avh4$elm_color$Color$rgb, 0, 0, 0),
			cl));
};
var $author$project$TT$Color$black = $author$project$TT$Color$Extra$hexToColor('#333');
var $elm$browser$Browser$Dom$blur = _Browser_call('blur');
var $author$project$Model$TkApiExistingCandidateDo = F5(
	function (hasAccount, hasPassword, hasGoogleSignIn, fullName, email) {
		return {cB: email, $9: fullName, ix: hasAccount, iB: hasGoogleSignIn, e3: hasPassword};
	});
var $author$project$Model$tkApiExistingCandidateDoJsonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'full_name',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'has_google_sign_in',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'has_password',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'has_account',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$Model$TkApiExistingCandidateDo))))));
var $author$project$Page$Home$MsgServerGotCheckAcountForEmailResponse = function (a) {
	return {$: 67, a: a};
};
var $author$project$Page$Home$upgradeMsgServerGotCheckAcountForEmailResponse = function (result) {
	return $author$project$Page$Home$MsgServerGotCheckAcountForEmailResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$checkAccountForEmail = F2(
	function (model, email) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'source',
					$elm$json$Json$Encode$string(model.M))
				]));
		return $elm$http$Http$riskyRequest(
			{
				ch: $elm$http$Http$jsonBody(body),
				dA: A2($elm$http$Http$expectJson, $author$project$Page$Home$upgradeMsgServerGotCheckAcountForEmailResponse, $author$project$Model$tkApiExistingCandidateDoJsonDecoder),
				dJ: _List_Nil,
				dU: 'POST',
				d8: $elm$core$Maybe$Just(model.J.dS),
				d9: $elm$core$Maybe$Nothing,
				Q: model.J.cV + '/v1/apply/check-existing-account'
			});
	});
var $author$project$Page$Home$MsgCityDropdownChanged = function (a) {
	return {$: 123, a: a};
};
var $author$project$Page$Home$MsgCityDropdownSelectChanged = function (a) {
	return {$: 124, a: a};
};
var $author$project$Page$Home$MsgInputLocationChanged = F2(
	function (a, b) {
		return {$: 122, a: a, b: b};
	});
var $author$project$Page$Home$MsgUserLeftCityDropdown = {$: 125};
var $author$project$TT$Dropdown$TextField = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$TT$FormField$InputText = 0;
var $author$project$TT$FormField$LabelHidden = 1;
var $author$project$TT$FormField$StateDefault = 0;
var $author$project$TT$FormField$StateError = 2;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$Attribute = $elm$core$Basics$identity;
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr = function (a) {
	return function (_v0) {
		return a;
	};
};
var $mdgriffith$elm_ui$Internal$Model$Colored = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$StyleClass = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$Flag = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Second = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$flag = function (i) {
	return (i > 31) ? $mdgriffith$elm_ui$Internal$Flag$Second(1 << (i - 32)) : $mdgriffith$elm_ui$Internal$Flag$Flag(1 << i);
};
var $mdgriffith$elm_ui$Internal$Flag$bgColor = $mdgriffith$elm_ui$Internal$Flag$flag(8);
var $mdgriffith$elm_ui$Internal$Model$floatClass = function (x) {
	return $elm$core$String$fromInt(
		$elm$core$Basics$round(x * 255));
};
var $mdgriffith$elm_ui$Internal$Model$formatColorClass = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return $mdgriffith$elm_ui$Internal$Model$floatClass(red) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(green) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(blue) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(alpha))))));
};
var $mdgriffith$elm_ui$Element$Background$color = function (clr) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$bgColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'bg-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr),
			'background-color',
			clr));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Background$color = function (clr) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr(
		$mdgriffith$elm_ui$Element$Background$color(clr));
};
var $mdgriffith$elm_ui$Internal$Flag$borderColor = $mdgriffith$elm_ui$Internal$Flag$flag(28);
var $mdgriffith$elm_ui$Element$Border$color = function (clr) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'bc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr),
			'border-color',
			clr));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$color = function (clr) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr(
		$mdgriffith$elm_ui$Element$Border$color(clr));
};
var $mdgriffith$elm_ui$Internal$Flag$fontColor = $mdgriffith$elm_ui$Internal$Flag$flag(14);
var $mdgriffith$elm_ui$Element$Font$color = function (fontColor) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'fc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(fontColor),
			'color',
			fontColor));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Font$color = function (fontColor) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr(
		$mdgriffith$elm_ui$Element$Font$color(fontColor));
};
var $author$project$TT$Dropdown$Config = $elm$core$Basics$identity;
var $author$project$TT$FormField$Input = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$TT$FormField$withFieldAttrs = F2(
	function (fieldAttrs, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var value = _v0.c;
		var label = _v0.d;
		return A4(
			$author$project$TT$FormField$Input,
			_Utils_update(
				options,
				{
					bN: _Utils_ap(options.bN, fieldAttrs)
				}),
			msg,
			value,
			label);
	});
var $author$project$TT$Dropdown$basic = function (_v0) {
	var defaultText = _v0.eJ;
	var promptElement = _v0.fN;
	var dropdownMsg = _v0.eN;
	var onSelectedMsg = _v0.fy;
	var itemToElement = _v0.fj;
	var itemToPrompt = _v0.fk;
	var selectionFromModel = _v0.f4;
	var inputType = _v0.fb;
	var emptyListElement = _v0.eO;
	var limitOptions = _v0.fo;
	return {
		cs: _List_Nil,
		eJ: defaultText,
		eN: dropdownMsg,
		eO: emptyListElement,
		fb: inputType,
		fj: itemToElement,
		fo: limitOptions,
		cT: _List_Nil,
		cX: $elm$core$Maybe$Nothing,
		fy: onSelectedMsg,
		fN: promptElement,
		c9: _List_Nil,
		f4: selectionFromModel,
		d1: itemToPrompt,
		b1: false,
		df: function (baseInput) {
			return A2($author$project$TT$FormField$withFieldAttrs, _List_Nil, baseInput);
		}
	};
};
var $mdgriffith$elm_ui$Internal$Model$Fill = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$fill = $mdgriffith$elm_ui$Internal$Model$Fill(1);
var $lucamug$elm_ui_with_context$Element$WithContext$fill = $mdgriffith$elm_ui$Element$fill;
var $author$project$TT$Color$gray4 = $author$project$TT$Color$Extra$hexToColor('#f5f5f5');
var $lucamug$elm_ui_with_context$Element$WithContext$attribute = function (elem) {
	return function (_v0) {
		return elem;
	};
};
var $mdgriffith$elm_ui$Internal$Model$Height = function (a) {
	return {$: 8, a: a};
};
var $mdgriffith$elm_ui$Element$height = $mdgriffith$elm_ui$Internal$Model$Height;
var $lucamug$elm_ui_with_context$Element$WithContext$height = function (l) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
		$mdgriffith$elm_ui$Element$height(l));
};
var $mdgriffith$elm_ui$Internal$Model$Attr = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Element$htmlAttribute = $mdgriffith$elm_ui$Internal$Model$Attr;
var $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute = function (child) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
		$mdgriffith$elm_ui$Element$htmlAttribute(child));
};
var $mdgriffith$elm_ui$Internal$Model$Max = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$maximum = F2(
	function (i, l) {
		return A2($mdgriffith$elm_ui$Internal$Model$Max, i, l);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$maximum = $mdgriffith$elm_ui$Element$maximum;
var $lucamug$elm_ui_with_context$Element$WithContext$attr = function (elem) {
	return function (_v0) {
		return elem;
	};
};
var $mdgriffith$elm_ui$Internal$Model$MoveY = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$TransformComponent = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$moveY = $mdgriffith$elm_ui$Internal$Flag$flag(26);
var $mdgriffith$elm_ui$Element$moveUp = function (y) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveY,
		$mdgriffith$elm_ui$Internal$Model$MoveY(-y));
};
var $lucamug$elm_ui_with_context$Element$WithContext$moveUp = function (y) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attr(
		$mdgriffith$elm_ui$Element$moveUp(y));
};
var $mdgriffith$elm_ui$Internal$Model$PaddingStyle = F5(
	function (a, b, c, d, e) {
		return {$: 7, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Internal$Flag$padding = $mdgriffith$elm_ui$Internal$Flag$flag(2);
var $mdgriffith$elm_ui$Element$paddingXY = F2(
	function (x, y) {
		if (_Utils_eq(x, y)) {
			var f = x;
			return A2(
				$mdgriffith$elm_ui$Internal$Model$StyleClass,
				$mdgriffith$elm_ui$Internal$Flag$padding,
				A5(
					$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
					'p-' + $elm$core$String$fromInt(x),
					f,
					f,
					f,
					f));
		} else {
			var yFloat = y;
			var xFloat = x;
			return A2(
				$mdgriffith$elm_ui$Internal$Model$StyleClass,
				$mdgriffith$elm_ui$Internal$Flag$padding,
				A5(
					$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
					'p-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y))),
					yFloat,
					xFloat,
					yFloat,
					xFloat));
		}
	});
var $lucamug$elm_ui_with_context$Element$WithContext$paddingXY = F2(
	function (x, y) {
		return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
			A2($mdgriffith$elm_ui$Element$paddingXY, x, y));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute = function (a) {
	return function (_v0) {
		return a;
	};
};
var $mdgriffith$elm_ui$Internal$Model$Single = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Flag$borderRound = $mdgriffith$elm_ui$Internal$Flag$flag(17);
var $mdgriffith$elm_ui$Element$Border$roundEach = function (_v0) {
	var topLeft = _v0.lA;
	var topRight = _v0.lB;
	var bottomLeft = _v0.hc;
	var bottomRight = _v0.hd;
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderRound,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			'br-' + ($elm$core$String$fromInt(topLeft) + ('-' + ($elm$core$String$fromInt(topRight) + ($elm$core$String$fromInt(bottomLeft) + ('-' + $elm$core$String$fromInt(bottomRight)))))),
			'border-radius',
			$elm$core$String$fromInt(topLeft) + ('px ' + ($elm$core$String$fromInt(topRight) + ('px ' + ($elm$core$String$fromInt(bottomRight) + ('px ' + ($elm$core$String$fromInt(bottomLeft) + 'px'))))))));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach = function (edges) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Border$roundEach(edges));
};
var $mdgriffith$elm_ui$Element$Border$rounded = function (radius) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderRound,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			'br-' + $elm$core$String$fromInt(radius),
			'border-radius',
			$elm$core$String$fromInt(radius) + 'px'));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded = function (radius) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Border$rounded(radius));
};
var $mdgriffith$elm_ui$Internal$Model$Class = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$classes = {gx: 'a', gy: 'atv', gG: 'ab', gH: 'cx', gI: 'cy', gJ: 'acb', gK: 'accx', gL: 'accy', gM: 'acr', en: 'al', eo: 'ar', gN: 'at', dm: 'ah', dn: 'av', gT: 's', g2: 'bh', g3: 'b', g6: 'w7', g8: 'bd', g9: 'bdt', ci: 'bn', ha: 'bs', cm: 'cpe', hu: 'cp', hv: 'cpx', hw: 'cpy', ay: 'c', cr: 'ctr', ct: 'cb', cu: 'ccx', az: 'ccy', bH: 'cl', cv: 'cr', hO: 'ct', hX: 'cptr', hY: 'ctxt', ii: 'fcs', e$: 'focus-within', io: 'fs', iu: 'g', dI: 'hbh', dL: 'hc', e4: 'he', dM: 'hf', e5: 'hfp', iG: 'hv', iK: 'ic', iM: 'fr', cN: 'lbl', iQ: 'iml', iR: 'imlf', iS: 'imlp', iT: 'implw', iU: 'it', jc: 'i', fp: 'lnk', bp: 'nb', fv: 'notxt', jH: 'ol', jJ: 'or', aZ: 'oq', jQ: 'oh', fz: 'pg', fA: 'p', jS: 'ppe', kv: 'ui', f_: 'r', kD: 'sb', kE: 'sbx', kF: 'sby', kG: 'sbt', kP: 'e', kR: 'cap', kU: 'sev', k0: 'sk', h: 't', lb: 'tc', lc: 'w8', ld: 'w2', le: 'w9', lf: 'tj', dg: 'tja', lg: 'tl', lh: 'w3', li: 'w5', lj: 'w4', lk: 'tr', ll: 'w6', lm: 'w1', ln: 'tun', lG: 'ts', a4: 'clr', aa: 'u', ef: 'wc', gq: 'we', eg: 'wf', gr: 'wfp', ei: 'wrp'};
var $mdgriffith$elm_ui$Internal$Flag$overflow = $mdgriffith$elm_ui$Internal$Flag$flag(20);
var $mdgriffith$elm_ui$Element$scrollbarY = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.kF);
var $lucamug$elm_ui_with_context$Element$WithContext$scrollbarY = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$scrollbarY);
var $mdgriffith$elm_ui$Internal$Model$Content = {$: 1};
var $mdgriffith$elm_ui$Element$shrink = $mdgriffith$elm_ui$Internal$Model$Content;
var $lucamug$elm_ui_with_context$Element$WithContext$shrink = $mdgriffith$elm_ui$Element$shrink;
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$Element = $elm$core$Basics$identity;
var $lucamug$elm_ui_with_context$Element$WithContext$element = function (elem) {
	return function (_v0) {
		return elem;
	};
};
var $mdgriffith$elm_ui$Internal$Model$Text = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$text = function (content) {
	return $mdgriffith$elm_ui$Internal$Model$Text(content);
};
var $lucamug$elm_ui_with_context$Element$WithContext$text = function (content) {
	return $lucamug$elm_ui_with_context$Element$WithContext$element(
		$mdgriffith$elm_ui$Element$text(content));
};
var $author$project$TT$Color$white = $author$project$TT$Color$Extra$hexToColor('#fff');
var $mdgriffith$elm_ui$Internal$Model$Width = function (a) {
	return {$: 7, a: a};
};
var $mdgriffith$elm_ui$Element$width = $mdgriffith$elm_ui$Internal$Model$Width;
var $lucamug$elm_ui_with_context$Element$WithContext$width = function (l) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
		$mdgriffith$elm_ui$Element$width(l));
};
var $mdgriffith$elm_ui$Internal$Model$BorderWidth = F5(
	function (a, b, c, d, e) {
		return {$: 6, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Internal$Flag$borderWidth = $mdgriffith$elm_ui$Internal$Flag$flag(27);
var $mdgriffith$elm_ui$Element$Border$width = function (v) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderWidth,
		A5(
			$mdgriffith$elm_ui$Internal$Model$BorderWidth,
			'b-' + $elm$core$String$fromInt(v),
			v,
			v,
			v,
			v));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$width = function (v) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Border$width(v));
};
var $mdgriffith$elm_ui$Element$Border$widthXY = F2(
	function (x, y) {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$borderWidth,
			A5(
				$mdgriffith$elm_ui$Internal$Model$BorderWidth,
				'b-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y))),
				y,
				x,
				y,
				x));
	});
var $mdgriffith$elm_ui$Element$Border$widthEach = function (_v0) {
	var bottom = _v0.hb;
	var top = _v0.lz;
	var left = _v0.jf;
	var right = _v0.ku;
	return (_Utils_eq(top, bottom) && _Utils_eq(left, right)) ? (_Utils_eq(top, right) ? $mdgriffith$elm_ui$Element$Border$width(top) : A2($mdgriffith$elm_ui$Element$Border$widthXY, left, top)) : A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderWidth,
		A5(
			$mdgriffith$elm_ui$Internal$Model$BorderWidth,
			'b-' + ($elm$core$String$fromInt(top) + ('-' + ($elm$core$String$fromInt(right) + ('-' + ($elm$core$String$fromInt(bottom) + ('-' + $elm$core$String$fromInt(left))))))),
			top,
			right,
			bottom,
			left));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$widthEach = function (edges) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Border$widthEach(edges));
};
var $author$project$TT$Dropdown$withContainerAttributes = F2(
	function (attrs, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{cs: attrs});
	});
var $author$project$TT$Dropdown$withListAttributes = F2(
	function (attrs, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{cT: attrs});
	});
var $author$project$TT$Dropdown$withOnBlurMsg = F2(
	function (onBlurMsg, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{cX: onBlurMsg});
	});
var $author$project$TT$Dropdown$withSelectAttributes = F2(
	function (attrs, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{c9: attrs});
	});
var $author$project$TT$Dropdown$withTextFieldAttributes = F2(
	function (attrs, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{df: attrs});
	});
var $author$project$Model$commonDropdownConfig = function (inputText) {
	return function (promptElement) {
		return function (dropdownMsg) {
			return function (itemPickedMsg) {
				return function (onBlurMsg) {
					return function (itemToElement) {
						return function (selectionFromModel) {
							return function (inputType) {
								return function (emptyListElement) {
									return function (inputConfig) {
										return A2(
											$author$project$TT$Dropdown$withTextFieldAttributes,
											inputConfig,
											A2(
												$author$project$TT$Dropdown$withListAttributes,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(5),
														$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
														A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, 8),
														$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$gray4),
														$lucamug$elm_ui_with_context$Element$WithContext$Border$widthEach(
														{hb: 1, jf: 1, ku: 1, lz: 0}),
														$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
														$lucamug$elm_ui_with_context$Element$WithContext$height(
														A2($lucamug$elm_ui_with_context$Element$WithContext$maximum, 350, $lucamug$elm_ui_with_context$Element$WithContext$shrink)),
														$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
														$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
														$elm$html$Html$Attributes$class('elevation-1')),
														$lucamug$elm_ui_with_context$Element$WithContext$moveUp(8)
													]),
												A2(
													$author$project$TT$Dropdown$withSelectAttributes,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
															$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
															{hc: 5, hd: 5, lA: 0, lB: 0}),
															A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 8)
														]),
													A2(
														$author$project$TT$Dropdown$withOnBlurMsg,
														onBlurMsg,
														A2(
															$author$project$TT$Dropdown$withContainerAttributes,
															_List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
																]),
															$author$project$TT$Dropdown$basic(
																{
																	eJ: inputText,
																	eN: dropdownMsg,
																	eO: emptyListElement,
																	fb: inputType,
																	fj: itemToElement,
																	fk: function (optionType) {
																		if (!optionType.$) {
																			var _v1 = optionType.a;
																			var item = _v1.b;
																			return $lucamug$elm_ui_with_context$Element$WithContext$text(item);
																		} else {
																			var _v2 = optionType.a;
																			var item = _v2.b;
																			return $lucamug$elm_ui_with_context$Element$WithContext$text(item);
																		}
																	},
																	fo: $elm$core$Maybe$Just(15),
																	fy: itemPickedMsg,
																	fN: promptElement,
																	f4: selectionFromModel
																}))))));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $mdgriffith$elm_ui$Internal$Model$Unkeyed = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$AsEl = 2;
var $mdgriffith$elm_ui$Internal$Model$asEl = 2;
var $mdgriffith$elm_ui$Internal$Model$Generic = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$div = $mdgriffith$elm_ui$Internal$Model$Generic;
var $mdgriffith$elm_ui$Internal$Model$NoNearbyChildren = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$columnClass = $mdgriffith$elm_ui$Internal$Style$classes.gT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ay);
var $mdgriffith$elm_ui$Internal$Model$gridClass = $mdgriffith$elm_ui$Internal$Style$classes.gT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.iu);
var $mdgriffith$elm_ui$Internal$Model$pageClass = $mdgriffith$elm_ui$Internal$Style$classes.gT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fz);
var $mdgriffith$elm_ui$Internal$Model$paragraphClass = $mdgriffith$elm_ui$Internal$Style$classes.gT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fA);
var $mdgriffith$elm_ui$Internal$Model$rowClass = $mdgriffith$elm_ui$Internal$Style$classes.gT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.f_);
var $mdgriffith$elm_ui$Internal$Model$singleClass = $mdgriffith$elm_ui$Internal$Style$classes.gT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.kP);
var $mdgriffith$elm_ui$Internal$Model$contextClasses = function (context) {
	switch (context) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Model$rowClass;
		case 1:
			return $mdgriffith$elm_ui$Internal$Model$columnClass;
		case 2:
			return $mdgriffith$elm_ui$Internal$Model$singleClass;
		case 3:
			return $mdgriffith$elm_ui$Internal$Model$gridClass;
		case 4:
			return $mdgriffith$elm_ui$Internal$Model$paragraphClass;
		default:
			return $mdgriffith$elm_ui$Internal$Model$pageClass;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Keyed = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$NoStyleSheet = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$Styled = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Unstyled = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addChildren = F2(
	function (existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(behind, existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(existing, inFront);
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					behind,
					_Utils_ap(existing, inFront));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$addKeyedChildren = F3(
	function (key, existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(
					existing,
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						inFront));
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					_Utils_ap(
						existing,
						A2(
							$elm$core$List$map,
							function (x) {
								return _Utils_Tuple2(key, x);
							},
							inFront)));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$AsParagraph = 4;
var $mdgriffith$elm_ui$Internal$Model$asParagraph = 4;
var $mdgriffith$elm_ui$Internal$Flag$alignBottom = $mdgriffith$elm_ui$Internal$Flag$flag(41);
var $mdgriffith$elm_ui$Internal$Flag$alignRight = $mdgriffith$elm_ui$Internal$Flag$flag(40);
var $mdgriffith$elm_ui$Internal$Flag$centerX = $mdgriffith$elm_ui$Internal$Flag$flag(42);
var $mdgriffith$elm_ui$Internal$Flag$centerY = $mdgriffith$elm_ui$Internal$Flag$flag(43);
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $mdgriffith$elm_ui$Internal$Model$lengthClassName = function (x) {
	switch (x.$) {
		case 0:
			var px = x.a;
			return $elm$core$String$fromInt(px) + 'px';
		case 1:
			return 'auto';
		case 2:
			var i = x.a;
			return $elm$core$String$fromInt(i) + 'fr';
		case 3:
			var min = x.a;
			var len = x.b;
			return 'min' + ($elm$core$String$fromInt(min) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
		default:
			var max = x.a;
			var len = x.b;
			return 'max' + ($elm$core$String$fromInt(max) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
	}
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $mdgriffith$elm_ui$Internal$Model$transformClass = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'mv-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(x) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(y) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(z))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			return $elm$core$Maybe$Just(
				'tfrm-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ty) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ox) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oz) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(angle))))))))))))))))))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$getStyleName = function (style) {
	switch (style.$) {
		case 13:
			var name = style.a;
			return name;
		case 12:
			var name = style.a;
			var o = style.b;
			return name;
		case 0:
			var _class = style.a;
			return _class;
		case 1:
			var name = style.a;
			return name;
		case 2:
			var i = style.a;
			return 'font-size-' + $elm$core$String$fromInt(i);
		case 3:
			var _class = style.a;
			return _class;
		case 4:
			var _class = style.a;
			return _class;
		case 5:
			var cls = style.a;
			var x = style.b;
			var y = style.c;
			return cls;
		case 7:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 6:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 8:
			var template = style.a;
			return 'grid-rows-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.kw)) + ('-cols-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.cq)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.kV.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.kV.b)))))));
		case 9:
			var pos = style.a;
			return 'gp grid-pos-' + ($elm$core$String$fromInt(pos.f_) + ('-' + ($elm$core$String$fromInt(pos.eB) + ('-' + ($elm$core$String$fromInt(pos.a8) + ('-' + $elm$core$String$fromInt(pos.aR)))))));
		case 11:
			var selector = style.a;
			var subStyle = style.b;
			var name = function () {
				switch (selector) {
					case 0:
						return 'fs';
					case 1:
						return 'hv';
					default:
						return 'act';
				}
			}();
			return A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					function (sty) {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$getStyleName(sty);
						if (_v1 === '') {
							return '';
						} else {
							var styleName = _v1;
							return styleName + ('-' + name);
						}
					},
					subStyle));
		default:
			var x = style.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$mdgriffith$elm_ui$Internal$Model$transformClass(x));
	}
};
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $mdgriffith$elm_ui$Internal$Model$reduceStyles = F2(
	function (style, nevermind) {
		var cache = nevermind.a;
		var existing = nevermind.b;
		var styleName = $mdgriffith$elm_ui$Internal$Model$getStyleName(style);
		return A2($elm$core$Set$member, styleName, cache) ? nevermind : _Utils_Tuple2(
			A2($elm$core$Set$insert, styleName, cache),
			A2($elm$core$List$cons, style, existing));
	});
var $mdgriffith$elm_ui$Internal$Model$Property = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$Style = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$dot = function (c) {
	return '.' + c;
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $mdgriffith$elm_ui$Internal$Model$formatColor = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return 'rgba(' + ($elm$core$String$fromInt(
		$elm$core$Basics$round(red * 255)) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(green * 255))) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(blue * 255))) + (',' + ($elm$core$String$fromFloat(alpha) + ')')))));
};
var $mdgriffith$elm_ui$Internal$Model$formatBoxShadow = function (shadow) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					shadow.fc ? $elm$core$Maybe$Just('inset') : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.jE.a) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.jE.b) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.g5) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.kQ) + 'px'),
					$elm$core$Maybe$Just(
					$mdgriffith$elm_ui$Internal$Model$formatColor(shadow.hz))
				])));
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $mdgriffith$elm_ui$Internal$Model$renderFocusStyle = function (focus) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e$) + ':focus-within',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.g7),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.g$),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										g5: shadow.g5,
										hz: shadow.hz,
										fc: false,
										jE: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.jE)),
										kQ: shadow.kQ
									}));
						},
						focus.kK),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					]))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT) + ':focus .focusable, ') + (($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT) + '.focusable:focus, ') + ('.ui-slide-bar:focus + ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT) + ' .focusable-thumb'))),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.g7),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.g$),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										g5: shadow.g5,
										hz: shadow.hz,
										fc: false,
										jE: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.jE)),
										kQ: shadow.kQ
									}));
						},
						focus.kK),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					])))
		]);
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $mdgriffith$elm_ui$Internal$Style$AllChildren = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Batch = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Style$Child = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Class = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Descriptor = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Left = 3;
var $mdgriffith$elm_ui$Internal$Style$Prop = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Right = 2;
var $mdgriffith$elm_ui$Internal$Style$Self = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Supports = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Content = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Bottom = 1;
var $mdgriffith$elm_ui$Internal$Style$CenterX = 4;
var $mdgriffith$elm_ui$Internal$Style$CenterY = 5;
var $mdgriffith$elm_ui$Internal$Style$Top = 0;
var $mdgriffith$elm_ui$Internal$Style$alignments = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $mdgriffith$elm_ui$Internal$Style$contentName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hO);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ct);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cv);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bH);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cu);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.az);
	}
};
var $mdgriffith$elm_ui$Internal$Style$selfName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gN);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gG);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eo);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.en);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gH);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gI);
	}
};
var $mdgriffith$elm_ui$Internal$Style$describeAlignment = function (values) {
	var createDescription = function (alignment) {
		var _v0 = values(alignment);
		var content = _v0.a;
		var indiv = _v0.b;
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$contentName(alignment),
				content),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						indiv)
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$elDescription = _List_fromArray(
	[
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dI),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g2),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kG),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.h),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dM),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eg),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'auto !important')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dL),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dM),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eg),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gr),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ef),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
			])),
		$mdgriffith$elm_ui$Internal$Style$describeAlignment(
		function (alignment) {
			switch (alignment) {
				case 0:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
							]));
				case 1:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
							]));
				case 2:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
							]));
				case 3:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							]));
				case 4:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
							]));
				default:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
									]))
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
							]));
			}
		})
	]);
var $mdgriffith$elm_ui$Internal$Style$gridAlignments = function (values) {
	var createDescription = function (alignment) {
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						values(alignment))
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$Above = 0;
var $mdgriffith$elm_ui$Internal$Style$Behind = 5;
var $mdgriffith$elm_ui$Internal$Style$Below = 1;
var $mdgriffith$elm_ui$Internal$Style$OnLeft = 3;
var $mdgriffith$elm_ui$Internal$Style$OnRight = 2;
var $mdgriffith$elm_ui$Internal$Style$Within = 4;
var $mdgriffith$elm_ui$Internal$Style$locations = function () {
	var loc = 0;
	var _v0 = function () {
		switch (loc) {
			case 0:
				return 0;
			case 1:
				return 0;
			case 2:
				return 0;
			case 3:
				return 0;
			case 4:
				return 0;
			default:
				return 0;
		}
	}();
	return _List_fromArray(
		[0, 1, 2, 3, 4, 5]);
}();
var $mdgriffith$elm_ui$Internal$Style$baseSheet = _List_fromArray(
	[
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		'html,body',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		_Utils_ap(
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT),
			_Utils_ap(
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kP),
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iK))),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dM),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-height', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eg),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT) + ':focus',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'outline', 'none')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kv),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'min-height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dM)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dM),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iM),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bp),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bp),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kP),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				$mdgriffith$elm_ui$Internal$Style$Batch(
				function (fn) {
					return A2($elm$core$List$map, fn, $mdgriffith$elm_ui$Internal$Style$locations);
				}(
					function (loc) {
						switch (loc) {
							case 0:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gx),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dM),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eg),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
												])),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 1:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g3),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dM),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												]))
										]));
							case 2:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jJ),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 3:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jH),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'right', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 4:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iM),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							default:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g2),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
						}
					}))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'resize', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'box-sizing', 'border-box'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-size', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-family', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'inherit'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ei),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-wrap', 'wrap')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fv),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-moz-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-webkit-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-ms-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'user-select', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hX),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'pointer')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hY),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jS),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cm),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.a4),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aZ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.iG, $mdgriffith$elm_ui$Internal$Style$classes.a4)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.iG, $mdgriffith$elm_ui$Internal$Style$classes.aZ)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.ii, $mdgriffith$elm_ui$Internal$Style$classes.a4)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.ii, $mdgriffith$elm_ui$Internal$Style$classes.aZ)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.gy, $mdgriffith$elm_ui$Internal$Style$classes.a4)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.gy, $mdgriffith$elm_ui$Internal$Style$classes.aZ)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lG),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Prop,
						'transition',
						A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								function (x) {
									return x + ' 160ms';
								},
								_List_fromArray(
									['transform', 'opacity', 'filter', 'background-color', 'color', 'font-size']))))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kD),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kE),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f_),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kF),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ay),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kP),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hu),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hv),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hw),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ef),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', 'auto')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ci),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g8),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dashed')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g9),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dotted')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ha),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.h),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iU),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1.05'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background', 'transparent'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'inherit')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kP),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f_),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', '0%'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gq),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fp),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dM),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e5),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eg),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cr),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.gM,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.gK,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gH),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-left', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.gK,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gH),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-right', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.gK,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gI),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.gK + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.gM + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.gK)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_Nil);
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_Nil);
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kU),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cN),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'baseline')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ay),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', '0px'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'min-height', 'min-content'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e4),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dM),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eg),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gr),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ef),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.gJ,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.gL,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gI),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.gL,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gI),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.gL,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gI),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.gL + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.gJ + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.gL)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cr),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kU),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iu),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', '-ms-grid'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'.gp',
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Supports,
						_Utils_Tuple2('display', 'grid'),
						_List_fromArray(
							[
								_Utils_Tuple2('display', 'grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$gridAlignments(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
										]);
								case 1:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
										]);
								case 2:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
										]);
								case 3:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
										]);
								case 4:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
										]);
								default:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
										]);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fz),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT + ':first-child'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.gT + ($mdgriffith$elm_ui$Internal$Style$selfName(3) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.gT))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.gT + ($mdgriffith$elm_ui$Internal$Style$selfName(2) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.gT))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\"\"'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\"\"'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iQ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background-color', 'transparent')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iT),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kP),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iS),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iR),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'transparent')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fA),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-wrap', 'break-word'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dI),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g2),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.h),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fA),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::after',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::before',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kP),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gq),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iM),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g2),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gx),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g3),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jJ),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jH),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.h),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f_),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ay),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-flex')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iu),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left')
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.hidden',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lm),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '100')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ld),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '200')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lh),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '300')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lj),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '400')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.li),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '500')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ll),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '600')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g6),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '700')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lc),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '800')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.le),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '900')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jc),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'italic')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.k0),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aa),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aa),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.k0)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ln),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'normal')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lf),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dg),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify-all')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lb),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'center')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lk),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'right')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lg),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'left')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.modal',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none')
					]))
			]))
	]);
var $mdgriffith$elm_ui$Internal$Style$fontVariant = function (_var) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + _var,
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\"' + (_var + '\"'))
				])),
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + (_var + '-off'),
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\"' + (_var + '\" 0'))
				]))
		]);
};
var $mdgriffith$elm_ui$Internal$Style$commonValues = $elm$core$List$concat(
	_List_fromArray(
		[
			A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.border-' + $elm$core$String$fromInt(x),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'border-width',
							$elm$core$String$fromInt(x) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 6)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 8, 32)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.p-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'padding',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 24)),
			_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'small-caps')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp-off',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'normal')
					]))
			]),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('zero'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('onum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('liga'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('dlig'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('ordn'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('tnum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('afrc'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('frac')
		]));
var $mdgriffith$elm_ui$Internal$Style$explainer = '\n.explain {\n    border: 6px solid rgb(174, 121, 15) !important;\n}\n.explain > .' + ($mdgriffith$elm_ui$Internal$Style$classes.gT + (' {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n.ctr {\n    border: none !important;\n}\n.explain > .ctr > .' + ($mdgriffith$elm_ui$Internal$Style$classes.gT + ' {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n')));
var $mdgriffith$elm_ui$Internal$Style$inputTextReset = '\ninput[type="search"],\ninput[type="search"]::-webkit-search-decoration,\ninput[type="search"]::-webkit-search-cancel-button,\ninput[type="search"]::-webkit-search-results-button,\ninput[type="search"]::-webkit-search-results-decoration {\n  -webkit-appearance:none;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$sliderReset = '\ninput[type=range] {\n  -webkit-appearance: none; \n  background: transparent;\n  position:absolute;\n  left:0;\n  top:0;\n  z-index:10;\n  width: 100%;\n  outline: dashed 1px;\n  height: 100%;\n  opacity: 0;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$thumbReset = '\ninput[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-moz-range-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-ms-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range][orient=vertical]{\n    writing-mode: bt-lr; /* IE */\n    -webkit-appearance: slider-vertical;  /* WebKit */\n}\n';
var $mdgriffith$elm_ui$Internal$Style$trackReset = '\ninput[type=range]::-moz-range-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-ms-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-webkit-slider-runnable-track {\n    background: transparent;\n    cursor: pointer;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$overrides = '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f_) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT) + (' { flex-basis: auto !important; } ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f_) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cr) + (' { flex-basis: auto !important; }}' + ($mdgriffith$elm_ui$Internal$Style$inputTextReset + ($mdgriffith$elm_ui$Internal$Style$sliderReset + ($mdgriffith$elm_ui$Internal$Style$trackReset + ($mdgriffith$elm_ui$Internal$Style$thumbReset + $mdgriffith$elm_ui$Internal$Style$explainer)))))))))))))));
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $mdgriffith$elm_ui$Internal$Style$Intermediate = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$emptyIntermediate = F2(
	function (selector, closing) {
		return {cp: closing, E: _List_Nil, aH: _List_Nil, ai: selector};
	});
var $mdgriffith$elm_ui$Internal$Style$renderRules = F2(
	function (_v0, rulesToRender) {
		var parent = _v0;
		var generateIntermediates = F2(
			function (rule, rendered) {
				switch (rule.$) {
					case 0:
						var name = rule.a;
						var val = rule.b;
						return _Utils_update(
							rendered,
							{
								aH: A2(
									$elm$core$List$cons,
									_Utils_Tuple2(name, val),
									rendered.aH)
							});
					case 3:
						var _v2 = rule.a;
						var prop = _v2.a;
						var value = _v2.b;
						var props = rule.b;
						return _Utils_update(
							rendered,
							{
								E: A2(
									$elm$core$List$cons,
									{cp: '\n}', E: _List_Nil, aH: props, ai: '@supports (' + (prop + (':' + (value + (') {' + parent.ai))))},
									rendered.E)
							});
					case 5:
						var selector = rule.a;
						var adjRules = rule.b;
						return _Utils_update(
							rendered,
							{
								E: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.ai + (' + ' + selector), ''),
										adjRules),
									rendered.E)
							});
					case 1:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								E: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.ai + (' > ' + child), ''),
										childRules),
									rendered.E)
							});
					case 2:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								E: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.ai + (' ' + child), ''),
										childRules),
									rendered.E)
							});
					case 4:
						var descriptor = rule.a;
						var descriptorRules = rule.b;
						return _Utils_update(
							rendered,
							{
								E: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2(
											$mdgriffith$elm_ui$Internal$Style$emptyIntermediate,
											_Utils_ap(parent.ai, descriptor),
											''),
										descriptorRules),
									rendered.E)
							});
					default:
						var batched = rule.a;
						return _Utils_update(
							rendered,
							{
								E: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.ai, ''),
										batched),
									rendered.E)
							});
				}
			});
		return A3($elm$core$List$foldr, generateIntermediates, parent, rulesToRender);
	});
var $mdgriffith$elm_ui$Internal$Style$renderCompact = function (styleClasses) {
	var renderValues = function (values) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				function (_v3) {
					var x = _v3.a;
					var y = _v3.b;
					return x + (':' + (y + ';'));
				},
				values));
	};
	var renderClass = function (rule) {
		var _v2 = rule.aH;
		if (!_v2.b) {
			return '';
		} else {
			return rule.ai + ('{' + (renderValues(rule.aH) + (rule.cp + '}')));
		}
	};
	var renderIntermediate = function (_v0) {
		var rule = _v0;
		return _Utils_ap(
			renderClass(rule),
			$elm$core$String$concat(
				A2($elm$core$List$map, renderIntermediate, rule.E)));
	};
	return $elm$core$String$concat(
		A2(
			$elm$core$List$map,
			renderIntermediate,
			A3(
				$elm$core$List$foldr,
				F2(
					function (_v1, existing) {
						var name = _v1.a;
						var styleRules = _v1.b;
						return A2(
							$elm$core$List$cons,
							A2(
								$mdgriffith$elm_ui$Internal$Style$renderRules,
								A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, name, ''),
								styleRules),
							existing);
					}),
				_List_Nil,
				styleClasses)));
};
var $mdgriffith$elm_ui$Internal$Style$rules = _Utils_ap(
	$mdgriffith$elm_ui$Internal$Style$overrides,
	$mdgriffith$elm_ui$Internal$Style$renderCompact(
		_Utils_ap($mdgriffith$elm_ui$Internal$Style$baseSheet, $mdgriffith$elm_ui$Internal$Style$commonValues)));
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $mdgriffith$elm_ui$Internal$Model$staticRoot = function (opts) {
	var _v0 = opts.ju;
	switch (_v0) {
		case 0:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'div',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$elm$virtual_dom$VirtualDom$node,
						'style',
						_List_Nil,
						_List_fromArray(
							[
								$elm$virtual_dom$VirtualDom$text($mdgriffith$elm_ui$Internal$Style$rules)
							]))
					]));
		case 1:
			return $elm$virtual_dom$VirtualDom$text('');
		default:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'elm-ui-static-rules',
				_List_fromArray(
					[
						A2(
						$elm$virtual_dom$VirtualDom$property,
						'rules',
						$elm$json$Json$Encode$string($mdgriffith$elm_ui$Internal$Style$rules))
					]),
				_List_Nil);
	}
};
var $mdgriffith$elm_ui$Internal$Model$fontName = function (font) {
	switch (font.$) {
		case 0:
			return 'serif';
		case 1:
			return 'sans-serif';
		case 2:
			return 'monospace';
		case 3:
			var name = font.a;
			return '\"' + (name + '\"');
		case 4:
			var name = font.a;
			var url = font.b;
			return '\"' + (name + '\"');
		default:
			var name = font.a.at;
			return '\"' + (name + '\"');
	}
};
var $mdgriffith$elm_ui$Internal$Model$isSmallCaps = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return name === 'smcp';
		case 1:
			var name = _var.a;
			return false;
		default:
			var name = _var.a;
			var index = _var.b;
			return (name === 'smcp') && (index === 1);
	}
};
var $mdgriffith$elm_ui$Internal$Model$hasSmallCaps = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$isSmallCaps, font.gj);
	} else {
		return false;
	}
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $mdgriffith$elm_ui$Internal$Model$renderProps = F3(
	function (force, _v0, existing) {
		var key = _v0.a;
		var val = _v0.b;
		return force ? (existing + ('\n  ' + (key + (': ' + (val + ' !important;'))))) : (existing + ('\n  ' + (key + (': ' + (val + ';')))));
	});
var $mdgriffith$elm_ui$Internal$Model$renderStyle = F4(
	function (options, maybePseudo, selector, props) {
		if (maybePseudo.$ === 1) {
			return _List_fromArray(
				[
					selector + ('{' + (A3(
					$elm$core$List$foldl,
					$mdgriffith$elm_ui$Internal$Model$renderProps(false),
					'',
					props) + '\n}'))
				]);
		} else {
			var pseudo = maybePseudo.a;
			switch (pseudo) {
				case 1:
					var _v2 = options.iG;
					switch (_v2) {
						case 0:
							return _List_Nil;
						case 2:
							return _List_fromArray(
								[
									selector + ('-hv {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(true),
									'',
									props) + '\n}'))
								]);
						default:
							return _List_fromArray(
								[
									selector + ('-hv:hover {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(false),
									'',
									props) + '\n}'))
								]);
					}
				case 0:
					var renderedProps = A3(
						$elm$core$List$foldl,
						$mdgriffith$elm_ui$Internal$Model$renderProps(false),
						'',
						props);
					return _List_fromArray(
						[
							selector + ('-fs:focus {' + (renderedProps + '\n}')),
							('.' + ($mdgriffith$elm_ui$Internal$Style$classes.gT + (':focus ' + (selector + '-fs  {')))) + (renderedProps + '\n}'),
							(selector + '-fs:focus-within {') + (renderedProps + '\n}'),
							('.ui-slide-bar:focus + ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT) + (' .focusable-thumb' + (selector + '-fs {')))) + (renderedProps + '\n}')
						]);
				default:
					return _List_fromArray(
						[
							selector + ('-act:active {' + (A3(
							$elm$core$List$foldl,
							$mdgriffith$elm_ui$Internal$Model$renderProps(false),
							'',
							props) + '\n}'))
						]);
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderVariant = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return '\"' + (name + '\"');
		case 1:
			var name = _var.a;
			return '\"' + (name + '\" 0');
		default:
			var name = _var.a;
			var index = _var.b;
			return '\"' + (name + ('\" ' + $elm$core$String$fromInt(index)));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderVariants = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$renderVariant, font.gj)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$transformValue = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'translate3d(' + ($elm$core$String$fromFloat(x) + ('px, ' + ($elm$core$String$fromFloat(y) + ('px, ' + ($elm$core$String$fromFloat(z) + 'px)'))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			var translate = 'translate3d(' + ($elm$core$String$fromFloat(tx) + ('px, ' + ($elm$core$String$fromFloat(ty) + ('px, ' + ($elm$core$String$fromFloat(tz) + 'px)')))));
			var scale = 'scale3d(' + ($elm$core$String$fromFloat(sx) + (', ' + ($elm$core$String$fromFloat(sy) + (', ' + ($elm$core$String$fromFloat(sz) + ')')))));
			var rotate = 'rotate3d(' + ($elm$core$String$fromFloat(ox) + (', ' + ($elm$core$String$fromFloat(oy) + (', ' + ($elm$core$String$fromFloat(oz) + (', ' + ($elm$core$String$fromFloat(angle) + 'rad)')))))));
			return $elm$core$Maybe$Just(translate + (' ' + (scale + (' ' + rotate))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderStyleRule = F3(
	function (options, rule, maybePseudo) {
		switch (rule.$) {
			case 0:
				var selector = rule.a;
				var props = rule.b;
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, selector, props);
			case 13:
				var name = rule.a;
				var prop = rule.b;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, 'box-shadow', prop)
						]));
			case 12:
				var name = rule.a;
				var transparency = rule.b;
				var opacity = A2(
					$elm$core$Basics$max,
					0,
					A2($elm$core$Basics$min, 1, 1 - transparency));
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'opacity',
							$elm$core$String$fromFloat(opacity))
						]));
			case 2:
				var i = rule.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			case 1:
				var name = rule.a;
				var typefaces = rule.b;
				var features = A2(
					$elm$core$String$join,
					', ',
					A2($elm$core$List$filterMap, $mdgriffith$elm_ui$Internal$Model$renderVariants, typefaces));
				var families = _List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-family',
						A2(
							$elm$core$String$join,
							', ',
							A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$fontName, typefaces))),
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'font-feature-settings', features),
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-variant',
						A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$hasSmallCaps, typefaces) ? 'small-caps' : 'normal')
					]);
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, '.' + name, families);
			case 3:
				var _class = rule.a;
				var prop = rule.b;
				var val = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, prop, val)
						]));
			case 4:
				var _class = rule.a;
				var prop = rule.b;
				var color = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							prop,
							$mdgriffith$elm_ui$Internal$Model$formatColor(color))
						]));
			case 5:
				var cls = rule.a;
				var x = rule.b;
				var y = rule.c;
				var yPx = $elm$core$String$fromInt(y) + 'px';
				var xPx = $elm$core$String$fromInt(x) + 'px';
				var single = '.' + $mdgriffith$elm_ui$Internal$Style$classes.kP;
				var row = '.' + $mdgriffith$elm_ui$Internal$Style$classes.f_;
				var wrappedRow = '.' + ($mdgriffith$elm_ui$Internal$Style$classes.ei + row);
				var right = '.' + $mdgriffith$elm_ui$Internal$Style$classes.eo;
				var paragraph = '.' + $mdgriffith$elm_ui$Internal$Style$classes.fA;
				var page = '.' + $mdgriffith$elm_ui$Internal$Style$classes.fz;
				var left = '.' + $mdgriffith$elm_ui$Internal$Style$classes.en;
				var halfY = $elm$core$String$fromFloat(y / 2) + 'px';
				var halfX = $elm$core$String$fromFloat(x / 2) + 'px';
				var column = '.' + $mdgriffith$elm_ui$Internal$Style$classes.ay;
				var _class = '.' + cls;
				var any = '.' + $mdgriffith$elm_ui$Internal$Style$classes.gT;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (row + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (wrappedRow + (' > ' + any)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin', halfY + (' ' + halfX))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (column + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_Utils_ap(_class, paragraph),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							'textarea' + (any + _class),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)')),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'height',
									'calc(100% + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::after'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\'\''),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-top',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::before'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\'\''),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-bottom',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								]))
						]));
			case 7:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'padding',
							$elm$core$String$fromFloat(top) + ('px ' + ($elm$core$String$fromFloat(right) + ('px ' + ($elm$core$String$fromFloat(bottom) + ('px ' + ($elm$core$String$fromFloat(left) + 'px')))))))
						]));
			case 6:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'border-width',
							$elm$core$String$fromInt(top) + ('px ' + ($elm$core$String$fromInt(right) + ('px ' + ($elm$core$String$fromInt(bottom) + ('px ' + ($elm$core$String$fromInt(left) + 'px')))))))
						]));
			case 8:
				var template = rule.a;
				var toGridLengthHelper = F3(
					function (minimum, maximum, x) {
						toGridLengthHelper:
						while (true) {
							switch (x.$) {
								case 0:
									var px = x.a;
									return $elm$core$String$fromInt(px) + 'px';
								case 1:
									var _v2 = _Utils_Tuple2(minimum, maximum);
									if (_v2.a.$ === 1) {
										if (_v2.b.$ === 1) {
											var _v3 = _v2.a;
											var _v4 = _v2.b;
											return 'max-content';
										} else {
											var _v6 = _v2.a;
											var maxSize = _v2.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v2.b.$ === 1) {
											var minSize = _v2.a.a;
											var _v5 = _v2.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + 'max-content)'));
										} else {
											var minSize = _v2.a.a;
											var maxSize = _v2.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 2:
									var i = x.a;
									var _v7 = _Utils_Tuple2(minimum, maximum);
									if (_v7.a.$ === 1) {
										if (_v7.b.$ === 1) {
											var _v8 = _v7.a;
											var _v9 = _v7.b;
											return $elm$core$String$fromInt(i) + 'fr';
										} else {
											var _v11 = _v7.a;
											var maxSize = _v7.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v7.b.$ === 1) {
											var minSize = _v7.a.a;
											var _v10 = _v7.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(i) + ('fr' + 'fr)'))));
										} else {
											var minSize = _v7.a.a;
											var maxSize = _v7.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 3:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = $elm$core$Maybe$Just(m),
										$temp$maximum = maximum,
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
								default:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = minimum,
										$temp$maximum = $elm$core$Maybe$Just(m),
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
							}
						}
					});
				var toGridLength = function (x) {
					return A3(toGridLengthHelper, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, x);
				};
				var xSpacing = toGridLength(template.kV.a);
				var ySpacing = toGridLength(template.kV.b);
				var rows = function (x) {
					return 'grid-template-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.kw)));
				var msRows = function (x) {
					return '-ms-grid-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.cq)));
				var msColumns = function (x) {
					return '-ms-grid-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.cq)));
				var gapY = 'grid-row-gap:' + (toGridLength(template.kV.b) + ';');
				var gapX = 'grid-column-gap:' + (toGridLength(template.kV.a) + ';');
				var columns = function (x) {
					return 'grid-template-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.cq)));
				var _class = '.grid-rows-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.kw)) + ('-cols-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.cq)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.kV.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.kV.b)))))));
				var modernGrid = _class + ('{' + (columns + (rows + (gapX + (gapY + '}')))));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msColumns + (msRows + '}')));
				return _List_fromArray(
					[base, supports]);
			case 9:
				var position = rule.a;
				var msPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'-ms-grid-row: ' + ($elm$core$String$fromInt(position.f_) + ';'),
							'-ms-grid-row-span: ' + ($elm$core$String$fromInt(position.aR) + ';'),
							'-ms-grid-column: ' + ($elm$core$String$fromInt(position.eB) + ';'),
							'-ms-grid-column-span: ' + ($elm$core$String$fromInt(position.a8) + ';')
						]));
				var modernPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'grid-row: ' + ($elm$core$String$fromInt(position.f_) + (' / ' + ($elm$core$String$fromInt(position.f_ + position.aR) + ';'))),
							'grid-column: ' + ($elm$core$String$fromInt(position.eB) + (' / ' + ($elm$core$String$fromInt(position.eB + position.a8) + ';')))
						]));
				var _class = '.grid-pos-' + ($elm$core$String$fromInt(position.f_) + ('-' + ($elm$core$String$fromInt(position.eB) + ('-' + ($elm$core$String$fromInt(position.a8) + ('-' + $elm$core$String$fromInt(position.aR)))))));
				var modernGrid = _class + ('{' + (modernPosition + '}'));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msPosition + '}'));
				return _List_fromArray(
					[base, supports]);
			case 11:
				var _class = rule.a;
				var styles = rule.b;
				var renderPseudoRule = function (style) {
					return A3(
						$mdgriffith$elm_ui$Internal$Model$renderStyleRule,
						options,
						style,
						$elm$core$Maybe$Just(_class));
				};
				return A2($elm$core$List$concatMap, renderPseudoRule, styles);
			default:
				var transform = rule.a;
				var val = $mdgriffith$elm_ui$Internal$Model$transformValue(transform);
				var _class = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				var _v12 = _Utils_Tuple2(_class, val);
				if ((!_v12.a.$) && (!_v12.b.$)) {
					var cls = _v12.a.a;
					var v = _v12.b.a;
					return A4(
						$mdgriffith$elm_ui$Internal$Model$renderStyle,
						options,
						maybePseudo,
						'.' + cls,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Model$Property, 'transform', v)
							]));
				} else {
					return _List_Nil;
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$encodeStyles = F2(
	function (options, stylesheet) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$map,
				function (style) {
					var styled = A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing);
					return _Utils_Tuple2(
						$mdgriffith$elm_ui$Internal$Model$getStyleName(style),
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, styled));
				},
				stylesheet));
	});
var $mdgriffith$elm_ui$Internal$Model$bracket = F2(
	function (selector, rules) {
		var renderPair = function (_v0) {
			var name = _v0.a;
			var val = _v0.b;
			return name + (': ' + (val + ';'));
		};
		return selector + (' {' + (A2(
			$elm$core$String$join,
			'',
			A2($elm$core$List$map, renderPair, rules)) + '}'));
	});
var $mdgriffith$elm_ui$Internal$Model$fontRule = F3(
	function (name, modifier, _v0) {
		var parentAdj = _v0.a;
		var textAdjustment = _v0.b;
		return _List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + (', ' + ('.' + (name + (' .' + modifier))))))), parentAdj),
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.h + (', .' + (name + (' .' + (modifier + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.h)))))))))), textAdjustment)
			]);
	});
var $mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule = F3(
	function (fontToAdjust, _v0, otherFontName) {
		var full = _v0.a;
		var capital = _v0.b;
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_Utils_ap(
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.kR, capital),
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.io, full)));
	});
var $mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule = F2(
	function (fontToAdjust, otherFontName) {
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.kR + (', ' + ('.' + (name + (' .' + $mdgriffith$elm_ui$Internal$Style$classes.kR))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('line-height', '1')
						])),
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.kR + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.h + (', .' + (name + (' .' + ($mdgriffith$elm_ui$Internal$Style$classes.kR + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.h)))))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('vertical-align', '0'),
							_Utils_Tuple2('line-height', '1')
						]))
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$adjust = F3(
	function (size, height, vertical) {
		return {aR: height / size, kQ: size, gm: vertical};
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$convertAdjustment = function (adjustment) {
	var lines = _List_fromArray(
		[adjustment.ho, adjustment.g1, adjustment.h2, adjustment.jo]);
	var lineHeight = 1.5;
	var normalDescender = (lineHeight - 1) / 2;
	var oldMiddle = lineHeight / 2;
	var descender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.h2,
		$elm$core$List$minimum(lines));
	var newBaseline = A2(
		$elm$core$Maybe$withDefault,
		adjustment.g1,
		$elm$core$List$minimum(
			A2(
				$elm$core$List$filter,
				function (x) {
					return !_Utils_eq(x, descender);
				},
				lines)));
	var base = lineHeight;
	var ascender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.ho,
		$elm$core$List$maximum(lines));
	var capitalSize = 1 / (ascender - newBaseline);
	var capitalVertical = 1 - ascender;
	var fullSize = 1 / (ascender - descender);
	var fullVertical = 1 - ascender;
	var newCapitalMiddle = ((ascender - newBaseline) / 2) + newBaseline;
	var newFullMiddle = ((ascender - descender) / 2) + descender;
	return {
		ho: A3($mdgriffith$elm_ui$Internal$Model$adjust, capitalSize, ascender - newBaseline, capitalVertical),
		e1: A3($mdgriffith$elm_ui$Internal$Model$adjust, fullSize, ascender - descender, fullVertical)
	};
};
var $mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules = function (converted) {
	return _Utils_Tuple2(
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'block')
			]),
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'inline-block'),
				_Utils_Tuple2(
				'line-height',
				$elm$core$String$fromFloat(converted.aR)),
				_Utils_Tuple2(
				'vertical-align',
				$elm$core$String$fromFloat(converted.gm) + 'em'),
				_Utils_Tuple2(
				'font-size',
				$elm$core$String$fromFloat(converted.kQ) + 'em')
			]));
};
var $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment = function (typefaces) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (face, found) {
				if (found.$ === 1) {
					if (face.$ === 5) {
						var _with = face.a;
						var _v2 = _with.gE;
						if (_v2.$ === 1) {
							return found;
						} else {
							var adjustment = _v2.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.e1;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment))),
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.ho;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment)))));
						}
					} else {
						return found;
					}
				} else {
					return found;
				}
			}),
		$elm$core$Maybe$Nothing,
		typefaces);
};
var $mdgriffith$elm_ui$Internal$Model$renderTopLevelValues = function (rules) {
	var withImport = function (font) {
		if (font.$ === 4) {
			var url = font.b;
			return $elm$core$Maybe$Just('@import url(\'' + (url + '\');'));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var fontImports = function (_v2) {
		var name = _v2.a;
		var typefaces = _v2.b;
		var imports = A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$filterMap, withImport, typefaces));
		return imports;
	};
	var allNames = A2($elm$core$List$map, $elm$core$Tuple$first, rules);
	var fontAdjustments = function (_v1) {
		var name = _v1.a;
		var typefaces = _v1.b;
		var _v0 = $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment(typefaces);
		if (_v0.$ === 1) {
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					$mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule(name),
					allNames));
		} else {
			var adjustment = _v0.a;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					A2($mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule, name, adjustment),
					allNames));
		}
	};
	return _Utils_ap(
		A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$map, fontImports, rules)),
		A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$map, fontAdjustments, rules)));
};
var $mdgriffith$elm_ui$Internal$Model$topLevelValue = function (rule) {
	if (rule.$ === 1) {
		var name = rule.a;
		var typefaces = rule.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(name, typefaces));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$toStyleSheetString = F2(
	function (options, stylesheet) {
		var combine = F2(
			function (style, rendered) {
				return {
					c6: _Utils_ap(
						rendered.c6,
						A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing)),
					cc: function () {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$topLevelValue(style);
						if (_v1.$ === 1) {
							return rendered.cc;
						} else {
							var topLevel = _v1.a;
							return A2($elm$core$List$cons, topLevel, rendered.cc);
						}
					}()
				};
			});
		var _v0 = A3(
			$elm$core$List$foldl,
			combine,
			{c6: _List_Nil, cc: _List_Nil},
			stylesheet);
		var topLevel = _v0.cc;
		var rules = _v0.c6;
		return _Utils_ap(
			$mdgriffith$elm_ui$Internal$Model$renderTopLevelValues(topLevel),
			$elm$core$String$concat(rules));
	});
var $mdgriffith$elm_ui$Internal$Model$toStyleSheet = F2(
	function (options, styleSheet) {
		var _v0 = options.ju;
		switch (_v0) {
			case 0:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			case 1:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			default:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'elm-ui-rules',
					_List_fromArray(
						[
							A2(
							$elm$virtual_dom$VirtualDom$property,
							'rules',
							A2($mdgriffith$elm_ui$Internal$Model$encodeStyles, options, styleSheet))
						]),
					_List_Nil);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$embedKeyed = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.ii)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'static-stylesheet',
				$mdgriffith$elm_ui$Internal$Model$staticRoot(opts)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
				children)) : A2(
			$elm$core$List$cons,
			_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
			children);
	});
var $mdgriffith$elm_ui$Internal$Model$embedWith = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.ii)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			$mdgriffith$elm_ui$Internal$Model$staticRoot(opts),
			A2($elm$core$List$cons, dynamicStyleSheet, children)) : A2($elm$core$List$cons, dynamicStyleSheet, children);
	});
var $mdgriffith$elm_ui$Internal$Flag$heightBetween = $mdgriffith$elm_ui$Internal$Flag$flag(45);
var $mdgriffith$elm_ui$Internal$Flag$heightFill = $mdgriffith$elm_ui$Internal$Flag$flag(37);
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $mdgriffith$elm_ui$Internal$Flag$present = F2(
	function (myFlag, _v0) {
		var fieldOne = _v0.a;
		var fieldTwo = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return _Utils_eq(first & fieldOne, first);
		} else {
			var second = myFlag.a;
			return _Utils_eq(second & fieldTwo, second);
		}
	});
var $elm$html$Html$s = _VirtualDom_node('s');
var $elm$html$Html$u = _VirtualDom_node('u');
var $mdgriffith$elm_ui$Internal$Flag$widthBetween = $mdgriffith$elm_ui$Internal$Flag$flag(44);
var $mdgriffith$elm_ui$Internal$Flag$widthFill = $mdgriffith$elm_ui$Internal$Flag$flag(39);
var $mdgriffith$elm_ui$Internal$Model$finalizeNode = F6(
	function (has, node, attributes, children, embedMode, parentContext) {
		var createNode = F2(
			function (nodeName, attrs) {
				if (children.$ === 1) {
					var keyed = children.a;
					return A3(
						$elm$virtual_dom$VirtualDom$keyedNode,
						nodeName,
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return keyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, false, opts, styles, keyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, true, opts, styles, keyed);
							}
						}());
				} else {
					var unkeyed = children.a;
					return A2(
						function () {
							switch (nodeName) {
								case 'div':
									return $elm$html$Html$div;
								case 'p':
									return $elm$html$Html$p;
								default:
									return $elm$virtual_dom$VirtualDom$node(nodeName);
							}
						}(),
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return unkeyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, false, opts, styles, unkeyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, true, opts, styles, unkeyed);
							}
						}());
				}
			});
		var html = function () {
			switch (node.$) {
				case 0:
					return A2(createNode, 'div', attributes);
				case 1:
					var nodeName = node.a;
					return A2(createNode, nodeName, attributes);
				default:
					var nodeName = node.a;
					var internal = node.b;
					return A3(
						$elm$virtual_dom$VirtualDom$node,
						nodeName,
						attributes,
						_List_fromArray(
							[
								A2(
								createNode,
								internal,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Style$classes.gT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.kP))
									]))
							]));
			}
		}();
		switch (parentContext) {
			case 0:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignRight, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.gT, $mdgriffith$elm_ui$Internal$Style$classes.kP, $mdgriffith$elm_ui$Internal$Style$classes.cr, $mdgriffith$elm_ui$Internal$Style$classes.az, $mdgriffith$elm_ui$Internal$Style$classes.gM])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerX, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.gT, $mdgriffith$elm_ui$Internal$Style$classes.kP, $mdgriffith$elm_ui$Internal$Style$classes.cr, $mdgriffith$elm_ui$Internal$Style$classes.az, $mdgriffith$elm_ui$Internal$Style$classes.gK])))
						]),
					_List_fromArray(
						[html])) : html));
			case 1:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerY, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.gT, $mdgriffith$elm_ui$Internal$Style$classes.kP, $mdgriffith$elm_ui$Internal$Style$classes.cr, $mdgriffith$elm_ui$Internal$Style$classes.gL])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignBottom, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.gT, $mdgriffith$elm_ui$Internal$Style$classes.kP, $mdgriffith$elm_ui$Internal$Style$classes.cr, $mdgriffith$elm_ui$Internal$Style$classes.gJ])))
						]),
					_List_fromArray(
						[html])) : html));
			default:
				return html;
		}
	});
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $mdgriffith$elm_ui$Internal$Model$textElementClasses = $mdgriffith$elm_ui$Internal$Style$classes.gT + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.h + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.ef + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dL)))));
var $mdgriffith$elm_ui$Internal$Model$textElement = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$textElementFillClasses = $mdgriffith$elm_ui$Internal$Style$classes.gT + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.h + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.eg + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dM)))));
var $mdgriffith$elm_ui$Internal$Model$textElementFill = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementFillClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$createElement = F3(
	function (context, children, rendered) {
		var gatherKeyed = F2(
			function (_v8, _v9) {
				var key = _v8.a;
				var child = _v8.b;
				var htmls = _v9.a;
				var existingStyles = _v9.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.iH, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.k1 : _Utils_ap(styled.k1, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.iH, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.k1 : _Utils_ap(styled.k1, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str)),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		var gather = F2(
			function (child, _v6) {
				var htmls = _v6.a;
				var existingStyles = _v6.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.iH, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.k1 : _Utils_ap(styled.k1, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.iH, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.k1 : _Utils_ap(styled.k1, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		if (children.$ === 1) {
			var keyedChildren = children.a;
			var _v1 = A3(
				$elm$core$List$foldr,
				gatherKeyed,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				keyedChildren);
			var keyed = _v1.a;
			var styles = _v1.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.k1 : _Utils_ap(rendered.k1, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered.aQ,
						rendered.aY,
						rendered.aL,
						$mdgriffith$elm_ui$Internal$Model$Keyed(
							A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.aM)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						iH: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered.aQ,
							rendered.aY,
							rendered.aL,
							$mdgriffith$elm_ui$Internal$Model$Keyed(
								A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.aM))),
						k1: allStyles
					});
			}
		} else {
			var unkeyedChildren = children.a;
			var _v3 = A3(
				$elm$core$List$foldr,
				gather,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				unkeyedChildren);
			var unkeyed = _v3.a;
			var styles = _v3.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.k1 : _Utils_ap(rendered.k1, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered.aQ,
						rendered.aY,
						rendered.aL,
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.aM)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						iH: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered.aQ,
							rendered.aY,
							rendered.aL,
							$mdgriffith$elm_ui$Internal$Model$Unkeyed(
								A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.aM))),
						k1: allStyles
					});
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Transform = function (a) {
	return {$: 10, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$add = F2(
	function (myFlag, _v0) {
		var one = _v0.a;
		var two = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, first | one, two);
		} else {
			var second = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, one, second | two);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehind = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenInFront = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$nearbyElement = F2(
	function (location, elem) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					function () {
						switch (location) {
							case 0:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bp, $mdgriffith$elm_ui$Internal$Style$classes.kP, $mdgriffith$elm_ui$Internal$Style$classes.gx]));
							case 1:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bp, $mdgriffith$elm_ui$Internal$Style$classes.kP, $mdgriffith$elm_ui$Internal$Style$classes.g3]));
							case 2:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bp, $mdgriffith$elm_ui$Internal$Style$classes.kP, $mdgriffith$elm_ui$Internal$Style$classes.jJ]));
							case 3:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bp, $mdgriffith$elm_ui$Internal$Style$classes.kP, $mdgriffith$elm_ui$Internal$Style$classes.jH]));
							case 4:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bp, $mdgriffith$elm_ui$Internal$Style$classes.kP, $mdgriffith$elm_ui$Internal$Style$classes.iM]));
							default:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bp, $mdgriffith$elm_ui$Internal$Style$classes.kP, $mdgriffith$elm_ui$Internal$Style$classes.g2]));
						}
					}())
				]),
			_List_fromArray(
				[
					function () {
					switch (elem.$) {
						case 3:
							return $elm$virtual_dom$VirtualDom$text('');
						case 2:
							var str = elem.a;
							return $mdgriffith$elm_ui$Internal$Model$textElement(str);
						case 0:
							var html = elem.a;
							return html($mdgriffith$elm_ui$Internal$Model$asEl);
						default:
							var styled = elem.a;
							return A2(styled.iH, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, $mdgriffith$elm_ui$Internal$Model$asEl);
					}
				}()
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$addNearbyElement = F3(
	function (location, elem, existing) {
		var nearby = A2($mdgriffith$elm_ui$Internal$Model$nearbyElement, location, elem);
		switch (existing.$) {
			case 0:
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						_List_fromArray(
							[nearby]));
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						_List_fromArray(
							[nearby]));
				}
			case 1:
				var existingBehind = existing.a;
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						A2($elm$core$List$cons, nearby, existingBehind));
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						_List_fromArray(
							[nearby]));
				}
			case 2:
				var existingInFront = existing.a;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						_List_fromArray(
							[nearby]),
						existingInFront);
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						A2($elm$core$List$cons, nearby, existingInFront));
				}
			default:
				var existingBehind = existing.a;
				var existingInFront = existing.b;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						A2($elm$core$List$cons, nearby, existingBehind),
						existingInFront);
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						A2($elm$core$List$cons, nearby, existingInFront));
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Embedded = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$NodeName = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addNodeName = F2(
	function (newNode, old) {
		switch (old.$) {
			case 0:
				return $mdgriffith$elm_ui$Internal$Model$NodeName(newNode);
			case 1:
				var name = old.a;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, name, newNode);
			default:
				var x = old.a;
				var y = old.b;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, x, y);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$alignXName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.dm + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.en);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.dm + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.eo);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.dm + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.gH);
	}
};
var $mdgriffith$elm_ui$Internal$Model$alignYName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.dn + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.gN);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.dn + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.gG);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.dn + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.gI);
	}
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $mdgriffith$elm_ui$Internal$Model$FullTransform = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Internal$Model$Moved = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$composeTransformation = F2(
	function (transform, component) {
		switch (transform.$) {
			case 0:
				switch (component.$) {
					case 0:
						var x = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, 0, 0));
					case 1:
						var y = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, y, 0));
					case 2:
						var z = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, 0, z));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var xyz = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							xyz,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			case 1:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(newX, y, z));
					case 1:
						var newY = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, newY, z));
					case 2:
						var newZ = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, y, newZ));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var scale = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							scale,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			default:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				var scaled = transform.b;
				var origin = transform.c;
				var angle = transform.d;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(newX, y, z),
							scaled,
							origin,
							angle);
					case 1:
						var newY = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, newY, z),
							scaled,
							origin,
							angle);
					case 2:
						var newZ = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, y, newZ),
							scaled,
							origin,
							angle);
					case 3:
						var newMove = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, newMove, scaled, origin, angle);
					case 4:
						var newOrigin = component.a;
						var newAngle = component.b;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, scaled, newOrigin, newAngle);
					default:
						var newScale = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, newScale, origin, angle);
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$height = $mdgriffith$elm_ui$Internal$Flag$flag(7);
var $mdgriffith$elm_ui$Internal$Flag$heightContent = $mdgriffith$elm_ui$Internal$Flag$flag(36);
var $mdgriffith$elm_ui$Internal$Flag$merge = F2(
	function (_v0, _v1) {
		var one = _v0.a;
		var two = _v0.b;
		var three = _v1.a;
		var four = _v1.b;
		return A2($mdgriffith$elm_ui$Internal$Flag$Field, one | three, two | four);
	});
var $mdgriffith$elm_ui$Internal$Flag$none = A2($mdgriffith$elm_ui$Internal$Flag$Field, 0, 0);
var $mdgriffith$elm_ui$Internal$Model$renderHeight = function (h) {
	switch (h.$) {
		case 0:
			var px = h.a;
			var val = $elm$core$String$fromInt(px);
			var name = 'height-px-' + val;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.e4 + (' ' + name),
				_List_fromArray(
					[
						A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height', val + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.dL,
				_List_Nil);
		case 2:
			var portion = h.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.dM,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.e5 + (' height-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.gT + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.ay + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'height-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = h.a;
			var len = h.b;
			var cls = 'min-height-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-height',
				$elm$core$String$fromInt(minSize) + 'px !important');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = h.a;
			var len = h.b;
			var cls = 'max-height-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-height',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$widthContent = $mdgriffith$elm_ui$Internal$Flag$flag(38);
var $mdgriffith$elm_ui$Internal$Model$renderWidth = function (w) {
	switch (w.$) {
		case 0:
			var px = w.a;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.gq + (' width-px-' + $elm$core$String$fromInt(px)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						'width-px-' + $elm$core$String$fromInt(px),
						'width',
						$elm$core$String$fromInt(px) + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.ef,
				_List_Nil);
		case 2:
			var portion = w.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.eg,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.gr + (' width-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.gT + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.f_ + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'width-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = w.a;
			var len = w.b;
			var cls = 'min-width-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-width',
				$elm$core$String$fromInt(minSize) + 'px');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = w.a;
			var len = w.b;
			var cls = 'max-width-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-width',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Model$skippable = F2(
	function (flag, style) {
		if (_Utils_eq(flag, $mdgriffith$elm_ui$Internal$Flag$borderWidth)) {
			if (style.$ === 3) {
				var val = style.c;
				switch (val) {
					case '0px':
						return true;
					case '1px':
						return true;
					case '2px':
						return true;
					case '3px':
						return true;
					case '4px':
						return true;
					case '5px':
						return true;
					case '6px':
						return true;
					default:
						return false;
				}
			} else {
				return false;
			}
		} else {
			switch (style.$) {
				case 2:
					var i = style.a;
					return (i >= 8) && (i <= 32);
				case 7:
					var name = style.a;
					var t = style.b;
					var r = style.c;
					var b = style.d;
					var l = style.e;
					return _Utils_eq(t, b) && (_Utils_eq(t, r) && (_Utils_eq(t, l) && ((t >= 0) && (t <= 24))));
				default:
					return false;
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$width = $mdgriffith$elm_ui$Internal$Flag$flag(6);
var $mdgriffith$elm_ui$Internal$Flag$xAlign = $mdgriffith$elm_ui$Internal$Flag$flag(30);
var $mdgriffith$elm_ui$Internal$Flag$yAlign = $mdgriffith$elm_ui$Internal$Flag$flag(29);
var $mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive = F8(
	function (classes, node, has, transform, styles, attrs, children, elementAttrs) {
		gatherAttrRecursive:
		while (true) {
			if (!elementAttrs.b) {
				var _v1 = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				if (_v1.$ === 1) {
					return {
						aL: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes),
							attrs),
						aM: children,
						aQ: has,
						aY: node,
						k1: styles
					};
				} else {
					var _class = _v1.a;
					return {
						aL: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes + (' ' + _class)),
							attrs),
						aM: children,
						aQ: has,
						aY: node,
						k1: A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$Transform(transform),
							styles)
					};
				}
			} else {
				var attribute = elementAttrs.a;
				var remaining = elementAttrs.b;
				switch (attribute.$) {
					case 0:
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 3:
						var flag = attribute.a;
						var exactClassName = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = exactClassName + (' ' + classes),
								$temp$node = node,
								$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					case 1:
						var actualAttribute = attribute.a;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = A2($elm$core$List$cons, actualAttribute, attrs),
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 4:
						var flag = attribute.a;
						var style = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							if (A2($mdgriffith$elm_ui$Internal$Model$skippable, flag, style)) {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							} else {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = A2($elm$core$List$cons, style, styles),
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							}
						}
					case 10:
						var flag = attribute.a;
						var component = attribute.b;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
							$temp$transform = A2($mdgriffith$elm_ui$Internal$Model$composeTransformation, transform, component),
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 7:
						var width = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$width, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (width.$) {
								case 0:
									var px = width.a;
									var $temp$classes = ($mdgriffith$elm_ui$Internal$Style$classes.gq + (' width-px-' + $elm$core$String$fromInt(px))) + (' ' + classes),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3(
											$mdgriffith$elm_ui$Internal$Model$Single,
											'width-px-' + $elm$core$String$fromInt(px),
											'width',
											$elm$core$String$fromInt(px) + 'px'),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ef),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$widthContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = width.a;
									if (portion === 1) {
										var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.eg),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.gr + (' width-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.gT + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.f_ + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'width-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v4 = $mdgriffith$elm_ui$Internal$Model$renderWidth(width);
									var addToFlags = _v4.a;
									var newClass = _v4.b;
									var newStyles = _v4.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 8:
						var height = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$height, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (height.$) {
								case 0:
									var px = height.a;
									var val = $elm$core$String$fromInt(px) + 'px';
									var name = 'height-px-' + val;
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.e4 + (' ' + (name + (' ' + classes))),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height ', val),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.dL + (' ' + classes),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$heightContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = height.a;
									if (portion === 1) {
										var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.dM + (' ' + classes),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.e5 + (' height-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.gT + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.ay + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'height-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v6 = $mdgriffith$elm_ui$Internal$Model$renderHeight(height);
									var addToFlags = _v6.a;
									var newClass = _v6.b;
									var newStyles = _v6.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 2:
						var description = attribute.a;
						switch (description.$) {
							case 0:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'main', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 1:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'nav', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 2:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'footer', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 3:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'aside', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 4:
								var i = description.a;
								if (i <= 1) {
									var $temp$classes = classes,
										$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h1', node),
										$temp$has = has,
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								} else {
									if (i < 7) {
										var $temp$classes = classes,
											$temp$node = A2(
											$mdgriffith$elm_ui$Internal$Model$addNodeName,
											'h' + $elm$core$String$fromInt(i),
											node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes,
											$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h6', node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								}
							case 9:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 8:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'role', 'button'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 5:
								var label = description.a;
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-label', label),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 6:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'polite'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							default:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'assertive'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
						}
					case 9:
						var location = attribute.a;
						var elem = attribute.b;
						var newStyles = function () {
							switch (elem.$) {
								case 3:
									return styles;
								case 2:
									var str = elem.a;
									return styles;
								case 0:
									var html = elem.a;
									return styles;
								default:
									var styled = elem.a;
									return _Utils_ap(styles, styled.k1);
							}
						}();
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = newStyles,
							$temp$attrs = attrs,
							$temp$children = A3($mdgriffith$elm_ui$Internal$Model$addNearbyElement, location, elem, children),
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 6:
						var x = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignXName(x) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (x) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerX, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignRight, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					default:
						var y = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignYName(y) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (y) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerY, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignBottom, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
				}
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Untransformed = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$untransformed = $mdgriffith$elm_ui$Internal$Model$Untransformed;
var $mdgriffith$elm_ui$Internal$Model$element = F4(
	function (context, node, attributes, children) {
		return A3(
			$mdgriffith$elm_ui$Internal$Model$createElement,
			context,
			children,
			A8(
				$mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive,
				$mdgriffith$elm_ui$Internal$Model$contextClasses(context),
				node,
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Model$untransformed,
				_List_Nil,
				_List_Nil,
				$mdgriffith$elm_ui$Internal$Model$NoNearbyChildren,
				$elm$core$List$reverse(attributes)));
	});
var $mdgriffith$elm_ui$Element$el = F2(
	function (attrs, child) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					attrs)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[child])));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$run = F2(
	function (context, _v0) {
		var f = _v0;
		return f(context);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$attributes = F2(
	function (context, attrs) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var f = _v0;
				return f(context);
			},
			attrs);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs = F4(
	function (ctor, f, attrs, child) {
		return function (context) {
			return A2(
				ctor,
				A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$attributes, context, attrs),
				A2(f, context, child));
		};
	});
var $lucamug$elm_ui_with_context$Element$WithContext$el = A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs, $mdgriffith$elm_ui$Element$el, $lucamug$elm_ui_with_context$Element$WithContext$Internal$run);
var $author$project$TT$Color$error = $author$project$TT$Color$Extra$hexToColor('#b00020');
var $mdgriffith$elm_ui$Internal$Model$Focus = 0;
var $mdgriffith$elm_ui$Internal$Model$PseudoSelector = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$focus = $mdgriffith$elm_ui$Internal$Flag$flag(31);
var $mdgriffith$elm_ui$Internal$Model$AlignX = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$AlignY = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Describe = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Nearby = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$NoAttribute = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$Empty = {$: 3};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $mdgriffith$elm_ui$Internal$Model$map = F2(
	function (fn, el) {
		switch (el.$) {
			case 1:
				var styled = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						iH: F2(
							function (add, context) {
								return A2(
									$elm$virtual_dom$VirtualDom$map,
									fn,
									A2(styled.iH, add, context));
							}),
						k1: styled.k1
					});
			case 0:
				var html = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A2(
						$elm$core$Basics$composeL,
						$elm$virtual_dom$VirtualDom$map(fn),
						html));
			case 2:
				var str = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Text(str);
			default:
				return $mdgriffith$elm_ui$Internal$Model$Empty;
		}
	});
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle = F2(
	function (fn, attr) {
		switch (attr.$) {
			case 0:
				return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
			case 2:
				var description = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Describe(description);
			case 6:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$AlignX(x);
			case 5:
				var y = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$AlignY(y);
			case 7:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Width(x);
			case 8:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Height(x);
			case 3:
				var x = attr.a;
				var y = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$Class, x, y);
			case 4:
				var flag = attr.a;
				var style = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$StyleClass, flag, style);
			case 9:
				var location = attr.a;
				var elem = attr.b;
				return A2(
					$mdgriffith$elm_ui$Internal$Model$Nearby,
					location,
					A2($mdgriffith$elm_ui$Internal$Model$map, fn, elem));
			case 1:
				var htmlAttr = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Attr(
					A2($elm$virtual_dom$VirtualDom$mapAttribute, fn, htmlAttr));
			default:
				var fl = attr.a;
				var trans = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$TransformComponent, fl, trans);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$removeNever = function (style) {
	return A2($mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle, $elm$core$Basics$never, style);
};
var $mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper = F2(
	function (attr, _v0) {
		var styles = _v0.a;
		var trans = _v0.b;
		var _v1 = $mdgriffith$elm_ui$Internal$Model$removeNever(attr);
		switch (_v1.$) {
			case 4:
				var style = _v1.b;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, style, styles),
					trans);
			case 10:
				var flag = _v1.a;
				var component = _v1.b;
				return _Utils_Tuple2(
					styles,
					A2($mdgriffith$elm_ui$Internal$Model$composeTransformation, trans, component));
			default:
				return _Utils_Tuple2(styles, trans);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$unwrapDecorations = function (attrs) {
	var _v0 = A3(
		$elm$core$List$foldl,
		$mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper,
		_Utils_Tuple2(_List_Nil, $mdgriffith$elm_ui$Internal$Model$Untransformed),
		attrs);
	var styles = _v0.a;
	var transform = _v0.b;
	return A2(
		$elm$core$List$cons,
		$mdgriffith$elm_ui$Internal$Model$Transform(transform),
		styles);
};
var $mdgriffith$elm_ui$Element$focused = function (decs) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$focus,
		A2(
			$mdgriffith$elm_ui$Internal$Model$PseudoSelector,
			0,
			$mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
};
var $lucamug$elm_ui_with_context$Element$WithContext$focused = function (decs) {
	return function (context) {
		return $mdgriffith$elm_ui$Element$focused(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var f = _v0;
					return f(context);
				},
				decs));
	};
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $mdgriffith$elm_ui$Internal$Model$Hover = 1;
var $mdgriffith$elm_ui$Internal$Flag$hover = $mdgriffith$elm_ui$Internal$Flag$flag(33);
var $mdgriffith$elm_ui$Element$mouseOver = function (decs) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$hover,
		A2(
			$mdgriffith$elm_ui$Internal$Model$PseudoSelector,
			1,
			$mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
};
var $lucamug$elm_ui_with_context$Element$WithContext$mouseOver = function (decs) {
	return function (context) {
		return $mdgriffith$elm_ui$Element$mouseOver(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var f = _v0;
					return f(context);
				},
				decs));
	};
};
var $mdgriffith$elm_ui$Element$padding = function (x) {
	var f = x;
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$padding,
		A5(
			$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
			'p-' + $elm$core$String$fromInt(x),
			f,
			f,
			f,
			f));
};
var $lucamug$elm_ui_with_context$Element$WithContext$padding = function (x) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
		$mdgriffith$elm_ui$Element$padding(x));
};
var $mdgriffith$elm_ui$Internal$Model$Paragraph = {$: 9};
var $mdgriffith$elm_ui$Internal$Model$SpacingStyle = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Flag$spacing = $mdgriffith$elm_ui$Internal$Flag$flag(3);
var $mdgriffith$elm_ui$Internal$Model$spacingName = F2(
	function (x, y) {
		return 'spacing-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y)));
	});
var $mdgriffith$elm_ui$Element$spacing = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$spacing,
		A3(
			$mdgriffith$elm_ui$Internal$Model$SpacingStyle,
			A2($mdgriffith$elm_ui$Internal$Model$spacingName, x, x),
			x,
			x));
};
var $mdgriffith$elm_ui$Element$paragraph = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asParagraph,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Paragraph),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$spacing(5),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapContainer = F3(
	function (container, attrs, children) {
		return function (context) {
			return A2(
				container,
				A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$attributes, context, attrs),
				A2(
					$elm$core$List$map,
					$lucamug$elm_ui_with_context$Element$WithContext$Internal$run(context),
					children));
		};
	});
var $lucamug$elm_ui_with_context$Element$WithContext$paragraph = $lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapContainer($mdgriffith$elm_ui$Element$paragraph);
var $author$project$TT$Color$primary = $author$project$TT$Color$Extra$hexToColor('#5c802d');
var $author$project$TT$Color$primaryLight = $author$project$TT$Color$Extra$hexToColor('#94af6c');
var $mdgriffith$elm_ui$Element$rgb255 = F3(
	function (red, green, blue) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, red / 255, green / 255, blue / 255, 1);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$rgb255 = $mdgriffith$elm_ui$Element$rgb255;
var $author$project$TT$Color$secondary = $author$project$TT$Color$Extra$hexToColor('#0080a8');
var $author$project$TT$Color$tertiaryLight = $author$project$TT$Color$Extra$hexToColor('#d5d36e');
var $author$project$TT$FormField$withInputType = F2(
	function (inputType, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var value = _v0.c;
		var label = _v0.d;
		return A4(
			$author$project$TT$FormField$Input,
			_Utils_update(
				options,
				{fb: inputType}),
			msg,
			value,
			label);
	});
var $author$project$TT$FormField$withLabelType = F2(
	function (labelType, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var value = _v0.c;
		var label = _v0.d;
		return A4(
			$author$project$TT$FormField$Input,
			_Utils_update(
				options,
				{cS: labelType}),
			msg,
			value,
			label);
	});
var $author$project$TT$FormField$withPlaceholder = F2(
	function (placeholder, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var value = _v0.c;
		var label = _v0.d;
		return A4(
			$author$project$TT$FormField$Input,
			_Utils_update(
				options,
				{
					aF: $elm$core$Maybe$Just(placeholder)
				}),
			msg,
			value,
			label);
	});
var $author$project$TT$FormField$withState = F2(
	function (state, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var value = _v0.c;
		var label = _v0.d;
		return A4(
			$author$project$TT$FormField$Input,
			_Utils_update(
				options,
				{av: state}),
			msg,
			value,
			label);
	});
var $author$project$TT$FormField$withWrapperAttrs = F2(
	function (wrapperAttrs, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var value = _v0.c;
		var label = _v0.d;
		return A4(
			$author$project$TT$FormField$Input,
			_Utils_update(
				options,
				{dh: wrapperAttrs}),
			msg,
			value,
			label);
	});
var $author$project$Model$commonLocationDropdownConfig = F9(
	function (selectionFromModel, inputText, inputType, dropdownMsg, itemPickedMsg, onBlurMsg, promptElement, inputHasError, inputPlaceholder) {
		var itemToElement = F3(
			function (selected, highlighted, optionType) {
				var cityDo = function () {
					if (!optionType.$) {
						var _v2 = optionType.a;
						var cityDo_ = _v2.c;
						return cityDo_;
					} else {
						var _v3 = optionType.a;
						var cityDo_ = _v3.c;
						return cityDo_;
					}
				}();
				var _v0 = highlighted ? _Utils_Tuple2($author$project$TT$Color$primaryLight, $author$project$TT$Color$white) : (selected ? _Utils_Tuple2($author$project$TT$Color$secondary, $author$project$TT$Color$white) : _Utils_Tuple2(
					A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 255, 255),
					$author$project$TT$Color$black));
				var bgColor = _v0.a;
				var fontColor = _v0.b;
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color(bgColor),
							$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$Font$color(fontColor),
							$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$tertiaryLight),
									$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$white)
								]))
						]),
					$lucamug$elm_ui_with_context$Element$WithContext$text(cityDo.ez + (' - ' + cityDo.fT)));
			});
		var inputConfig = function (baseInput) {
			return A2(
				$author$project$TT$FormField$withState,
				inputHasError ? 2 : 0,
				A2(
					$author$project$TT$FormField$withInputType,
					0,
					A2(
						$author$project$TT$FormField$withPlaceholder,
						$lucamug$elm_ui_with_context$Element$WithContext$text(inputPlaceholder),
						A2(
							$author$project$TT$FormField$withFieldAttrs,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(16),
									$lucamug$elm_ui_with_context$Element$WithContext$focused(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
											inputHasError ? $author$project$TT$Color$error : $author$project$TT$Color$primary)
										])),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$id('location')),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$autocomplete(false))
								]),
							A2(
								$author$project$TT$FormField$withWrapperAttrs,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
									]),
								A2($author$project$TT$FormField$withLabelType, 1, baseInput))))));
		};
		var emptyListElement = A2(
			$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(5),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$padding(12),
					$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
					$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class('elevation-1')),
					$lucamug$elm_ui_with_context$Element$WithContext$moveUp(8)
				]),
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$text(
					(inputText === '') ? 'Empieza a escribir tu ciudad y elígela de la lista' : 'Te recomendamos volver a escribir la ciudad y elegir alguna de la lista de ciudades sugeridas.')
				]));
		return $author$project$Model$commonDropdownConfig(inputText)(promptElement)(dropdownMsg)(itemPickedMsg)(
			$elm$core$Maybe$Just(onBlurMsg))(itemToElement)(selectionFromModel)(inputType)(emptyListElement)(inputConfig);
	});
var $mdgriffith$elm_ui$Element$none = $mdgriffith$elm_ui$Internal$Model$Empty;
var $lucamug$elm_ui_with_context$Element$WithContext$none = $lucamug$elm_ui_with_context$Element$WithContext$element($mdgriffith$elm_ui$Element$none);
var $author$project$Page$Home$citiesDropdown = function (model) {
	var promptElement = $lucamug$elm_ui_with_context$Element$WithContext$none;
	var inputPlaceholder = 'Ingresa un municipio / delegación';
	return A9(
		$author$project$Model$commonLocationDropdownConfig,
		model.a.b.cU.f3,
		model.a.b.cU.cO,
		A2($author$project$TT$Dropdown$TextField, $author$project$Page$Home$MsgInputLocationChanged, ''),
		$author$project$Page$Home$MsgCityDropdownChanged,
		$author$project$Page$Home$MsgCityDropdownSelectChanged,
		$author$project$Page$Home$MsgUserLeftCityDropdown,
		promptElement,
		!_Utils_eq(model.a.b.cU.bM, $elm$core$Maybe$Nothing),
		inputPlaceholder);
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$String$toUpper = _String_toUpper;
var $elm$core$String$trim = _String_trim;
var $elm_community$string_extra$String$Extra$camelize = function (string) {
	return A3(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('[-_\\s]+(.)?'),
		function (_v0) {
			var submatches = _v0.k2;
			if (submatches.b && (!submatches.a.$)) {
				var match = submatches.a.a;
				return $elm$core$String$toUpper(match);
			} else {
				return '';
			}
		},
		$elm$core$String$trim(string));
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $elm_community$string_extra$String$Extra$classify = function (string) {
	return $elm_community$string_extra$String$Extra$toSentenceCase(
		A3(
			$elm$core$String$replace,
			' ',
			'',
			$elm_community$string_extra$String$Extra$camelize(
				A3(
					$elm$regex$Regex$replace,
					$elm_community$string_extra$String$Extra$regexFromString('[\\W_]'),
					$elm$core$Basics$always(' '),
					string))));
};
var $author$project$TT$Dropdown$Button = {$: 0};
var $author$project$TT$Color$gray1 = $author$project$TT$Color$Extra$hexToColor('#616161');
var $author$project$TT$Color$gray2 = $author$project$TT$Color$Extra$hexToColor('#878787');
var $mdgriffith$elm_ui$Element$spacingXY = F2(
	function (x, y) {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$spacing,
			A3(
				$mdgriffith$elm_ui$Internal$Model$SpacingStyle,
				A2($mdgriffith$elm_ui$Internal$Model$spacingName, x, y),
				x,
				y));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$spacingXY = F2(
	function (x, y) {
		return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
			A2($mdgriffith$elm_ui$Element$spacingXY, x, y));
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$TT$Color$tertiary = $author$project$TT$Color$Extra$hexToColor('#b8bf0d');
var $author$project$Model$commonSelectDropdownConfig = F8(
	function (selectionFromModel, inputType, dropdownMsg, itemPickedMsg, promptElement, height, hasError, dropdownOptionsListClass) {
		var itemToElement = F3(
			function (selected, highlighted, optionType) {
				var category = function () {
					if (!optionType.$) {
						var _v5 = optionType.a;
						var category_ = _v5.c;
						return category_;
					} else {
						var _v6 = optionType.a;
						var category_ = _v6.c;
						return category_;
					}
				}();
				var _v3 = highlighted ? _Utils_Tuple2($author$project$TT$Color$primaryLight, $author$project$TT$Color$white) : (selected ? _Utils_Tuple2($author$project$TT$Color$secondary, $author$project$TT$Color$white) : _Utils_Tuple2(
					A3($lucamug$elm_ui_with_context$Element$WithContext$rgb255, 255, 255, 255),
					$author$project$TT$Color$black));
				var bgColor = _v3.a;
				var fontColor = _v3.b;
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color(bgColor),
							$lucamug$elm_ui_with_context$Element$WithContext$padding(12),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$Font$color(fontColor),
							$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$tertiary),
									$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$white)
								]))
						]),
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$text(category.h)
						]));
			});
		return A2(
			$author$project$TT$Dropdown$withListAttributes,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(5),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 0, 10),
					$lucamug$elm_ui_with_context$Element$WithContext$padding(5),
					$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					A2($lucamug$elm_ui_with_context$Element$WithContext$maximum, height, $lucamug$elm_ui_with_context$Element$WithContext$shrink)),
					$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class('elevation-4')),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class(dropdownOptionsListClass))
				]),
			A2(
				$author$project$TT$Dropdown$withSelectAttributes,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(16),
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 16),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
						hasError ? $author$project$TT$Color$error : $author$project$TT$Color$gray2),
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
						$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
						hasError ? $author$project$TT$Color$error : $author$project$TT$Color$gray1),
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'overflow-x', 'clip'))
					]),
				A2(
					$author$project$TT$Dropdown$withContainerAttributes,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
						]),
					$author$project$TT$Dropdown$basic(
						{
							eJ: '',
							eN: dropdownMsg,
							eO: $lucamug$elm_ui_with_context$Element$WithContext$none,
							fb: inputType,
							fj: itemToElement,
							fk: function (optionType) {
								if (!optionType.$) {
									var _v1 = optionType.a;
									var item = _v1.b;
									return A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Attributes$class(dropdownOptionsListClass + '-item'))
											]),
										$lucamug$elm_ui_with_context$Element$WithContext$text(item));
								} else {
									var _v2 = optionType.a;
									var item = _v2.b;
									return A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Attributes$class(dropdownOptionsListClass + '-item'))
											]),
										$lucamug$elm_ui_with_context$Element$WithContext$text(item));
								}
							},
							fo: $elm$core$Maybe$Just(15),
							fy: itemPickedMsg,
							fN: promptElement,
							f4: selectionFromModel
						}))));
	});
var $mdgriffith$elm_ui$Internal$Model$unstyled = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Unstyled, $elm$core$Basics$always);
var $mdgriffith$elm_ui$Element$html = $mdgriffith$elm_ui$Internal$Model$unstyled;
var $lucamug$elm_ui_with_context$Element$WithContext$html = function (child) {
	return $lucamug$elm_ui_with_context$Element$WithContext$element(
		$mdgriffith$elm_ui$Element$html(child));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Page$Home$commonSelectDropdown = F6(
	function (selectedItem, hasError, dropdownChangeMsg, dropdownSelectedChangedMsg, dropdownContainerClass, dropdownOptionsListClass) {
		var promptElement = A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					A2($elm$html$Html$Attributes$style, 'overflow-x', 'clip')),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class(dropdownContainerClass))
				]),
			$lucamug$elm_ui_with_context$Element$WithContext$html(
				A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Selecciona una opción')
						]))));
		return A8($author$project$Model$commonSelectDropdownConfig, selectedItem, $author$project$TT$Dropdown$Button, dropdownChangeMsg, dropdownSelectedChangedMsg, promptElement, 350, hasError, dropdownOptionsListClass);
	});
var $author$project$TT$ApiModel$cvFileTypeAccepted = _List_fromArray(
	['application/pdf', 'application/x-pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-word.document.12', 'application/vnd.oasis.opendocument.text', 'application/rtf']);
var $author$project$Page$Home$cvInputFieldIdForApply = 'CvInputFieldIdForApply';
var $author$project$Page$Home$delayHideNotification = function (msg) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return msg;
		},
		$elm$core$Process$sleep(5000));
};
var $elm$file$File$Download$url = function (href) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$never,
		_File_downloadUrl(href));
};
var $author$project$Page$Home$downloadCV = function (link) {
	return $elm$file$File$Download$url(link);
};
var $author$project$Page$Home$extractCurrentApplyFromUrl = function (url) {
	return A2($author$project$TT$Util$extractSearchArgument, 'ci', url);
};
var $author$project$Page$Home$extractStageFromUrl = function (url) {
	return A2(
		$elm$core$Maybe$map,
		function (stage) {
			var _v0 = $elm$core$String$toLower(stage);
			switch (_v0) {
				case 'filterquestions':
					return 3;
				case 'applyquestions':
					return 4;
				case 'candidatecv':
					return 5;
				case 'complete':
					return 5;
				default:
					return 1;
			}
		},
		A2($author$project$TT$Util$extractSearchArgument, 'stage', url));
};
var $author$project$Ports$fileSelected = _Platform_outgoingPort('fileSelected', $elm$json$Json$Encode$string);
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Page$Home$MsgServerSendCountriesListResult = function (a) {
	return {$: 116, a: a};
};
var $author$project$Page$Home$msgGotCountriesResponse = function (result) {
	return $author$project$Page$Home$MsgServerSendCountriesListResult(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Model$TkCountriesDo = F2(
	function (value, text) {
		return {h: text, g: value};
	});
var $author$project$Model$tkCountriesDoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'text',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$TkCountriesDo)));
var $author$project$Page$Home$getCountries = function (model) {
	return $elm$http$Http$riskyRequest(
		{
			ch: $elm$http$Http$emptyBody,
			dA: A2(
				$elm$http$Http$expectJson,
				$author$project$Page$Home$msgGotCountriesResponse,
				$elm$json$Json$Decode$list($author$project$Model$tkCountriesDoDecoder)),
			dJ: _List_Nil,
			dU: 'GET',
			d8: $elm$core$Maybe$Just(model.J.dS),
			d9: $elm$core$Maybe$Nothing,
			Q: model.J.cV + '/v1/countries-list'
		});
};
var $author$project$Model$TkApiCandidateApplyInfoDo = function (email) {
	return function (fullname) {
		return function (phoneNumber) {
			return function (location) {
				return function (headline) {
					return function (category) {
						return function (experienceLevel) {
							return function (educationLevel) {
								return function (experienceYears) {
									return function (skillsList) {
										return function (privateCv) {
											return function (attachmentPath) {
												return function (attachmentHash) {
													return function (mimeType) {
														return function (cvDownloadLink) {
															return function (candidateAlreadyApplied) {
																return function (countryCode) {
																	return function (message) {
																		return function (isCurrentCvFromProfile) {
																			return function (cvCreatedAtHumanReadable) {
																				return {dp: attachmentHash, dq: attachmentPath, er: candidateAlreadyApplied, du: category, hU: countryCode, eG: cvCreatedAtHumanReadable, eH: cvDownloadLink, dz: educationLevel, cB: email, dB: experienceLevel, dC: experienceYears, dG: fullname, dK: headline, ff: isCurrentCvFromProfile, cU: location, js: message, dV: mimeType, fD: phoneNumber, fJ: privateCv, d4: skillsList};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$TkApplyCandidateLocationDo = F5(
	function (displayName, cityName, cityId, regionName, regionId) {
		return {ex: cityId, ey: cityName, eL: displayName, fR: regionId, fS: regionName};
	});
var $author$project$Model$tkApplyCandidateLocationDoJsonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'region_id',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'region_name',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'city_id',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'city_name',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'display_name',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					$elm$json$Json$Decode$succeed($author$project$Model$TkApplyCandidateLocationDo))))));
var $author$project$Model$tkApiCandidateApplyInfoDoJsonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'cv_created_at_human_readable',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_current_cv_from_profile',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'message',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'country_code',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'candidate_already_applied',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'cv_download_link',
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'mime_type',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'attachment_hash',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'attachment_path',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'private_cv',
										$elm$json$Json$Decode$bool,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'skills_list',
											A2(
												$elm$json$Json$Decode$map,
												$elm$core$Maybe$Just,
												$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'experience_years',
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'education_level',
													A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'experience_level',
														A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'category',
															A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
															$elm$core$Maybe$Nothing,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'headline',
																A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																$elm$core$Maybe$Nothing,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'location',
																	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Model$tkApplyCandidateLocationDoJsonDecoder),
																	$elm$core$Maybe$Nothing,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'phone_number',
																		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																		$elm$core$Maybe$Nothing,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'full_name',
																			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																			$elm$core$Maybe$Nothing,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'email',
																				$elm$json$Json$Decode$string,
																				$elm$json$Json$Decode$succeed($author$project$Model$TkApiCandidateApplyInfoDo)))))))))))))))))))));
var $author$project$Page$Home$MsgServerGotCurrentCandidateApplyInfoResponse = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Home$upgradeMsgGotCurrentCandidateApplyInfoResult = F2(
	function (jobAdSummaryDo, result) {
		return A2(
			$author$project$Page$Home$MsgServerGotCurrentCandidateApplyInfoResponse,
			jobAdSummaryDo,
			$krisajenkins$remotedata$RemoteData$fromResult(result));
	});
var $author$project$Page$Home$getCurrentCandidateApplyInfo = F2(
	function (model, jobAdSummaryDo) {
		var _v0 = model.fl;
		if (!_v0.$) {
			var jobAdId = _v0.a;
			return $elm$http$Http$riskyRequest(
				{
					ch: $elm$http$Http$jsonBody(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'job_ad_id',
									$elm$json$Json$Encode$string(jobAdId)),
									_Utils_Tuple2(
									'source',
									$elm$json$Json$Encode$string(model.M))
								]))),
					dA: A2(
						$elm$http$Http$expectJson,
						$author$project$Page$Home$upgradeMsgGotCurrentCandidateApplyInfoResult(jobAdSummaryDo),
						$author$project$Model$tkApiCandidateApplyInfoDoJsonDecoder),
					dJ: _List_Nil,
					dU: 'POST',
					d8: $elm$core$Maybe$Just(model.J.dS),
					d9: $elm$core$Maybe$Nothing,
					Q: model.J.cV + '/v1/apply/current-candidate'
				});
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$Page$Home$validateFullname = function (fullname) {
	var isValid = function () {
		if (fullname === '') {
			return false;
		} else {
			var validateTwoFirstWords = F2(
				function (n1, n2) {
					return ($elm$core$String$length(n1) >= 2) && ($elm$core$String$length(n2) >= 2);
				});
			var fullNameSpplited = A2($elm$core$String$split, ' ', fullname);
			if (fullNameSpplited.b && fullNameSpplited.b.b) {
				var n1 = fullNameSpplited.a;
				var _v1 = fullNameSpplited.b;
				var n2 = _v1.a;
				return A2(validateTwoFirstWords, n1, n2);
			} else {
				return false;
			}
		}
	}();
	return isValid ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Por favor ingresa un nombre y apellido válido');
};
var $author$project$Page$Home$getFullnameSubmittedAndValidatedModel = function (model) {
	var loginModel = model.f;
	var currentCandidateInfoStageModel = model.a;
	var currentApplyInfo = currentCandidateInfoStageModel.b;
	var currentFullnameField = currentApplyInfo.dG;
	var fullnameProcessed = $elm$core$String$trim(currentFullnameField.cO);
	var fullnameError = $author$project$Page$Home$validateFullname(fullnameProcessed);
	var newActiveQuestion = _Utils_eq(fullnameError, $elm$core$Maybe$Nothing) ? (currentCandidateInfoStageModel.s ? currentCandidateInfoStageModel.aq : 2) : currentCandidateInfoStageModel.l;
	var newIsEditingQuestion = _Utils_eq(fullnameError, $elm$core$Maybe$Nothing) ? false : currentCandidateInfoStageModel.s;
	var newFullnameField = _Utils_update(
		currentFullnameField,
		{bM: fullnameError, cE: true, cO: fullnameProcessed});
	var newFullnameFieldWithValue = _Utils_eq(fullnameError, $elm$core$Maybe$Nothing) ? _Utils_update(
		newFullnameField,
		{
			g: $elm$core$Maybe$Just(fullnameProcessed)
		}) : newFullnameField;
	var newModel = _Utils_update(
		model,
		{
			a: _Utils_update(
				currentCandidateInfoStageModel,
				{
					l: newActiveQuestion,
					b: _Utils_update(
						currentApplyInfo,
						{dG: newFullnameFieldWithValue}),
					s: newIsEditingQuestion
				})
		});
	var newModelWithNextStep = _Utils_eq(fullnameError, $elm$core$Maybe$Nothing) ? _Utils_update(
		newModel,
		{
			gV: 7,
			f: _Utils_update(
				loginModel,
				{V: model.C.ix, W: false})
		}) : newModel;
	return newModelWithNextStep;
};
var $author$project$Page$Home$validateHeadline = function (headline) {
	return (headline === '') ? $elm$core$Maybe$Just('Por favor ingresa tu perfil profesional') : (($elm$core$String$length(headline) > 75) ? $elm$core$Maybe$Just('Por favor ingresa menos de 75 letras') : $elm$core$Maybe$Nothing);
};
var $author$project$Page$Home$getHeadlineSubmittedAndValidatedModel = function (model) {
	var currentCandidateInfoStageModel = model.a;
	var currentApplyInfo = currentCandidateInfoStageModel.b;
	var currentHeadlineField = currentApplyInfo.dK;
	var headlineProcessed = $elm$core$String$trim(currentHeadlineField.cO);
	var headlineError = $author$project$Page$Home$validateHeadline(headlineProcessed);
	var newActiveQuestion = _Utils_eq(headlineError, $elm$core$Maybe$Nothing) ? (currentCandidateInfoStageModel.s ? currentCandidateInfoStageModel.aq : 6) : currentCandidateInfoStageModel.l;
	var newIsEditingQuestion = _Utils_eq(headlineError, $elm$core$Maybe$Nothing) ? false : currentCandidateInfoStageModel.s;
	var newHeadlineField = _Utils_update(
		currentHeadlineField,
		{bM: headlineError, cE: true, cO: headlineProcessed});
	var newHeadlineFieldWithValue = _Utils_eq(headlineError, $elm$core$Maybe$Nothing) ? _Utils_update(
		newHeadlineField,
		{
			g: $elm$core$Maybe$Just(headlineProcessed)
		}) : newHeadlineField;
	var newModel = _Utils_update(
		model,
		{
			a: _Utils_update(
				currentCandidateInfoStageModel,
				{
					l: newActiveQuestion,
					b: _Utils_update(
						currentApplyInfo,
						{dK: newHeadlineFieldWithValue}),
					s: newIsEditingQuestion
				})
		});
	var newModelWithNextStep = _Utils_eq(headlineError, $elm$core$Maybe$Nothing) ? _Utils_update(
		newModel,
		{gV: 7}) : newModel;
	return newModelWithNextStep;
};
var $author$project$Model$TkJobAdFilterQuestion = F6(
	function (id, typeQuestion, titleQuestion, answersList, openAnswerMaxCharacters, openAnswerMinCharacters) {
		return {gS: answersList, iJ: id, jN: openAnswerMaxCharacters, jO: openAnswerMinCharacters, lu: titleQuestion, lH: typeQuestion};
	});
var $author$project$Model$TkJobAdFilterQuestionAnswerOptions = function (titleAnswer) {
	return {lt: titleAnswer};
};
var $author$project$Model$tkJobAdFilterQuestionAnswerOptionsJsonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'title_answer',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$TkJobAdFilterQuestionAnswerOptions));
var $author$project$Model$tkJobAdFilterQuestionJsonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'open_answer_min_characters',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'open_answer_max_characters',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'answers_list',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				$elm$json$Json$Decode$list($author$project$Model$tkJobAdFilterQuestionAnswerOptionsJsonDecoder)),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title_question',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type_question',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$TkJobAdFilterQuestion)))))));
var $author$project$Model$tkJobAdFilterQuestionListJsonDecoder = $elm$json$Json$Decode$list($author$project$Model$tkJobAdFilterQuestionJsonDecoder);
var $author$project$Page$Home$MsgServerGotJobAdFilterQuestionsResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Home$upgradeMsgGotJobAdFilterQuestionsResult = function (result) {
	return $author$project$Page$Home$MsgServerGotJobAdFilterQuestionsResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$getJobAdFilterQuestions = function (model) {
	var _v0 = model.fl;
	if (!_v0.$) {
		var jobAdId = _v0.a;
		return $elm$http$Http$riskyRequest(
			{
				ch: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'job_ad_id',
								$elm$json$Json$Encode$string(jobAdId))
							]))),
				dA: A2($elm$http$Http$expectJson, $author$project$Page$Home$upgradeMsgGotJobAdFilterQuestionsResult, $author$project$Model$tkJobAdFilterQuestionListJsonDecoder),
				dJ: _List_Nil,
				dU: 'POST',
				d8: $elm$core$Maybe$Just(model.J.dS),
				d9: $elm$core$Maybe$Nothing,
				Q: model.J.cV + '/v1/job-ad/filter-questions'
			});
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Page$Home$getLocationSubmittedAndValidatedModel = function (model) {
	var currentCandidateInfoStageModel = model.a;
	var currentApplyInfo = currentCandidateInfoStageModel.b;
	var currentLocationField = currentApplyInfo.cU;
	var locationError = ($elm$core$String$trim(currentLocationField.cO) === '') ? $elm$core$Maybe$Just('Por favor ingresa el lugar donde vives') : $elm$core$Maybe$Nothing;
	var newActiveQuestion = _Utils_eq(locationError, $elm$core$Maybe$Nothing) ? (currentCandidateInfoStageModel.s ? currentCandidateInfoStageModel.aq : 5) : currentCandidateInfoStageModel.l;
	var newIsEditingQuestion = _Utils_eq(locationError, $elm$core$Maybe$Nothing) ? false : currentCandidateInfoStageModel.s;
	var newLocationField = _Utils_update(
		currentLocationField,
		{bM: locationError, cE: true, cO: currentLocationField.cO});
	var newLocationFieldWithValue = _Utils_eq(locationError, $elm$core$Maybe$Nothing) ? _Utils_update(
		newLocationField,
		{
			g: $elm$core$Maybe$Just(currentLocationField.cO)
		}) : newLocationField;
	var newModel = _Utils_update(
		model,
		{
			a: _Utils_update(
				currentCandidateInfoStageModel,
				{
					l: newActiveQuestion,
					b: _Utils_update(
						currentApplyInfo,
						{cU: newLocationFieldWithValue}),
					s: newIsEditingQuestion
				})
		});
	return newModel;
};
var $author$project$Page$Home$validatePhone = F2(
	function (phone, countryCode) {
		if (phone === '') {
			return $elm$core$Maybe$Just('Por favor ingresa un número celular válido');
		} else {
			if (countryCode === 'mx') {
				var phoneRegex = A2(
					$elm$core$Maybe$withDefault,
					$elm$regex$Regex$never,
					$elm$regex$Regex$fromString('^([0-9]|\\+)[0-9]{9,12}$'));
				return A2($elm$regex$Regex$contains, phoneRegex, phone) ? (A2($elm$core$String$startsWith, '+52', phone) ? (($elm$core$String$length(phone) === 13) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Por favor ingresa 10 dígitos además del código de país')) : (($elm$core$String$length(phone) === 10) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Por favor ingresa 10 dígitos'))) : $elm$core$Maybe$Just('Por favor incluye 10 dígitos sin guiones ni caracteres especiales');
			} else {
				var phoneRegex = A2(
					$elm$core$Maybe$withDefault,
					$elm$regex$Regex$never,
					$elm$regex$Regex$fromString('^([0-9]|\\+)[0-9]*$'));
				return A2($elm$regex$Regex$contains, phoneRegex, phone) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Por favor ingresa un número celular válido');
			}
		}
	});
var $author$project$Page$Home$getPhoneSubmittedAndValidatedModel = F2(
	function (model, jobAdSummaryDo) {
		var removeWhiteSpacesRegex = '\\s';
		var currentCandidateInfoStageModel = model.a;
		var currentApplyInfo = currentCandidateInfoStageModel.b;
		var currentPhoneField = currentApplyInfo.jT;
		var phoneProcessed = function () {
			var _v0 = $elm$regex$Regex$fromString(removeWhiteSpacesRegex);
			if (_v0.$ === 1) {
				return $elm$core$String$trim(currentPhoneField.cO);
			} else {
				var regex = _v0.a;
				return $elm$core$String$trim(
					A3(
						$elm$regex$Regex$replace,
						regex,
						function (_v1) {
							return '';
						},
						currentPhoneField.cO));
			}
		}();
		var phoneError = A2($author$project$Page$Home$validatePhone, phoneProcessed, jobAdSummaryDo.hU);
		var newActiveQuestion = _Utils_eq(phoneError, $elm$core$Maybe$Nothing) ? (currentCandidateInfoStageModel.s ? currentCandidateInfoStageModel.aq : 4) : currentCandidateInfoStageModel.l;
		var newIsEditingQuestion = _Utils_eq(phoneError, $elm$core$Maybe$Nothing) ? false : currentCandidateInfoStageModel.s;
		var newPhoneField = _Utils_update(
			currentPhoneField,
			{bM: phoneError, cE: true, cO: phoneProcessed});
		var newPhoneFieldWithValue = _Utils_eq(phoneError, $elm$core$Maybe$Nothing) ? _Utils_update(
			newPhoneField,
			{
				g: $elm$core$Maybe$Just(phoneProcessed)
			}) : newPhoneField;
		var newModel = _Utils_update(
			model,
			{
				a: _Utils_update(
					currentCandidateInfoStageModel,
					{
						l: newActiveQuestion,
						b: _Utils_update(
							currentApplyInfo,
							{jT: newPhoneFieldWithValue}),
						s: newIsEditingQuestion
					})
			});
		var newModelWithNextStep = _Utils_eq(phoneError, $elm$core$Maybe$Nothing) ? _Utils_update(
			newModel,
			{gV: 7}) : newModel;
		return newModelWithNextStep;
	});
var $author$project$TT$Util$httpErrorToString = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return 'BadUrl: The request is invalid for ' + url;
		case 1:
			return 'Timeout: Time out trying to reach the service, try again';
		case 2:
			return 'NetworkError: Unable to reach the service, check your network connection';
		case 3:
			var status = error.a;
			var statusString = '(HTTP ' + ($elm$core$String$fromInt(status) + ')');
			return (status === 403) ? ('Service call not allowed, check your credentials ' + statusString) : (((status >= 400) && (status <= 499)) ? ('Invalid request, verify your information and try again ' + statusString) : (((status >= 500) && (status <= 599)) ? ('The server had a problem, try again later ' + statusString) : ('Unknown service response status ' + statusString)));
		default:
			var errorMessage = error.a;
			return 'BadBody: Unable to parse the service data :: ' + errorMessage;
	}
};
var $author$project$Model$initCountryList = F2(
	function (countryList, dropdownState) {
		return A3(
			$author$project$TT$Dropdown$withOptions,
			function ($) {
				return $.h;
			},
			countryList,
			dropdownState);
	});
var $author$project$TT$Util$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $avh4$elm_color$Color$hsla = F4(
	function (hue, sat, light, alpha) {
		var _v0 = _Utils_Tuple3(hue, sat, light);
		var h = _v0.a;
		var s = _v0.b;
		var l = _v0.c;
		var m2 = (l <= 0.5) ? (l * (s + 1)) : ((l + s) - (l * s));
		var m1 = (l * 2) - m2;
		var hueToRgb = function (h__) {
			var h_ = (h__ < 0) ? (h__ + 1) : ((h__ > 1) ? (h__ - 1) : h__);
			return ((h_ * 6) < 1) ? (m1 + (((m2 - m1) * h_) * 6)) : (((h_ * 2) < 1) ? m2 : (((h_ * 3) < 2) ? (m1 + (((m2 - m1) * ((2 / 3) - h_)) * 6)) : m1));
		};
		var b = hueToRgb(h - (1 / 3));
		var g = hueToRgb(h);
		var r = hueToRgb(h + (1 / 3));
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, alpha);
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $noahzgordon$elm_color_extra$Color$Manipulate$limit = A2($elm$core$Basics$clamp, 0, 1);
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $avh4$elm_color$Color$toHsla = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var minColor = A2(
		$elm$core$Basics$min,
		r,
		A2($elm$core$Basics$min, g, b));
	var maxColor = A2(
		$elm$core$Basics$max,
		r,
		A2($elm$core$Basics$max, g, b));
	var l = (minColor + maxColor) / 2;
	var s = _Utils_eq(minColor, maxColor) ? 0 : ((l < 0.5) ? ((maxColor - minColor) / (maxColor + minColor)) : ((maxColor - minColor) / ((2 - maxColor) - minColor)));
	var h1 = _Utils_eq(maxColor, r) ? ((g - b) / (maxColor - minColor)) : (_Utils_eq(maxColor, g) ? (2 + ((b - r) / (maxColor - minColor))) : (4 + ((r - g) / (maxColor - minColor))));
	var h2 = h1 * (1 / 6);
	var h3 = $elm$core$Basics$isNaN(h2) ? 0 : ((h2 < 0) ? (h2 + 1) : h2);
	return {$7: a, e7: h3, fn: l, f0: s};
};
var $noahzgordon$elm_color_extra$Color$Manipulate$darken = F2(
	function (offset, cl) {
		var _v0 = $avh4$elm_color$Color$toHsla(cl);
		var hue = _v0.e7;
		var saturation = _v0.f0;
		var lightness = _v0.fn;
		var alpha = _v0.$7;
		return A4(
			$avh4$elm_color$Color$hsla,
			hue,
			saturation,
			$noahzgordon$elm_color_extra$Color$Manipulate$limit(lightness - offset),
			alpha);
	});
var $noahzgordon$elm_color_extra$Color$Manipulate$lighten = F2(
	function (offset, cl) {
		return A2($noahzgordon$elm_color_extra$Color$Manipulate$darken, -offset, cl);
	});
var $mdgriffith$elm_ui$Element$toRgb = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {$7: a, ds: b, dH: g, d0: r};
};
var $author$project$TT$Color$Extra$toColor = function (elementColor) {
	var cl = $mdgriffith$elm_ui$Element$toRgb(elementColor);
	return A4($avh4$elm_color$Color$rgba, cl.d0, cl.dH, cl.ds, cl.$7);
};
var $author$project$TT$Color$Extra$lighten = F2(
	function (offset, elementColor) {
		var cl = $author$project$TT$Color$Extra$toColor(elementColor);
		return $author$project$TT$Color$Extra$fromColor(
			A2($noahzgordon$elm_color_extra$Color$Manipulate$lighten, offset, cl));
	});
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map = F2(
	function (func, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = function (node) {
			if (!node.$) {
				var subTree = node.a;
				return $elm$core$Array$SubTree(
					A2($elm$core$Elm$JsArray$map, helper, subTree));
			} else {
				var values = node.a;
				return $elm$core$Array$Leaf(
					A2($elm$core$Elm$JsArray$map, func, values));
			}
		};
		return A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A2($elm$core$Elm$JsArray$map, helper, tree),
			A2($elm$core$Elm$JsArray$map, func, tail));
	});
var $author$project$Model$categoryItemsAsDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (e) {
			return _Utils_Tuple2(e.g, e);
		},
		$author$project$Model$categoryItemsList));
var $author$project$Model$matchCategory = function (categoryText) {
	return A2($elm$core$Dict$get, categoryText, $author$project$Model$categoryItemsAsDict);
};
var $author$project$Model$educationLevelItemsAsDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (e) {
			return _Utils_Tuple2(e.g, e);
		},
		$author$project$Model$educationLevelItems));
var $author$project$Model$matchEducationLevel = function (educationLevelText) {
	return A2($elm$core$Dict$get, educationLevelText, $author$project$Model$educationLevelItemsAsDict);
};
var $author$project$Model$experienceLevelItemsAsDict = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (e) {
			return _Utils_Tuple2(e.g, e);
		},
		$author$project$Model$experienceLevelItemsList));
var $author$project$Model$matchExperienceLevel = function (experienceText) {
	return A2($elm$core$Dict$get, experienceText, $author$project$Model$experienceLevelItemsAsDict);
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $author$project$Ports$redirectoToExternalUrl = _Platform_outgoingPort(
	'redirectoToExternalUrl',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'externalApplyUrl',
					$elm$json$Json$Encode$string($.ic))
				]));
	});
var $author$project$Ports$refreshCandidateSession = _Platform_outgoingPort(
	'refreshCandidateSession',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'successUrl',
					$elm$json$Json$Encode$string($.k7))
				]));
	});
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $elm_community$string_extra$String$Extra$accentRegex = function () {
	var matches = _List_fromArray(
		[
			_Utils_Tuple2('[à-æ]', 'a'),
			_Utils_Tuple2('[À-Æ]', 'A'),
			_Utils_Tuple2('ç', 'c'),
			_Utils_Tuple2('Ç', 'C'),
			_Utils_Tuple2('[è-ë]', 'e'),
			_Utils_Tuple2('[È-Ë]', 'E'),
			_Utils_Tuple2('[ì-ï]', 'i'),
			_Utils_Tuple2('[Ì-Ï]', 'I'),
			_Utils_Tuple2('ñ', 'n'),
			_Utils_Tuple2('Ñ', 'N'),
			_Utils_Tuple2('[ò-ö]', 'o'),
			_Utils_Tuple2('[Ò-Ö]', 'O'),
			_Utils_Tuple2('[ù-ü]', 'u'),
			_Utils_Tuple2('[Ù-Ü]', 'U'),
			_Utils_Tuple2('ý', 'y'),
			_Utils_Tuple2('ÿ', 'y'),
			_Utils_Tuple2('Ý', 'Y')
		]);
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$mapFirst($elm_community$string_extra$String$Extra$regexFromString),
		matches);
}();
var $elm_community$string_extra$String$Extra$removeAccents = function (string) {
	if ($elm$core$String$isEmpty(string)) {
		return string;
	} else {
		var do_regex_to_remove_acents = function (_v1) {
			var regex = _v1.a;
			var replace_character = _v1.b;
			return A2(
				$elm$regex$Regex$replace,
				regex,
				function (_v0) {
					return replace_character;
				});
		};
		return A3($elm$core$List$foldl, do_regex_to_remove_acents, string, $elm_community$string_extra$String$Extra$accentRegex);
	}
};
var $author$project$Ports$removeGoogleSignInButton = _Platform_outgoingPort(
	'removeGoogleSignInButton',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$renderGoogleSignInButton = _Platform_outgoingPort(
	'renderGoogleSignInButton',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'googleClientId',
					$elm$json$Json$Encode$string($.is))
				]));
	});
var $author$project$Ports$saveJobAdAsFavoriteFromLocalStorage = _Platform_outgoingPort(
	'saveJobAdAsFavoriteFromLocalStorage',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Page$Home$MsgServerGotSavedJobAdResponse = F3(
	function (a, b, c) {
		return {$: 112, a: a, b: b, c: c};
	});
var $author$project$Page$Home$upgradeMsgServerGotSavedJobAdResponse = F3(
	function (jobAdId, position, result) {
		return A3(
			$author$project$Page$Home$MsgServerGotSavedJobAdResponse,
			jobAdId,
			position,
			$krisajenkins$remotedata$RemoteData$fromResult(result));
	});
var $author$project$Page$Home$saveJobAdAsFavorite = F2(
	function (model, position) {
		var _v0 = model.fl;
		if (!_v0.$) {
			var jobAdId = _v0.a;
			var candidateIsLoggedIn = model.J.dt.eu;
			var body = $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'job_ad_id',
						$elm$json$Json$Encode$string(jobAdId)),
						_Utils_Tuple2(
						'source',
						$elm$json$Json$Encode$string('new-apply'))
					]));
			if (candidateIsLoggedIn) {
				return _Utils_Tuple2(
					model,
					$elm$http$Http$riskyRequest(
						{
							ch: $elm$http$Http$jsonBody(body),
							dA: A2(
								$elm$http$Http$expectJson,
								A2($author$project$Page$Home$upgradeMsgServerGotSavedJobAdResponse, jobAdId, position),
								$author$project$TT$ApiModel$apiResponseSimpleStatusJsonDecoder),
							dJ: _List_Nil,
							dU: 'POST',
							d8: $elm$core$Maybe$Just(model.J.dS),
							d9: $elm$core$Maybe$Nothing,
							Q: model.J.cV + '/v1/candidate/save-job-ad'
						}));
			} else {
				var messageId = 'save-job-ad-ok';
				var successMessages = A2(
					$elm$core$Array$push,
					_Utils_Tuple2(
						messageId,
						A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text('Vacante añadida como favorita')
								]))),
					model.dd);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dd: successMessages}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$saveJobAdAsFavoriteFromLocalStorage(
								_Utils_Tuple2(jobAdId, position)),
								$author$project$Page$Home$delayHideNotification(
								$author$project$Page$Home$MsgBrowserHideSuccessMessage(messageId))
							])));
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Ports$scrollToChatTop = _Platform_outgoingPort(
	'scrollToChatTop',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Model$TkMagicLinkLoginResponseDo = F4(
	function (status, candidateFullname, candidateEmailHint, hasPassword) {
		return {hh: candidateEmailHint, hi: candidateFullname, e3: hasPassword, f9: status};
	});
var $author$project$Model$tkMagicLinkLoginResponseDoJsonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'has_password',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'candidate_email_hint',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'candidate_fullname',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$TkMagicLinkLoginResponseDo)))));
var $author$project$Page$Home$MsgServerGotMagicLinkResponse = function (a) {
	return {$: 71, a: a};
};
var $author$project$Page$Home$upgradeMsgServerGotMagicLinkResponse = function (result) {
	return $author$project$Page$Home$MsgServerGotMagicLinkResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$sendMagicLinkLogin = F2(
	function (model, email) {
		var minimized = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (m) {
					return m === 'true';
				},
				A2($author$project$TT$Util$extractSearchArgument, 'minimized', model.Q)));
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'resume_link',
					$elm$json$Json$Encode$string(
						$elm$url$Url$toString(model.Q))),
					_Utils_Tuple2(
					'minimized',
					$elm$json$Json$Encode$bool(minimized))
				]));
		return $elm$http$Http$riskyRequest(
			{
				ch: $elm$http$Http$jsonBody(body),
				dA: A2($elm$http$Http$expectJson, $author$project$Page$Home$upgradeMsgServerGotMagicLinkResponse, $author$project$Model$tkMagicLinkLoginResponseDoJsonDecoder),
				dJ: _List_Nil,
				dU: 'POST',
				d8: $elm$core$Maybe$Just(model.J.dS),
				d9: $elm$core$Maybe$Nothing,
				Q: model.J.cV + '/v1/candidate/auth/digits/request-by-email'
			});
	});
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $author$project$Page$Home$MsgServerGotSendToFriendSavedResponse = function (a) {
	return {$: 66, a: a};
};
var $author$project$Page$Home$upgradeMsgServerGotSendToFriendSentResponse = function (result) {
	return $author$project$Page$Home$MsgServerGotSendToFriendSavedResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$sendSendToFriendForm = function (model) {
	var _v0 = model.fl;
	if (!_v0.$) {
		var jobAdId = _v0.a;
		var sendToFriendModel = model.i;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'job_ad_id',
					$elm$json$Json$Encode$string(jobAdId)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(sendToFriendModel.cB.g)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(sendToFriendModel.at.g)),
					_Utils_Tuple2(
					'friend_email',
					$elm$json$Json$Encode$string(sendToFriendModel.an.g)),
					_Utils_Tuple2(
					'friend_name',
					$elm$json$Json$Encode$string(sendToFriendModel.ao.g)),
					_Utils_Tuple2(
					'spam_control',
					$elm$json$Json$Encode$string(sendToFriendModel.db))
				]));
		return $elm$http$Http$riskyRequest(
			{
				ch: $elm$http$Http$jsonBody(body),
				dA: $elm$http$Http$expectString($author$project$Page$Home$upgradeMsgServerGotSendToFriendSentResponse),
				dJ: _List_Nil,
				dU: 'POST',
				d8: $elm$core$Maybe$Just(model.J.dS),
				d9: $elm$core$Maybe$Nothing,
				Q: model.J.cV + '/v1/job-ad/send-to-a-friend'
			});
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$Array$sliceLeft = F2(
	function (from, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		if (!from) {
			return array;
		} else {
			if (_Utils_cmp(
				from,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					len - from,
					$elm$core$Array$shiftStep,
					$elm$core$Elm$JsArray$empty,
					A3(
						$elm$core$Elm$JsArray$slice,
						from - $elm$core$Array$tailIndex(len),
						$elm$core$Elm$JsArray$length(tail),
						tail));
			} else {
				var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
				var helper = F2(
					function (node, acc) {
						if (!node.$) {
							var subTree = node.a;
							return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
						} else {
							var leaf = node.a;
							return A2($elm$core$List$cons, leaf, acc);
						}
					});
				var leafNodes = A3(
					$elm$core$Elm$JsArray$foldr,
					helper,
					_List_fromArray(
						[tail]),
					tree);
				var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);
				if (!nodesToInsert.b) {
					return $elm$core$Array$empty;
				} else {
					var head = nodesToInsert.a;
					var rest = nodesToInsert.b;
					var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
					var initialBuilder = {
						z: _List_Nil,
						x: 0,
						y: A3(
							$elm$core$Elm$JsArray$slice,
							firstSlice,
							$elm$core$Elm$JsArray$length(head),
							head)
					};
					return A2(
						$elm$core$Array$builderToArray,
						true,
						A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
				}
			}
		}
	});
var $elm$core$Array$fetchNewTail = F4(
	function (shift, end, treeEnd, tree) {
		fetchNewTail:
		while (true) {
			var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var sub = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$end = end,
					$temp$treeEnd = treeEnd,
					$temp$tree = sub;
				shift = $temp$shift;
				end = $temp$end;
				treeEnd = $temp$treeEnd;
				tree = $temp$tree;
				continue fetchNewTail;
			} else {
				var values = _v0.a;
				return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
			}
		}
	});
var $elm$core$Array$hoistTree = F3(
	function (oldShift, newShift, tree) {
		hoistTree:
		while (true) {
			if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
				return tree;
			} else {
				var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
				if (!_v0.$) {
					var sub = _v0.a;
					var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
						$temp$newShift = newShift,
						$temp$tree = sub;
					oldShift = $temp$oldShift;
					newShift = $temp$newShift;
					tree = $temp$tree;
					continue hoistTree;
				} else {
					return tree;
				}
			}
		}
	});
var $elm$core$Array$sliceTree = F3(
	function (shift, endIdx, tree) {
		var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
		if (!_v0.$) {
			var sub = _v0.a;
			var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
			return (!$elm$core$Elm$JsArray$length(newSub)) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
				$elm$core$Elm$JsArray$unsafeSet,
				lastPos,
				$elm$core$Array$SubTree(newSub),
				A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
		} else {
			return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
		}
	});
var $elm$core$Array$sliceRight = F2(
	function (end, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		if (_Utils_eq(end, len)) {
			return array;
		} else {
			if (_Utils_cmp(
				end,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					startShift,
					tree,
					A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
			} else {
				var endIdx = $elm$core$Array$tailIndex(end);
				var depth = $elm$core$Basics$floor(
					A2(
						$elm$core$Basics$logBase,
						$elm$core$Array$branchFactor,
						A2($elm$core$Basics$max, 1, endIdx - 1)));
				var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					newShift,
					A3(
						$elm$core$Array$hoistTree,
						startShift,
						newShift,
						A3($elm$core$Array$sliceTree, startShift, endIdx, tree)),
					A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
			}
		}
	});
var $elm$core$Array$translateIndex = F2(
	function (index, _v0) {
		var len = _v0.a;
		var posIndex = (index < 0) ? (len + index) : index;
		return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
	});
var $elm$core$Array$slice = F3(
	function (from, to, array) {
		var correctTo = A2($elm$core$Array$translateIndex, to, array);
		var correctFrom = A2($elm$core$Array$translateIndex, from, array);
		return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : A2(
			$elm$core$Array$sliceLeft,
			correctFrom,
			A2($elm$core$Array$sliceRight, correctTo, array));
	});
var $author$project$Page$Home$MsgServerApplyQuestionsSavedResponse = function (a) {
	return {$: 42, a: a};
};
var $author$project$Page$Home$upgradeMsgServerApplyQuestionsSavedResponse = function (result) {
	return $author$project$Page$Home$MsgServerApplyQuestionsSavedResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$submitApplyQuestions = function (model) {
	var _v0 = model.fl;
	if (!_v0.$) {
		var jobAdId = _v0.a;
		var candidateInfoDo = model.a.b;
		var applyQuestionsDo = model.e.d;
		var body = $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'job_ad_id',
						$elm$json$Json$Encode$string(jobAdId)),
						_Utils_Tuple2(
						'source',
						$elm$json$Json$Encode$string(model.M)),
						_Utils_Tuple2(
						'experience_years',
						$elm$json$Json$Encode$string(applyQuestionsDo.dC.g)),
						_Utils_Tuple2(
						'skills_list',
						A2(
							$elm$json$Json$Encode$list,
							$elm$json$Json$Encode$string,
							$elm$core$Array$toList(
								A2(
									$elm$core$Array$map,
									function ($) {
										return $.g;
									},
									applyQuestionsDo.kS))))
					]),
				_Utils_ap(
					function () {
						var _v1 = candidateInfoDo.cB.g;
						if (!_v1.$) {
							var email = _v1.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(email))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v2 = applyQuestionsDo.du.g;
							if (!_v2.$) {
								var category = _v2.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'category',
										$elm$json$Json$Encode$string(category.g))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						_Utils_ap(
							function () {
								var _v3 = applyQuestionsDo.dB.g;
								if (!_v3.$) {
									var experience = _v3.a;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'experience_level',
											$elm$json$Json$Encode$string(experience.g))
										]);
								} else {
									return _List_Nil;
								}
							}(),
							function () {
								var _v4 = applyQuestionsDo.dz.g;
								if (!_v4.$) {
									var educationLevel = _v4.a;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'education_level',
											$elm$json$Json$Encode$string(educationLevel.g))
										]);
								} else {
									return _List_Nil;
								}
							}())))));
		return $elm$http$Http$riskyRequest(
			{
				ch: $elm$http$Http$jsonBody(body),
				dA: $elm$http$Http$expectWhatever($author$project$Page$Home$upgradeMsgServerApplyQuestionsSavedResponse),
				dJ: _List_Nil,
				dU: 'POST',
				d8: $elm$core$Maybe$Just(model.J.dS),
				d9: $elm$core$Maybe$Nothing,
				Q: model.J.cV + '/v1/apply/apply-questions'
			});
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Model$TkApplyApiResultDo = F3(
	function (success, succesMessage, errorMessage) {
		return {bM: errorMessage, k5: succesMessage, k6: success};
	});
var $author$project$Model$tkApplyApiResultDoJsonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'error_message',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'success_message',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'success',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Model$TkApplyApiResultDo))));
var $author$project$Page$Home$MsgServerCandidateCvSavedResponse = F3(
	function (a, b, c) {
		return {$: 51, a: a, b: b, c: c};
	});
var $author$project$Page$Home$upgradeMsgServerCandidateCvSavedResponse = F3(
	function (jobAdId, companyName, result) {
		return A3(
			$author$project$Page$Home$MsgServerCandidateCvSavedResponse,
			jobAdId,
			companyName,
			$krisajenkins$remotedata$RemoteData$fromResult(result));
	});
var $author$project$Page$Home$submitCandidateCv = function (model) {
	var _v0 = model.fl;
	if (!_v0.$) {
		var jobAdId = _v0.a;
		var queryParamsFromUrl = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (uq) {
				return '?' + uq;
			},
			A2($author$project$Model$removeQueryParam, 'ci', model.Q.j6));
		var companyName = A3(
			$krisajenkins$remotedata$RemoteData$unwrap,
			$elm$core$Maybe$Nothing,
			function (summary) {
				return $elm$core$Maybe$Just(summary.hK);
			},
			model.bS);
		var candidateInfoDo = model.a.b;
		var candidateCvDo = model.k.u;
		var body = $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'job_ad_id',
						$elm$json$Json$Encode$string(jobAdId)),
						_Utils_Tuple2(
						'source',
						$elm$json$Json$Encode$string(model.M)),
						_Utils_Tuple2(
						'message',
						$elm$json$Json$Encode$string(candidateCvDo.js)),
						_Utils_Tuple2(
						'private_cv',
						$elm$json$Json$Encode$bool(!candidateCvDo.j1)),
						_Utils_Tuple2(
						'subscribe_to_notifications',
						$elm$json$Json$Encode$bool(candidateCvDo.k3))
					]),
				_Utils_ap(
					function () {
						var _v1 = candidateInfoDo.cB.g;
						if (!_v1.$) {
							var email = _v1.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(email))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v2 = candidateCvDo.hm;
							if (!_v2.$) {
								var candidateNewCv = _v2.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'new_cv',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'array_bytes',
													$elm$json$Json$Encode$string(candidateNewCv.gX)),
													_Utils_Tuple2(
													'mime_type',
													$elm$json$Json$Encode$string(candidateNewCv.dV)),
													_Utils_Tuple2(
													'file_name',
													$elm$json$Json$Encode$string(candidateNewCv.ie))
												])))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						function () {
							var _v3 = candidateCvDo.hg;
							if (!_v3.$) {
								var candidateCurrentCv = _v3.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'current_cv',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'attachment_path',
													$elm$json$Json$Encode$string(candidateCurrentCv.dq)),
													_Utils_Tuple2(
													'attachment_hash',
													$elm$json$Json$Encode$string(candidateCurrentCv.dp)),
													_Utils_Tuple2(
													'attachment_mime_type',
													$elm$json$Json$Encode$string(candidateCurrentCv.g_))
												])))
									]);
							} else {
								return _List_Nil;
							}
						}()))));
		return $elm$http$Http$riskyRequest(
			{
				ch: $elm$http$Http$jsonBody(body),
				dA: A2(
					$elm$http$Http$expectJson,
					A2($author$project$Page$Home$upgradeMsgServerCandidateCvSavedResponse, jobAdId, companyName),
					$author$project$Model$tkApplyApiResultDoJsonDecoder),
				dJ: _List_Nil,
				dU: 'POST',
				d8: $elm$core$Maybe$Just(model.J.jp),
				d9: $elm$core$Maybe$Nothing,
				Q: model.J.cV + ('/v1/apply/candidate-cv' + queryParamsFromUrl)
			});
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Page$Home$MsgServerCandidateInfoSavedResponse = F3(
	function (a, b, c) {
		return {$: 21, a: a, b: b, c: c};
	});
var $author$project$Page$Home$upgradeMsgServerCandidateInfoSavedResponse = F3(
	function (jobAdId, tkJobAdSummaryDo, result) {
		return A3(
			$author$project$Page$Home$MsgServerCandidateInfoSavedResponse,
			jobAdId,
			tkJobAdSummaryDo,
			$krisajenkins$remotedata$RemoteData$fromResult(result));
	});
var $author$project$Page$Home$submitCandidateInfo = F2(
	function (model, tkJobAdSummaryDo) {
		var _v0 = model.fl;
		if (!_v0.$) {
			var jobAdId = _v0.a;
			var candidateInfoDo = model.a.b;
			var candidateInfoBody = $elm$json$Json$Encode$object(
				_Utils_ap(
					function () {
						var _v1 = candidateInfoDo.cB.g;
						if (!_v1.$) {
							var email = _v1.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(email))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v2 = candidateInfoDo.dG.g;
							if (!_v2.$) {
								var fullname = _v2.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'full_name',
										$elm$json$Json$Encode$string(fullname))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						_Utils_ap(
							function () {
								var _v3 = candidateInfoDo.jT.g;
								if (!_v3.$) {
									var phone = _v3.a;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'phone_number',
											$elm$json$Json$Encode$string(phone))
										]);
								} else {
									return _List_Nil;
								}
							}(),
							_Utils_ap(
								function () {
									var _v4 = candidateInfoDo.dK.g;
									if (!_v4.$) {
										var headline = _v4.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'headline',
												$elm$json$Json$Encode$string(headline))
											]);
									} else {
										return _List_Nil;
									}
								}(),
								_Utils_ap(
									function () {
										var _v5 = tkJobAdSummaryDo.hJ;
										if (!_v5.$) {
											var companyId = _v5.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'corporate_id',
													$elm$json$Json$Encode$string(companyId))
												]);
										} else {
											return _List_Nil;
										}
									}(),
									_Utils_ap(
										function () {
											var _v6 = candidateInfoDo.cU.g;
											if (!_v6.$) {
												var location = _v6.a;
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'location',
														$elm$json$Json$Encode$object(
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2(
																	'display_name',
																	$elm$json$Json$Encode$string(location)),
																_Utils_ap(
																	A2(
																		$elm$core$Maybe$withDefault,
																		_List_Nil,
																		A2(
																			$elm$core$Maybe$map,
																			function (l) {
																				return _List_fromArray(
																					[
																						_Utils_Tuple2(
																						'city_name',
																						$elm$json$Json$Encode$string(l.ez))
																					]);
																			},
																			candidateInfoDo.cU.f3)),
																	_Utils_ap(
																		A2(
																			$elm$core$Maybe$withDefault,
																			_List_Nil,
																			A2(
																				$elm$core$Maybe$map,
																				function (l) {
																					return _List_fromArray(
																						[
																							_Utils_Tuple2(
																							'city_id',
																							$elm$json$Json$Encode$string(l.ht))
																						]);
																				},
																				candidateInfoDo.cU.f3)),
																		_Utils_ap(
																			A2(
																				$elm$core$Maybe$withDefault,
																				_List_Nil,
																				A2(
																					$elm$core$Maybe$map,
																					function (l) {
																						return _List_fromArray(
																							[
																								_Utils_Tuple2(
																								'region_name',
																								$elm$json$Json$Encode$string(l.fT))
																							]);
																					},
																					candidateInfoDo.cU.f3)),
																			A2(
																				$elm$core$Maybe$withDefault,
																				_List_Nil,
																				A2(
																					$elm$core$Maybe$map,
																					function (l) {
																						return _List_fromArray(
																							[
																								_Utils_Tuple2(
																								'region_id',
																								$elm$json$Json$Encode$string(l.kp))
																							]);
																					},
																					candidateInfoDo.cU.f3))))))))
													]);
											} else {
												return _List_Nil;
											}
										}(),
										_List_fromArray(
											[
												_Utils_Tuple2(
												'recruiter_id',
												$elm$json$Json$Encode$string(tkJobAdSummaryDo.kb)),
												_Utils_Tuple2(
												'recruiter_plan_type',
												$elm$json$Json$Encode$string(tkJobAdSummaryDo.kk)),
												_Utils_Tuple2(
												'recruiter_plan_is_paid',
												$elm$json$Json$Encode$bool(tkJobAdSummaryDo.kj)),
												_Utils_Tuple2(
												'country_code',
												$elm$json$Json$Encode$string(
													A2($elm$core$Maybe$withDefault, tkJobAdSummaryDo.hU, model.hU))),
												_Utils_Tuple2(
												'source',
												$elm$json$Json$Encode$string(model.M))
											]))))))));
			var body = $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'job_ad_id',
						$elm$json$Json$Encode$string(jobAdId)),
						_Utils_Tuple2('candidate_info', candidateInfoBody)
					]));
			return $elm$http$Http$riskyRequest(
				{
					ch: $elm$http$Http$jsonBody(body),
					dA: $elm$http$Http$expectWhatever(
						A2($author$project$Page$Home$upgradeMsgServerCandidateInfoSavedResponse, jobAdId, tkJobAdSummaryDo)),
					dJ: _List_Nil,
					dU: 'POST',
					d8: $elm$core$Maybe$Just(model.J.dS),
					d9: $elm$core$Maybe$Nothing,
					Q: model.J.cV + '/v1/apply/candidate/info'
				});
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Page$Home$MsgServerFilterQuestionsSavedResponse = function (a) {
	return {$: 27, a: a};
};
var $author$project$Page$Home$upgradeMsgServerFilterQuestionsSavedResponse = function (result) {
	return $author$project$Page$Home$MsgServerFilterQuestionsSavedResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$submitFilterQuestions = function (model) {
	var _v0 = model.fl;
	if (!_v0.$) {
		var jobAdId = _v0.a;
		var candidateInfoDo = model.a.b;
		var answersList = model.o.gS;
		var answersEncoder = function (_v2) {
			var id = _v2.a;
			var answer = _v2.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(id)),
						_Utils_Tuple2(
						'answer',
						$elm$json$Json$Encode$string(answer.g))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'job_ad_id',
						$elm$json$Json$Encode$string(jobAdId)),
						_Utils_Tuple2(
						'source',
						$elm$json$Json$Encode$string(model.M)),
						_Utils_Tuple2(
						'answers',
						A2(
							$elm$json$Json$Encode$list,
							answersEncoder,
							$elm$core$Dict$toList(answersList)))
					]),
				function () {
					var _v1 = candidateInfoDo.cB.g;
					if (!_v1.$) {
						var email = _v1.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(email))
							]);
					} else {
						return _List_Nil;
					}
				}()));
		return $elm$http$Http$riskyRequest(
			{
				ch: $elm$http$Http$jsonBody(body),
				dA: $elm$http$Http$expectWhatever($author$project$Page$Home$upgradeMsgServerFilterQuestionsSavedResponse),
				dJ: _List_Nil,
				dU: 'POST',
				d8: $elm$core$Maybe$Just(model.J.dS),
				d9: $elm$core$Maybe$Nothing,
				Q: model.J.cV + '/v1/apply/filter-questions'
			});
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Model$TkCurrentCandidateApplyDo = F3(
	function (currentStep, jobAdId, candidateApplyInfo) {
		return {es: candidateApplyInfo, eE: currentStep, fl: jobAdId};
	});
var $author$project$Model$CompleteApplyStep = 6;
var $author$project$Model$applyScreenStringAsStep = function (step) {
	switch (step) {
		case 'WelcomeStep':
			return 0;
		case 'CandidateInfoStep':
			return 1;
		case 'ExternalApplyStep':
			return 2;
		case 'FilterQuestionsStep':
			return 3;
		case 'ApplyQuestionsStep':
			return 4;
		case 'CandidateCvStep':
			return 5;
		case 'CompleteApplyStep':
			return 6;
		default:
			return 1;
	}
};
var $author$project$Model$tkCurrentCandidateApplyDoJsonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'apply_info',
	$author$project$Model$tkApiCandidateApplyInfoDoJsonDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'job_ad_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'current_step',
			A2($elm$json$Json$Decode$map, $author$project$Model$applyScreenStringAsStep, $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Model$TkCurrentCandidateApplyDo))));
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $author$project$Ports$trackCompleteApplication = _Platform_outgoingPort(
	'trackCompleteApplication',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'companyName',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.hK)),
					_Utils_Tuple2(
					'jobAdId',
					$elm$json$Json$Encode$string($.fl)),
					_Utils_Tuple2(
					'source',
					$elm$json$Json$Encode$string($.M))
				]));
	});
var $author$project$Page$Home$trackExternalApplication = F3(
	function (model, jobAdId, companyId) {
		var body = $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'job_ad_id',
						$elm$json$Json$Encode$string(jobAdId)),
						_Utils_Tuple2(
						'source',
						$elm$json$Json$Encode$string(model.M)),
						_Utils_Tuple2(
						'provider',
						$elm$json$Json$Encode$string(model.d$))
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (e) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'company_id',
									$elm$json$Json$Encode$string(e))
								]);
						},
						companyId))));
		return $elm$http$Http$riskyRequest(
			{
				ch: $elm$http$Http$jsonBody(body),
				dA: $elm$http$Http$expectString(
					function (_v0) {
						return $author$project$Page$Home$PassThrough;
					}),
				dJ: _List_Nil,
				dU: 'POST',
				d8: $elm$core$Maybe$Just(model.J.dS),
				d9: $elm$core$Maybe$Nothing,
				Q: model.J.cV + '/v1/apply/track-external-application'
			});
	});
var $author$project$Page$Home$trackGoogleSignInButtonClick = function (model) {
	return $elm$http$Http$riskyRequest(
		{
			ch: $elm$http$Http$emptyBody,
			dA: $elm$http$Http$expectString(
				function (_v0) {
					return $author$project$Page$Home$PassThrough;
				}),
			dJ: _List_Nil,
			dU: 'POST',
			d8: $elm$core$Maybe$Just(model.J.dS),
			d9: $elm$core$Maybe$Nothing,
			Q: model.J.cV + '/v1/apply/track-google-sign-in'
		});
};
var $author$project$Ports$trackInitiateApplication = _Platform_outgoingPort(
	'trackInitiateApplication',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'jobAdId',
					$elm$json$Json$Encode$string($.fl)),
					_Utils_Tuple2(
					'source',
					$elm$json$Json$Encode$string($.M))
				]));
	});
var $author$project$Ports$triggerUploadButton = _Platform_outgoingPort('triggerUploadButton', $elm$json$Json$Encode$string);
var $author$project$TT$Dropdown$HeadOption = function (a) {
	return {$: 1, a: a};
};
var $author$project$TT$Dropdown$findFocusedItem = F2(
	function (focusedIndex, items) {
		var maybeFocusedItemFold = F2(
			function (list, i) {
				if (list.b) {
					var item = list.a;
					var tail = list.b;
					return _Utils_eq(i, focusedIndex) ? $elm$core$Maybe$Just(item) : A2(maybeFocusedItemFold, tail, i + 1);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			});
		return A2(maybeFocusedItemFold, items, 0);
	});
var $author$project$TT$Dropdown$updateSelectedItemCommand = F2(
	function (onSelectedMsg, itemNew) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$identity,
			$elm$core$Task$succeed(
				onSelectedMsg(itemNew)));
	});
var $author$project$TT$Dropdown$updateKeyDown = F4(
	function (config, key, model, state) {
		var items = (!$elm$core$List$length(state.jP)) ? state.Z : state.jP;
		var clampIndex = function (i) {
			return A3(
				$elm$core$Basics$clamp,
				0,
				$elm$core$List$length(items) - 1,
				i);
		};
		switch (key) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{
							ad: clampIndex(state.ad + 1),
							L: true
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{
							ad: clampIndex(state.ad - 1),
							L: true
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return (!state.L) ? _Utils_Tuple2(
					_Utils_update(
						state,
						{L: true}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						state,
						{L: false}),
					function () {
						var _v1 = A2($author$project$TT$Dropdown$findFocusedItem, state.ad, state.Z);
						if (!_v1.$) {
							var focusedItem = _v1.a;
							return A2($author$project$TT$Dropdown$updateSelectedItemCommand, config.fy, focusedItem);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			default:
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{ad: -1, L: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$TT$Dropdown$filter = F3(
	function (condFunc, val, state) {
		var val_ = $elm$core$String$toLower(val);
		return $elm$core$List$filter(
			function (optionType) {
				if (!optionType.$) {
					var _v1 = optionType.a;
					var label_ = _v1.b;
					var item = _v1.c;
					var _v2 = state.bX;
					if (!_v2.$) {
						var matchFunction = _v2.a;
						return A3(matchFunction, condFunc, val_, item);
					} else {
						return A2(
							condFunc,
							val_,
							$elm$core$String$toLower(label_));
					}
				} else {
					var _v3 = optionType.a;
					var label_ = _v3.b;
					var item = _v3.c;
					var _v4 = state.bX;
					if (!_v4.$) {
						var matchFunction = _v4.a;
						return A3(matchFunction, condFunc, val_, item);
					} else {
						return A2(
							condFunc,
							val_,
							$elm$core$String$toLower(label_));
					}
				}
			});
	});
var $author$project$TT$Dropdown$filterContains = $author$project$TT$Dropdown$filter($elm$core$String$contains);
var $author$project$TT$Dropdown$filterStartsWith = $author$project$TT$Dropdown$filter($elm$core$String$startsWith);
var $author$project$TT$Dropdown$filterStartsWithThenContains = F3(
	function (val, options_, state) {
		var startsWith = A3($author$project$TT$Dropdown$filterStartsWith, val, state, options_);
		var contains = A2(
			$elm$core$List$filter,
			function (v) {
				return !A2($elm$core$List$member, v, startsWith);
			},
			A3($author$project$TT$Dropdown$filterContains, val, state, options_));
		return A2($elm$core$List$append, startsWith, contains);
	});
var $author$project$TT$Dropdown$updateMatchedOptions = F3(
	function (val, options_, state) {
		var setIndex = F2(
			function (index, optionType) {
				if (!optionType.$) {
					var _v1 = optionType.a;
					var label_ = _v1.b;
					var option = _v1.c;
					return $author$project$TT$Dropdown$Option(
						_Utils_Tuple3(index, label_, option));
				} else {
					var _v2 = optionType.a;
					var label_ = _v2.b;
					var option = _v2.c;
					return $author$project$TT$Dropdown$HeadOption(
						_Utils_Tuple3(index, label_, option));
				}
			});
		var setIndices = $elm$core$List$indexedMap(setIndex);
		return setIndices(
			A3($author$project$TT$Dropdown$filterStartsWithThenContains, val, options_, state));
	});
var $author$project$TT$Dropdown$updateOnBlurCommand = function (onBlurMsg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(onBlurMsg));
};
var $author$project$TT$Dropdown$update = F4(
	function (_v0, msg, model, _v1) {
		var config = _v0;
		var state = _v1;
		switch (msg.$) {
			case 0:
				var isOpen = function () {
					var _v3 = config.fb;
					if (!_v3.$) {
						return !state.L;
					} else {
						return true;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{L: isOpen}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var item = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{ad: -1, L: false}),
					A2($author$project$TT$Dropdown$updateSelectedItemCommand, config.fy, item));
			case 2:
				var key = msg.a;
				return A4($author$project$TT$Dropdown$updateKeyDown, config, key, model, state);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{L: false}),
					function () {
						var _v4 = config.cX;
						if (!_v4.$) {
							var onBlurMsg = _v4.a;
							return $author$project$TT$Dropdown$updateOnBlurCommand(onBlurMsg);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 4:
				var text = msg.a;
				var matchedOptions_ = $elm$core$String$isEmpty(text) ? (config.b1 ? state.jP : _List_Nil) : A3($author$project$TT$Dropdown$updateMatchedOptions, text, state.jP, state);
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{L: true, Z: matchedOptions_}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var result = msg.a;
				var accessorFunc = msg.b;
				var options__ = A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, option) {
							return $author$project$TT$Dropdown$Option(
								_Utils_Tuple3(
									index,
									accessorFunc(option),
									option));
						}),
					result);
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{Z: options__, jP: options__}),
					$elm$core$Platform$Cmd$none);
			default:
				var result = msg.a;
				var accessorFunc = msg.b;
				var accessorHeadFunc = msg.c;
				var _v5 = A3(
					$elm$core$List$foldl,
					F2(
						function (_v6, _v7) {
							var head = _v6.a;
							var groupedData = _v6.b;
							var counter = _v7.a;
							var acc = _v7.b;
							var num_elements = $elm$core$List$length(groupedData);
							var _v8 = A3(
								$elm$core$List$foldl,
								F2(
									function (item, _v9) {
										var internal_counter = _v9.a;
										var internal_acc = _v9.b;
										return _Utils_Tuple2(
											internal_counter + 1,
											A2(
												$elm$core$List$cons,
												$author$project$TT$Dropdown$Option(
													_Utils_Tuple3(
														internal_counter,
														accessorFunc(item),
														item)),
												internal_acc));
									}),
								_Utils_Tuple2(counter + 1, _List_Nil),
								A2($elm$core$List$cons, head, groupedData));
							var elements = _v8.b;
							var group = _Utils_ap(
								_List_fromArray(
									[
										$author$project$TT$Dropdown$HeadOption(
										_Utils_Tuple3(
											counter,
											accessorHeadFunc(head),
											head))
									]),
								$elm$core$List$reverse(elements));
							return _Utils_Tuple2(
								(counter + num_elements) + 2,
								_Utils_ap(acc, group));
						}),
					_Utils_Tuple2(0, _List_Nil),
					result);
				var options__ = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						state,
						{Z: options__, jP: options__}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $truqu$elm_base64$Base64$Encode$intToBase64 = function (i) {
	switch (i) {
		case 0:
			return 'A';
		case 1:
			return 'B';
		case 2:
			return 'C';
		case 3:
			return 'D';
		case 4:
			return 'E';
		case 5:
			return 'F';
		case 6:
			return 'G';
		case 7:
			return 'H';
		case 8:
			return 'I';
		case 9:
			return 'J';
		case 10:
			return 'K';
		case 11:
			return 'L';
		case 12:
			return 'M';
		case 13:
			return 'N';
		case 14:
			return 'O';
		case 15:
			return 'P';
		case 16:
			return 'Q';
		case 17:
			return 'R';
		case 18:
			return 'S';
		case 19:
			return 'T';
		case 20:
			return 'U';
		case 21:
			return 'V';
		case 22:
			return 'W';
		case 23:
			return 'X';
		case 24:
			return 'Y';
		case 25:
			return 'Z';
		case 26:
			return 'a';
		case 27:
			return 'b';
		case 28:
			return 'c';
		case 29:
			return 'd';
		case 30:
			return 'e';
		case 31:
			return 'f';
		case 32:
			return 'g';
		case 33:
			return 'h';
		case 34:
			return 'i';
		case 35:
			return 'j';
		case 36:
			return 'k';
		case 37:
			return 'l';
		case 38:
			return 'm';
		case 39:
			return 'n';
		case 40:
			return 'o';
		case 41:
			return 'p';
		case 42:
			return 'q';
		case 43:
			return 'r';
		case 44:
			return 's';
		case 45:
			return 't';
		case 46:
			return 'u';
		case 47:
			return 'v';
		case 48:
			return 'w';
		case 49:
			return 'x';
		case 50:
			return 'y';
		case 51:
			return 'z';
		case 52:
			return '0';
		case 53:
			return '1';
		case 54:
			return '2';
		case 55:
			return '3';
		case 56:
			return '4';
		case 57:
			return '5';
		case 58:
			return '6';
		case 59:
			return '7';
		case 60:
			return '8';
		case 61:
			return '9';
		case 62:
			return '+';
		default:
			return '/';
	}
};
var $truqu$elm_base64$Base64$Encode$toBase64 = function (_int) {
	return _Utils_ap(
		$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 18)),
		_Utils_ap(
			$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 12)),
			_Utils_ap(
				$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 6)),
				$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 0)))));
};
var $truqu$elm_base64$Base64$Encode$add = F2(
	function (_char, _v0) {
		var res = _v0.a;
		var count = _v0.b;
		var acc = _v0.c;
		var current = (acc << 8) | _char;
		if (count === 2) {
			return _Utils_Tuple3(
				_Utils_ap(
					res,
					$truqu$elm_base64$Base64$Encode$toBase64(current)),
				0,
				0);
		} else {
			return _Utils_Tuple3(res, count + 1, current);
		}
	});
var $truqu$elm_base64$Base64$Encode$chomp = F2(
	function (char_, acc) {
		var _char = $elm$core$Char$toCode(char_);
		return (_char < 128) ? A2($truqu$elm_base64$Base64$Encode$add, _char, acc) : ((_char < 2048) ? A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2($truqu$elm_base64$Base64$Encode$add, 192 | (_char >>> 6), acc)) : (((_char < 55296) || ((_char >= 57344) && (_char <= 65535))) ? A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2(
				$truqu$elm_base64$Base64$Encode$add,
				128 | (63 & (_char >>> 6)),
				A2($truqu$elm_base64$Base64$Encode$add, 224 | (_char >>> 12), acc))) : A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2(
				$truqu$elm_base64$Base64$Encode$add,
				128 | (63 & (_char >>> 6)),
				A2(
					$truqu$elm_base64$Base64$Encode$add,
					128 | (63 & (_char >>> 12)),
					A2($truqu$elm_base64$Base64$Encode$add, 240 | (_char >>> 18), acc))))));
	});
var $truqu$elm_base64$Base64$Encode$initial = _Utils_Tuple3('', 0, 0);
var $truqu$elm_base64$Base64$Encode$wrapUp = function (_v0) {
	var res = _v0.a;
	var cnt = _v0.b;
	var acc = _v0.c;
	switch (cnt) {
		case 1:
			return res + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 2)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc << 4)) + '=='));
		case 2:
			return res + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 10)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 4)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc << 2)) + '=')));
		default:
			return res;
	}
};
var $truqu$elm_base64$Base64$Encode$encode = function (input) {
	return $truqu$elm_base64$Base64$Encode$wrapUp(
		A3($elm$core$String$foldl, $truqu$elm_base64$Base64$Encode$chomp, $truqu$elm_base64$Base64$Encode$initial, input));
};
var $truqu$elm_base64$Base64$encode = $truqu$elm_base64$Base64$Encode$encode;
var $author$project$Model$applyScreenStepAsString = function (step) {
	switch (step) {
		case 0:
			return 'WelcomeStep';
		case 1:
			return 'CandidateInfoStep';
		case 2:
			return 'ExternalApplyStep';
		case 3:
			return 'FilterQuestionsStep';
		case 4:
			return 'ApplyQuestionsStep';
		case 5:
			return 'CandidateCvStep';
		case 6:
			return 'CompleteApplyStep';
		default:
			return 'EmptyScreenStep';
	}
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Model$tkApplyCandidateLocationDoEncoder = function (locationDo) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			function () {
				var _v0 = locationDo.eL;
				if (!_v0.$) {
					var displayName = _v0.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'display_name',
							$elm$json$Json$Encode$string(displayName))
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _v1 = locationDo.ey;
					if (!_v1.$) {
						var cityName = _v1.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'city_name',
								$elm$json$Json$Encode$string(cityName))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						var _v2 = locationDo.ex;
						if (!_v2.$) {
							var cityId = _v2.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'city_id',
									$elm$json$Json$Encode$string(cityId))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v3 = locationDo.fS;
							if (!_v3.$) {
								var regionName = _v3.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'region_name',
										$elm$json$Json$Encode$string(regionName))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						function () {
							var _v4 = locationDo.fR;
							if (!_v4.$) {
								var regionId = _v4.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'region_id',
										$elm$json$Json$Encode$string(regionId))
									]);
							} else {
								return _List_Nil;
							}
						}())))));
};
var $author$project$Model$tkApiCandidateApplyInfoDoEncoder = function (applyInfo) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(applyInfo.cB)),
					_Utils_Tuple2(
					'private_cv',
					$elm$json$Json$Encode$bool(applyInfo.fJ)),
					_Utils_Tuple2(
					'candidate_already_applied',
					$elm$json$Json$Encode$bool(applyInfo.er))
				]),
			_Utils_ap(
				function () {
					var _v0 = applyInfo.dG;
					if (!_v0.$) {
						var fullname = _v0.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'full_name',
								$elm$json$Json$Encode$string(fullname))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						var _v1 = applyInfo.fD;
						if (!_v1.$) {
							var phone = _v1.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'phone_number',
									$elm$json$Json$Encode$string(phone))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v2 = applyInfo.cU;
							if (!_v2.$) {
								var location = _v2.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'location',
										$author$project$Model$tkApplyCandidateLocationDoEncoder(location))
									]);
							} else {
								return _List_Nil;
							}
						}(),
						_Utils_ap(
							function () {
								var _v3 = applyInfo.dK;
								if (!_v3.$) {
									var headline = _v3.a;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'headline',
											$elm$json$Json$Encode$string(headline))
										]);
								} else {
									return _List_Nil;
								}
							}(),
							_Utils_ap(
								function () {
									var _v4 = applyInfo.du;
									if (!_v4.$) {
										var category = _v4.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'category',
												$elm$json$Json$Encode$string(category))
											]);
									} else {
										return _List_Nil;
									}
								}(),
								_Utils_ap(
									function () {
										var _v5 = applyInfo.dB;
										if (!_v5.$) {
											var experience = _v5.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'experience_level',
													$elm$json$Json$Encode$string(experience))
												]);
										} else {
											return _List_Nil;
										}
									}(),
									_Utils_ap(
										function () {
											var _v6 = applyInfo.dz;
											if (!_v6.$) {
												var educationLevel = _v6.a;
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'education_level',
														$elm$json$Json$Encode$string(educationLevel))
													]);
											} else {
												return _List_Nil;
											}
										}(),
										_Utils_ap(
											function () {
												var _v7 = applyInfo.dC;
												if (!_v7.$) {
													var experienceYears = _v7.a;
													return _List_fromArray(
														[
															_Utils_Tuple2(
															'experience_years',
															$elm$json$Json$Encode$int(experienceYears))
														]);
												} else {
													return _List_Nil;
												}
											}(),
											_Utils_ap(
												function () {
													var _v8 = applyInfo.d4;
													if (!_v8.$) {
														var skillsList = _v8.a;
														return _List_fromArray(
															[
																_Utils_Tuple2(
																'skills_list',
																A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, skillsList))
															]);
													} else {
														return _List_Nil;
													}
												}(),
												_Utils_ap(
													function () {
														var _v9 = applyInfo.dq;
														if (!_v9.$) {
															var attachmentPath = _v9.a;
															return _List_fromArray(
																[
																	_Utils_Tuple2(
																	'attachment_path',
																	$elm$json$Json$Encode$string(attachmentPath))
																]);
														} else {
															return _List_Nil;
														}
													}(),
													_Utils_ap(
														function () {
															var _v10 = applyInfo.dp;
															if (!_v10.$) {
																var attachmentHash = _v10.a;
																return _List_fromArray(
																	[
																		_Utils_Tuple2(
																		'attachment_hash',
																		$elm$json$Json$Encode$string(attachmentHash))
																	]);
															} else {
																return _List_Nil;
															}
														}(),
														_Utils_ap(
															function () {
																var _v11 = applyInfo.dV;
																if (!_v11.$) {
																	var mimeType = _v11.a;
																	return _List_fromArray(
																		[
																			_Utils_Tuple2(
																			'mime_type',
																			$elm$json$Json$Encode$string(mimeType))
																		]);
																} else {
																	return _List_Nil;
																}
															}(),
															_Utils_ap(
																function () {
																	var _v12 = applyInfo.eH;
																	if (!_v12.$) {
																		var cvDownloadLink = _v12.a;
																		return _List_fromArray(
																			[
																				_Utils_Tuple2(
																				'cv_download_link',
																				$elm$json$Json$Encode$string(cvDownloadLink))
																			]);
																	} else {
																		return _List_Nil;
																	}
																}(),
																_Utils_ap(
																	function () {
																		var _v13 = applyInfo.js;
																		if (!_v13.$) {
																			var message = _v13.a;
																			return _List_fromArray(
																				[
																					_Utils_Tuple2(
																					'message',
																					$elm$json$Json$Encode$string(message))
																				]);
																		} else {
																			return _List_Nil;
																		}
																	}(),
																	_Utils_ap(
																		function () {
																			var _v14 = applyInfo.eG;
																			if (!_v14.$) {
																				var cvCreatedAtHumanReadable = _v14.a;
																				return _List_fromArray(
																					[
																						_Utils_Tuple2(
																						'cv_created_at_human_readable',
																						$elm$json$Json$Encode$string(cvCreatedAtHumanReadable))
																					]);
																			} else {
																				return _List_Nil;
																			}
																		}(),
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				'is_current_cv_from_profile',
																				$elm$json$Json$Encode$bool(applyInfo.ff))
																			]))))))))))))))))));
};
var $author$project$Model$tkCurrentCandidateApplyDoEncoder = function (currentCandidateApplyDo) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'current_step',
				$elm$json$Json$Encode$string(
					$author$project$Model$applyScreenStepAsString(currentCandidateApplyDo.eE))),
				_Utils_Tuple2(
				'job_ad_id',
				$elm$json$Json$Encode$string(currentCandidateApplyDo.fl)),
				_Utils_Tuple2(
				'apply_info',
				$author$project$Model$tkApiCandidateApplyInfoDoEncoder(currentCandidateApplyDo.es))
			]));
};
var $author$project$Page$Home$getCandidateInfoEncoded = function (currentApplyInfo) {
	var currentApplyInfoEncoded = $author$project$Model$tkCurrentCandidateApplyDoEncoder(currentApplyInfo);
	var currentApplyAsString = A2($elm$json$Json$Encode$encode, 0, currentApplyInfoEncoded);
	return $truqu$elm_base64$Base64$encode(currentApplyAsString);
};
var $sporto$qs$QS$One = function (a) {
	return {$: 0, a: a};
};
var $sporto$qs$QS$Config = $elm$core$Basics$identity;
var $sporto$qs$QS$config = {cf: true, bL: true};
var $sporto$qs$QS$Many = function (a) {
	return {$: 1, a: a};
};
var $sporto$qs$QS$get = F2(
	function (key, query) {
		return A2($elm$core$Dict$get, key, query);
	});
var $sporto$qs$QS$rawValueToValue = F2(
	function (cfg, val) {
		var trimmed = $elm$core$String$trim(val);
		var isEmpty = trimmed === '';
		return isEmpty ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(trimmed);
	});
var $sporto$qs$QS$set = F3(
	function (key, value, query) {
		return A3($elm$core$Dict$insert, key, value, query);
	});
var $sporto$qs$QS$addListValToQuery = F4(
	function (cfg, key, rawValue, query) {
		var currentVals = A2($sporto$qs$QS$get, key, query);
		var pushValue = function (value) {
			if (!currentVals.$) {
				if (currentVals.a.$ === 1) {
					var vals = currentVals.a.a;
					return $sporto$qs$QS$Many(
						A2(
							$elm$core$List$append,
							vals,
							_List_fromArray(
								[value])));
				} else {
					var preValue = currentVals.a.a;
					return $sporto$qs$QS$Many(
						_List_fromArray(
							[preValue, value]));
				}
			} else {
				return $sporto$qs$QS$Many(
					_List_fromArray(
						[value]));
			}
		};
		var _v0 = A2($sporto$qs$QS$rawValueToValue, cfg, rawValue);
		if (_v0.$ === 1) {
			return query;
		} else {
			var value = _v0.a;
			return A3(
				$sporto$qs$QS$set,
				key,
				pushValue(value),
				query);
		}
	});
var $sporto$qs$QS$addUniqueValToQuery = F4(
	function (cfg, key, val, query) {
		var _v0 = A2($sporto$qs$QS$rawValueToValue, cfg, val);
		if (_v0.$ === 1) {
			return query;
		} else {
			var value = _v0.a;
			return A3(
				$sporto$qs$QS$set,
				key,
				$sporto$qs$QS$One(value),
				query);
		}
	});
var $sporto$qs$QS$querySegmentToTuple = function (element) {
	var splitted = A2($elm$core$String$split, '=', element);
	var second = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2($elm$core$List$drop, 1, splitted)));
	var secondDecoded = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$url$Url$percentDecode(second));
	var first = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(splitted));
	var firstDecoded = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$url$Url$percentDecode(first));
	return _Utils_Tuple2(firstDecoded, secondDecoded);
};
var $sporto$qs$QS$addSegmentToQuery = F3(
	function (cfg, segment, query) {
		var _v0 = $sporto$qs$QS$querySegmentToTuple(segment);
		var key = _v0.a;
		var val = _v0.b;
		if (A2($elm$core$String$endsWith, '[]', key)) {
			var newKey = A2($elm$core$String$dropRight, 2, key);
			return A4($sporto$qs$QS$addListValToQuery, cfg, newKey, val, query);
		} else {
			return A4($sporto$qs$QS$addUniqueValToQuery, cfg, key, val, query);
		}
	});
var $sporto$qs$QS$empty = $elm$core$Dict$empty;
var $sporto$qs$QS$parse = F2(
	function (_v0, queryString) {
		var cfg = _v0;
		var trimmed = A2(
			$elm$core$String$join,
			'',
			A2($elm$core$String$split, '?', queryString));
		return $elm$core$String$isEmpty(trimmed) ? $sporto$qs$QS$empty : A3(
			$elm$core$List$foldl,
			$sporto$qs$QS$addSegmentToQuery(cfg),
			$sporto$qs$QS$empty,
			A2($elm$core$String$split, '&', trimmed));
	});
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Page$Home$getNewUrl = F2(
	function (model, currentApplyAsBase64) {
		var queryParamsParsed = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Dict$empty,
			A2(
				$elm$core$Maybe$map,
				function (e) {
					return A2($sporto$qs$QS$parse, $sporto$qs$QS$config, e);
				},
				model.Q.j6));
		var queryParamsWithApplyInfoParam = A3(
			$elm$core$Dict$insert,
			'ci',
			$sporto$qs$QS$One(currentApplyAsBase64),
			queryParamsParsed);
		var urlQs = A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					model.J.ly,
					A3(
					$elm$core$String$slice,
					1,
					$elm$core$String$length(model.Q.fB),
					model.Q.fB)
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var q = _v0.a;
					var v = _v0.b;
					var value = function () {
						if (q === 'ci') {
							return currentApplyAsBase64;
						} else {
							if (!v.$) {
								var oneVal = v.a;
								return oneVal;
							} else {
								if (v.a.b) {
									var _v2 = v.a;
									var val = _v2.a;
									return val;
								} else {
									return '';
								}
							}
						}
					}();
					return A2($elm$url$Url$Builder$string, q, value);
				},
				$elm$core$List$reverse(
					A2(
						$elm$core$List$filter,
						function (_v3) {
							var q = _v3.a;
							return (!(A2($elm$core$String$contains, 'utm', q) && (!A2($elm$core$String$contains, 'tk_utm', q)))) && (!A2($elm$core$String$contains, 'email', q));
						},
						$elm$core$Dict$toList(queryParamsWithApplyInfoParam)))));
		return urlQs;
	});
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Page$Home$updateUrlWithCurrentCandidateApplyInfo = F3(
	function (model, currentStep, nextstep) {
		var currentCandidateInfoStageModel = model.a;
		var currentCandidateApplyInfo = model.X;
		var candidateInfoDo = currentCandidateInfoStageModel.b;
		var applyQuestionsInfoDo = model.e.d;
		var currentApplyInfo = {
			es: {
				dp: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.dp;
					},
					currentCandidateApplyInfo),
				dq: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.dq;
					},
					currentCandidateApplyInfo),
				er: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (c) {
							return c.er;
						},
						currentCandidateApplyInfo)),
				du: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.g;
					},
					applyQuestionsInfoDo.du.g),
				hU: model.hU,
				eG: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.eG;
					},
					currentCandidateApplyInfo),
				eH: A2(
					$elm$core$Maybe$andThen,
					function (c) {
						return c.eH;
					},
					currentCandidateApplyInfo),
				dz: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.g;
					},
					applyQuestionsInfoDo.dz.g),
				cB: A2($elm$core$Maybe$withDefault, '', candidateInfoDo.cB.g),
				dB: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.g;
					},
					applyQuestionsInfoDo.dB.g),
				dC: $elm$core$String$toInt(applyQuestionsInfoDo.dC.g),
				dG: candidateInfoDo.dG.g,
				dK: candidateInfoDo.dK.g,
				ff: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (c) {
							return c.ff;
						},
						currentCandidateApplyInfo)),
				cU: $elm$core$Maybe$Just(
					{
						ex: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ht;
							},
							candidateInfoDo.cU.f3),
						ey: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.ez;
							},
							candidateInfoDo.cU.f3),
						eL: candidateInfoDo.cU.g,
						fR: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.kp;
							},
							candidateInfoDo.cU.f3),
						fS: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fT;
							},
							candidateInfoDo.cU.f3)
					}),
				js: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.js;
					},
					currentCandidateApplyInfo),
				dV: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.dV;
					},
					currentCandidateApplyInfo),
				fD: candidateInfoDo.jT.g,
				fJ: false,
				d4: $elm$core$Maybe$Just(
					$elm$core$Array$toList(
						A2(
							$elm$core$Array$map,
							function ($) {
								return $.g;
							},
							applyQuestionsInfoDo.kS)))
			},
			eE: currentStep,
			fl: A2($elm$core$Maybe$withDefault, '', model.fl)
		};
		var nextStepApplyInfo = _Utils_update(
			currentApplyInfo,
			{eE: nextstep});
		var nextStepApplyAsBase64 = $author$project$Page$Home$getCandidateInfoEncoded(nextStepApplyInfo);
		var urlWithNextStep = A2($author$project$Page$Home$getNewUrl, model, nextStepApplyAsBase64);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					Q: A2(
						$elm$core$Maybe$withDefault,
						model.Q,
						$elm$url$Url$fromString(urlWithNextStep))
				}),
			A2($elm$browser$Browser$Navigation$replaceUrl, model.cW, urlWithNextStep));
	});
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $author$project$Page$Home$validateApplyQuestions = function (model) {
	var validateSkillAndAddErrorMessage = function (skill) {
		return _Utils_update(
			skill,
			{
				bM: ($elm$core$String$trim(skill.g) === '') ? $elm$core$Maybe$Just('Por favor ingresa una habilidad') : $elm$core$Maybe$Nothing
			});
	};
	var currentApplyQuestionsStageModel = model.e;
	var currentCategoryField = currentApplyQuestionsStageModel.d.du;
	var currentEducationLevelField = currentApplyQuestionsStageModel.d.dz;
	var educationLevelError = _Utils_eq(currentEducationLevelField.g, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just('Por favor selecciona una opción') : $elm$core$Maybe$Nothing;
	var currentExperienceLevelField = currentApplyQuestionsStageModel.d.dB;
	var experienceError = _Utils_eq(currentExperienceLevelField.g, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just('Por favor selecciona una opción') : $elm$core$Maybe$Nothing;
	var currentExperienceYearsField = currentApplyQuestionsStageModel.d.dC;
	var experienceYearsError = ($elm$core$String$trim(currentExperienceYearsField.g) === '') ? $elm$core$Maybe$Just('Ingresa tus años de experiencia profesional') : $elm$core$Maybe$Nothing;
	var currentSkillsField = currentApplyQuestionsStageModel.d.kS;
	var newSkillsWithErrorMessages = A2($elm$core$Array$map, validateSkillAndAddErrorMessage, currentSkillsField);
	var skillsHaveErrors = A3(
		$elm$core$Array$foldl,
		F2(
			function (skill, acc) {
				return (!_Utils_eq(skill.bM, $elm$core$Maybe$Nothing)) || acc;
			}),
		false,
		newSkillsWithErrorMessages);
	var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.d;
	var categoryError = _Utils_eq(currentCategoryField.g, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just('Por favor selecciona una opción') : $elm$core$Maybe$Nothing;
	var formaHasErrors = (!_Utils_eq(categoryError, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(experienceError, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(educationLevelError, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(experienceYearsError, $elm$core$Maybe$Nothing)) || skillsHaveErrors)));
	var newModelWithErrorsUpdated = _Utils_update(
		model,
		{
			e: _Utils_update(
				currentApplyQuestionsStageModel,
				{
					d: _Utils_update(
						currentApplyQuestionsInfo,
						{
							du: _Utils_update(
								currentCategoryField,
								{bM: categoryError}),
							dz: _Utils_update(
								currentEducationLevelField,
								{bM: educationLevelError}),
							dB: _Utils_update(
								currentExperienceLevelField,
								{bM: experienceError}),
							dC: _Utils_update(
								currentExperienceYearsField,
								{bM: experienceYearsError}),
							kS: newSkillsWithErrorMessages
						})
				})
		});
	return _Utils_Tuple2(newModelWithErrorsUpdated, formaHasErrors);
};
var $author$project$Page$Home$validateEmail = function (email) {
	var emailRegex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^(([^<>()\\[\\]\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'));
	return A2(
		$elm$regex$Regex$contains,
		emailRegex,
		$elm$core$String$trim(
			$elm$core$String$toLower(email))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Ingresa un correo electrónico válido');
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Page$Home$MsgServerGotMagicLinkVerifyResponse = function (a) {
	return {$: 99, a: a};
};
var $author$project$Page$Home$upgradeMsgServerGotMagicLinkVerifyResponse = function (result) {
	return $author$project$Page$Home$MsgServerGotMagicLinkVerifyResponse(
		$krisajenkins$remotedata$RemoteData$fromResult(result));
};
var $author$project$Page$Home$verifyMagicLink = function (model) {
	var body = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(model.C.cB)),
				_Utils_Tuple2(
				'digits_code',
				$elm$json$Json$Encode$string(
					_Utils_ap(
						model.c.aU,
						_Utils_ap(
							model.c.aX,
							_Utils_ap(
								model.c.aW,
								_Utils_ap(
									model.c.aT,
									_Utils_ap(model.c.aS, model.c.aV)))))))
			]));
	return $elm$http$Http$riskyRequest(
		{
			ch: $elm$http$Http$jsonBody(body),
			dA: $elm$http$Http$expectWhatever($author$project$Page$Home$upgradeMsgServerGotMagicLinkVerifyResponse),
			dJ: _List_Nil,
			dU: 'POST',
			d8: $elm$core$Maybe$Just(model.J.dS),
			d9: $elm$core$Maybe$Nothing,
			Q: model.J.cV + '/v1/candidate/auth/digits/login'
		});
};
var $author$project$TT$Color$warning = $author$project$TT$Color$Extra$hexToColor('#f57c00');
var $author$project$Page$Home$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					var windowSize = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{q: windowSize}),
						$elm$core$Platform$Cmd$none);
				case 75:
					var visualViewportHeightOffset = msg.a;
					var lastNotZeroViewportHeightOffset = (visualViewportHeightOffset < 100) ? ((model.a6 > 100) ? model.a6 : model.bn) : visualViewportHeightOffset;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bn: lastNotZeroViewportHeightOffset, a6: visualViewportHeightOffset}),
						$elm$core$Platform$Cmd$none);
				case 40:
					var currentYear = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cx: currentYear}),
						$elm$core$Platform$Cmd$none);
				case 1:
					return _Utils_Tuple2(
						model,
						$author$project$Page$Home$getJobAdSummary(model));
				case 2:
					var result = msg.a;
					var nextCmd = function () {
						switch (result.$) {
							case 0:
								return $elm$core$Platform$Cmd$none;
							case 2:
								return $elm$core$Platform$Cmd$none;
							case 1:
								return $elm$core$Platform$Cmd$none;
							default:
								var jobAdSummaryDo = result.a;
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Page$Home$getCurrentCandidateApplyInfo, model, jobAdSummaryDo),
											$author$project$Page$Home$getJobAdFilterQuestions(model)
										]));
						}
					}();
					var newExternalApplyEnabled = function () {
						switch (result.$) {
							case 0:
								return false;
							case 2:
								return false;
							case 1:
								return false;
							default:
								var jobAd = result.a;
								return model.dD && (!_Utils_eq(jobAd.ic, $elm$core$Maybe$Nothing));
						}
					}();
					var modelWithDefaultPhoneNumber = function () {
						switch (result.$) {
							case 0:
								return model;
							case 2:
								return model;
							case 1:
								return model;
							default:
								var jobAd = result.a;
								var candidateInfoStageModel = model.a;
								var candidateInfoDo = candidateInfoStageModel.b;
								var phoneField = candidateInfoDo.jT;
								return _Utils_update(
									model,
									{
										a: _Utils_update(
											candidateInfoStageModel,
											{
												b: _Utils_update(
													candidateInfoDo,
													{
														jT: _Utils_update(
															phoneField,
															{
																cO: (jobAd.hU === 'mx') ? '+52' : ''
															})
													})
											})
									});
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							modelWithDefaultPhoneNumber,
							{bi: newExternalApplyEnabled, bS: result}),
						nextCmd);
				case 3:
					var jobAdSummaryDo = msg.a;
					var result = msg.b;
					var maybeCurrentApplyFromUrl = A2(
						$elm$core$Maybe$andThen,
						function (applyAsBase64) {
							var _v6 = $truqu$elm_base64$Base64$decode(applyAsBase64);
							if (!_v6.$) {
								var applyDecoded = _v6.a;
								var _v7 = A2($elm$json$Json$Decode$decodeString, $author$project$Model$tkCurrentCandidateApplyDoJsonDecoder, applyDecoded);
								if (!_v7.$) {
									var applyParsed = _v7.a;
									return $elm$core$Maybe$Just(applyParsed);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						$author$project$Page$Home$extractCurrentApplyFromUrl(model.Q));
					if (!maybeCurrentApplyFromUrl.$) {
						var currentApply = maybeCurrentApplyFromUrl.a;
						var $temp$msg = A3(
							$author$project$Page$Home$MsgLoadCandidateInfo,
							currentApply.es,
							jobAdSummaryDo,
							_Utils_eq(currentApply.fl, jobAdSummaryDo.iJ) ? $elm$core$Maybe$Just(currentApply.eE) : $elm$core$Maybe$Nothing),
							$temp$model = model;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						switch (result.$) {
							case 1:
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							case 0:
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple2(
									model,
									model.K ? $author$project$TT$Util$msgToCmd(
										$author$project$Page$Home$MsgUserClickedSendMagicLink(model.C.cB)) : $author$project$Ports$renderGoogleSignInButton(
										{is: jobAdSummaryDo.is}));
							default:
								var currentCandidateInfo = result.a;
								var maybeCurrentStep = currentCandidateInfo.er ? $author$project$Page$Home$extractStageFromUrl(model.Q) : $elm$core$Maybe$Nothing;
								var $temp$msg = A3($author$project$Page$Home$MsgLoadCandidateInfo, currentCandidateInfo, jobAdSummaryDo, maybeCurrentStep),
									$temp$model = model;
								msg = $temp$msg;
								model = $temp$model;
								continue update;
						}
					}
				case 4:
					var result = msg.a;
					switch (result.$) {
						case 1:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 0:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 2:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						default:
							var jobAdFilterQuestions = result.a;
							var filterQuestionsStageModel = model.o;
							var answersList = $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									function (e) {
										return _Utils_Tuple2(
											e.iJ,
											{bM: $elm$core$Maybe$Nothing, cE: false, g: ''});
									},
									jobAdFilterQuestions));
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										o: _Utils_update(
											filterQuestionsStageModel,
											{gS: answersList}),
										aD: jobAdFilterQuestions
									}),
								$elm$core$Platform$Cmd$none);
					}
				case 6:
					var candidateInfo = msg.a;
					var jobAdSummaryDo = msg.b;
					var maybeCurrentStep = msg.c;
					var newModel = function () {
						if ($elm$core$String$trim(candidateInfo.cB) === '') {
							return model;
						} else {
							var emailProcessed = $elm$core$String$trim(
								$elm$core$String$toLower(candidateInfo.cB));
							var emailError = $author$project$Page$Home$validateEmail(emailProcessed);
							var currentLoginModel = model.f;
							var currentCvDo = A2(
								$elm$core$Maybe$andThen,
								function (attachmentPath) {
									return A2(
										$elm$core$Maybe$andThen,
										function (attachmentHash) {
											return A2(
												$elm$core$Maybe$map,
												function (mimeType) {
													return {dp: attachmentHash, g_: mimeType, dq: attachmentPath};
												},
												candidateInfo.dV);
										},
										candidateInfo.dp);
								},
								candidateInfo.dq);
							var candidateInfoStageModel = model.a;
							var candidateInfoDo = candidateInfoStageModel.b;
							var emailField = candidateInfoDo.cB;
							var newEmailField = _Utils_update(
								emailField,
								{
									bM: emailError,
									cE: true,
									cO: emailProcessed,
									g: _Utils_eq(emailError, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(emailProcessed) : $elm$core$Maybe$Nothing
								});
							var newFullnameField = function () {
								var _v16 = candidateInfo.dG;
								if (!_v16.$) {
									var fullname = _v16.a;
									var fullnameProcessed = $elm$core$String$trim(fullname);
									var fullnameField = candidateInfoDo.dG;
									var fullnameError = $author$project$Page$Home$validateFullname(fullnameProcessed);
									return _Utils_update(
										fullnameField,
										{
											bM: fullnameError,
											cE: true,
											cO: fullnameProcessed,
											g: _Utils_eq(newEmailField.g, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : (_Utils_eq(fullnameError, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(fullnameProcessed) : $elm$core$Maybe$Nothing)
										});
								} else {
									return candidateInfoDo.dG;
								}
							}();
							var newPhoneField = function () {
								var _v13 = candidateInfo.fD;
								if (!_v13.$) {
									var phone = _v13.a;
									var removeWhiteSpacesRegex = '\\s';
									var phoneProcessed = function () {
										var _v14 = $elm$regex$Regex$fromString(removeWhiteSpacesRegex);
										if (_v14.$ === 1) {
											return $elm$core$String$trim(phone);
										} else {
											var regex = _v14.a;
											return $elm$core$String$trim(
												A3(
													$elm$regex$Regex$replace,
													regex,
													function (_v15) {
														return '';
													},
													phone));
										}
									}();
									var phoneWithCountryCode = (jobAdSummaryDo.hU === 'mx') ? (A2($elm$core$String$startsWith, '+52', phoneProcessed) ? phoneProcessed : ('+52' + phoneProcessed)) : phoneProcessed;
									var phoneField = candidateInfoDo.jT;
									var phoneError = A2($author$project$Page$Home$validatePhone, phoneWithCountryCode, jobAdSummaryDo.hU);
									return _Utils_update(
										phoneField,
										{
											bM: phoneError,
											cE: true,
											cO: phoneWithCountryCode,
											g: _Utils_eq(newFullnameField.g, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : (_Utils_eq(phoneError, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(phoneWithCountryCode) : $elm$core$Maybe$Nothing)
										});
								} else {
									return candidateInfoDo.jT;
								}
							}();
							var newLocationField = function () {
								var _v12 = candidateInfo.cU;
								if (!_v12.$) {
									var location = _v12.a;
									var newSelectedCity = A2(
										$elm$core$Maybe$andThen,
										function (cityId) {
											return A2(
												$elm$core$Maybe$andThen,
												function (cityName) {
													return A2(
														$elm$core$Maybe$andThen,
														function (regionName) {
															return A2(
																$elm$core$Maybe$map,
																function (regionId) {
																	return {ht: cityId, ez: cityName, kp: regionId, fT: regionName};
																},
																location.fR);
														},
														location.fS);
												},
												location.ey);
										},
										location.ex);
									var locationField = candidateInfoDo.cU;
									var locationError = ($elm$core$String$trim(
										A2($elm$core$Maybe$withDefault, '', location.eL)) === '') ? $elm$core$Maybe$Just('Por favor ingresa el lugar donde vives') : $elm$core$Maybe$Nothing;
									return _Utils_update(
										locationField,
										{
											bM: locationError,
											cE: true,
											cO: A2($elm$core$Maybe$withDefault, '', location.eL),
											f3: newSelectedCity,
											g: _Utils_eq(newPhoneField.g, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : ((!_Utils_eq(newSelectedCity, $elm$core$Maybe$Nothing)) ? location.eL : $elm$core$Maybe$Nothing)
										});
								} else {
									return candidateInfoDo.cU;
								}
							}();
							var newHeadlineField = function () {
								var _v11 = candidateInfo.dK;
								if (!_v11.$) {
									var headline = _v11.a;
									var headlineProcessed = $elm$core$String$trim(headline);
									var headlineField = candidateInfoDo.dK;
									var headlineError = $author$project$Page$Home$validateHeadline(headlineProcessed);
									return _Utils_update(
										headlineField,
										{
											bM: headlineError,
											cE: true,
											cO: headlineProcessed,
											g: _Utils_eq(newLocationField.g, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Nothing : (_Utils_eq(headlineError, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(headlineProcessed) : $elm$core$Maybe$Nothing)
										});
								} else {
									return candidateInfoDo.dK;
								}
							}();
							var newActiveQuestion = _Utils_eq(newEmailField.g, $elm$core$Maybe$Nothing) ? 0 : (_Utils_eq(newFullnameField.g, $elm$core$Maybe$Nothing) ? 1 : (_Utils_eq(newPhoneField.g, $elm$core$Maybe$Nothing) ? 2 : (model.by ? 3 : (_Utils_eq(newLocationField.g, $elm$core$Maybe$Nothing) ? 4 : (_Utils_eq(newHeadlineField.g, $elm$core$Maybe$Nothing) ? 5 : 6)))));
							var candidateCvStageModel = model.k;
							var candidateCvDo = candidateCvStageModel.u;
							var message = A2($elm$core$Maybe$withDefault, candidateCvDo.js, candidateInfo.js);
							var newCandidateCvDo = _Utils_update(
								candidateCvDo,
								{hg: currentCvDo, js: message, j1: !candidateInfo.fJ});
							var applyQuestionsStageModelWithCandidateInfoUpdated = model.e;
							var applyQuestionsInfo = applyQuestionsStageModelWithCandidateInfoUpdated.d;
							var newCategory = A2(
								$elm$core$Maybe$withDefault,
								applyQuestionsInfo.du.g,
								A2($elm$core$Maybe$map, $author$project$Model$matchCategory, candidateInfo.du));
							var newEducationLevel = A2(
								$elm$core$Maybe$withDefault,
								applyQuestionsInfo.dz.g,
								A2($elm$core$Maybe$map, $author$project$Model$matchEducationLevel, candidateInfo.dz));
							var newExperienceLevel = A2(
								$elm$core$Maybe$withDefault,
								applyQuestionsInfo.dB.g,
								A2($elm$core$Maybe$map, $author$project$Model$matchExperienceLevel, candidateInfo.dB));
							var newApplyQuestionsInfo = _Utils_update(
								applyQuestionsInfo,
								{
									du: {bM: $elm$core$Maybe$Nothing, g: newCategory},
									dz: {bM: $elm$core$Maybe$Nothing, g: newEducationLevel},
									dB: {bM: $elm$core$Maybe$Nothing, g: newExperienceLevel},
									dC: {
										bM: $elm$core$Maybe$Nothing,
										g: A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, candidateInfo.dC))
									},
									kS: A2(
										$elm$core$Maybe$withDefault,
										applyQuestionsInfo.kS,
										A2(
											$elm$core$Maybe$map,
											function (skillList) {
												return $elm$core$Array$fromList(
													A2(
														$elm$core$List$map,
														function (skill) {
															return {bM: $elm$core$Maybe$Nothing, g: skill};
														},
														skillList));
											},
											candidateInfo.d4))
								});
							var modelWithNewApplyQuestionsInfo = _Utils_update(
								model,
								{
									e: _Utils_update(
										applyQuestionsStageModelWithCandidateInfoUpdated,
										{d: newApplyQuestionsInfo}),
									gV: 7,
									k: _Utils_update(
										candidateCvStageModel,
										{
											u: newCandidateCvDo,
											br: !_Utils_eq(newCandidateCvDo.hg, $elm$core$Maybe$Nothing)
										}),
									a: _Utils_update(
										candidateInfoStageModel,
										{
											l: newActiveQuestion,
											b: _Utils_update(
												candidateInfoDo,
												{cB: newEmailField, dG: newFullnameField, dK: newHeadlineField, cU: newLocationField, jT: newPhoneField}),
											b3: function () {
												if (!maybeCurrentStep.$) {
													return false;
												} else {
													return !model.bi;
												}
											}()
										}),
									f: _Utils_update(
										currentLoginModel,
										{V: false, W: false}),
									b2: candidateInfo.er
								});
							var _v9 = $author$project$Page$Home$validateApplyQuestions(modelWithNewApplyQuestionsInfo);
							var modelWithApplyQuestionsValidated = _v9.a;
							return _Utils_eq(
								maybeCurrentStep,
								$elm$core$Maybe$Just(4)) ? _Utils_update(
								modelWithNewApplyQuestionsInfo,
								{K: false}) : _Utils_update(
								modelWithApplyQuestionsValidated,
								{K: false});
						}
					}();
					var loginModel = model.f;
					var logInToCompleteApplicationFromCustomMessage = newModel.K ? $author$project$TT$Util$msgToCmd(
						$author$project$Page$Home$MsgUserClickedSendMagicLink(model.C.cB)) : $elm$core$Platform$Cmd$none;
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								gV: A2($elm$core$Maybe$withDefault, 1, maybeCurrentStep),
								hU: candidateInfo.hU,
								X: $elm$core$Maybe$Just(candidateInfo),
								f: _Utils_update(
									loginModel,
									{b4: true})
							}),
						logInToCompleteApplicationFromCustomMessage);
				case 5:
					var newEmail = msg.a;
					var currentCandidateInfoStageModel = model.a;
					var currentApplyInfo = currentCandidateInfoStageModel.b;
					var currentEmailField = currentApplyInfo.cB;
					if (currentEmailField.cE) {
						var emailProcessed = $elm$core$String$trim(
							$elm$core$String$toLower(newEmail));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: _Utils_update(
										currentCandidateInfoStageModel,
										{
											b: _Utils_update(
												currentApplyInfo,
												{
													cB: _Utils_update(
														currentEmailField,
														{
															bM: $author$project$Page$Home$validateEmail(emailProcessed),
															cO: emailProcessed
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: _Utils_update(
										currentCandidateInfoStageModel,
										{
											b: _Utils_update(
												currentApplyInfo,
												{
													cB: _Utils_update(
														currentEmailField,
														{cO: newEmail})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 14:
					var currentCandidateInfoStageModel = model.a;
					var currentApplyInfo = currentCandidateInfoStageModel.b;
					var currentEmailField = currentApplyInfo.cB;
					var emailProcessed = $elm$core$String$trim(
						$elm$core$String$toLower(currentEmailField.cO));
					var errorMessage = ((emailProcessed === '') && (!currentEmailField.cE)) ? currentEmailField.bM : $author$project$Page$Home$validateEmail(emailProcessed);
					var firstInputMade = ((emailProcessed === '') && (!currentEmailField.cE)) ? false : true;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: _Utils_update(
									currentCandidateInfoStageModel,
									{
										b: _Utils_update(
											currentApplyInfo,
											{
												cB: _Utils_update(
													currentEmailField,
													{bM: errorMessage, cE: firstInputMade, cO: emailProcessed})
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 7:
					var canSubmitEmail = !(!_Utils_eq(model.a.b.cB.bM, $elm$core$Maybe$Nothing));
					if (canSubmitEmail) {
						var currentCandidateInfoStageModel = model.a;
						var currentApplyInfo = currentCandidateInfoStageModel.b;
						var currentEmailField = currentApplyInfo.cB;
						var emailProcessed = $elm$core$String$trim(
							$elm$core$String$toLower(currentApplyInfo.cB.cO));
						var emailError = $author$project$Page$Home$validateEmail(emailProcessed);
						var newActiveQuestion = _Utils_eq(emailError, $elm$core$Maybe$Nothing) ? (currentCandidateInfoStageModel.s ? currentCandidateInfoStageModel.aq : 1) : currentCandidateInfoStageModel.l;
						var newIsEditingQuestion = _Utils_eq(emailError, $elm$core$Maybe$Nothing) ? false : currentCandidateInfoStageModel.s;
						var newEmailField = _Utils_update(
							currentEmailField,
							{bM: emailError, cE: true, cO: emailProcessed});
						var newEmailFieldWithValue = _Utils_eq(emailError, $elm$core$Maybe$Nothing) ? _Utils_update(
							newEmailField,
							{
								g: $elm$core$Maybe$Just(emailProcessed)
							}) : newEmailField;
						var newModel = _Utils_update(
							model,
							{
								a: _Utils_update(
									currentCandidateInfoStageModel,
									{
										l: newActiveQuestion,
										b: _Utils_update(
											currentApplyInfo,
											{cB: newEmailFieldWithValue}),
										s: newIsEditingQuestion
									})
							});
						return _Utils_eq(emailError, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(
							_Utils_update(
								newModel,
								{gV: 1}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Ports$removeGoogleSignInButton(0),
										A2($author$project$Page$Home$checkAccountForEmail, model, emailProcessed)
									]))) : _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 8:
					var newFullname = msg.a;
					var currentCandidateInfoStageModel = model.a;
					var currentApplyInfo = currentCandidateInfoStageModel.b;
					var currentFullnameField = currentApplyInfo.dG;
					if (currentFullnameField.cE) {
						var fullnameProcessed = $elm$core$String$trim(newFullname);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: _Utils_update(
										currentCandidateInfoStageModel,
										{
											b: _Utils_update(
												currentApplyInfo,
												{
													dG: _Utils_update(
														currentFullnameField,
														{
															bM: $author$project$Page$Home$validateFullname(fullnameProcessed),
															cO: newFullname
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: _Utils_update(
										currentCandidateInfoStageModel,
										{
											b: _Utils_update(
												currentApplyInfo,
												{
													dG: _Utils_update(
														currentFullnameField,
														{cO: newFullname})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 15:
					var currentCandidateInfoStageModel = model.a;
					var currentApplyInfo = currentCandidateInfoStageModel.b;
					var currentFullnameField = currentApplyInfo.dG;
					var fullnameProcessed = $elm$core$String$trim(currentFullnameField.cO);
					var errorMessage = ((fullnameProcessed === '') && (!currentFullnameField.cE)) ? currentFullnameField.bM : $author$project$Page$Home$validateFullname(fullnameProcessed);
					var firstInputMade = ((fullnameProcessed === '') && (!currentFullnameField.cE)) ? false : true;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: _Utils_update(
									currentCandidateInfoStageModel,
									{
										b: _Utils_update(
											currentApplyInfo,
											{
												dG: _Utils_update(
													currentFullnameField,
													{bM: errorMessage, cE: firstInputMade, cO: fullnameProcessed})
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 9:
					var canSubmitFullname = !((!_Utils_eq(model.a.b.dG.bM, $elm$core$Maybe$Nothing)) || (model.a.b.dG.cO === ''));
					if (canSubmitFullname) {
						var newModel = $author$project$Page$Home$getFullnameSubmittedAndValidatedModel(model);
						return _Utils_Tuple2(
							_Utils_update(
								newModel,
								{gV: 1}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 10:
					var jobAdSummaryDo = msg.a;
					var newPhone = msg.b;
					var currentCandidateInfoStageModel = model.a;
					var currentApplyInfo = currentCandidateInfoStageModel.b;
					var currentPhoneField = currentApplyInfo.jT;
					if (currentPhoneField.cE) {
						var removeWhiteSpacesRegex = '\\s';
						var phoneProcessed = function () {
							var _v17 = $elm$regex$Regex$fromString(removeWhiteSpacesRegex);
							if (_v17.$ === 1) {
								return $elm$core$String$trim(newPhone);
							} else {
								var regex = _v17.a;
								return $elm$core$String$trim(
									A3(
										$elm$regex$Regex$replace,
										regex,
										function (_v18) {
											return '';
										},
										newPhone));
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: _Utils_update(
										currentCandidateInfoStageModel,
										{
											b: _Utils_update(
												currentApplyInfo,
												{
													jT: _Utils_update(
														currentPhoneField,
														{
															bM: A2($author$project$Page$Home$validatePhone, phoneProcessed, jobAdSummaryDo.hU),
															cO: newPhone
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: _Utils_update(
										currentCandidateInfoStageModel,
										{
											b: _Utils_update(
												currentApplyInfo,
												{
													jT: _Utils_update(
														currentPhoneField,
														{cO: newPhone})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 16:
					var jobAdSummaryDo = msg.a;
					var removeWhiteSpacesRegex = '\\s';
					var currentCandidateInfoStageModel = model.a;
					var currentApplyInfo = currentCandidateInfoStageModel.b;
					var currentPhoneField = currentApplyInfo.jT;
					var phoneProcessed = function () {
						var _v19 = $elm$regex$Regex$fromString(removeWhiteSpacesRegex);
						if (_v19.$ === 1) {
							return $elm$core$String$trim(currentPhoneField.cO);
						} else {
							var regex = _v19.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v20) {
										return '';
									},
									currentPhoneField.cO));
						}
					}();
					var errorMessage = ((phoneProcessed === '') && (!currentPhoneField.cE)) ? currentPhoneField.bM : A2($author$project$Page$Home$validatePhone, phoneProcessed, jobAdSummaryDo.hU);
					var firstInputMade = ((phoneProcessed === '') && (!currentPhoneField.cE)) ? false : true;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: _Utils_update(
									currentCandidateInfoStageModel,
									{
										b: _Utils_update(
											currentApplyInfo,
											{
												jT: _Utils_update(
													currentPhoneField,
													{bM: errorMessage, cE: firstInputMade})
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 11:
					var tkJobAdSummaryDo = msg.a;
					var canSubmitPhone = !((!_Utils_eq(model.a.b.jT.bM, $elm$core$Maybe$Nothing)) || (model.a.b.jT.cO === ''));
					if (canSubmitPhone) {
						var newModel = A2($author$project$Page$Home$getPhoneSubmittedAndValidatedModel, model, tkJobAdSummaryDo);
						return _Utils_Tuple2(
							_Utils_update(
								newModel,
								{gV: 1}),
							$author$project$Ports$scrollToChatBottom(0));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 12:
					var canSubmitLocation = !((!_Utils_eq(model.a.b.cU.bM, $elm$core$Maybe$Nothing)) || (model.a.b.cU.cO === ''));
					if (canSubmitLocation) {
						var newModel = $author$project$Page$Home$getLocationSubmittedAndValidatedModel(model);
						return _Utils_Tuple2(
							_Utils_update(
								newModel,
								{gV: 1}),
							$author$project$Ports$scrollToChatBottom(0));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 17:
					var newHeadline = msg.a;
					var currentCandidateInfoStageModel = model.a;
					var currentApplyInfo = currentCandidateInfoStageModel.b;
					var currentHeadlineField = currentApplyInfo.dK;
					if (currentHeadlineField.cE) {
						var headlineProcessed = $elm$core$String$trim(newHeadline);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: _Utils_update(
										currentCandidateInfoStageModel,
										{
											b: _Utils_update(
												currentApplyInfo,
												{
													dK: _Utils_update(
														currentHeadlineField,
														{
															bM: $author$project$Page$Home$validateHeadline(headlineProcessed),
															cO: newHeadline
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: _Utils_update(
										currentCandidateInfoStageModel,
										{
											b: _Utils_update(
												currentApplyInfo,
												{
													dK: _Utils_update(
														currentHeadlineField,
														{cO: newHeadline})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 18:
					var currentCandidateInfoStageModel = model.a;
					var currentApplyInfo = currentCandidateInfoStageModel.b;
					var currentHeadlineField = currentApplyInfo.dK;
					var headlineProcessed = $elm$core$String$trim(currentHeadlineField.cO);
					var errorMessage = ((headlineProcessed === '') && (!currentHeadlineField.cE)) ? currentHeadlineField.bM : $author$project$Page$Home$validateHeadline(headlineProcessed);
					var firstInputMade = ((headlineProcessed === '') && (!currentHeadlineField.cE)) ? false : true;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: _Utils_update(
									currentCandidateInfoStageModel,
									{
										b: _Utils_update(
											currentApplyInfo,
											{
												dK: _Utils_update(
													currentHeadlineField,
													{bM: errorMessage, cE: firstInputMade})
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 19:
					var canSubmitHeadline = !((!_Utils_eq(model.a.b.dK.bM, $elm$core$Maybe$Nothing)) || (model.a.b.dK.cO === ''));
					if (canSubmitHeadline) {
						var newModel = $author$project$Page$Home$getHeadlineSubmittedAndValidatedModel(model);
						return _Utils_Tuple2(
							_Utils_update(
								newModel,
								{gV: 1}),
							$author$project$Ports$scrollToChatBottom(0));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 13:
					var question = msg.a;
					var currentCandidateInfoStageModel = model.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: _Utils_update(
									currentCandidateInfoStageModel,
									{l: question, s: true, aq: model.a.l})
							}),
						$elm$core$Platform$Cmd$none);
				case 28:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{gV: 5}),
						$elm$core$Platform$Cmd$none);
				case 20:
					var tkJobAdInfo = msg.a;
					var currentCandidateInfoStageModel = model.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: _Utils_update(
									currentCandidateInfoStageModel,
									{bQ: true})
							}),
						A2($author$project$Page$Home$submitCandidateInfo, model, tkJobAdInfo));
				case 22:
					var question = msg.a;
					var answer = msg.b;
					var filterQuestionsStageModel = model.o;
					var firstInputMade = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.cE;
							},
							A2($elm$core$Dict$get, question.iJ, filterQuestionsStageModel.gS)));
					var errorMessage = function () {
						if (firstInputMade) {
							var openAnswerMinCharacters = A2($elm$core$Maybe$withDefault, 0, question.jO);
							var openAnswerMaxCharacters = A2($elm$core$Maybe$withDefault, 0, question.jN);
							return (_Utils_cmp(
								$elm$core$String$length(answer),
								openAnswerMinCharacters) < 0) ? $elm$core$Maybe$Just(
								'Por favor ingresa entre ' + ($elm$core$String$fromInt(openAnswerMinCharacters) + (' y ' + ($elm$core$String$fromInt(openAnswerMaxCharacters) + ' caracteres')))) : $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					var answerDo = {bM: errorMessage, cE: true, g: answer};
					var newAnswersList = A3($elm$core$Dict$insert, question.iJ, answerDo, filterQuestionsStageModel.gS);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									filterQuestionsStageModel,
									{gS: newAnswersList})
							}),
						$elm$core$Platform$Cmd$none);
				case 23:
					var question = msg.a;
					var answer = msg.b;
					var filterQuestionsStageModel = model.o;
					var currentAnswer = A2(
						$elm$core$Maybe$map,
						function (e) {
							return _Utils_update(
								e,
								{cE: true});
						},
						A2($elm$core$Dict$get, question.iJ, filterQuestionsStageModel.gS));
					var newAnswersList = A2(
						$elm$core$Maybe$withDefault,
						filterQuestionsStageModel.gS,
						A2(
							$elm$core$Maybe$map,
							function (e) {
								return A3($elm$core$Dict$insert, question.iJ, e, filterQuestionsStageModel.gS);
							},
							currentAnswer));
					var $temp$msg = A2($author$project$Page$Home$MsgUserChangedOpenFilterQuestionAnswer, question, answer),
						$temp$model = _Utils_update(
						model,
						{
							o: _Utils_update(
								filterQuestionsStageModel,
								{gS: newAnswersList}),
							a0: false
						});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 24:
					var question = msg.a;
					var answer = msg.b;
					var filterQuestionsStageModel = model.o;
					var answerDo = {bM: $elm$core$Maybe$Nothing, cE: false, g: answer};
					var newAnswersList = A3($elm$core$Dict$insert, question.iJ, answerDo, filterQuestionsStageModel.gS);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									filterQuestionsStageModel,
									{gS: newAnswersList})
							}),
						$elm$core$Platform$Cmd$none);
				case 25:
					var validateSkillAndAddErrorMessage = function (skill) {
						return _Utils_update(
							skill,
							{bM: $elm$core$Maybe$Nothing});
					};
					var currentApplyQuestionsStageModel = model.e;
					var currentSkillsField = currentApplyQuestionsStageModel.d.kS;
					var newSkillsWithErrorMessages = A2($elm$core$Array$map, validateSkillAndAddErrorMessage, currentSkillsField);
					var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.d;
					var currentCategoryField = currentApplyQuestionsInfo.du;
					var currentEducationLevelField = currentApplyQuestionsInfo.dz;
					var currentExperienceLevelField = currentApplyQuestionsInfo.dB;
					var currentExperienceYearsField = currentApplyQuestionsInfo.dC;
					var newModelErrorsCleaned = _Utils_update(
						model,
						{
							e: _Utils_update(
								currentApplyQuestionsStageModel,
								{
									d: _Utils_update(
										currentApplyQuestionsInfo,
										{
											du: _Utils_update(
												currentCategoryField,
												{bM: $elm$core$Maybe$Nothing}),
											dz: _Utils_update(
												currentEducationLevelField,
												{bM: $elm$core$Maybe$Nothing}),
											dB: _Utils_update(
												currentExperienceLevelField,
												{bM: $elm$core$Maybe$Nothing}),
											dC: _Utils_update(
												currentExperienceYearsField,
												{bM: $elm$core$Maybe$Nothing}),
											kS: newSkillsWithErrorMessages
										})
								})
						});
					return _Utils_Tuple2(
						_Utils_update(
							newModelErrorsCleaned,
							{gV: 4}),
						$elm$core$Platform$Cmd$none);
				case 26:
					var validateAnswer = F2(
						function (question, answer) {
							var openAnswerMinCharacters = A2($elm$core$Maybe$withDefault, 0, question.jO);
							var openAnswerMaxCharacters = A2($elm$core$Maybe$withDefault, 0, question.jN);
							return (question.lH === 'OPEN_QUESTION_TYPE') ? ((_Utils_cmp(
								$elm$core$String$length(answer.g),
								openAnswerMinCharacters) < 0) ? _Utils_update(
								answer,
								{
									bM: $elm$core$Maybe$Just(
										'Por favor ingresa entre ' + ($elm$core$String$fromInt(openAnswerMinCharacters) + (' y ' + ($elm$core$String$fromInt(openAnswerMaxCharacters) + ' caracteres'))))
								}) : answer) : ((answer.g === '') ? _Utils_update(
								answer,
								{
									bM: $elm$core$Maybe$Just('Por favor selecciona una opción')
								}) : answer);
						});
					var filterQuestionsStageModel = model.o;
					var validatedAnswers = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (filterQuestion) {
								return A2(
									$elm$core$Maybe$withDefault,
									_Utils_Tuple2(
										filterQuestion.iJ,
										A2(
											validateAnswer,
											filterQuestion,
											{bM: $elm$core$Maybe$Nothing, cE: false, g: ''})),
									A2(
										$elm$core$Maybe$map,
										function (answer) {
											return _Utils_Tuple2(
												filterQuestion.iJ,
												A2(validateAnswer, filterQuestion, answer));
										},
										A2($elm$core$Dict$get, filterQuestion.iJ, filterQuestionsStageModel.gS)));
							},
							model.aD));
					var modelWithFilterQuestionsValidated = _Utils_update(
						model,
						{
							o: _Utils_update(
								filterQuestionsStageModel,
								{gS: validatedAnswers})
						});
					var areErrors = A2(
						$elm$core$List$any,
						function (answer) {
							return $author$project$TT$Util$isJust(answer.bM);
						},
						$elm$core$Dict$values(validatedAnswers));
					return areErrors ? _Utils_Tuple2(modelWithFilterQuestionsValidated, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						_Utils_update(
							modelWithFilterQuestionsValidated,
							{
								o: _Utils_update(
									filterQuestionsStageModel,
									{bR: true})
							}),
						$author$project$Page$Home$submitFilterQuestions(model));
				case 27:
					var response = msg.a;
					switch (response.$) {
						case 1:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 0:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 2:
							var currentFilterQuestionsStageModel = model.o;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										o: _Utils_update(
											currentFilterQuestionsStageModel,
											{
												bR: false,
												G: $elm$core$Maybe$Just('Ha ocurrido un error en el proceso de aplicación, por favor intenta nuevamente.')
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideFilterQuestionsStageErrorMessage));
						default:
							var currentFilterQuestionsStageModel = model.o;
							var _v22 = A3($author$project$Page$Home$updateUrlWithCurrentCandidateApplyInfo, model, 3, 4);
							var newModel = _v22.a;
							var updateUrlCmd = _v22.b;
							return _Utils_Tuple2(
								_Utils_update(
									newModel,
									{
										gV: 4,
										o: _Utils_update(
											currentFilterQuestionsStageModel,
											{bR: false})
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Ports$scrollToChatTop(0),
											updateUrlCmd
										])));
					}
				case 29:
					var currentFilterQuestionsStageModel = model.o;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								o: _Utils_update(
									currentFilterQuestionsStageModel,
									{G: $elm$core$Maybe$Nothing})
							}),
						$elm$core$Platform$Cmd$none);
				case 21:
					var jobAdId = msg.a;
					var jobAdSummaryDo = msg.b;
					var response = msg.c;
					switch (response.$) {
						case 1:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 0:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 2:
							var currentCandidateInfoStageModel = model.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: _Utils_update(
											currentCandidateInfoStageModel,
											{
												bQ: false,
												G: $elm$core$Maybe$Just('Ha ocurrido un error en el proceso de aplicación, por favor intenta nuevamente.')
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideCandidateInfoStageErrorMessage));
						default:
							var nextStep = model.bi ? 2 : ((!$elm$core$List$length(model.aD)) ? 4 : 3);
							var currentCandidateInfoStageModel = model.a;
							var _v24 = A3($author$project$Page$Home$updateUrlWithCurrentCandidateApplyInfo, model, 1, nextStep);
							var newModel = _v24.a;
							var updateUrlCmd = _v24.b;
							var externalApplyCmds = model.bi ? _List_fromArray(
								[
									A3($author$project$Page$Home$trackExternalApplication, model, jobAdId, jobAdSummaryDo.hJ),
									$author$project$Page$Home$delayHideNotification(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Page$Home$PassThrough,
										A2(
											$elm$core$Maybe$map,
											function (url) {
												return $author$project$Page$Home$MsgRedirectToExternalUrl(url);
											},
											jobAdSummaryDo.ic)))
								]) : _List_fromArray(
								[updateUrlCmd]);
							return _Utils_Tuple2(
								_Utils_update(
									newModel,
									{
										gV: nextStep,
										a: _Utils_update(
											currentCandidateInfoStageModel,
											{bQ: false})
									}),
								$elm$core$Platform$Cmd$batch(
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Ports$trackInitiateApplication(
												{fl: jobAdId, M: model.M}),
												$author$project$Ports$scrollToChatTop(0)
											]),
										externalApplyCmds)));
					}
				case 49:
					var currentCandidateInfoStageModel = model.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: _Utils_update(
									currentCandidateInfoStageModel,
									{G: $elm$core$Maybe$Nothing})
							}),
						$elm$core$Platform$Cmd$none);
				case 30:
					var subMsg = msg.a;
					var currentApplyQuestionsStageModel = model.e;
					var _v25 = A4(
						$author$project$TT$Dropdown$update,
						A6(
							$author$project$Page$Home$commonSelectDropdown,
							currentApplyQuestionsStageModel.d.du.g,
							!_Utils_eq(currentApplyQuestionsStageModel.d.du.bM, $elm$core$Maybe$Nothing),
							$author$project$Page$Home$MsgCategoryDropdownChanged,
							$author$project$Page$Home$MsgCategoryDropdownSelectChanged,
							'category-container',
							'category-options'),
						subMsg,
						model,
						currentApplyQuestionsStageModel.cn);
					var newState = _v25.a;
					var cmd = _v25.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								e: _Utils_update(
									currentApplyQuestionsStageModel,
									{cn: newState})
							}),
						cmd);
				case 31:
					if (!msg.a.$) {
						var _v26 = msg.a.a;
						var categoryDo = _v26.c;
						var currentApplyQuestionsStageModel = model.e;
						var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.d;
						var currentCategoryField = currentApplyQuestionsInfo.du;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									e: _Utils_update(
										currentApplyQuestionsStageModel,
										{
											d: _Utils_update(
												currentApplyQuestionsInfo,
												{
													du: _Utils_update(
														currentCategoryField,
														{
															bM: $elm$core$Maybe$Nothing,
															g: $elm$core$Maybe$Just(categoryDo)
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var _v27 = msg.a.a;
						var categoryDo = _v27.c;
						var currentApplyQuestionsStageModel = model.e;
						var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.d;
						var currentCategoryField = currentApplyQuestionsInfo.du;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									e: _Utils_update(
										currentApplyQuestionsStageModel,
										{
											d: _Utils_update(
												currentApplyQuestionsInfo,
												{
													du: _Utils_update(
														currentCategoryField,
														{
															bM: $elm$core$Maybe$Nothing,
															g: $elm$core$Maybe$Just(categoryDo)
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 32:
					var subMsg = msg.a;
					var currentApplyQuestionsStageModel = model.e;
					var _v28 = A4(
						$author$project$TT$Dropdown$update,
						A6(
							$author$project$Page$Home$commonSelectDropdown,
							currentApplyQuestionsStageModel.d.dB.g,
							!_Utils_eq(currentApplyQuestionsStageModel.d.dB.bM, $elm$core$Maybe$Nothing),
							$author$project$Page$Home$MsgExperienceDropdownChanged,
							$author$project$Page$Home$MsgExperienceDropdownSelectChanged,
							'experience_level-container',
							'experience_level-options'),
						subMsg,
						model,
						currentApplyQuestionsStageModel.cD);
					var newState = _v28.a;
					var cmd = _v28.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								e: _Utils_update(
									currentApplyQuestionsStageModel,
									{cD: newState})
							}),
						cmd);
				case 33:
					if (!msg.a.$) {
						var _v29 = msg.a.a;
						var experienceDo = _v29.c;
						var currentApplyQuestionsStageModel = model.e;
						var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.d;
						var currentExperienceField = currentApplyQuestionsInfo.dB;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									e: _Utils_update(
										currentApplyQuestionsStageModel,
										{
											d: _Utils_update(
												currentApplyQuestionsInfo,
												{
													dB: _Utils_update(
														currentExperienceField,
														{
															bM: $elm$core$Maybe$Nothing,
															g: $elm$core$Maybe$Just(experienceDo)
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var _v30 = msg.a.a;
						var experienceDo = _v30.c;
						var currentApplyQuestionsStageModel = model.e;
						var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.d;
						var currentExperienceField = currentApplyQuestionsInfo.dB;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									e: _Utils_update(
										currentApplyQuestionsStageModel,
										{
											d: _Utils_update(
												currentApplyQuestionsInfo,
												{
													dB: _Utils_update(
														currentExperienceField,
														{
															bM: $elm$core$Maybe$Nothing,
															g: $elm$core$Maybe$Just(experienceDo)
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 34:
					var subMsg = msg.a;
					var currentApplyQuestionsStageModel = model.e;
					var _v31 = A4(
						$author$project$TT$Dropdown$update,
						A6(
							$author$project$Page$Home$commonSelectDropdown,
							currentApplyQuestionsStageModel.d.dz.g,
							!_Utils_eq(currentApplyQuestionsStageModel.d.dz.bM, $elm$core$Maybe$Nothing),
							$author$project$Page$Home$MsgEducationLevelDropdownChanged,
							$author$project$Page$Home$MsgEducationLevelDropdownSelectChanged,
							'education_level-container',
							'education_level-options'),
						subMsg,
						model,
						currentApplyQuestionsStageModel.cA);
					var newState = _v31.a;
					var cmd = _v31.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								e: _Utils_update(
									currentApplyQuestionsStageModel,
									{cA: newState})
							}),
						cmd);
				case 35:
					if (!msg.a.$) {
						var _v32 = msg.a.a;
						var educationLevelDo = _v32.c;
						var currentApplyQuestionsStageModel = model.e;
						var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.d;
						var currentEducationLevelField = currentApplyQuestionsInfo.dz;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									e: _Utils_update(
										currentApplyQuestionsStageModel,
										{
											d: _Utils_update(
												currentApplyQuestionsInfo,
												{
													dz: _Utils_update(
														currentEducationLevelField,
														{
															bM: $elm$core$Maybe$Nothing,
															g: $elm$core$Maybe$Just(educationLevelDo)
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var _v33 = msg.a.a;
						var educationLevelDo = _v33.c;
						var currentApplyQuestionsStageModel = model.e;
						var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.d;
						var currentEducationLevelField = currentApplyQuestionsInfo.dz;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									e: _Utils_update(
										currentApplyQuestionsStageModel,
										{
											d: _Utils_update(
												currentApplyQuestionsInfo,
												{
													dz: _Utils_update(
														currentEducationLevelField,
														{
															bM: $elm$core$Maybe$Nothing,
															g: $elm$core$Maybe$Just(educationLevelDo)
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 39:
					var experienceYears = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var experienceYearsProcessed = function () {
						var _v34 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v34.$ === 1) {
							return $elm$core$String$trim(experienceYears);
						} else {
							var regex = _v34.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v35) {
										return '';
									},
									experienceYears));
						}
					}();
					var currentApplyQuestionsStageModel = model.e;
					var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.d;
					var currentExperienceYearsField = currentApplyQuestionsInfo.dC;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								e: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										d: _Utils_update(
											currentApplyQuestionsInfo,
											{
												dC: _Utils_update(
													currentExperienceYearsField,
													{g: experienceYearsProcessed})
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 36:
					var index = msg.a;
					var skillValue = msg.b;
					var currentApplyQuestionsStageModel = model.e;
					var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.d;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								e: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										d: _Utils_update(
											currentApplyQuestionsInfo,
											{
												kS: A3(
													$elm$core$Array$set,
													index,
													{bM: $elm$core$Maybe$Nothing, g: skillValue},
													currentApplyQuestionsInfo.kS)
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 37:
					var currentApplyQuestionsStageModel = model.e;
					var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.d;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								e: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										d: _Utils_update(
											currentApplyQuestionsInfo,
											{
												kS: A2(
													$elm$core$Array$push,
													{bM: $elm$core$Maybe$Nothing, g: ''},
													currentApplyQuestionsInfo.kS)
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 38:
					var index = msg.a;
					var currentApplyQuestionsStageModel = model.e;
					var currentApplyQuestionsInfo = currentApplyQuestionsStageModel.d;
					var a2 = A3(
						$elm$core$Array$slice,
						index + 1,
						$elm$core$Array$length(currentApplyQuestionsInfo.kS),
						currentApplyQuestionsInfo.kS);
					var a1 = A3($elm$core$Array$slice, 0, index, currentApplyQuestionsInfo.kS);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								e: _Utils_update(
									currentApplyQuestionsStageModel,
									{
										d: _Utils_update(
											currentApplyQuestionsInfo,
											{
												kS: A2($elm$core$Array$append, a1, a2)
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 41:
					var _v36 = $author$project$Page$Home$validateApplyQuestions(model);
					var modelWithApplyQuestionsValidated = _v36.a;
					var areErrors = _v36.b;
					var applyQuestionsStageModel = modelWithApplyQuestionsValidated.e;
					return areErrors ? _Utils_Tuple2(modelWithApplyQuestionsValidated, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						_Utils_update(
							modelWithApplyQuestionsValidated,
							{
								e: _Utils_update(
									applyQuestionsStageModel,
									{bP: true})
							}),
						$author$project$Page$Home$submitApplyQuestions(model));
				case 42:
					var response = msg.a;
					switch (response.$) {
						case 1:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 0:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 2:
							var currentApplyQuestionsStageModel = model.e;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										e: _Utils_update(
											currentApplyQuestionsStageModel,
											{
												bP: false,
												G: $elm$core$Maybe$Just('Ha ocurrido un error en el proceso de aplicación, por favor intenta nuevamente.')
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideApplyQuestionsStageErrorMessage));
						default:
							var currentApplyQuestionsStageModel = model.e;
							var _v38 = A3($author$project$Page$Home$updateUrlWithCurrentCandidateApplyInfo, model, 4, 5);
							var newModel = _v38.a;
							var cmd = _v38.b;
							return _Utils_Tuple2(
								_Utils_update(
									newModel,
									{
										e: _Utils_update(
											currentApplyQuestionsStageModel,
											{bP: false}),
										gV: 5
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Ports$scrollToChatTop(0),
											cmd
										])));
					}
				case 50:
					var currentApplyQuestionsStageModel = model.e;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								e: _Utils_update(
									currentApplyQuestionsStageModel,
									{G: $elm$core$Maybe$Nothing})
							}),
						$elm$core$Platform$Cmd$none);
				case 43:
					var newMessage = msg.a;
					var currentCandidateCvStageModel = model.k;
					var currentCandidateCvInfo = currentCandidateCvStageModel.u;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: _Utils_update(
									currentCandidateCvStageModel,
									{
										u: _Utils_update(
											currentCandidateCvInfo,
											{js: newMessage})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 44:
					var newValue = msg.a;
					var currentCandidateCvStageModel = model.k;
					var currentCandidateCvInfo = currentCandidateCvStageModel.u;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: _Utils_update(
									currentCandidateCvStageModel,
									{
										u: _Utils_update(
											currentCandidateCvInfo,
											{k3: newValue})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 45:
					var newValue = msg.a;
					var currentCandidateCvStageModel = model.k;
					var currentCandidateCvInfo = currentCandidateCvStageModel.u;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: _Utils_update(
									currentCandidateCvStageModel,
									{
										u: _Utils_update(
											currentCandidateCvInfo,
											{j1: newValue})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 46:
					var currentCandidateCvStageModel = model.k;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: _Utils_update(
									currentCandidateCvStageModel,
									{br: true})
							}),
						$elm$core$Platform$Cmd$none);
				case 101:
					return _Utils_Tuple2(
						model,
						$author$project$Ports$fileSelected($author$project$Page$Home$cvInputFieldIdForApply));
				case 102:
					var maybeFile = msg.a;
					if (!maybeFile.$) {
						var file = maybeFile.a;
						if (file.$8 > 11010048) {
							var currentCandidateCvStageModel = model.k;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										k: _Utils_update(
											currentCandidateCvStageModel,
											{
												aJ: $elm$core$Maybe$Just('El CV que has intentado subir excede los límites. El archivo debe ser de máximo 10MB.')
											}),
										ap: false
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideCandidateCVStageErrorMessage));
						} else {
							if (!A2($elm$core$List$member, file.eY, $author$project$TT$ApiModel$cvFileTypeAccepted)) {
								var currentCandidateCvStageModel = model.k;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											k: _Utils_update(
												currentCandidateCvStageModel,
												{
													aJ: $elm$core$Maybe$Just('El CV que has intentado subir no es admitido.')
												}),
											ap: false
										}),
									$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideCandidateCVStageErrorMessage));
							} else {
								var currentCandidateCvStageModel = model.k;
								var currentCandidateCvInfo = currentCandidateCvStageModel.u;
								var arrayBytesMaybe = A2(
									$elm$core$Maybe$map,
									function (index) {
										return A3(
											$elm$core$String$slice,
											index + 1,
											$elm$core$String$length(file.dv),
											file.dv);
									},
									$elm$core$List$head(
										A2($elm$core$String$indexes, ',', file.dv)));
								var candidateNewCv = A2(
									$elm$core$Maybe$map,
									function (arrayBytes) {
										return {gX: arrayBytes, ie: file.ie, dV: file.eY};
									},
									arrayBytesMaybe);
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											k: _Utils_update(
												currentCandidateCvStageModel,
												{
													u: _Utils_update(
														currentCandidateCvInfo,
														{hm: candidateNewCv})
												}),
											ap: false
										}),
									$elm$core$Platform$Cmd$none);
							}
						}
					} else {
						var reportErrorCmd = $author$project$TT$Log$error(
							{js: 'Unable to get a cv-file on candidate gelada apply '});
						var currentCandidateCvStageModel = model.k;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									k: _Utils_update(
										currentCandidateCvStageModel,
										{
											aJ: $elm$core$Maybe$Just('Hubo un problema a procesar el CV que has intentado subir. Reintenta por favor.')
										}),
									ap: false
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										reportErrorCmd,
										$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideCandidateCVStageErrorMessage)
									])));
					}
				case 103:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ap: true}),
						$author$project$Ports$triggerUploadButton($author$project$Page$Home$cvInputFieldIdForApply));
				case 104:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ap: false}),
						$elm$core$Platform$Cmd$none);
				case 48:
					var currentCandidateCvStageModel = model.k;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: _Utils_update(
									currentCandidateCvStageModel,
									{aJ: $elm$core$Maybe$Nothing})
							}),
						$elm$core$Platform$Cmd$none);
				case 47:
					var currentCandidateCvStageModel = model.k;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: _Utils_update(
									currentCandidateCvStageModel,
									{bm: true})
							}),
						$author$project$Page$Home$submitCandidateCv(model));
				case 51:
					var jobAdId = msg.a;
					var companyName = msg.b;
					var response = msg.c;
					var currentCandidateCvStageModel = model.k;
					var errorModelAndCmd = _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: _Utils_update(
									currentCandidateCvStageModel,
									{
										bm: false,
										aJ: $elm$core$Maybe$Just('Ha ocurrido un error en el proceso de aplicación, por favor intenta nuevamente.')
									})
							}),
						$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideCandidateCVStageErrorMessage));
					switch (response.$) {
						case 1:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 0:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 2:
							return errorModelAndCmd;
						default:
							var result = response.a;
							if (result.k6) {
								var _v41 = result.k5;
								if (!_v41.$) {
									var successUri = _v41.a;
									var newModel = _Utils_update(
										model,
										{
											k: _Utils_update(
												currentCandidateCvStageModel,
												{bm: false})
										});
									var localCmds = _List_fromArray(
										[
											$author$project$Ports$refreshCandidateSession(
											{k7: successUri}),
											$author$project$Ports$trackCompleteApplication(
											{
												hK: A2(
													$elm$core$Maybe$map,
													function (cn) {
														return $elm_community$string_extra$String$Extra$classify(
															$elm_community$string_extra$String$Extra$removeAccents(cn));
													},
													companyName),
												fl: jobAdId,
												M: model.M
											})
										]);
									var modelWithFinalStep = _Utils_Tuple2(
										newModel,
										$elm$core$Platform$Cmd$batch(localCmds));
									return modelWithFinalStep;
								} else {
									return errorModelAndCmd;
								}
							} else {
								var _v42 = result.bM;
								if (!_v42.$) {
									var errorCode = _v42.a;
									var warningMessage = function () {
										switch (errorCode) {
											case 'invalid_cv_mime_type':
												return 'El formato del CV que has intentado subir no está permitido. Los formatos permitos son: imágenes, PDFs y documentos';
											case 'cv_size_exceeded':
												return 'El CV que has intentado subir excede los límites. El archivo debe ser de máximo 10MB.';
											default:
												return 'Ocurrió un error al subir tu CV, reintenta por favor. Si el error persiste comunícate con nosotros.';
										}
									}();
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												k: _Utils_update(
													currentCandidateCvStageModel,
													{
														bm: false,
														aJ: $elm$core$Maybe$Just(warningMessage)
													})
											}),
										$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgHideCandidateCVStageErrorMessage));
								} else {
									return errorModelAndCmd;
								}
							}
					}
				case 100:
					var response = msg.a;
					var _v44 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, response);
					if (!_v44.$) {
						var successUrl = _v44.a;
						return _Utils_Tuple2(
							model,
							$elm$browser$Browser$Navigation$load(successUrl));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 52:
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load('/postular?j_id=000000000000000000000000'));
				case 53:
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load('/empleos'));
				case 76:
					var url = msg.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$elm$browser$Browser$Navigation$load(url),
									$author$project$Ports$redirectoToExternalUrl(
									{ic: url})
								])));
				case 54:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b6: true}),
						$elm$core$Platform$Cmd$none);
				case 55:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b6: false}),
						$elm$core$Platform$Cmd$none);
				case 56:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bs: true}),
						$elm$core$Platform$Cmd$none);
				case 57:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bs: false}),
						$elm$core$Platform$Cmd$none);
				case 58:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b5: true}),
						$elm$core$Platform$Cmd$none);
				case 59:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b5: false}),
						$elm$core$Platform$Cmd$none);
				case 60:
					var newEmail = msg.a;
					var sendToFriendModel = model.i;
					var email = sendToFriendModel.cB;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								i: _Utils_update(
									sendToFriendModel,
									{
										cB: _Utils_update(
											email,
											{g: newEmail})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 61:
					var newName = msg.a;
					var sendToFriendModel = model.i;
					var name = sendToFriendModel.at;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								i: _Utils_update(
									sendToFriendModel,
									{
										at: _Utils_update(
											name,
											{g: newName})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 62:
					var newEmail = msg.a;
					var sendToFriendModel = model.i;
					var friendEmail = sendToFriendModel.an;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								i: _Utils_update(
									sendToFriendModel,
									{
										an: _Utils_update(
											friendEmail,
											{g: newEmail})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 63:
					var newName = msg.a;
					var sendToFriendModel = model.i;
					var friendName = sendToFriendModel.ao;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								i: _Utils_update(
									sendToFriendModel,
									{
										ao: _Utils_update(
											friendName,
											{g: newName})
									})
							}),
						$elm$core$Platform$Cmd$none);
				case 64:
					var newValue = msg.a;
					var sendToFriendModel = model.i;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								i: _Utils_update(
									sendToFriendModel,
									{db: newValue})
							}),
						$elm$core$Platform$Cmd$none);
				case 65:
					var sendToFriendModel = model.i;
					var name = sendToFriendModel.at;
					var nameError = ($elm$core$String$trim(name.g) === '') ? $elm$core$Maybe$Just('Ingresa tu nombre') : $elm$core$Maybe$Nothing;
					var friendName = sendToFriendModel.ao;
					var friendNameError = ($elm$core$String$trim(friendName.g) === '') ? $elm$core$Maybe$Just('Ingresa el nombre de tu amigo') : $elm$core$Maybe$Nothing;
					var friendEmail = sendToFriendModel.an;
					var friendEmailError = $author$project$Page$Home$validateEmail(friendEmail.g);
					var email = sendToFriendModel.cB;
					var emailError = $author$project$Page$Home$validateEmail(email.g);
					var newModelAndCmd = (_Utils_eq(emailError, $elm$core$Maybe$Nothing) && (_Utils_eq(nameError, $elm$core$Maybe$Nothing) && (_Utils_eq(friendEmailError, $elm$core$Maybe$Nothing) && _Utils_eq(friendNameError, $elm$core$Maybe$Nothing)))) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								i: _Utils_update(
									sendToFriendModel,
									{t: true})
							}),
						$author$project$Page$Home$sendSendToFriendForm(model)) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								i: _Utils_update(
									sendToFriendModel,
									{
										cB: _Utils_update(
											email,
											{bM: emailError}),
										an: _Utils_update(
											friendEmail,
											{bM: friendEmailError}),
										ao: _Utils_update(
											friendName,
											{bM: friendNameError}),
										at: _Utils_update(
											name,
											{bM: nameError})
									})
							}),
						$elm$core$Platform$Cmd$none);
					return newModelAndCmd;
				case 66:
					var response = msg.a;
					switch (response.$) {
						case 1:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 0:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 2:
							var sendToFriendModel = model.i;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										i: _Utils_update(
											sendToFriendModel,
											{
												t: false,
												G: $elm$core$Maybe$Just('Ha ocurrido un error al enviar a un amigo, por favor intenta nuevamente.')
											})
									}),
								$elm$core$Platform$Cmd$none);
						default:
							var result = response.a;
							if (result === 'true') {
								var sendToFriendModel = model.i;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											i: _Utils_update(
												sendToFriendModel,
												{t: false, de: true})
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								var sendToFriendModel = model.i;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											i: _Utils_update(
												sendToFriendModel,
												{
													t: false,
													G: $elm$core$Maybe$Just('Ha ocurrido un error al enviar la vacante, por favor intenta nuevamente.'),
													de: false
												})
										}),
									$elm$core$Platform$Cmd$none);
							}
					}
				case 67:
					var response = msg.a;
					switch (response.$) {
						case 1:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 0:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 2:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						default:
							var result = response.a;
							var existAccount = result.ix;
							var showCandidateNotLoggedInMessage = existAccount;
							var currentMagicLinkCodeValidationModel = model.c;
							var currentLoginModel = model.f;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										C: result,
										f: _Utils_update(
											currentLoginModel,
											{W: showCandidateNotLoggedInMessage}),
										c: _Utils_update(
											currentMagicLinkCodeValidationModel,
											{aI: false})
									}),
								showCandidateNotLoggedInMessage ? A2(
									$elm$core$Task$attempt,
									$author$project$Page$Home$MsgBrowserGetContinueWithTalentecaWidthResult,
									$elm$browser$Browser$Dom$getElement('continueWithTalentecaButton')) : $elm$core$Platform$Cmd$none);
					}
				case 69:
					var currentLoginModel = model.f;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								K: false,
								f: _Utils_update(
									currentLoginModel,
									{V: false, W: false}),
								c: {cJ: false, t: false, aS: '', aT: '', aU: '', aV: '', aW: '', aX: '', aI: false, bz: 0}
							}),
						$elm$core$Platform$Cmd$none);
				case 68:
					var currentMagicLinkCodeValidationModel = model.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									currentMagicLinkCodeValidationModel,
									{aI: false})
							}),
						$elm$core$Platform$Cmd$none);
				case 70:
					var email = msg.a;
					var loginModel = model.f;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: _Utils_update(
									loginModel,
									{t: true})
							}),
						A2($author$project$Page$Home$sendMagicLinkLogin, model, email));
				case 71:
					var response = msg.a;
					var loginModel = model.f;
					switch (response.$) {
						case 1:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 0:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 2:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										K: false,
										f: _Utils_update(
											loginModel,
											{
												t: false,
												af: $elm$core$Maybe$Just('Hubo un fallo al procesar tu solicitud. Por favor continúa tu proceso de postulación'),
												V: false,
												W: false
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton));
						default:
							var result = response.a;
							var currentMagicLinkCodeValidationModel = model.c;
							var newModelAndCmd = (result.f9 === 'ok') ? _Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: _Utils_update(
											loginModel,
											{t: false}),
										c: _Utils_update(
											currentMagicLinkCodeValidationModel,
											{aI: true})
									}),
								A2(
									$elm$core$Task$attempt,
									function (_v48) {
										return $author$project$Page$Home$PassThrough;
									},
									$elm$browser$Browser$Dom$focus('magic-link-input-1'))) : ((result.f9 === 'email-wrong') ? _Utils_Tuple2(
								_Utils_update(
									model,
									{
										K: false,
										f: _Utils_update(
											loginModel,
											{
												t: false,
												af: $elm$core$Maybe$Just(
													'El correo electrónico ingresado no es correcto.' + A2(
														$elm$core$Maybe$withDefault,
														'',
														A2(
															$elm$core$Maybe$map,
															function (h) {
																return ' ¿Quizás quisiste decir: ' + h;
															},
															result.hh))),
												V: false,
												W: false
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton)) : ((result.f9 === 'failed') ? _Utils_Tuple2(
								_Utils_update(
									model,
									{
										K: false,
										f: _Utils_update(
											loginModel,
											{
												t: false,
												af: $elm$core$Maybe$Just('Hubo un fallo al procesar tu solicitud. Por favor continúa tu proceso de postulación'),
												V: false,
												W: false
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton)) : _Utils_Tuple2(
								_Utils_update(
									model,
									{
										K: false,
										f: _Utils_update(
											loginModel,
											{
												t: false,
												af: $elm$core$Maybe$Just('Hubo un fallo al procesar tu solicitud. Por favor continúa tu proceso de postulación'),
												V: false,
												W: false
											})
									}),
								$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton))));
							return newModelAndCmd;
					}
				case 72:
					var candidateInfoStageModel = model.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: _Utils_update(
									candidateInfoStageModel,
									{b3: false})
							}),
						$elm$core$Platform$Cmd$none);
				case 73:
					var loginModel = model.f;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: _Utils_update(
									loginModel,
									{b4: true})
							}),
						$elm$core$Platform$Cmd$none);
				case 74:
					var loginModel = model.f;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: _Utils_update(
									loginModel,
									{
										t: false,
										af: $elm$core$Maybe$Just('No se ha podido iniciar sesión con Google. Por favor intenta nuevamente')
									})
							}),
						$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton));
				case 77:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a0: true}),
						$elm$core$Platform$Cmd$none);
				case 78:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a0: false}),
						$elm$core$Platform$Cmd$none);
				case 79:
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load('/empleos'));
				case 80:
					var googleClientId = msg.a;
					var previousStep = function () {
						var _v51 = model.gV;
						switch (_v51) {
							case 0:
								return $elm$core$Maybe$Nothing;
							case 1:
								return (!_Utils_eq(model.X, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(0);
							case 2:
								return $elm$core$Maybe$Just(1);
							case 3:
								return $elm$core$Maybe$Just(1);
							case 4:
								return (!$elm$core$List$length(model.aD)) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Just(3);
							case 5:
								return $elm$core$Maybe$Just(4);
							case 6:
								return $elm$core$Maybe$Just(5);
							default:
								return $elm$core$Maybe$Nothing;
						}
					}();
					if (!previousStep.$) {
						var step = previousStep.a;
						var currentCandidateInfoStageModel = model.a;
						var _v50 = (!step) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: _Utils_update(
										currentCandidateInfoStageModel,
										{
											l: 0,
											b: {
												hT: {bM: $elm$core$Maybe$Nothing, g: $elm$core$Maybe$Nothing},
												cB: $author$project$Model$defaultTkCommonField,
												dG: $author$project$Model$defaultTkCommonField,
												dK: $author$project$Model$defaultTkCommonField,
												cU: $author$project$Model$defaultTkLocationField,
												jT: _Utils_update(
													$author$project$Model$defaultTkCommonField,
													{cO: ''})
											},
											aq: 0
										})
								}),
							$author$project$Ports$renderGoogleSignInButton(
								{is: googleClientId})) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						var newModel = _v50.a;
						var newCmd = _v50.b;
						return _Utils_Tuple2(
							_Utils_update(
								newModel,
								{gV: step}),
							newCmd);
					} else {
						return _Utils_Tuple2(
							model,
							A2($elm$browser$Browser$Navigation$back, model.cW, 1));
					}
				case 81:
					var loginModel = model.f;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: _Utils_update(
									loginModel,
									{V: true, W: false})
							}),
						$elm$core$Platform$Cmd$none);
				case 82:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b2: false}),
						$elm$core$Platform$Cmd$none);
				case 83:
					var inputId = msg.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							function (_v52) {
								return $author$project$Page$Home$PassThrough;
							},
							$elm$browser$Browser$Dom$blur(inputId)));
				case 84:
					var jobAdLink = msg.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(jobAdLink));
				case 85:
					var value = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var valueProcessed = function () {
						var _v55 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v55.$ === 1) {
							return $elm$core$String$trim(value);
						} else {
							var regex = _v55.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v56) {
										return '';
									},
									value));
						}
					}();
					var magickLinkValidation = model.c;
					var getNewMagickLinkValidation = function (inputValue) {
						var newMagickLinkValidation = _Utils_update(
							magickLinkValidation,
							{aU: inputValue});
						return newMagickLinkValidation;
					};
					var newModelAndCmd = function () {
						var _v53 = A2($elm$core$String$split, '', valueProcessed);
						if (!_v53.b) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										c: getNewMagickLinkValidation('')
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							if (!_v53.b.b) {
								var inputValue = _v53.a;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{c: magicLinkValidationWithErrors}),
									A2(
										$elm$core$Task$attempt,
										function (_v54) {
											return $author$project$Page$Home$PassThrough;
										},
										$elm$browser$Browser$Dom$focus('magic-link-input-2')));
							} else {
								var inputValue = _v53.a;
								var tail = _v53.b;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								var newModel = _Utils_update(
									model,
									{c: magicLinkValidationWithErrors});
								return A2(
									$author$project$Page$Home$update,
									$author$project$Page$Home$MsgUserChangeMagicLinkValidationInputTwo(
										$elm$core$String$concat(tail)),
									newModel);
							}
						}
					}();
					return newModelAndCmd;
				case 86:
					var value = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var valueProcessed = function () {
						var _v59 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v59.$ === 1) {
							return $elm$core$String$trim(value);
						} else {
							var regex = _v59.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v60) {
										return '';
									},
									value));
						}
					}();
					var magickLinkValidation = model.c;
					var getNewMagickLinkValidation = function (inputValue) {
						var newMagickLinkValidation = _Utils_update(
							magickLinkValidation,
							{aX: inputValue});
						return newMagickLinkValidation;
					};
					var newModelAndCmd = function () {
						var _v57 = A2($elm$core$String$split, '', valueProcessed);
						if (!_v57.b) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										c: getNewMagickLinkValidation('')
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							if (!_v57.b.b) {
								var inputValue = _v57.a;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{c: magicLinkValidationWithErrors}),
									A2(
										$elm$core$Task$attempt,
										function (_v58) {
											return $author$project$Page$Home$PassThrough;
										},
										$elm$browser$Browser$Dom$focus('magic-link-input-3')));
							} else {
								var inputValue = _v57.a;
								var tail = _v57.b;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								var newModel = _Utils_update(
									model,
									{c: magicLinkValidationWithErrors});
								return A2(
									$author$project$Page$Home$update,
									$author$project$Page$Home$MsgUserChangeMagicLinkValidationInputThree(
										$elm$core$String$concat(tail)),
									newModel);
							}
						}
					}();
					return newModelAndCmd;
				case 88:
					var value = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var valueProcessed = function () {
						var _v63 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v63.$ === 1) {
							return $elm$core$String$trim(value);
						} else {
							var regex = _v63.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v64) {
										return '';
									},
									value));
						}
					}();
					var magickLinkValidation = model.c;
					var getNewMagickLinkValidation = function (inputValue) {
						var newMagickLinkValidation = _Utils_update(
							magickLinkValidation,
							{aW: inputValue});
						return newMagickLinkValidation;
					};
					var newModelAndCmd = function () {
						var _v61 = A2($elm$core$String$split, '', valueProcessed);
						if (!_v61.b) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										c: getNewMagickLinkValidation('')
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							if (!_v61.b.b) {
								var inputValue = _v61.a;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{c: magicLinkValidationWithErrors}),
									A2(
										$elm$core$Task$attempt,
										function (_v62) {
											return $author$project$Page$Home$PassThrough;
										},
										$elm$browser$Browser$Dom$focus('magic-link-input-4')));
							} else {
								var inputValue = _v61.a;
								var tail = _v61.b;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								var newModel = _Utils_update(
									model,
									{c: magicLinkValidationWithErrors});
								return A2(
									$author$project$Page$Home$update,
									$author$project$Page$Home$MsgUserChangeMagicLinkValidationInputFour(
										$elm$core$String$concat(tail)),
									newModel);
							}
						}
					}();
					return newModelAndCmd;
				case 90:
					var value = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var valueProcessed = function () {
						var _v67 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v67.$ === 1) {
							return $elm$core$String$trim(value);
						} else {
							var regex = _v67.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v68) {
										return '';
									},
									value));
						}
					}();
					var magickLinkValidation = model.c;
					var getNewMagickLinkValidation = function (inputValue) {
						var newMagickLinkValidation = _Utils_update(
							magickLinkValidation,
							{aT: inputValue});
						return newMagickLinkValidation;
					};
					var newModelAndCmd = function () {
						var _v65 = A2($elm$core$String$split, '', valueProcessed);
						if (!_v65.b) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										c: getNewMagickLinkValidation('')
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							if (!_v65.b.b) {
								var inputValue = _v65.a;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{c: magicLinkValidationWithErrors}),
									A2(
										$elm$core$Task$attempt,
										function (_v66) {
											return $author$project$Page$Home$PassThrough;
										},
										$elm$browser$Browser$Dom$focus('magic-link-input-5')));
							} else {
								var inputValue = _v65.a;
								var tail = _v65.b;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								var newModel = _Utils_update(
									model,
									{c: magicLinkValidationWithErrors});
								return A2(
									$author$project$Page$Home$update,
									$author$project$Page$Home$MsgUserChangeMagicLinkValidationInputFive(
										$elm$core$String$concat(tail)),
									newModel);
							}
						}
					}();
					return newModelAndCmd;
				case 87:
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							function (_v69) {
								return $author$project$Page$Home$PassThrough;
							},
							$elm$browser$Browser$Dom$focus('magic-link-input-1')));
				case 89:
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							function (_v70) {
								return $author$project$Page$Home$PassThrough;
							},
							$elm$browser$Browser$Dom$focus('magic-link-input-2')));
				case 91:
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							function (_v71) {
								return $author$project$Page$Home$PassThrough;
							},
							$elm$browser$Browser$Dom$focus('magic-link-input-3')));
				case 93:
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							function (_v72) {
								return $author$project$Page$Home$PassThrough;
							},
							$elm$browser$Browser$Dom$focus('magic-link-input-4')));
				case 95:
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							function (_v73) {
								return $author$project$Page$Home$PassThrough;
							},
							$elm$browser$Browser$Dom$focus('magic-link-input-5')));
				case 92:
					var value = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var valueProcessed = function () {
						var _v76 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v76.$ === 1) {
							return $elm$core$String$trim(value);
						} else {
							var regex = _v76.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v77) {
										return '';
									},
									value));
						}
					}();
					var magickLinkValidation = model.c;
					var getNewMagickLinkValidation = function (inputValue) {
						var newMagickLinkValidation = _Utils_update(
							magickLinkValidation,
							{aS: inputValue});
						return newMagickLinkValidation;
					};
					var newModelAndCmd = function () {
						var _v74 = A2($elm$core$String$split, '', valueProcessed);
						if (!_v74.b) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										c: getNewMagickLinkValidation('')
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							if (!_v74.b.b) {
								var inputValue = _v74.a;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{c: magicLinkValidationWithErrors}),
									A2(
										$elm$core$Task$attempt,
										function (_v75) {
											return $author$project$Page$Home$PassThrough;
										},
										$elm$browser$Browser$Dom$focus('magic-link-input-6')));
							} else {
								var inputValue = _v74.a;
								var tail = _v74.b;
								var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
								var newModel = _Utils_update(
									model,
									{c: magicLinkValidationWithErrors});
								return A2(
									$author$project$Page$Home$update,
									$author$project$Page$Home$MsgUserChangeMagicLinkValidationInputSix(
										$elm$core$String$concat(tail)),
									newModel);
							}
						}
					}();
					return newModelAndCmd;
				case 94:
					var value = msg.a;
					var removeNonNumbersRegex = '[^0-9]';
					var valueProcessed = function () {
						var _v79 = $elm$regex$Regex$fromString(removeNonNumbersRegex);
						if (_v79.$ === 1) {
							return $elm$core$String$trim(value);
						} else {
							var regex = _v79.a;
							return $elm$core$String$trim(
								A3(
									$elm$regex$Regex$replace,
									regex,
									function (_v80) {
										return '';
									},
									value));
						}
					}();
					var magickLinkValidation = model.c;
					var getNewMagickLinkValidation = function (inputValue) {
						var newMagickLinkValidation = _Utils_update(
							magickLinkValidation,
							{aV: inputValue});
						return newMagickLinkValidation;
					};
					var commonModelAndCmd = function (inputValue) {
						var magicLinkValidationWithErrors = getNewMagickLinkValidation(inputValue);
						var newModel = _Utils_update(
							model,
							{c: magicLinkValidationWithErrors});
						return A2($author$project$Page$Home$update, $author$project$Page$Home$MsgUserPressedValidateMagicLinkCodeButton, newModel);
					};
					var newModelAndCmd = function () {
						var _v78 = A2($elm$core$String$split, '', valueProcessed);
						if (!_v78.b) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										c: getNewMagickLinkValidation('')
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							if (!_v78.b.b) {
								var inputValue = _v78.a;
								return commonModelAndCmd(inputValue);
							} else {
								var inputValue = _v78.a;
								return commonModelAndCmd(inputValue);
							}
						}
					}();
					return newModelAndCmd;
				case 96:
					var magickLinkValidation = model.c;
					return ((magickLinkValidation.aU === '') && ((magickLinkValidation.aX === '') && ((magickLinkValidation.aW === '') && ((magickLinkValidation.aT === '') && ((magickLinkValidation.aS === '') && (magickLinkValidation.aV === '')))))) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: _Utils_update(
									magickLinkValidation,
									{t: true})
							}),
						$author$project$Page$Home$verifyMagicLink(model));
				case 99:
					var response = msg.a;
					var loginModel = model.f;
					switch (response.$) {
						case 1:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 0:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 2:
							var httpError = response.a;
							var magickLinkValidation = model.c;
							var newModelAfterError = function (errorMessage) {
								return (magickLinkValidation.bz < 2) ? _Utils_Tuple2(
									_Utils_update(
										model,
										{
											f: _Utils_update(
												loginModel,
												{
													af: $elm$core$Maybe$Just(errorMessage + ' Por favor intenta nuevamente')
												}),
											c: _Utils_update(
												magickLinkValidation,
												{t: false, bz: magickLinkValidation.bz + 1})
										}),
									$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton)) : _Utils_Tuple2(
									_Utils_update(
										model,
										{
											K: false,
											f: _Utils_update(
												loginModel,
												{
													af: $elm$core$Maybe$Just(errorMessage + ' Por favor continúa tu proceso de postulación'),
													V: false,
													W: false
												}),
											c: {cJ: false, t: false, aS: '', aT: '', aU: '', aV: '', aW: '', aX: '', aI: false, bz: 0}
										}),
									$author$project$Page$Home$delayHideNotification($author$project$Page$Home$MsgUserPressedDismissLoginErrorBannerButton));
							};
							if (httpError.$ === 3) {
								var status = httpError.a;
								return (status === 403) ? newModelAfterError('El código ingresado es incorrecto.') : newModelAfterError('Hubo un fallo al procesar tu solicitud.');
							} else {
								return newModelAfterError('Hubo un fallo al procesar tu solicitud.');
							}
						default:
							var currentMagicLinkCodeValidationModel = model.c;
							var newModelAndCmd = _Utils_Tuple2(
								_Utils_update(
									model,
									{
										K: false,
										f: _Utils_update(
											loginModel,
											{t: false}),
										c: _Utils_update(
											currentMagicLinkCodeValidationModel,
											{aI: false})
									}),
								$elm$browser$Browser$Navigation$reload);
							return newModelAndCmd;
					}
				case 97:
					if (!msg.a.$) {
						var element = msg.a.a;
						var loginModel = model.f;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: _Utils_update(
										loginModel,
										{
											cw: $elm$core$Basics$ceiling(element.h6.a8)
										})
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 98:
					var loginModel = model.f;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: _Utils_update(
									loginModel,
									{af: $elm$core$Maybe$Nothing})
							}),
						$elm$core$Platform$Cmd$none);
				case 105:
					var link = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Page$Home$downloadCV(link));
				case 106:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cy: true}),
						$elm$core$Platform$Cmd$none);
				case 107:
					var messageId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dd: A2(
									$elm$core$Array$filter,
									function (m) {
										return !_Utils_eq(m.a, messageId);
									},
									model.dd)
							}),
						$elm$core$Platform$Cmd$none);
				case 108:
					var messageId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ac: A2(
									$elm$core$Array$filter,
									function (m) {
										return !_Utils_eq(m.a, messageId);
									},
									model.ac)
							}),
						$elm$core$Platform$Cmd$none);
				case 109:
					var messageId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a7: A2(
									$elm$core$Array$filter,
									function (m) {
										return !_Utils_eq(m.a, messageId);
									},
									model.a7)
							}),
						$elm$core$Platform$Cmd$none);
				case 110:
					return _Utils_Tuple2(
						model,
						$author$project$Page$Home$trackGoogleSignInButtonClick(model));
				case 111:
					var position = msg.a;
					return A2($author$project$Page$Home$saveJobAdAsFavorite, model, position);
				case 112:
					var jobAdId = msg.a;
					var position = msg.b;
					var response = msg.c;
					var messageIdError = 'save-job-ad-failure';
					var errorMessages = A2(
						$elm$core$Array$push,
						_Utils_Tuple2(messageIdError, 'Ha ocurrido un error al guardar la vacante, por favor intenta nuevamente'),
						model.ac);
					switch (response.$) {
						case 1:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 0:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 2:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{ac: errorMessages}),
								$author$project$Page$Home$delayHideNotification(
									$author$project$Page$Home$MsgBrowserHideErrorMessage(messageIdError)));
						default:
							var result = response.a;
							if ((result.f9 === 'ok') || (result.f9 === 'notification-not-send')) {
								var messageId = 'save-job-ad-ok';
								var successMessages = A2(
									$elm$core$Array$push,
									_Utils_Tuple2(
										messageId,
										A2(
											$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
											_List_Nil,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$text('Vacante añadida como favorita')
												]))),
									model.dd);
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{dd: successMessages}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												$author$project$Ports$saveJobAdAsFavoriteFromLocalStorage(
												_Utils_Tuple2(jobAdId, position)),
												$author$project$Page$Home$delayHideNotification(
												$author$project$Page$Home$MsgBrowserHideSuccessMessage(messageId))
											])));
							} else {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{ac: errorMessages}),
									$author$project$Page$Home$delayHideNotification(
										$author$project$Page$Home$MsgBrowserHideErrorMessage(messageIdError)));
							}
					}
				case 113:
					var result = msg.a;
					if (!result.$) {
						var response = result.a;
						if (response.f9 === 'ok') {
							var _v85 = function () {
								var _v86 = response.js;
								if (!_v86.$) {
									var text = _v86.a;
									var trimmedText = $elm$core$String$trim(text);
									return (trimmedText === '') ? _Utils_Tuple2($elm$core$Maybe$Nothing, 64) : _Utils_Tuple2(
										$elm$core$Maybe$Just(
											_Utils_Tuple3(
												trimmedText,
												A2($author$project$TT$Color$Extra$lighten, 0.1, $author$project$TT$Color$warning),
												$author$project$TT$Color$black)),
										model.p ? 140 : 184);
								} else {
									return _Utils_Tuple2($elm$core$Maybe$Nothing, 64);
								}
							}();
							var pageAlert = _v85.a;
							var heightSizeToReduce = _v85.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{ae: heightSizeToReduce, bY: pageAlert}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						var err = result.a;
						return _Utils_Tuple2(
							model,
							$author$project$TT$Log$error(
								{
									js: 'Error displaying global banner info on jobads search page: ' + $author$project$TT$Util$httpErrorToString(err)
								}));
					}
				case 114:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ae: 64, bY: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				case 115:
					var currentCandidateInfoStageModel = model.a;
					var newModel = _Utils_update(
						model,
						{
							a: _Utils_update(
								currentCandidateInfoStageModel,
								{l: 3}),
							by: true
						});
					return _Utils_Tuple2(
						newModel,
						$author$project$Page$Home$getCountries(newModel));
				case 116:
					var response = msg.a;
					switch (response.$) {
						case 1:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 0:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 2:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						default:
							var result = response.a;
							var currentCandidateInfoStageModel = model.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										a: _Utils_update(
											currentCandidateInfoStageModel,
											{
												be: A2($author$project$Model$initCountryList, result, currentCandidateInfoStageModel.be)
											})
									}),
								$elm$core$Platform$Cmd$none);
					}
				case 117:
					var updateLocation = function (location) {
						return _Utils_update(
							location,
							{cE: false, cO: '', g: $elm$core$Maybe$Nothing});
					};
					var oldCommonModel = model.J;
					var newModel = function () {
						var _v88 = model.a.b.hT.g;
						if (!_v88.$) {
							var tkCommonDropdownItem = _v88.a;
							var newCurrentCandidateApplyInfo = A2(
								$elm$core$Maybe$map,
								function (currentCandidateApplyInfo) {
									return _Utils_update(
										currentCandidateApplyInfo,
										{
											hU: $elm$core$Maybe$Just(tkCommonDropdownItem.g)
										});
								},
								model.X);
							var newCommonModel = _Utils_update(
								oldCommonModel,
								{hU: tkCommonDropdownItem.g});
							return _Utils_update(
								model,
								{
									J: newCommonModel,
									hU: $elm$core$Maybe$Just(tkCommonDropdownItem.g),
									X: newCurrentCandidateApplyInfo
								});
						} else {
							return model;
						}
					}();
					var currentCandidateInfoStageModel = model.a;
					var updatedCandidateInfoDo = function (infoDo) {
						return _Utils_update(
							infoDo,
							{
								cU: updateLocation(infoDo.cU)
							});
					}(currentCandidateInfoStageModel.b);
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								a: _Utils_update(
									currentCandidateInfoStageModel,
									{l: 4, b: updatedCandidateInfoDo}),
								by: false
							}),
						$elm$core$Platform$Cmd$none);
				case 118:
					var subMsg = msg.a;
					var currentCandidateInfoStageModel = model.a;
					var _v89 = A4(
						$author$project$TT$Dropdown$update,
						A6(
							$author$project$Page$Home$commonSelectDropdown,
							currentCandidateInfoStageModel.b.hT.g,
							!_Utils_eq(currentCandidateInfoStageModel.b.hT.bM, $elm$core$Maybe$Nothing),
							$author$project$Page$Home$MsgCountryDropdownChanged,
							$author$project$Page$Home$MsgCountryDropdownSelectChanged,
							'country-container',
							'country-options'),
						subMsg,
						model,
						currentCandidateInfoStageModel.be);
					var newState = _v89.a;
					var cmd = _v89.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: _Utils_update(
									currentCandidateInfoStageModel,
									{be: newState})
							}),
						cmd);
				case 119:
					if (!msg.a.$) {
						var _v90 = msg.a.a;
						var countryDo = _v90.c;
						var currentCandidateInfoStageModel = model.a;
						var currentCandidateInfoDo = currentCandidateInfoStageModel.b;
						var currentCountryField = currentCandidateInfoDo.hT;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: _Utils_update(
										currentCandidateInfoStageModel,
										{
											b: _Utils_update(
												currentCandidateInfoDo,
												{
													hT: _Utils_update(
														currentCountryField,
														{
															bM: $elm$core$Maybe$Nothing,
															g: $elm$core$Maybe$Just(countryDo)
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var _v91 = msg.a.a;
						var countryDo = _v91.c;
						var currentCandidateInfoStageModel = model.a;
						var currentCandidateInfoDo = currentCandidateInfoStageModel.b;
						var currentCountryField = currentCandidateInfoDo.hT;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: _Utils_update(
										currentCandidateInfoStageModel,
										{
											b: _Utils_update(
												currentCandidateInfoDo,
												{
													hT: _Utils_update(
														currentCountryField,
														{
															bM: $elm$core$Maybe$Nothing,
															g: $elm$core$Maybe$Just(countryDo)
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 120:
					var currentCandidateInfoStageModel = model.a;
					var newModel = _Utils_update(
						model,
						{
							a: _Utils_update(
								currentCandidateInfoStageModel,
								{l: 4}),
							by: false
						});
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				case 121:
					var result = msg.a;
					var currentCandidateInfoStageModel = model.a;
					var _v92 = A4(
						$author$project$TT$Dropdown$update,
						$author$project$Page$Home$citiesDropdown(model),
						A2(
							$author$project$TT$Dropdown$OnReceivedMatches,
							result,
							function ($) {
								return $.ez;
							}),
						model,
						currentCandidateInfoStageModel.ak);
					var newState = _v92.a;
					var cmd = _v92.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: _Utils_update(
									currentCandidateInfoStageModel,
									{ak: newState})
							}),
						cmd);
				case 122:
					var subMsg = msg.a;
					var newLocation = msg.b;
					var errorMessage = ($elm$core$String$trim(newLocation) === '') ? $elm$core$Maybe$Just('Por favor ingresa el lugar donde vives') : $elm$core$Maybe$Nothing;
					var currentCandidateInfoStageModel = model.a;
					var currentApplyInfo = currentCandidateInfoStageModel.b;
					var currentLocationField = currentApplyInfo.cU;
					var newSelectedCity = _Utils_eq(newLocation, currentLocationField.cO) ? currentLocationField.f3 : $elm$core$Maybe$Nothing;
					var newModel = _Utils_update(
						model,
						{
							a: _Utils_update(
								currentCandidateInfoStageModel,
								{
									b: _Utils_update(
										currentApplyInfo,
										{
											cU: _Utils_update(
												currentLocationField,
												{bM: errorMessage, cO: newLocation, f3: newSelectedCity})
										})
								})
						});
					var newCandidateInfoStageModel = newModel.a;
					var _v93 = A4(
						$author$project$TT$Dropdown$update,
						$author$project$Page$Home$citiesDropdown(newModel),
						subMsg,
						newModel,
						newCandidateInfoStageModel.ak);
					var newState = _v93.a;
					var cmd = _v93.b;
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								a: _Utils_update(
									newCandidateInfoStageModel,
									{ak: newState})
							}),
						cmd);
				case 123:
					var subMsg = msg.a;
					var currentCandidateInfoStageModel = model.a;
					var _v94 = A4(
						$author$project$TT$Dropdown$update,
						$author$project$Page$Home$citiesDropdown(model),
						subMsg,
						model,
						currentCandidateInfoStageModel.ak);
					var newState = _v94.a;
					var cmd = _v94.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a: _Utils_update(
									currentCandidateInfoStageModel,
									{ak: newState})
							}),
						cmd);
				case 124:
					if (!msg.a.$) {
						var _v95 = msg.a.a;
						var cityDo = _v95.c;
						var currentCandidateInfoStageModel = model.a;
						var currentApplyInfo = currentCandidateInfoStageModel.b;
						var currentLocationField = currentApplyInfo.cU;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: _Utils_update(
										currentCandidateInfoStageModel,
										{
											b: _Utils_update(
												currentApplyInfo,
												{
													cU: _Utils_update(
														currentLocationField,
														{
															bM: $elm$core$Maybe$Nothing,
															cO: cityDo.ez + (' - ' + cityDo.fT),
															f3: $elm$core$Maybe$Just(cityDo)
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var _v96 = msg.a.a;
						var cityDo = _v96.c;
						var currentCandidateInfoStageModel = model.a;
						var currentApplyInfo = currentCandidateInfoStageModel.b;
						var currentLocationField = currentApplyInfo.cU;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									a: _Utils_update(
										currentCandidateInfoStageModel,
										{
											b: _Utils_update(
												currentApplyInfo,
												{
													cU: _Utils_update(
														currentLocationField,
														{
															bM: $elm$core$Maybe$Nothing,
															cO: cityDo.ez + (' - ' + cityDo.fT),
															f3: $elm$core$Maybe$Just(cityDo)
														})
												})
										})
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 125:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 13:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var width = msg.a;
				var height = msg.b;
				var newWindowSize = {aR: height, a8: width};
				var context = model.bI;
				var newModel = _Utils_update(
					model,
					{
						bI: _Utils_update(
							context,
							{q: newWindowSize}),
						q: newWindowSize
					});
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Main$syncWindowSize, newModel.Q, newModel.q),
								$author$project$Ports$getVisualViewportHeight(0)
							])));
			case 5:
				var response = msg.a;
				var _v1 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$float, response);
				if (!_v1.$) {
					var height = _v1.a;
					var newModel = _Utils_update(
						model,
						{
							a6: $elm$core$Basics$ceiling(height)
						});
					return _Utils_Tuple2(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Main$syncViewportHeightOffset, newModel.Q, newModel.a6),
									$author$project$Ports$scrollToDocumentTop(0),
									$author$project$Ports$scrollToChatBottom(0)
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 0:
				var msgHome = msg.a;
				var _v2 = A2($author$project$Page$Home$update, msgHome, model.as);
				var modelHome = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{as: modelHome}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$MsgHome, cmd));
			case 2:
				var urlRequest = msg.a;
				if (!urlRequest.$) {
					var url = urlRequest.a;
					return $author$project$Route$isTonkeanUrl(url) ? _Utils_Tuple2(
						model,
						$author$project$Ports$goToTonkeanUrl(
							$elm$url$Url$toString(url))) : _Utils_Tuple2(
						_Utils_update(
							model,
							{Q: url}),
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							model.cW,
							$elm$url$Url$toString(url)));
				} else {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(url));
				}
			case 3:
				var url = msg.a;
				var newModel = _Utils_update(
					model,
					{
						b0: $author$project$Route$fromUrl(url),
						Q: url
					});
				var mainModelWithPageInitialized = function () {
					var _v4 = newModel.b0;
					if (!_v4.$) {
						var applyStepToShow = newModel.as.gV;
						return _Utils_update(
							newModel,
							{
								as: A5(
									$author$project$Page$Home$initModel,
									newModel.q,
									newModel.J,
									newModel.Q,
									newModel.cW,
									$elm$core$Maybe$Just(applyStepToShow))
							});
					} else {
						return newModel;
					}
				}();
				return _Utils_Tuple2(
					mainModelWithPageInitialized,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$elm$core$Platform$Cmd$none,
								$author$project$Main$initPageCmds(mainModelWithPageInitialized)
							])));
			case 4:
				var messageId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dd: A2(
								$elm$core$Array$filter,
								function (m) {
									return !_Utils_eq(m.a, messageId);
								},
								model.dd)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{da: result}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var oldStatesSidebarMenu = model.a1;
				var newStatesForMenu = _Utils_update(
					oldStatesSidebarMenu,
					{d3: true});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a1: newStatesForMenu}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var oldStatesSidebarMenu = model.a1;
				var newStatesForMenu = _Utils_update(
					oldStatesSidebarMenu,
					{d3: false});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a1: newStatesForMenu}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var toastId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Main$delayHideNotification(
						$author$project$Main$MsgBrowserHideToast(toastId)));
			case 10:
				var toastId = msg.a;
				var globalAlertsModelUpdate = _Utils_update(
					model,
					{
						aB: A2($elm$core$Dict$remove, toastId, model.aB),
						aO: A2($elm$core$Dict$remove, toastId, model.aO)
					});
				return _Utils_Tuple2(globalAlertsModelUpdate, $elm$core$Platform$Cmd$none);
			case 11:
				var response = msg.a;
				var _v5 = A2($elm$json$Json$Decode$decodeValue, $author$project$TT$ApiModel$tkNotificationsFromLocalStorageDecoder, response);
				if (!_v5.$) {
					var tkNotificationsFromLocalStorage = _v5.a;
					var jobAdsIdsSavedAsFavoriteInLocalStorage = A2(
						$elm$core$List$map,
						function (f) {
							return f.iJ;
						},
						_Utils_ap(tkNotificationsFromLocalStorage.dE.gD, tkNotificationsFromLocalStorage.dE.fP));
					var candidateIsLoggedIn = model.J.dt.eu;
					var cmdToSynchronize = (candidateIsLoggedIn && ((!tkNotificationsFromLocalStorage.gd) && ($elm$core$List$length(jobAdsIdsSavedAsFavoriteInLocalStorage) > 0))) ? $elm$http$Http$riskyRequest(
						{
							ch: $elm$http$Http$jsonBody(
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'list_job_ads_ids_to_synchronize',
											A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, jobAdsIdsSavedAsFavoriteInLocalStorage)),
											_Utils_Tuple2(
											'source',
											$elm$json$Json$Encode$string('new-jobads-search'))
										]))),
							dA: A2($elm$http$Http$expectJson, $author$project$Main$getMsgSavedJobAdsSynchronizedWithLocalStorageResponseDo, $author$project$TT$ApiModel$apiResponseSimpleStatusJsonDecoder),
							dJ: _List_Nil,
							dU: 'POST',
							d8: $elm$core$Maybe$Just(model.J.dS),
							d9: $elm$core$Maybe$Nothing,
							Q: model.J.cV + '/v1/candidate/synchronize-save-job-ads'
						}) : $elm$core$Platform$Cmd$none;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bw: tkNotificationsFromLocalStorage}),
						cmdToSynchronize);
				} else {
					var error = _v5.a;
					return _Utils_Tuple2(
						model,
						$author$project$TT$Log$error(
							{
								js: 'Error while getting favorite jobads from local storage. Error: ' + $elm$json$Json$Decode$errorToString(error)
							}));
				}
			default:
				var response = msg.a;
				var oldTkNotificationsFromLocalStorage = model.bw;
				var _v6 = A3(
					$krisajenkins$remotedata$RemoteData$unwrap,
					_Utils_Tuple2(oldTkNotificationsFromLocalStorage, $elm$core$Platform$Cmd$none),
					function (r) {
						return ((r.f9 === 'ok') || (r.f9 === 'notification-not-send')) ? _Utils_Tuple2(
							_Utils_update(
								oldTkNotificationsFromLocalStorage,
								{gd: true}),
							$author$project$Ports$setNotificationsAsSynchronizedWithLoggedInCandidate(0)) : _Utils_Tuple2(oldTkNotificationsFromLocalStorage, $elm$core$Platform$Cmd$none);
					},
					response);
				var tkNotificationsFromLocalStorage = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bw: tkNotificationsFromLocalStorage}),
					cmd);
		}
	});
var $author$project$Main$MsgBrowserDeleteToast = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$MsgUserPressedHideAccountInfoDropdown = {$: 7};
var $author$project$Main$MsgUserPressedShowAccountInfoDropdown = {$: 8};
var $mdgriffith$elm_ui$Internal$Model$Behind = 5;
var $mdgriffith$elm_ui$Element$createNearby = F2(
	function (loc, element) {
		if (element.$ === 3) {
			return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
		} else {
			return A2($mdgriffith$elm_ui$Internal$Model$Nearby, loc, element);
		}
	});
var $mdgriffith$elm_ui$Element$behindContent = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 5, element);
};
var $lucamug$elm_ui_with_context$Element$WithContext$createNearby = F2(
	function (toAttr, _v0) {
		var f = _v0;
		return A2($elm$core$Basics$composeR, f, toAttr);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$behindContent = $lucamug$elm_ui_with_context$Element$WithContext$createNearby($mdgriffith$elm_ui$Element$behindContent);
var $author$project$TT$BubbleAlertsWrapper$BubbleAlertElm = F4(
	function (text, id, role, delayDeleteMsg) {
		return {h$: delayDeleteMsg, iJ: id, n: role, h: text};
	});
var $author$project$TT$Alerts$bubbleAlertsList = F2(
	function (bubbles, msgHideToast) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var id = _v0.a;
				var bubble = _v0.b;
				return A4(
					$author$project$TT$BubbleAlertsWrapper$BubbleAlertElm,
					bubble.js,
					id,
					bubble.n,
					msgHideToast(id));
			},
			$elm$core$Dict$toList(bubbles));
	});
var $author$project$TT$BubbleAlertsWrapper$BubbleAlertsWrapper = $elm$core$Basics$identity;
var $author$project$TT$BubbleAlertsWrapper$defaultOptions = {bE: _List_Nil, ck: 300, c1: 0, c8: 3.5};
var $author$project$TT$BubbleAlertsWrapper$default = F4(
	function (bubbles, positionY, bubblesWidth, hideBubbleDelay) {
		return _Utils_update(
			$author$project$TT$BubbleAlertsWrapper$defaultOptions,
			{bE: bubbles, ck: bubblesWidth, c1: positionY, c8: hideBubbleDelay});
	});
var $mdgriffith$elm_ui$Internal$Model$Right = 2;
var $mdgriffith$elm_ui$Element$alignRight = $mdgriffith$elm_ui$Internal$Model$AlignX(2);
var $lucamug$elm_ui_with_context$Element$WithContext$alignRight = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$alignRight);
var $mdgriffith$elm_ui$Internal$Model$AsColumn = 1;
var $mdgriffith$elm_ui$Internal$Model$asColumn = 1;
var $mdgriffith$elm_ui$Internal$Model$htmlClass = function (cls) {
	return $mdgriffith$elm_ui$Internal$Model$Attr(
		$elm$html$Html$Attributes$class(cls));
};
var $mdgriffith$elm_ui$Element$column = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.hO + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.bH)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$column = $lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapContainer($mdgriffith$elm_ui$Element$column);
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$spacing = function (x) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
		$mdgriffith$elm_ui$Element$spacing(x));
};
var $author$project$TT$Color$success = $author$project$TT$Color$Extra$hexToColor('#2faa0e');
var $author$project$TT$BubbleAlertsWrapper$render = function (_v0) {
	var options = _v0;
	var bgColor = function (role) {
		switch (role) {
			case 0:
				return $author$project$TT$Color$success;
			case 1:
				return $author$project$TT$Color$secondary;
			case 2:
				return $author$project$TT$Color$warning;
			default:
				return $author$project$TT$Color$error;
		}
	};
	return $elm$core$List$isEmpty(options.bE) ? $lucamug$elm_ui_with_context$Element$WithContext$none : A2(
		$lucamug$elm_ui_with_context$Element$WithContext$column,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'position', 'fixed')),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2(
					$elm$html$Html$Attributes$style,
					'top',
					$elm$core$String$fromFloat(options.c1) + 'px')),
				$lucamug$elm_ui_with_context$Element$WithContext$alignRight
			]),
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$html(
				A3(
					$elm$html$Html$node,
					'style',
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' @keyframes pulse { 0%   {background-color: transparent;} 100% {background-color: transparent;} } ')
						]))),
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$spacing(12),
						$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0)
					]),
				A2(
					$elm$core$List$map,
					function (bubble) {
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 0, 16),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$id(bubble.iJ)),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2(
										$elm$html$Html$Attributes$style,
										'animation',
										'pulse ' + ($elm$core$String$fromFloat(options.c8) + 's'))),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2(
										$elm$html$Html$Events$on,
										'webkitAnimationEnd',
										$elm$json$Json$Decode$succeed(bubble.h$))),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2(
										$elm$html$Html$Events$on,
										'animationend',
										$elm$json$Json$Decode$succeed(bubble.h$))),
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$alignRight
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
											bgColor(bubble.n)),
											$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$white),
											$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
											$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(8),
											$lucamug$elm_ui_with_context$Element$WithContext$width(
											A2($lucamug$elm_ui_with_context$Element$WithContext$maximum, options.ck, $lucamug$elm_ui_with_context$Element$WithContext$shrink)),
											$lucamug$elm_ui_with_context$Element$WithContext$alignRight
										]),
									A2(
										$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
										_List_Nil,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$text(bubble.h)
											])))
								]));
					},
					options.bE))
			]));
};
var $author$project$TT$Alerts$bubbleAlertsWrapper = F5(
	function (localBubbles, msgHideToast, position, bubblesWidth, secsToHideBubble) {
		return $author$project$TT$BubbleAlertsWrapper$render(
			A4(
				$author$project$TT$BubbleAlertsWrapper$default,
				A2($author$project$TT$Alerts$bubbleAlertsList, localBubbles, msgHideToast),
				position,
				bubblesWidth,
				secsToHideBubble));
	});
var $mdgriffith$elm_ui$Internal$Model$CenterX = 1;
var $mdgriffith$elm_ui$Element$centerX = $mdgriffith$elm_ui$Internal$Model$AlignX(1);
var $lucamug$elm_ui_with_context$Element$WithContext$centerX = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$centerX);
var $mdgriffith$elm_ui$Internal$Model$CenterY = 1;
var $mdgriffith$elm_ui$Element$centerY = $mdgriffith$elm_ui$Internal$Model$AlignY(1);
var $lucamug$elm_ui_with_context$Element$WithContext$centerY = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$centerY);
var $noahzgordon$elm_color_extra$Color$Manipulate$fadeIn = F2(
	function (offset, cl) {
		var _v0 = $avh4$elm_color$Color$toHsla(cl);
		var hue = _v0.e7;
		var saturation = _v0.f0;
		var lightness = _v0.fn;
		var alpha = _v0.$7;
		return A4(
			$avh4$elm_color$Color$hsla,
			hue,
			saturation,
			lightness,
			$noahzgordon$elm_color_extra$Color$Manipulate$limit(alpha + offset));
	});
var $noahzgordon$elm_color_extra$Color$Manipulate$fadeOut = F2(
	function (offset, cl) {
		return A2($noahzgordon$elm_color_extra$Color$Manipulate$fadeIn, -offset, cl);
	});
var $author$project$TT$Color$Extra$fadeOut = F2(
	function (opacityOffset, elementColor) {
		return $author$project$TT$Color$Extra$fromColor(
			A2(
				$noahzgordon$elm_color_extra$Color$Manipulate$fadeOut,
				opacityOffset,
				$author$project$TT$Color$Extra$toColor(elementColor)));
	});
var $mdgriffith$elm_ui$Internal$Model$FocusStyleOption = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Element$focusStyle = $mdgriffith$elm_ui$Internal$Model$FocusStyleOption;
var $lucamug$elm_ui_with_context$Element$WithContext$focusStyle = $mdgriffith$elm_ui$Element$focusStyle;
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $mdgriffith$elm_ui$Element$image = F2(
	function (attrs, _v0) {
		var src = _v0.kY;
		var description = _v0.h3;
		var imageAttributes = A2(
			$elm$core$List$filter,
			function (a) {
				switch (a.$) {
					case 7:
						return true;
					case 8:
						return true;
					default:
						return false;
				}
			},
			attrs);
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.iK),
				attrs),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[
						A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asEl,
						$mdgriffith$elm_ui$Internal$Model$NodeName('img'),
						_Utils_ap(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Internal$Model$Attr(
									$elm$html$Html$Attributes$src(src)),
									$mdgriffith$elm_ui$Internal$Model$Attr(
									$elm$html$Html$Attributes$alt(description))
								]),
							imageAttributes),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil))
					])));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$image = A2(
	$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
	$mdgriffith$elm_ui$Element$image,
	$elm$core$Basics$always($elm$core$Basics$identity));
var $mdgriffith$elm_ui$Internal$Model$InFront = 4;
var $mdgriffith$elm_ui$Element$inFront = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 4, element);
};
var $lucamug$elm_ui_with_context$Element$WithContext$inFront = $lucamug$elm_ui_with_context$Element$WithContext$createNearby($mdgriffith$elm_ui$Element$inFront);
var $mdgriffith$elm_ui$Internal$Model$OnlyDynamic = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$AllowHover = 1;
var $mdgriffith$elm_ui$Internal$Model$Layout = 0;
var $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle = {
	g$: $elm$core$Maybe$Nothing,
	g7: $elm$core$Maybe$Nothing,
	kK: $elm$core$Maybe$Just(
		{
			g5: 0,
			hz: A4($mdgriffith$elm_ui$Internal$Model$Rgba, 155 / 255, 203 / 255, 1, 1),
			jE: _Utils_Tuple2(0, 0),
			kQ: 3
		})
};
var $mdgriffith$elm_ui$Internal$Model$optionsToRecord = function (options) {
	var combine = F2(
		function (opt, record) {
			switch (opt.$) {
				case 0:
					var hoverable = opt.a;
					var _v4 = record.iG;
					if (_v4.$ === 1) {
						return _Utils_update(
							record,
							{
								iG: $elm$core$Maybe$Just(hoverable)
							});
					} else {
						return record;
					}
				case 1:
					var focusStyle = opt.a;
					var _v5 = record.ii;
					if (_v5.$ === 1) {
						return _Utils_update(
							record,
							{
								ii: $elm$core$Maybe$Just(focusStyle)
							});
					} else {
						return record;
					}
				default:
					var renderMode = opt.a;
					var _v6 = record.ju;
					if (_v6.$ === 1) {
						return _Utils_update(
							record,
							{
								ju: $elm$core$Maybe$Just(renderMode)
							});
					} else {
						return record;
					}
			}
		});
	var andFinally = function (record) {
		return {
			ii: function () {
				var _v0 = record.ii;
				if (_v0.$ === 1) {
					return $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle;
				} else {
					var focusable = _v0.a;
					return focusable;
				}
			}(),
			iG: function () {
				var _v1 = record.iG;
				if (_v1.$ === 1) {
					return 1;
				} else {
					var hoverable = _v1.a;
					return hoverable;
				}
			}(),
			ju: function () {
				var _v2 = record.ju;
				if (_v2.$ === 1) {
					return 0;
				} else {
					var actualMode = _v2.a;
					return actualMode;
				}
			}()
		};
	};
	return andFinally(
		A3(
			$elm$core$List$foldr,
			combine,
			{ii: $elm$core$Maybe$Nothing, iG: $elm$core$Maybe$Nothing, ju: $elm$core$Maybe$Nothing},
			options));
};
var $mdgriffith$elm_ui$Internal$Model$toHtml = F2(
	function (mode, el) {
		switch (el.$) {
			case 0:
				var html = el.a;
				return html($mdgriffith$elm_ui$Internal$Model$asEl);
			case 1:
				var styles = el.a.k1;
				var html = el.a.iH;
				return A2(
					html,
					mode(styles),
					$mdgriffith$elm_ui$Internal$Model$asEl);
			case 2:
				var text = el.a;
				return $mdgriffith$elm_ui$Internal$Model$textElement(text);
			default:
				return $mdgriffith$elm_ui$Internal$Model$textElement('');
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderRoot = F3(
	function (optionList, attributes, child) {
		var options = $mdgriffith$elm_ui$Internal$Model$optionsToRecord(optionList);
		var embedStyle = function () {
			var _v0 = options.ju;
			if (_v0 === 1) {
				return $mdgriffith$elm_ui$Internal$Model$OnlyDynamic(options);
			} else {
				return $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic(options);
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Internal$Model$toHtml,
			embedStyle,
			A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				attributes,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[child]))));
	});
var $mdgriffith$elm_ui$Internal$Model$FontFamily = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$FontSize = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$SansSerif = {$: 1};
var $mdgriffith$elm_ui$Internal$Model$Typeface = function (a) {
	return {$: 3, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$fontFamily = $mdgriffith$elm_ui$Internal$Flag$flag(5);
var $mdgriffith$elm_ui$Internal$Flag$fontSize = $mdgriffith$elm_ui$Internal$Flag$flag(4);
var $elm$core$String$words = _String_words;
var $mdgriffith$elm_ui$Internal$Model$renderFontClassName = F2(
	function (font, current) {
		return _Utils_ap(
			current,
			function () {
				switch (font.$) {
					case 0:
						return 'serif';
					case 1:
						return 'sans-serif';
					case 2:
						return 'monospace';
					case 3:
						var name = font.a;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					case 4:
						var name = font.a;
						var url = font.b;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					default:
						var name = font.a.at;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
				}
			}());
	});
var $mdgriffith$elm_ui$Internal$Model$rootStyle = function () {
	var families = _List_fromArray(
		[
			$mdgriffith$elm_ui$Internal$Model$Typeface('Open Sans'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Helvetica'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Verdana'),
			$mdgriffith$elm_ui$Internal$Model$SansSerif
		]);
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$bgColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'bg-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0)),
				'background-color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'fc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1)),
				'color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontSize,
			$mdgriffith$elm_ui$Internal$Model$FontSize(20)),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontFamily,
			A2(
				$mdgriffith$elm_ui$Internal$Model$FontFamily,
				A3($elm$core$List$foldl, $mdgriffith$elm_ui$Internal$Model$renderFontClassName, 'font-', families),
				families))
		]);
}();
var $mdgriffith$elm_ui$Element$layoutWith = F3(
	function (_v0, attrs, child) {
		var options = _v0.jP;
		return A3(
			$mdgriffith$elm_ui$Internal$Model$renderRoot,
			options,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[$mdgriffith$elm_ui$Internal$Style$classes.kv, $mdgriffith$elm_ui$Internal$Style$classes.gT, $mdgriffith$elm_ui$Internal$Style$classes.kP]))),
				_Utils_ap($mdgriffith$elm_ui$Internal$Model$rootStyle, attrs)),
			child);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$layoutWith = F4(
	function (context, options, attrs, _v0) {
		var f = _v0;
		return A3(
			$mdgriffith$elm_ui$Element$layoutWith,
			options,
			A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$attributes, context, attrs),
			f(context));
	});
var $mdgriffith$elm_ui$Internal$Model$Min = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$minimum = F2(
	function (i, l) {
		return A2($mdgriffith$elm_ui$Internal$Model$Min, i, l);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$minimum = $mdgriffith$elm_ui$Element$minimum;
var $mdgriffith$elm_ui$Internal$Model$Px = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$px = $mdgriffith$elm_ui$Internal$Model$Px;
var $lucamug$elm_ui_with_context$Element$WithContext$px = $mdgriffith$elm_ui$Element$px;
var $mdgriffith$elm_ui$Internal$Model$AsRow = 0;
var $mdgriffith$elm_ui$Internal$Model$asRow = 0;
var $mdgriffith$elm_ui$Element$row = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asRow,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bH + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.az)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$row = $lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapContainer($mdgriffith$elm_ui$Element$row);
var $mdgriffith$elm_ui$Internal$Model$boxShadowClass = function (shadow) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				shadow.fc ? 'box-inset' : 'box-',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.jE.a) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.jE.b) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.g5) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.kQ) + 'px',
				$mdgriffith$elm_ui$Internal$Model$formatColorClass(shadow.hz)
			]));
};
var $mdgriffith$elm_ui$Internal$Flag$shadows = $mdgriffith$elm_ui$Internal$Flag$flag(19);
var $mdgriffith$elm_ui$Element$Border$shadow = function (almostShade) {
	var shade = {g5: almostShade.g5, hz: almostShade.hz, fc: false, jE: almostShade.jE, kQ: almostShade.kQ};
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$shadows,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			$mdgriffith$elm_ui$Internal$Model$boxShadowClass(shade),
			'box-shadow',
			$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(shade)));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$shadow = function (almostShade) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr(
		$mdgriffith$elm_ui$Element$Border$shadow(almostShade));
};
var $author$project$TT$Size$Normal = 4;
var $mdgriffith$elm_ui$Element$Font$family = function (families) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontFamily,
		A2(
			$mdgriffith$elm_ui$Internal$Model$FontFamily,
			A3($elm$core$List$foldl, $mdgriffith$elm_ui$Internal$Model$renderFontClassName, 'ff-', families),
			families));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Font$family = function (families) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Font$family(families));
};
var $mdgriffith$elm_ui$Element$Font$typeface = $mdgriffith$elm_ui$Internal$Model$Typeface;
var $lucamug$elm_ui_with_context$Element$WithContext$Font$typeface = function (name) {
	return $mdgriffith$elm_ui$Element$Font$typeface(name);
};
var $author$project$TT$Font$fontAttr = F2(
	function (typeface, fallback) {
		return $lucamug$elm_ui_with_context$Element$WithContext$Font$family(
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$typeface(typeface),
					fallback
				]));
	});
var $mdgriffith$elm_ui$Element$Font$size = function (i) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontSize,
		$mdgriffith$elm_ui$Internal$Model$FontSize(i));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Font$size = function (i) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr(
		$mdgriffith$elm_ui$Element$Font$size(i));
};
var $author$project$TT$Size$fontSize = function (size) {
	switch (size) {
		case 0:
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(9)
				]);
		case 1:
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(11)
				]);
		case 2:
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(12)
				]);
		case 3:
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(14)
				]);
		case 4:
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(16)
				]);
		case 5:
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(18)
				]);
		case 6:
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(20)
				]);
		case 7:
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(23)
				]);
		case 8:
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(28)
				]);
		case 9:
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(39)
				]);
		case 10:
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(55)
				]);
		default:
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(69)
				]);
	}
};
var $mdgriffith$elm_ui$Internal$Flag$letterSpacing = $mdgriffith$elm_ui$Internal$Flag$flag(16);
var $mdgriffith$elm_ui$Element$Font$letterSpacing = function (offset) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$letterSpacing,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			'ls-' + $mdgriffith$elm_ui$Internal$Model$floatClass(offset),
			'letter-spacing',
			$elm$core$String$fromFloat(offset) + 'px'));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Font$letterSpacing = function (offset) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Font$letterSpacing(offset));
};
var $mdgriffith$elm_ui$Element$Font$sansSerif = $mdgriffith$elm_ui$Internal$Model$SansSerif;
var $lucamug$elm_ui_with_context$Element$WithContext$Font$sansSerif = $mdgriffith$elm_ui$Element$Font$sansSerif;
var $author$project$TT$Font$mainRegular = F3(
	function (_v0, size, letterSpacing) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2($author$project$TT$Font$fontAttr, 'Alegreya Sans', $lucamug$elm_ui_with_context$Element$WithContext$Font$sansSerif),
					$lucamug$elm_ui_with_context$Element$WithContext$Font$letterSpacing(letterSpacing)
				]),
			$author$project$TT$Size$fontSize(size));
	});
var $author$project$TT$Color$text = $author$project$TT$Color$black;
var $author$project$TT$Font$text = A3($author$project$TT$Font$mainRegular, $author$project$TT$Color$text, 4, 0.25);
var $author$project$TT$ToastWrapper$ToastWrapper = $elm$core$Basics$identity;
var $author$project$TT$ToastWrapper$defaultOptions = {cg: _List_Nil, jY: 0, cb: _List_Nil, a8: 300};
var $author$project$TT$ToastWrapper$default = F3(
	function (toasts, position, width) {
		return _Utils_update(
			$author$project$TT$ToastWrapper$defaultOptions,
			{jY: position, cb: toasts, a8: width});
	});
var $author$project$TT$Size$ExtraLarge = 7;
var $mdgriffith$elm_ui$Internal$Model$Top = 0;
var $mdgriffith$elm_ui$Element$alignTop = $mdgriffith$elm_ui$Internal$Model$AlignY(0);
var $lucamug$elm_ui_with_context$Element$WithContext$alignTop = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$alignTop);
var $mdgriffith$elm_ui$Internal$Flag$fontWeight = $mdgriffith$elm_ui$Internal$Flag$flag(13);
var $mdgriffith$elm_ui$Element$Font$bold = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.g6);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$bold = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$bold);
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$desc = $elm$svg$Svg$trustedNode('desc');
var $author$project$TT$Size$iconSize = function (size) {
	switch (size) {
		case 0:
			return '1';
		case 1:
			return '2';
		case 2:
			return '4';
		case 3:
			return '6';
		case 4:
			return '8';
		case 5:
			return '10';
		case 6:
			return '14';
		case 7:
			return '18';
		case 8:
			return '20';
		case 9:
			return '22';
		case 10:
			return '24';
		default:
			return '96';
	}
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $noahzgordon$elm_color_extra$Color$Convert$toRadix = function (n) {
	var getChr = function (c) {
		return (c < 10) ? $elm$core$String$fromInt(c) : $elm$core$String$fromChar(
			$elm$core$Char$fromCode(87 + c));
	};
	return (n < 16) ? getChr(n) : _Utils_ap(
		$noahzgordon$elm_color_extra$Color$Convert$toRadix((n / 16) | 0),
		getChr(
			A2($elm$core$Basics$modBy, 16, n)));
};
var $noahzgordon$elm_color_extra$Color$Convert$toHex = A2(
	$elm$core$Basics$composeR,
	$noahzgordon$elm_color_extra$Color$Convert$toRadix,
	A2($elm$core$String$padLeft, 2, '0'));
var $noahzgordon$elm_color_extra$Color$Convert$colorToHex = function (cl) {
	var _v0 = $avh4$elm_color$Color$toRgba(cl);
	var red = _v0.d0;
	var green = _v0.dH;
	var blue = _v0.ds;
	return A2(
		$elm$core$String$join,
		'',
		A2(
			$elm$core$List$cons,
			'#',
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $elm$core$Basics$round, $noahzgordon$elm_color_extra$Color$Convert$toHex),
				_List_fromArray(
					[red * 255, green * 255, blue * 255]))));
};
var $author$project$TT$Color$Extra$colorToHex = function (elementColor) {
	var cl = $author$project$TT$Color$Extra$toColor(elementColor);
	return $noahzgordon$elm_color_extra$Color$Convert$colorToHex(cl);
};
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $author$project$TT$IF$path = F2(
	function (color, p) {
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill(
					$author$project$TT$Color$Extra$colorToHex(color)),
					$elm$svg$Svg$Attributes$d(p)
				]),
			_List_Nil);
	});
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$title = $elm$svg$Svg$trustedNode('title');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$TT$IF$render = F6(
	function (title, desc, color, size, width, paths) {
		return $lucamug$elm_ui_with_context$Element$WithContext$html(
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox(
						'0 0 ' + ($elm$core$String$fromInt(width) + ' 512')),
						$elm$svg$Svg$Attributes$width(
						$author$project$TT$Size$iconSize(size))
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$title,
							_List_Nil,
							_List_fromArray(
								[
									$elm$svg$Svg$text(title)
								])),
							A2(
							$elm$svg$Svg$desc,
							_List_Nil,
							_List_fromArray(
								[
									$elm$svg$Svg$text(desc)
								]))
						]),
					A2(
						$elm$core$List$map,
						$author$project$TT$IF$path(color),
						paths))));
	});
var $author$project$TT$IF$checkCircle = F2(
	function (color, size) {
		return A6(
			$author$project$TT$IF$render,
			'checkCircle',
			'checkCircle',
			color,
			size,
			512,
			_List_fromArray(
				['M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z']));
	});
var $author$project$TT$IT$Icon = $elm$core$Basics$identity;
var $author$project$TT$IT$defaultAttributes = function (name) {
	return {
		bG: $elm$core$Maybe$Just('tk-icon tk-icon-' + name),
		hz: $author$project$TT$Color$gray2,
		kQ: 24,
		b7: 'px',
		dc: 1,
		ls: $elm$core$Maybe$Nothing,
		ed: '0 0 24 24'
	};
};
var $author$project$TT$IT$makeBuilder = F3(
	function (name, svgAttributes, src) {
		return {
			I: $author$project$TT$IT$defaultAttributes(name),
			kY: src,
			N: svgAttributes
		};
	});
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $author$project$TT$IT$close = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'close',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M22 2 2 22M2 2l20 20'),
						$elm$svg$Svg$Attributes$stroke('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$TT$Color$grayDark = $author$project$TT$Color$Extra$hexToColor('#454545');
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $mdgriffith$elm_ui$Element$Events$onClick = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onClick);
var $lucamug$elm_ui_with_context$Element$WithContext$Events$onClick = function (msg) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Events$onClick(msg));
};
var $mdgriffith$elm_ui$Internal$Model$paddingName = F4(
	function (top, right, bottom, left) {
		return 'pad-' + ($elm$core$String$fromInt(top) + ('-' + ($elm$core$String$fromInt(right) + ('-' + ($elm$core$String$fromInt(bottom) + ('-' + $elm$core$String$fromInt(left)))))));
	});
var $mdgriffith$elm_ui$Element$paddingEach = function (_v0) {
	var top = _v0.lz;
	var right = _v0.ku;
	var bottom = _v0.hb;
	var left = _v0.jf;
	if (_Utils_eq(top, right) && (_Utils_eq(top, bottom) && _Utils_eq(top, left))) {
		var topFloat = top;
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$padding,
			A5(
				$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
				'p-' + $elm$core$String$fromInt(top),
				topFloat,
				topFloat,
				topFloat,
				topFloat));
	} else {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$padding,
			A5(
				$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
				A4($mdgriffith$elm_ui$Internal$Model$paddingName, top, right, bottom, left),
				top,
				right,
				bottom,
				left));
	}
};
var $lucamug$elm_ui_with_context$Element$WithContext$paddingEach = function (paddings) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attribute(
		$mdgriffith$elm_ui$Element$paddingEach(paddings));
};
var $mdgriffith$elm_ui$Internal$Flag$cursor = $mdgriffith$elm_ui$Internal$Flag$flag(21);
var $mdgriffith$elm_ui$Element$pointer = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.hX);
var $lucamug$elm_ui_with_context$Element$WithContext$pointer = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$pointer);
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$map = $elm$virtual_dom$VirtualDom$map;
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $author$project$TT$IT$render = function (_v0) {
	var src = _v0.kY;
	var attrs = _v0.I;
	var svgAttributes = _v0.N;
	var strSize = $elm$core$String$fromFloat(attrs.kQ);
	var srcWithTitle = function () {
		var _v3 = attrs.ls;
		if (!_v3.$) {
			var title = _v3.a;
			return A2(
				$elm$core$List$cons,
				A2(
					$elm$svg$Svg$title,
					_List_Nil,
					_List_fromArray(
						[
							$elm$svg$Svg$text(title)
						])),
				src);
		} else {
			return src;
		}
	}();
	var baseAttributes = _List_fromArray(
		[
			$elm$svg$Svg$Attributes$height(
			_Utils_ap(strSize, attrs.b7)),
			$elm$svg$Svg$Attributes$width(
			_Utils_ap(strSize, attrs.b7)),
			$elm$svg$Svg$Attributes$style('vertical-align: middle; fill:currentColor; overflow:hidden;'),
			$elm$svg$Svg$Attributes$strokeLinecap('round'),
			$elm$svg$Svg$Attributes$strokeLinejoin('round'),
			$elm$svg$Svg$Attributes$strokeWidth(
			$elm$core$String$fromFloat(attrs.dc)),
			$elm$svg$Svg$Attributes$viewBox(attrs.ed)
		]);
	var combinedAttributes = _Utils_ap(
		function () {
			var _v2 = attrs.bG;
			if (!_v2.$) {
				var c = _v2.a;
				return A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$class(c),
					baseAttributes);
			} else {
				return baseAttributes;
			}
		}(),
		svgAttributes);
	return A2(
		$lucamug$elm_ui_with_context$Element$WithContext$el,
		_Utils_ap(
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$color(attrs.hz),
					$lucamug$elm_ui_with_context$Element$WithContext$Font$size(
					$elm$core$Basics$round(attrs.kQ))
				]),
			function () {
				var _v1 = attrs.bG;
				if (!_v1.$) {
					var c = _v1.a;
					return _List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class(c))
						]);
				} else {
					return _List_Nil;
				}
			}()),
		$lucamug$elm_ui_with_context$Element$WithContext$html(
			A2(
				$elm$svg$Svg$svg,
				combinedAttributes,
				A2(
					$elm$core$List$map,
					$elm$svg$Svg$map($elm$core$Basics$never),
					srcWithTitle))));
};
var $mdgriffith$elm_ui$Internal$Flag$borderStyle = $mdgriffith$elm_ui$Internal$Flag$flag(11);
var $mdgriffith$elm_ui$Element$Border$solid = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$borderStyle, $mdgriffith$elm_ui$Internal$Style$classes.ha);
var $lucamug$elm_ui_with_context$Element$WithContext$Border$solid = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Border$solid);
var $author$project$TT$IT$withColor = F2(
	function (color, _v0) {
		var attrs = _v0.I;
		var src = _v0.kY;
		var svgAttributes = _v0.N;
		return {
			I: _Utils_update(
				attrs,
				{hz: color}),
			kY: src,
			N: svgAttributes
		};
	});
var $author$project$TT$IT$withSize = F2(
	function (size, _v0) {
		var attrs = _v0.I;
		var src = _v0.kY;
		var svgAttributes = _v0.N;
		return {
			I: _Utils_update(
				attrs,
				{kQ: size}),
			kY: src,
			N: svgAttributes
		};
	});
var $author$project$TT$IT$withStrokeWidth = F2(
	function (strokeWidth, _v0) {
		var attrs = _v0.I;
		var src = _v0.kY;
		var svgAttributes = _v0.N;
		return {
			I: _Utils_update(
				attrs,
				{dc: strokeWidth}),
			kY: src,
			N: svgAttributes
		};
	});
var $author$project$TT$ToastWrapper$render = function (_v0) {
	var options = _v0;
	var iconType = function (role) {
		switch (role) {
			case 0:
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_Nil,
					A2($author$project$TT$IF$checkCircle, $author$project$TT$Color$success, 7));
			case 1:
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_Nil,
					A2($author$project$TT$IF$checkCircle, $author$project$TT$Color$success, 7));
			case 2:
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_Nil,
					A2($author$project$TT$IF$checkCircle, $author$project$TT$Color$warning, 7));
			default:
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_Nil,
					A2($author$project$TT$IF$checkCircle, $author$project$TT$Color$error, 7));
		}
	};
	return $elm$core$List$isEmpty(options.cb) ? $lucamug$elm_ui_with_context$Element$WithContext$none : A2(
		$lucamug$elm_ui_with_context$Element$WithContext$column,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$moveUp(options.jY),
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'position', 'fixed')),
				A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 10, 0)
			]),
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$html(
				A3(
					$elm$html$Html$node,
					'style',
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' @keyframes pulse { 0%   {background-color: white;} 100% {background-color: white;} } ')
						]))),
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_Utils_ap(
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(10),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
						]),
					options.cg),
				A2(
					$elm$core$List$map,
					function (toast) {
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$centerX,
									A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 0, 16),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$id(toast.iJ)),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2($elm$html$Html$Attributes$style, 'animation', 'pulse 0.1s')),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2(
										$elm$html$Html$Events$on,
										'webkitAnimationEnd',
										$elm$json$Json$Decode$succeed(toast.h$))),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									A2(
										$elm$html$Html$Events$on,
										'animationend',
										$elm$json$Json$Decode$succeed(toast.h$))),
									$lucamug$elm_ui_with_context$Element$WithContext$width(
									A2(
										$lucamug$elm_ui_with_context$Element$WithContext$minimum,
										180,
										A2($lucamug$elm_ui_with_context$Element$WithContext$maximum, 380, $lucamug$elm_ui_with_context$Element$WithContext$fill)))
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$white),
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray1),
											$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(2),
											$lucamug$elm_ui_with_context$Element$WithContext$Border$solid,
											$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
											$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$gray1),
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									_List_fromArray(
										[
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$row,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$grayDark),
													$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
													$lucamug$elm_ui_with_context$Element$WithContext$spacing(10),
													A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 4, 12)
												]),
											_List_fromArray(
												[
													iconType(toast.n),
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
													_List_fromArray(
														[$lucamug$elm_ui_with_context$Element$WithContext$Font$bold]),
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$text(toast.ls)
														])),
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$el,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$pointer,
															$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
															toast.hx(toast.iJ)),
															$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
															$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
															$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
															{hb: 0, jf: 0, ku: 8, lz: 4})
														]),
													$author$project$TT$IT$render(
														A2(
															$author$project$TT$IT$withSize,
															12,
															A2(
																$author$project$TT$IT$withStrokeWidth,
																3,
																A2(
																	$author$project$TT$IT$withColor,
																	$author$project$TT$Color$white,
																	$author$project$TT$IT$close(_List_Nil))))))
												])),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
													A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 4, 12)
												]),
											toast.h)
										]))
								]));
					},
					options.cb))
			]));
};
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {eB: col, hP: contextStack, fK: problem, f_: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.f_, s.eB, x, s.bI));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.jE, s.kY);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{eB: 1, bI: s.bI, m: s.m, jE: s.jE + 1, f_: s.f_ + 1, kY: s.kY}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{eB: s.eB + 1, bI: s.bI, m: s.m, jE: newOffset, f_: s.f_, kY: s.kY}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.kY);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.jE, offset) < 0,
					0,
					{eB: col, bI: s0.bI, m: s0.m, jE: offset, f_: row, kY: s0.kY});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.jE, s.f_, s.eB, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.jE, s1.jE, s0.kY),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.jE, s.f_, s.eB, s.kY);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.bI)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.jE, newOffset) < 0,
			0,
			{eB: newCol, bI: s.bI, m: s.m, jE: newOffset, f_: newRow, kY: s.kY});
	};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.jE, s.f_, s.eB, s.kY);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{eB: newCol, bI: s.bI, m: s.m, jE: newOffset, f_: newRow, kY: s.kY});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$commentString = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $hecrj$html_parser$Html$Parser$comment = A2($elm$parser$Parser$map, $hecrj$html_parser$Html$Parser$Comment, $hecrj$html_parser$Html$Parser$commentString);
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {eB: s.eB + (newOffset - s.jE), bI: s.bI, m: s.m, jE: newOffset, f_: s.f_, kY: s.kY};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.jE, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$core$String$toFloat = _String_toFloat;
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.kY);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.f_, s.eB - (floatOffset + s.jE), invalid, s.bI));
		} else {
			if (_Utils_eq(s.jE, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.jE, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.jE, floatOffset, s.kY));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.jE, s.kY)) {
			var zeroOffset = s.jE + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.kY) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.iW,
				c.iD,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.kY),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.kY) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.iW,
				c.fx,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.kY),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.kY) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.iW,
				c.eq,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.kY),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.iW,
				c.eU,
				c.fd,
				c.e_,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.iW,
				c.eU,
				c.fd,
				c.e_,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.jE, s.kY),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				eq: $elm$core$Result$Err(invalid),
				eU: expecting,
				e_: $elm$core$Result$Err(invalid),
				iD: $elm$core$Result$Err(invalid),
				fd: $elm$core$Result$Ok($elm$core$Basics$identity),
				iW: invalid,
				fx: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {eB: col, fK: problem, f_: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.f_, p.eB, p.fK);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{eB: 1, bI: _List_Nil, m: 1, jE: 0, f_: 1, kY: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $hecrj$html_parser$Html$Parser$Util$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				$elm$html$Html$node,
				name,
				A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				$hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return $elm$html$Html$text(s);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$TT$Alerts$toastList = F3(
	function (localToastAlerts, delayDeleteMsg, closeMsg) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var id = _v0.a;
				var toast = _v0.b;
				var innerHtml = function () {
					var _v1 = $hecrj$html_parser$Html$Parser$run(toast.js);
					if (!_v1.$) {
						var nodes = _v1.a;
						return $hecrj$html_parser$Html$Parser$Util$toVirtualDom(nodes);
					} else {
						return _List_fromArray(
							[
								$elm$html$Html$text(toast.js)
							]);
					}
				}();
				var parsedText = A2($elm$core$List$map, $lucamug$elm_ui_with_context$Element$WithContext$html, innerHtml);
				return {
					hx: closeMsg,
					h$: delayDeleteMsg(id),
					iJ: id,
					n: toast.n,
					h: parsedText,
					ls: toast.ls
				};
			},
			$elm$core$Dict$toList(localToastAlerts));
	});
var $author$project$TT$ToastWrapper$withToastWrapperAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{cg: attrs});
	});
var $author$project$TT$Alerts$toastWrapper = F6(
	function (localToastAlerts, attrs, position, windowWidth, delayDeleteMsg, closeMsg) {
		return $author$project$TT$ToastWrapper$render(
			A2(
				$author$project$TT$ToastWrapper$withToastWrapperAttrs,
				attrs,
				A3(
					$author$project$TT$ToastWrapper$default,
					A3($author$project$TT$Alerts$toastList, localToastAlerts, delayDeleteMsg, closeMsg),
					position,
					windowWidth)));
	});
var $author$project$TT$Size$Micro = 1;
var $mdgriffith$elm_ui$Internal$Model$Above = 0;
var $mdgriffith$elm_ui$Element$above = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 0, element);
};
var $lucamug$elm_ui_with_context$Element$WithContext$above = $lucamug$elm_ui_with_context$Element$WithContext$createNearby($mdgriffith$elm_ui$Element$above);
var $mdgriffith$elm_ui$Internal$Model$Bottom = 2;
var $mdgriffith$elm_ui$Element$alignBottom = $mdgriffith$elm_ui$Internal$Model$AlignY(2);
var $lucamug$elm_ui_with_context$Element$WithContext$alignBottom = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$alignBottom);
var $mdgriffith$elm_ui$Internal$Model$Transparency = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$transparency = $mdgriffith$elm_ui$Internal$Flag$flag(0);
var $mdgriffith$elm_ui$Element$alpha = function (o) {
	var transparency = function (x) {
		return 1 - x;
	}(
		A2(
			$elm$core$Basics$min,
			1.0,
			A2($elm$core$Basics$max, 0.0, o)));
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2(
			$mdgriffith$elm_ui$Internal$Model$Transparency,
			'transparency-' + $mdgriffith$elm_ui$Internal$Model$floatClass(transparency),
			transparency));
};
var $lucamug$elm_ui_with_context$Element$WithContext$alpha = function (o) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attr(
		$mdgriffith$elm_ui$Element$alpha(o));
};
var $author$project$TT$Size$Small = 3;
var $author$project$TT$Font$body3 = A3($author$project$TT$Font$mainRegular, $author$project$TT$Color$text, 3, 0.25);
var $elm$svg$Svg$Attributes$clipRule = _VirtualDom_attribute('clip-rule');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $author$project$TT$IT$briefcase = F2(
	function (outlined, svgAttributes) {
		var extraStyles = outlined ? _List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$stroke('currentColor')
			]) : _List_fromArray(
			[
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$clipRule('evenodd'),
				$elm$svg$Svg$Attributes$stroke('none')
			]);
		return A3(
			$author$project$TT$IT$makeBuilder,
			'briefcase',
			svgAttributes,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$d('M14.498 14.223v.184A2.504 2.504 0 0 1 12 16.904a2.504 2.504 0 0 1-2.498-2.497v-.184l-7.927-1.536a1.1 1.1 0 0 1-.459-.159v6.92a3.071 3.071 0 0 0 3.07 3.07h15.652a3.072 3.072 0 0 0 3.072-3.07v-6.922c-.139.07-.299.114-.459.161L14.5 14.222v.001Z'),
						extraStyles),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$d('M19.86 6.317h-2.795V5.17a3.218 3.218 0 0 0-3.209-3.207h-3.714A3.218 3.218 0 0 0 6.934 5.17v1.147H4.14a3.022 3.022 0 0 0-3.026 3.025v1.283c0 .413.298.757.687.848l7.7 1.489A2.475 2.475 0 0 1 12 10.533c1.352 0 2.475 1.077 2.498 2.429l7.677-1.489a.88.88 0 0 0 .71-.848V9.318a3.018 3.018 0 0 0-3.025-3.001ZM9.296 5.148c0-.458.389-.825.825-.825h3.735c.459 0 .825.39.825.825v1.145H9.295V5.148h.001Z'),
						extraStyles),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$d('M13.26 14.407v-1.375a1.271 1.271 0 0 0-1.26-1.26 1.272 1.272 0 0 0-1.26 1.258v1.377a1.271 1.271 0 0 0 1.26 1.26 1.271 1.271 0 0 0 1.26-1.26Z'),
						extraStyles),
					_List_Nil)
				]));
	});
var $author$project$TT$IT$candidate = F2(
	function (transparent, svgAttributes) {
		return A3(
			$author$project$TT$IT$makeBuilder,
			'candidate',
			svgAttributes,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M17.366 6.47c0-3.016-2.44-5.47-5.46-5.47a5.476 5.476 0 0 0-5.472 5.47c0 2.142 1.232 4.52 3.032 5.717C5.177 13.272 2 16.995 2 19.749c0 3.261 19.8 3.261 19.8 0 0-2.754-3.177-6.477-7.453-7.562 1.787-1.197 3.02-3.575 3.02-5.716Z'),
							transparent ? $elm$svg$Svg$Attributes$fill('none') : $elm$svg$Svg$Attributes$fill('currentColor'),
							$elm$svg$Svg$Attributes$fillRule('evenodd'),
							$elm$svg$Svg$Attributes$clipRule('evenodd'),
							$elm$svg$Svg$Attributes$stroke('currentColor'),
							$elm$svg$Svg$Attributes$strokeWidth('2')
						]),
					_List_Nil)
				]));
	});
var $author$project$TT$Font$caption = A3($author$project$TT$Font$mainRegular, $author$project$TT$Color$text, 3, 0.4);
var $author$project$TT$IF$chevronDown = F2(
	function (color, size) {
		return A6(
			$author$project$TT$IF$render,
			'chevronDown',
			'chevronDown',
			color,
			size,
			448,
			_List_fromArray(
				['M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z']));
	});
var $author$project$TT$Color$gray3 = $author$project$TT$Color$Extra$hexToColor('#d6d8dc');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $mdgriffith$elm_ui$Element$link = F2(
	function (attrs, _v0) {
		var url = _v0.Q;
		var label = _v0.dQ;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$NodeName('a'),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Attr(
					$elm$html$Html$Attributes$href(url)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$Attr(
						$elm$html$Html$Attributes$rel('noopener noreferrer')),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cu + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.az + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fp)))),
								attrs))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$link = A2(
	$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
	$mdgriffith$elm_ui$Element$link,
	F2(
		function (context, _v0) {
			var url = _v0.Q;
			var label = _v0.dQ;
			return {
				dQ: A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$run, context, label),
				Q: url
			};
		}));
var $author$project$TT$Size$Tiny = 2;
var $author$project$TT$Font$numbersRegular = F3(
	function (color, size, letterSpacing) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2($author$project$TT$Font$fontAttr, 'Open Sans', $lucamug$elm_ui_with_context$Element$WithContext$Font$sansSerif),
					$lucamug$elm_ui_with_context$Element$WithContext$Font$color(color),
					$lucamug$elm_ui_with_context$Element$WithContext$Font$letterSpacing(letterSpacing)
				]),
			$author$project$TT$Size$fontSize(size));
	});
var $author$project$TT$Font$numbersSmall = A3($author$project$TT$Font$numbersRegular, $author$project$TT$Color$text, 2, 0.25);
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$TT$SideBarMenu$referenceDataName = 'data-dropdown-id';
var $author$project$TT$SideBarMenu$onBlurAttribute = F2(
	function (id, hideMsg) {
		var dataDecoder = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['relatedTarget', 'attributes', $author$project$TT$SideBarMenu$referenceDataName, 'value']),
			$elm$json$Json$Decode$string);
		var attrToMsg = function (maybeAttr) {
			if (!maybeAttr.$) {
				var attr = maybeAttr.a;
				return _Utils_eq(attr, id) ? $elm$json$Json$Decode$fail('') : $elm$json$Json$Decode$succeed(hideMsg);
			} else {
				return $elm$json$Json$Decode$succeed(hideMsg);
			}
		};
		return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
			A2(
				$elm$html$Html$Events$on,
				'blur',
				A2(
					$elm$json$Json$Decode$andThen,
					attrToMsg,
					$elm$json$Json$Decode$maybe(dataDecoder))));
	});
var $author$project$TT$IT$publishJobAd = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'publishJobAd',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M14.479 5.663c-.991 0-1.794-.803-1.794-1.793V1.359h-8.25c-.594 0-1.076.481-1.076 1.076v17.217c0 .594.482 1.076 1.076 1.076h7.554a4.62 4.62 0 0 1-.717-2.51 4.67 4.67 0 0 1 4.641-4.664c.363-.001.724.042 1.076.13V5.662h-2.51Zm-4.305 8.609H5.87a.359.359 0 1 1 0-.718h4.304a.359.359 0 0 1 0 .718Zm4.305-2.87h-8.61a.359.359 0 1 1 0-.717h8.61a.359.359 0 0 1 0 .717Zm0-2.87h-8.61a.359.359 0 1 1 0-.717h8.61a.359.359 0 0 1 0 .718Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m17.24 14.501-.1-.036a3.946 3.946 0 0 0-4.226 6.313l.043.05a3.946 3.946 0 1 0 4.305-6.327h-.022Zm.108 4.075h-1.076v1.076a.359.359 0 0 1-.718 0v-1.076h-1.162a.359.359 0 0 1-.272-.359c0-.198.16-.358.358-.358h1.076v-1.076a.344.344 0 0 1 .266-.345h.093c.198 0 .359.16.359.359v1.076h1.076a.359.359 0 0 1 0 .717v-.014ZM16.48 4.946h-2.002a1.076 1.076 0 0 1-1.076-1.076V1.868l3.078 3.078Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd')
					]),
				_List_Nil)
			]));
};
var $author$project$TT$SideBarMenu$referenceAttr = function (id) {
	return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
		A2($elm$html$Html$Attributes$attribute, $author$project$TT$SideBarMenu$referenceDataName, id));
};
var $mdgriffith$elm_ui$Internal$Model$Button = {$: 8};
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $mdgriffith$elm_ui$Element$Input$enter = 'Enter';
var $mdgriffith$elm_ui$Element$Input$hasFocusStyle = function (attr) {
	if (((attr.$ === 4) && (attr.b.$ === 11)) && (!attr.b.a)) {
		var _v1 = attr.b;
		var _v2 = _v1.a;
		return true;
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Element$Input$focusDefault = function (attrs) {
	return A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, attrs) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass('focusable');
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $mdgriffith$elm_ui$Element$Input$onKeyLookup = function (lookup) {
	var decode = function (code) {
		var _v0 = lookup(code);
		if (_v0.$ === 1) {
			return $elm$json$Json$Decode$fail('No key matched');
		} else {
			var msg = _v0.a;
			return $elm$json$Json$Decode$succeed(msg);
		}
	};
	var isKey = A2(
		$elm$json$Json$Decode$andThen,
		decode,
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	return $mdgriffith$elm_ui$Internal$Model$Attr(
		A2(
			$elm$html$Html$Events$preventDefaultOn,
			'keydown',
			A2(
				$elm$json$Json$Decode$map,
				function (fired) {
					return _Utils_Tuple2(fired, true);
				},
				isKey)));
};
var $mdgriffith$elm_ui$Element$Input$space = ' ';
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $mdgriffith$elm_ui$Element$Input$button = F2(
	function (attrs, _v0) {
		var onPress = _v0.jI;
		var label = _v0.dQ;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cu + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.az + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.kG + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fv)))))),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$pointer,
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$Input$focusDefault(attrs),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Button),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Internal$Model$Attr(
											$elm$html$Html$Attributes$tabindex(0)),
										function () {
											if (onPress.$ === 1) {
												return A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Internal$Model$Attr(
														$elm$html$Html$Attributes$disabled(true)),
													attrs);
											} else {
												var msg = onPress.a;
												return A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Element$Events$onClick(msg),
													A2(
														$elm$core$List$cons,
														$mdgriffith$elm_ui$Element$Input$onKeyLookup(
															function (code) {
																return _Utils_eq(code, $mdgriffith$elm_ui$Element$Input$enter) ? $elm$core$Maybe$Just(msg) : (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space) ? $elm$core$Maybe$Just(msg) : $elm$core$Maybe$Nothing);
															}),
														attrs));
											}
										}()))))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$button = A2(
	$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
	$mdgriffith$elm_ui$Element$Input$button,
	F2(
		function (context, _v0) {
			var onPress = _v0.jI;
			var label = _v0.dQ;
			return {
				dQ: A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$run, context, label),
				jI: onPress
			};
		}));
var $author$project$TT$Color$Extra$darken = F2(
	function (offset, elementColor) {
		var cl = $author$project$TT$Color$Extra$toColor(elementColor);
		return $author$project$TT$Color$Extra$fromColor(
			A2($noahzgordon$elm_color_extra$Color$Manipulate$darken, offset, cl));
	});
var $mdgriffith$elm_ui$Element$Font$medium = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.li);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$medium = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$medium);
var $author$project$TT$Font$mainMedium = F3(
	function (color, size, letterSpacing) {
		return _Utils_ap(
			A3($author$project$TT$Font$mainRegular, color, size, letterSpacing),
			_List_fromArray(
				[$lucamug$elm_ui_with_context$Element$WithContext$Font$medium]));
	});
var $author$project$TT$Font$headline2 = A3($author$project$TT$Font$mainMedium, $author$project$TT$Color$text, 7, 0.15);
var $author$project$TT$Color$link = $author$project$TT$Color$Extra$hexToColor('#337ab7');
var $author$project$TT$Font$link = A3($author$project$TT$Font$mainRegular, $author$project$TT$Color$text, 4, 0.5);
var $author$project$TT$Font$linkSmall = A3($author$project$TT$Font$mainRegular, $author$project$TT$Color$text, 3, 0.5);
var $author$project$TT$Font$linkTiny = A3($author$project$TT$Font$mainRegular, $author$project$TT$Color$text, 2, 0.5);
var $author$project$TT$Color$linkVisited = $author$project$TT$Color$Extra$hexToColor('#265A88');
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $mdgriffith$elm_ui$Element$newTabLink = F2(
	function (attrs, _v0) {
		var url = _v0.Q;
		var label = _v0.dQ;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$NodeName('a'),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Attr(
					$elm$html$Html$Attributes$href(url)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$Attr(
						$elm$html$Html$Attributes$rel('noopener noreferrer')),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$Attr(
							$elm$html$Html$Attributes$target('_blank')),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cu + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.az + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fp)))),
									attrs)))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$newTabLink = A2(
	$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
	$mdgriffith$elm_ui$Element$newTabLink,
	F2(
		function (context, _v0) {
			var url = _v0.Q;
			var label = _v0.dQ;
			return {
				dQ: A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$run, context, label),
				Q: url
			};
		}));
var $author$project$TT$Size$Medium = 5;
var $author$project$TT$Font$subtitle1 = A3($author$project$TT$Font$mainRegular, $author$project$TT$Color$text, 5, 0.15);
var $author$project$TT$Link$render = function (_v0) {
	var options = _v0.a;
	var attrs = _v0.b;
	var label = _v0.c;
	var url = _v0.d;
	var underlineAttr = options.aa ? _List_fromArray(
		[
			$lucamug$elm_ui_with_context$Element$WithContext$Border$solid,
			$lucamug$elm_ui_with_context$Element$WithContext$Border$widthEach(
			{hb: 1, jf: 0, ku: 0, lz: 0})
		]) : _List_Nil;
	var iconView = function (icon) {
		if (!icon.$) {
			var i = icon.a;
			var iconSize = function () {
				var _v7 = options.kQ;
				switch (_v7) {
					case 0:
						return 23.0;
					case 1:
						return 18.0;
					case 2:
						return 16.0;
					case 3:
						return 14.0;
					default:
						return 12.0;
				}
			}();
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink)
					]),
				$author$project$TT$IT$render(
					A2($author$project$TT$IT$withSize, iconSize, i)));
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$none;
		}
	};
	var fontSizeAttrs = function () {
		var _v5 = options.kQ;
		switch (_v5) {
			case 0:
				return $author$project$TT$Font$headline2;
			case 1:
				return $author$project$TT$Font$subtitle1;
			case 2:
				return $author$project$TT$Font$link;
			case 3:
				return $author$project$TT$Font$linkSmall;
			default:
				return $author$project$TT$Font$linkTiny;
		}
	}();
	var labelAttrs = _Utils_ap(
		fontSizeAttrs,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
			]));
	var textLabel = options.c_ ? A2(
		$lucamug$elm_ui_with_context$Element$WithContext$el,
		labelAttrs,
		$lucamug$elm_ui_with_context$Element$WithContext$text(label)) : A2(
		$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
		labelAttrs,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$text(label)
			]));
	var linkLabelView = A2(
		$lucamug$elm_ui_with_context$Element$WithContext$row,
		_Utils_ap(
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
					$lucamug$elm_ui_with_context$Element$WithContext$centerY,
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
				]),
			underlineAttr),
		_List_fromArray(
			[
				iconView(options.bo),
				textLabel,
				iconView(options.bx)
			]));
	var _v1 = function () {
		var _v2 = options.hz;
		switch (_v2.$) {
			case 1:
				return _Utils_Tuple2($author$project$TT$Color$link, $author$project$TT$Color$linkVisited);
			case 0:
				return _Utils_Tuple2(
					$author$project$TT$Color$primary,
					A2($author$project$TT$Color$Extra$darken, 0.1, $author$project$TT$Color$primary));
			default:
				var colorForLink = _v2.a;
				var colorForHover = _v2.b;
				return _Utils_Tuple2(colorForLink, colorForHover);
		}
	}();
	var linkColor = _v1.a;
	var hoverColor = _v1.b;
	var hoverAttrs = $lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$Font$color(hoverColor)
			]));
	var linkAttrs = _Utils_ap(
		attrs,
		_Utils_ap(
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$color(linkColor),
					hoverAttrs
				]),
			function () {
				var _v4 = options.co;
				if (!_v4.$) {
					var className = _v4.a;
					return _List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class(className))
						]);
				} else {
					return _List_Nil;
				}
			}()));
	var _v3 = options.bd;
	switch (_v3.$) {
		case 0:
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$link,
				linkAttrs,
				{dQ: linkLabelView, Q: url});
		case 1:
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$newTabLink,
				linkAttrs,
				{dQ: linkLabelView, Q: url});
		default:
			var msg = _v3.a;
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$Input$button,
				linkAttrs,
				{
					dQ: linkLabelView,
					jI: $elm$core$Maybe$Just(msg)
				});
	}
};
var $author$project$TT$Link$Custom = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$TT$Link$Link = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$TT$Link$Tiny = 4;
var $author$project$TT$Link$Base = {$: 1};
var $author$project$TT$Link$Normal = 2;
var $author$project$TT$Link$SameTab = {$: 0};
var $author$project$TT$Link$defaultOptions = {bd: $author$project$TT$Link$SameTab, co: $elm$core$Maybe$Nothing, hz: $author$project$TT$Link$Base, bo: $elm$core$Maybe$Nothing, c_: false, kQ: 2, bx: $elm$core$Maybe$Nothing, aa: true};
var $author$project$TT$Link$sidebarFooterItem = F2(
	function (label, url) {
		return A4(
			$author$project$TT$Link$Link,
			_Utils_update(
				$author$project$TT$Link$defaultOptions,
				{
					hz: A2($author$project$TT$Link$Custom, $author$project$TT$Color$gray3, $author$project$TT$Color$white),
					kQ: 4,
					aa: false
				}),
			_List_fromArray(
				[$lucamug$elm_ui_with_context$Element$WithContext$centerY]),
			label,
			url);
	});
var $author$project$TT$Font$sidebarMenuItem = A3($author$project$TT$Font$mainMedium, $author$project$TT$Color$gray3, 3, 0.25);
var $author$project$TT$Link$Small = 3;
var $author$project$TT$Link$sidebarPrimaryItem = F2(
	function (label, url) {
		return A4(
			$author$project$TT$Link$Link,
			_Utils_update(
				$author$project$TT$Link$defaultOptions,
				{
					hz: A2($author$project$TT$Link$Custom, $author$project$TT$Color$gray3, $author$project$TT$Color$white),
					kQ: 3,
					aa: false
				}),
			_List_fromArray(
				[$lucamug$elm_ui_with_context$Element$WithContext$centerY]),
			label,
			url);
	});
var $author$project$TT$Link$sidebarPrimaryItemWithIcon = F3(
	function (label, url, icon) {
		return A4(
			$author$project$TT$Link$Link,
			_Utils_update(
				$author$project$TT$Link$defaultOptions,
				{
					hz: A2($author$project$TT$Link$Custom, $author$project$TT$Color$gray3, $author$project$TT$Color$white),
					bo: $elm$core$Maybe$Just(icon),
					kQ: 3,
					bx: $elm$core$Maybe$Nothing,
					aa: false
				}),
			_List_fromArray(
				[$lucamug$elm_ui_with_context$Element$WithContext$centerY]),
			label,
			url);
	});
var $author$project$TT$Font$sidebarSecondaryMenuItem = A3($author$project$TT$Font$mainRegular, $author$project$TT$Color$gray3, 2, 0.25);
var $author$project$TT$IT$star = F2(
	function (transparent, svgAttributes) {
		return A3(
			$author$project$TT$IT$makeBuilder,
			'star',
			svgAttributes,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2v0Z'),
							$elm$svg$Svg$Attributes$stroke('currentColor'),
							transparent ? $elm$svg$Svg$Attributes$fill('transparent') : $elm$svg$Svg$Attributes$fill('currentColor')
						]),
					_List_Nil)
				]));
	});
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $author$project$TT$VectorImage$talenteca = function (size) {
	return $lucamug$elm_ui_with_context$Element$WithContext$html(
		A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 876 197.844'),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromFloat(size)),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat((size * 876) / 197.844))
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$title,
					_List_Nil,
					_List_fromArray(
						[
							$elm$svg$Svg$text('Talenteca Logo')
						])),
					A2(
					$elm$svg$Svg$desc,
					_List_Nil,
					_List_fromArray(
						[
							$elm$svg$Svg$text('An image with the logo of the company of this website, Talenteca')
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#D4D36E')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M31.435 31.819c0-7.97 4.014-15.017 10.124-19.235a19.873 19.873 0 00-4.799-.588c-10.948 0-19.823 8.875-19.823 19.823 0 10.513 8.185 19.11 18.529 19.777a17.407 17.407 0 014.666-1.609c-5.3-4.287-8.697-10.837-8.697-18.168zM32.28 165.58V121.8h-6.421V67.225c0-5.725 2.764-10.806 7.019-14.01h-7.506c-7.738 0-14.01 6.272-14.01 14.01v51.036h6.421v47.319c0 7.737 6.272 14.01 14.01 14.01h7.482c-4.245-3.206-6.995-8.293-6.995-14.01z')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#BABF10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M58.271 31.819c0-6.569 2.729-12.51 7.109-16.759a19.722 19.722 0 00-10.583-3.064c-10.948 0-19.823 8.875-19.823 19.823s8.875 19.824 19.823 19.824c3.895 0 7.524-1.127 10.588-3.068-4.381-4.249-7.114-10.186-7.114-16.756zM59.117 165.58V121.8h-6.421V67.225c0-5.725 2.764-10.806 7.019-14.01H43.408c-7.738 0-14.01 6.272-14.01 14.01v51.036h6.421v47.319c0 7.737 6.272 14.01 14.01 14.01h9.935c1.82 0 3.554-.358 5.149-.99-3.557-3.214-5.796-7.86-5.796-13.02z')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#95AF6D')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M80.152 31.819c0-7.445 3.505-14.083 8.947-18.364a19.76 19.76 0 00-7.466-1.459c-10.948 0-19.824 8.875-19.824 19.823s8.875 19.824 19.824 19.824c.967 0 1.917-.073 2.848-.207a17.417 17.417 0 014.367-1.449c-5.299-4.287-8.696-10.837-8.696-18.168zM80.999 165.58V121.8h-6.422V67.225c0-5.725 2.764-10.806 7.019-14.01H70.245c-7.737 0-14.01 6.272-14.01 14.01v51.036h6.421v47.319c0 7.737 6.272 14.01 14.01 14.01h9.935c.441 0 .877-.026 1.308-.066-4.197-3.21-6.91-8.265-6.91-13.944z')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#7A9C49')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx('103.515'),
									$elm$svg$Svg$Attributes$cy('31.819'),
									$elm$svg$Svg$Attributes$r('19.823')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M128.914 67.225c0-7.738-6.272-14.01-14.01-14.01H92.126c-7.737 0-14.01 6.272-14.01 14.01v51.036h6.421v47.319c0 7.737 6.272 14.01 14.01 14.01h9.935c7.738 0 14.01-6.272 14.01-14.01v-47.319h6.422V67.225z')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#7A9C49')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M190.254 179.652c-11.566 0-20.393-3.126-26.483-9.382-6.09-6.252-9.135-15.634-9.135-28.146v-37.708h-12.365V85.293h12.365V59.132h23.253v26.161h20.67v19.124h-20.67v37.764c0 5.996 1.229 10.371 3.691 13.128 2.46 2.757 6.211 4.135 11.258 4.135a32.88 32.88 0 003.414-.181 30.019 30.019 0 003.415-.541v19.846a157.88 157.88 0 01-4.521.722 34.08 34.08 0 01-4.892.362zM236.022 180.193c-4.308 0-8.521-.513-12.642-1.533-4.124-1.021-7.783-2.645-10.98-4.871-3.201-2.225-5.785-5.111-7.751-8.661-1.969-3.546-2.953-7.786-2.953-12.719 0-5.17 1.076-9.411 3.23-12.72 2.151-3.306 4.983-5.981 8.489-8.028 3.506-2.043 7.475-3.608 11.904-4.691a129.629 129.629 0 0113.288-2.526c9.966-1.321 17.224-2.855 21.777-4.601 4.55-1.742 6.828-4.538 6.828-8.39 0-3.366-1.447-5.832-4.337-7.396-2.892-1.562-7.105-2.346-12.642-2.346-5.292 0-9.66.933-13.103 2.797-3.446 1.866-5.721 4.722-6.829 8.569h-24.176c.738-4.33 2.214-8.327 4.429-11.998 2.215-3.667 5.167-6.856 8.859-9.562 3.691-2.707 8.088-4.809 13.195-6.314 5.104-1.502 10.917-2.255 17.44-2.255 7.751 0 14.21.843 19.378 2.526 5.167 1.686 9.32 3.969 12.457 6.856s5.352 6.315 6.644 10.284c1.292 3.969 1.938 8.24 1.938 12.81v43.12c0 4.572.398 8.57 1.2 11.998.799 3.428 1.505 5.985 2.123 7.667h-22.885c-.617-1.201-1.2-2.887-1.753-5.052-.554-2.166-.955-5.051-1.2-8.66-2.832 4.691-6.828 8.48-11.996 11.367-5.168 2.886-11.812 4.329-19.932 4.329zm5.537-18.763c7.627 0 13.81-1.714 18.547-5.142 4.735-3.428 7.105-8.029 7.105-13.802v-10.104c-3.201 2.047-6.892 3.581-11.073 4.601-4.184 1.023-8.858 2.015-14.026 2.977-5.167.965-9.228 2.196-12.181 3.699-2.953 1.506-4.429 4.122-4.429 7.848 0 3.129 1.26 5.565 3.784 7.307 2.52 1.744 6.612 2.616 12.273 2.616zM303.935 43.977h23.254v134.231h-23.254V43.977zM358.931 139.058c1.107 7.098 3.937 12.389 8.49 15.876 4.55 3.491 10.334 5.233 17.348 5.233 8.979 0 15.255-2.887 18.825-8.661h24.914c-2.832 9.382-8.091 16.54-15.779 21.47-7.691 4.933-17.011 7.396-27.96 7.396-7.013 0-13.536-1.203-19.562-3.608-6.029-2.404-11.321-5.774-15.872-10.104-4.553-4.33-8.12-9.441-10.704-15.336-2.583-5.892-3.875-12.387-3.875-19.485 0-6.974 1.26-13.469 3.784-19.485 2.52-6.013 5.935-11.186 10.242-15.516 4.306-4.33 9.412-7.727 15.318-10.193 5.906-2.464 12.181-3.699 18.825-3.699 7.503 0 14.363 1.443 20.578 4.331 6.211 2.886 11.471 6.827 15.779 11.817 4.305 4.993 7.474 10.915 9.504 17.771 2.03 6.856 2.613 14.253 1.753 22.192h-71.608zm23.992-36.265c-5.537 0-10.459 1.745-14.764 5.232-4.309 3.49-7.198 8.42-8.674 14.794h46.692c-1.231-6.495-3.875-11.457-7.936-14.884s-9.167-5.142-15.318-5.142zM437.919 85.293h22.515v14.614c2.215-5.531 5.842-9.743 10.89-12.629 5.043-2.887 10.519-4.331 16.424-4.331 10.58 0 18.886 3.58 24.915 10.735 6.026 7.157 9.043 17.111 9.043 29.859v54.667h-23.254v-54.667c0-5.652-1.384-10.343-4.151-14.073-2.769-3.727-7.414-5.593-13.934-5.593-6.275 0-11.045 1.835-14.304 5.503-3.261 3.67-4.891 8.389-4.891 14.163v54.667h-23.253V85.293zM572.274 179.652c-11.566 0-20.393-3.126-26.482-9.382-6.091-6.252-9.136-15.634-9.136-28.146v-37.708h-12.365V85.293h12.365V59.132h23.253v26.161h20.671v19.124h-20.671v37.764c0 5.996 1.229 10.371 3.691 13.128 2.46 2.757 6.212 4.135 11.258 4.135 1.107 0 2.243-.059 3.414-.181a29.93 29.93 0 003.414-.541v19.846c-1.355.239-2.86.479-4.521.722a34.056 34.056 0 01-4.891.362zM609.001 139.058c1.107 7.098 3.936 12.389 8.489 15.876 4.55 3.491 10.335 5.233 17.348 5.233 8.979 0 15.255-2.887 18.824-8.661h24.915c-2.832 9.382-8.092 16.54-15.78 21.47-7.69 4.933-17.01 7.396-27.959 7.396-7.013 0-13.535-1.203-19.562-3.608-6.03-2.404-11.321-5.774-15.871-10.104-4.554-4.33-8.12-9.441-10.704-15.336-2.584-5.892-3.876-12.387-3.876-19.485 0-6.974 1.26-13.469 3.783-19.485 2.521-6.013 5.935-11.186 10.243-15.516 4.305-4.33 9.411-7.727 15.317-10.193 5.905-2.464 12.181-3.699 18.824-3.699 7.504 0 14.363 1.443 20.577 4.331 6.212 2.886 11.472 6.827 15.78 11.817 4.305 4.993 7.475 10.915 9.504 17.771 2.03 6.856 2.612 14.253 1.754 22.192h-71.606zm23.991-36.265c-5.537 0-10.459 1.745-14.764 5.232-4.309 3.49-7.197 8.42-8.674 14.794h46.691c-1.231-6.495-3.876-11.457-7.937-14.884-4.058-3.427-9.165-5.142-15.316-5.142zM730.805 180.373c-6.523 0-12.705-1.203-18.548-3.608-5.845-2.404-10.98-5.774-15.41-10.104-4.429-4.33-7.936-9.441-10.519-15.336-2.584-5.892-3.877-12.387-3.877-19.485 0-6.974 1.293-13.469 3.877-19.485 2.583-6.013 6.09-11.186 10.519-15.516 4.43-4.33 9.565-7.727 15.41-10.193 5.843-2.464 12.024-3.699 18.548-3.699 5.536 0 10.733.812 15.595 2.436 4.858 1.624 9.228 3.879 13.103 6.766 3.876 2.886 7.135 6.405 9.782 10.554 2.644 4.15 4.581 8.75 5.813 13.802H750.92c-1.354-4.209-3.814-7.488-7.381-9.833-3.57-2.346-7.814-3.518-12.734-3.518-3.322 0-6.459.663-9.412 1.984a22.045 22.045 0 00-7.659 5.683c-2.153 2.467-3.875 5.503-5.168 9.112-1.291 3.608-1.938 7.639-1.938 12.087 0 4.452.646 8.42 1.938 11.908 1.293 3.49 3.015 6.436 5.168 8.84a21.47 21.47 0 007.659 5.502c2.953 1.263 6.09 1.895 9.412 1.895 5.536 0 9.965-1.232 13.288-3.699 3.321-2.464 5.657-5.684 7.013-9.653h24.36c-1.23 5.052-3.169 9.653-5.813 13.803-2.647 4.149-5.877 7.667-9.688 10.554-3.815 2.886-8.184 5.142-13.104 6.765-4.923 1.627-10.275 2.438-16.056 2.438zM810.345 180.193c-4.308 0-8.521-.513-12.642-1.533-4.123-1.021-7.783-2.645-10.98-4.871-3.201-2.225-5.785-5.111-7.752-8.661-1.969-3.546-2.952-7.786-2.952-12.719 0-5.17 1.075-9.411 3.229-12.72 2.151-3.306 4.982-5.981 8.489-8.028 3.506-2.043 7.475-3.608 11.903-4.691a129.68 129.68 0 0113.288-2.526c9.966-1.321 17.224-2.855 21.777-4.601 4.55-1.742 6.828-4.538 6.828-8.39 0-3.366-1.447-5.832-4.337-7.396-2.893-1.562-7.105-2.346-12.642-2.346-5.291 0-9.661.933-13.104 2.797-3.445 1.866-5.722 4.722-6.829 8.569h-24.176c.738-4.33 2.215-8.327 4.43-11.998 2.215-3.667 5.167-6.856 8.858-9.562s8.088-4.809 13.195-6.314c5.104-1.502 10.917-2.255 17.439-2.255 7.752 0 14.211.843 19.379 2.526 5.167 1.686 9.319 3.969 12.457 6.856s5.353 6.315 6.644 10.284c1.293 3.969 1.938 8.24 1.938 12.81v43.12c0 4.572.397 8.57 1.199 11.998.799 3.428 1.506 5.985 2.122 7.667h-22.885c-.616-1.201-1.199-2.887-1.753-5.052-.554-2.166-.954-5.051-1.199-8.66-2.832 4.691-6.828 8.48-11.996 11.367-5.164 2.886-11.808 4.329-19.928 4.329zm5.536-18.763c7.628 0 13.811-1.714 18.548-5.142 4.735-3.428 7.105-8.029 7.105-13.802v-10.104c-3.201 2.047-6.892 3.581-11.073 4.601-4.184 1.023-8.858 2.015-14.025 2.977-5.168.965-9.229 2.196-12.181 3.699-2.953 1.506-4.43 4.122-4.43 7.848 0 3.129 1.261 5.565 3.783 7.307 2.521 1.744 6.613 2.616 12.273 2.616z')
								]),
							_List_Nil)
						]))
				])));
};
var $author$project$TT$IT$upload = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'upload',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M18.802 11.147a4.04 4.04 0 0 0-.938.099v-.05c0-3.333-2.691-6.074-6-6.074-2.864 0-5.308 2.025-5.876 4.84H5.79c-2.642 0-4.79 2.173-4.79 4.84 0 2.641 2.099 4.79 4.691 4.839h4.494v-3.333H8.506a.44.44 0 0 1-.395-.247c-.074-.149-.074-.321.025-.445l3.506-5.086a.425.425 0 0 1 .346-.198c.148 0 .271.074.345.198l3.506 5.086c.05.074.075.173.075.247a.465.465 0 0 1-.05.198.44.44 0 0 1-.395.247h-1.63v3.333h5.013c2.197-.025 4-1.803 4.148-3.975v-.519c-.148-2.247-1.975-4-4.198-4Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd')
					]),
				_List_Nil)
			]));
};
var $author$project$TT$Link$withClassName = F2(
	function (className, _v0) {
		var options = _v0.a;
		var attrs = _v0.b;
		var label = _v0.c;
		var url = _v0.d;
		return A4(
			$author$project$TT$Link$Link,
			_Utils_update(
				options,
				{co: className}),
			attrs,
			label,
			url);
	});
var $mdgriffith$elm_ui$Internal$Model$Padding = F5(
	function (a, b, c, d, e) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Internal$Model$Spaced = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$extractSpacingAndPadding = function (attrs) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (attr, _v0) {
				var pad = _v0.a;
				var spacing = _v0.b;
				return _Utils_Tuple2(
					function () {
						if (!pad.$) {
							var x = pad.a;
							return pad;
						} else {
							if ((attr.$ === 4) && (attr.b.$ === 7)) {
								var _v3 = attr.b;
								var name = _v3.a;
								var t = _v3.b;
								var r = _v3.c;
								var b = _v3.d;
								var l = _v3.e;
								return $elm$core$Maybe$Just(
									A5($mdgriffith$elm_ui$Internal$Model$Padding, name, t, r, b, l));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}(),
					function () {
						if (!spacing.$) {
							var x = spacing.a;
							return spacing;
						} else {
							if ((attr.$ === 4) && (attr.b.$ === 5)) {
								var _v6 = attr.b;
								var name = _v6.a;
								var x = _v6.b;
								var y = _v6.c;
								return $elm$core$Maybe$Just(
									A3($mdgriffith$elm_ui$Internal$Model$Spaced, name, x, y));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}());
			}),
		_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
		attrs);
};
var $mdgriffith$elm_ui$Internal$Model$paddingNameFloat = F4(
	function (top, right, bottom, left) {
		return 'pad-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(top) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(right) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(bottom) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(left)))))));
	});
var $mdgriffith$elm_ui$Element$wrappedRow = F2(
	function (attrs, children) {
		var _v0 = $mdgriffith$elm_ui$Internal$Model$extractSpacingAndPadding(attrs);
		var padded = _v0.a;
		var spaced = _v0.b;
		if (spaced.$ === 1) {
			return A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asRow,
				$mdgriffith$elm_ui$Internal$Model$div,
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bH + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.az + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ei)))),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
							attrs))),
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
		} else {
			var _v2 = spaced.a;
			var spaceName = _v2.a;
			var x = _v2.b;
			var y = _v2.c;
			var newPadding = function () {
				if (!padded.$) {
					var _v5 = padded.a;
					var name = _v5.a;
					var t = _v5.b;
					var r = _v5.c;
					var b = _v5.d;
					var l = _v5.e;
					if ((_Utils_cmp(r, x / 2) > -1) && (_Utils_cmp(b, y / 2) > -1)) {
						var newTop = t - (y / 2);
						var newRight = r - (x / 2);
						var newLeft = l - (x / 2);
						var newBottom = b - (y / 2);
						return $elm$core$Maybe$Just(
							A2(
								$mdgriffith$elm_ui$Internal$Model$StyleClass,
								$mdgriffith$elm_ui$Internal$Flag$padding,
								A5(
									$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
									A4($mdgriffith$elm_ui$Internal$Model$paddingNameFloat, newTop, newRight, newBottom, newLeft),
									newTop,
									newRight,
									newBottom,
									newLeft)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			if (!newPadding.$) {
				var pad = newPadding.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asRow,
					$mdgriffith$elm_ui$Internal$Model$div,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bH + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.az + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ei)))),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
								_Utils_ap(
									attrs,
									_List_fromArray(
										[pad]))))),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
			} else {
				var halfY = -(y / 2);
				var halfX = -(x / 2);
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					attrs,
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[
								A4(
								$mdgriffith$elm_ui$Internal$Model$element,
								$mdgriffith$elm_ui$Internal$Model$asRow,
								$mdgriffith$elm_ui$Internal$Model$div,
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bH + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.az + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ei)))),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Internal$Model$Attr(
											A2(
												$elm$html$Html$Attributes$style,
												'margin',
												$elm$core$String$fromFloat(halfY) + ('px' + (' ' + ($elm$core$String$fromFloat(halfX) + 'px'))))),
										A2(
											$elm$core$List$cons,
											$mdgriffith$elm_ui$Internal$Model$Attr(
												A2(
													$elm$html$Html$Attributes$style,
													'width',
													'calc(100% + ' + ($elm$core$String$fromInt(x) + 'px)'))),
											A2(
												$elm$core$List$cons,
												$mdgriffith$elm_ui$Internal$Model$Attr(
													A2(
														$elm$html$Html$Attributes$style,
														'height',
														'calc(100% + ' + ($elm$core$String$fromInt(y) + 'px)'))),
												A2(
													$elm$core$List$cons,
													A2(
														$mdgriffith$elm_ui$Internal$Model$StyleClass,
														$mdgriffith$elm_ui$Internal$Flag$spacing,
														A3($mdgriffith$elm_ui$Internal$Model$SpacingStyle, spaceName, x, y)),
													_List_Nil))))),
								$mdgriffith$elm_ui$Internal$Model$Unkeyed(children))
							])));
			}
		}
	});
var $lucamug$elm_ui_with_context$Element$WithContext$wrappedRow = $lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapContainer($mdgriffith$elm_ui$Element$wrappedRow);
var $author$project$TT$SideBarMenu$viewDesktopSidebar = F6(
	function (tkSidebarMenuItemsResponse, serverInfoLabelMaybe, statesForMenu, counterForFavoritesNotifications, msgShowAccountInfoDropdown, msgHideAccountInfoDropdown) {
		var serverInfoView = function () {
			if (!serverInfoLabelMaybe.$) {
				var serverInfoLabel = serverInfoLabelMaybe.a;
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$centerX,
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 8, 4),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray1)
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							_Utils_ap(
								$author$project$TT$Font$caption,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$warning),
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$centerX
									])),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text(serverInfoLabel)
								]))
						]));
			} else {
				return $lucamug$elm_ui_with_context$Element$WithContext$none;
			}
		}();
		var recentFavoritesNotificationsCounter = function (sidebarMenuItem) {
			return (_Utils_eq(
				sidebarMenuItem.iJ,
				$elm$core$Maybe$Just('i_favorites')) && (counterForFavoritesNotifications > 0)) ? A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_Utils_ap(
					$author$project$TT$Font$numbersSmall,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(16),
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 4, 2),
							$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$gray1),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray3),
							$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
							$lucamug$elm_ui_with_context$Element$WithContext$centerX,
							$lucamug$elm_ui_with_context$Element$WithContext$Font$bold
						])),
				$lucamug$elm_ui_with_context$Element$WithContext$text(
					$elm$core$String$fromInt(counterForFavoritesNotifications))) : $lucamug$elm_ui_with_context$Element$WithContext$none;
		};
		var mainMenuItemView = function (sidebarMenuItem) {
			var linkBuilder = function () {
				var _v3 = sidebarMenuItem.fq;
				if (_v3.$ === 1) {
					return A2($author$project$TT$Link$sidebarPrimaryItem, sidebarMenuItem.dQ, sidebarMenuItem.Q);
				} else {
					switch (_v3.a) {
						case 'suitcase':
							return A3(
								$author$project$TT$Link$sidebarPrimaryItemWithIcon,
								sidebarMenuItem.dQ,
								sidebarMenuItem.Q,
								A2(
									$author$project$TT$IT$withColor,
									$author$project$TT$Color$gray3,
									A2($author$project$TT$IT$briefcase, false, _List_Nil)));
						case 'upload':
							return A3(
								$author$project$TT$Link$sidebarPrimaryItemWithIcon,
								sidebarMenuItem.dQ,
								sidebarMenuItem.Q,
								A2(
									$author$project$TT$IT$withColor,
									$author$project$TT$Color$gray3,
									$author$project$TT$IT$upload(_List_Nil)));
						case 'person':
							return A3(
								$author$project$TT$Link$sidebarPrimaryItemWithIcon,
								sidebarMenuItem.dQ,
								sidebarMenuItem.Q,
								A2(
									$author$project$TT$IT$withColor,
									$author$project$TT$Color$gray3,
									A2($author$project$TT$IT$candidate, false, _List_Nil)));
						case 'paper':
							return A3(
								$author$project$TT$Link$sidebarPrimaryItemWithIcon,
								sidebarMenuItem.dQ,
								sidebarMenuItem.Q,
								A2(
									$author$project$TT$IT$withColor,
									$author$project$TT$Color$gray3,
									$author$project$TT$IT$publishJobAd(_List_Nil)));
						case 'star':
							return A3(
								$author$project$TT$Link$sidebarPrimaryItemWithIcon,
								sidebarMenuItem.dQ,
								sidebarMenuItem.Q,
								A2(
									$author$project$TT$IT$withColor,
									$author$project$TT$Color$gray3,
									A2($author$project$TT$IT$star, false, _List_Nil)));
						default:
							return A2($author$project$TT$Link$sidebarPrimaryItem, sidebarMenuItem.dQ, sidebarMenuItem.Q);
					}
				}
			}();
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$wrappedRow,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						$lucamug$elm_ui_with_context$Element$WithContext$px(36)),
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0),
						$lucamug$elm_ui_with_context$Element$WithContext$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$TT$Link$render(
						A2($author$project$TT$Link$withClassName, sidebarMenuItem.iJ, linkBuilder)),
						recentFavoritesNotificationsCounter(sidebarMenuItem)
					]));
		};
		var defaultSidebar = {a9: $elm$core$Maybe$Nothing, cG: _List_Nil, cK: 'un clic, miles de empleos', bU: _List_Nil, bV: _List_Nil};
		var sidebarItems = function () {
			switch (tkSidebarMenuItemsResponse.$) {
				case 3:
					var res = tkSidebarMenuItemsResponse.a;
					return res;
				case 0:
					return defaultSidebar;
				case 1:
					return defaultSidebar;
				default:
					return defaultSidebar;
			}
		}();
		var footerItemsView = A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_Utils_ap(
				$author$project$TT$Font$sidebarSecondaryMenuItem,
				_List_fromArray(
					[
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, 8),
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$alignBottom
					])),
			A2(
				$elm$core$List$map,
				function (footerItem) {
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								$lucamug$elm_ui_with_context$Element$WithContext$px(28)),
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0)
							]),
						$author$project$TT$Link$render(
							A2($author$project$TT$Link$sidebarFooterItem, footerItem.dQ, footerItem.Q)));
				},
				sidebarItems.cG));
		var headerAndLogo = A2(
			$lucamug$elm_ui_with_context$Element$WithContext$link,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
				]),
			{
				dQ: A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$grayDark),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							$lucamug$elm_ui_with_context$Element$WithContext$px(87)),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, 12)
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(5),
									$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
									$lucamug$elm_ui_with_context$Element$WithContext$centerX
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_Nil,
									$author$project$TT$VectorImage$talenteca(32)),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_Utils_ap(
										$author$project$TT$Font$body3,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$white),
												$lucamug$elm_ui_with_context$Element$WithContext$alignRight
											])),
									$lucamug$elm_ui_with_context$Element$WithContext$text(sidebarItems.cK))
								]))
						])),
				Q: '/'
			});
		var loggedInMenuItems = A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_Utils_ap(
				$author$project$TT$Font$sidebarMenuItem,
				_List_fromArray(
					[
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, 20),
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$gray3)
					])),
			A2(
				$elm$core$List$map,
				function (e) {
					return mainMenuItemView(e);
				},
				sidebarItems.bU));
		var mainMenuItems = A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_Utils_ap(
				$author$project$TT$Font$sidebarMenuItem,
				_List_fromArray(
					[
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, 8),
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$gray3)
					])),
			A2($elm$core$List$map, mainMenuItemView, sidebarItems.bV));
		var accountView = function () {
			var _v0 = sidebarItems.a9;
			if (!_v0.$) {
				var accountInfo = _v0.a;
				var viewAccountInfoDropdownItem = function (item) {
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$link,
						_Utils_ap(
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 15, 15),
									A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 8, 0),
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
									$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$gray4),
									$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray4)
										])),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$tabindex(-1)),
									$author$project$TT$SideBarMenu$referenceAttr('account-actions')
								]),
							(item.dQ === 'Cerrar sesión') ? _List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('ss-mainSidebar__logout'))
								]) : _List_Nil),
						{
							dQ: A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_Utils_ap(
									$author$project$TT$Font$body3,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$grayDark)
										])),
								$lucamug$elm_ui_with_context$Element$WithContext$text(item.dQ)),
							Q: item.ec
						});
				};
				var accountInfoDropdown = statesForMenu.d3 ? A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(5),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$gray4),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink)
						]),
					A2($elm$core$List$map, viewAccountInfoDropdownItem, accountInfo.dj)) : $lucamug$elm_ui_with_context$Element$WithContext$none;
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_Utils_ap(
						_List_fromArray(
							[
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 8, 8),
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$grayDark),
								$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
								$lucamug$elm_ui_with_context$Element$WithContext$pointer,
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$id('js-mainSidebar__accountMenuBtn')),
								$lucamug$elm_ui_with_context$Element$WithContext$above(accountInfoDropdown),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$tabindex(0)),
								$author$project$TT$SideBarMenu$referenceAttr('account-actions')
							]),
						function () {
							var _v1 = _Utils_Tuple2(msgShowAccountInfoDropdown, msgHideAccountInfoDropdown);
							if ((!_v1.a.$) && (!_v1.b.$)) {
								var msShow = _v1.a.a;
								var msHide = _v1.b.a;
								return _List_fromArray(
									[
										A2($author$project$TT$SideBarMenu$onBlurAttribute, 'account-actions', msHide),
										$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
										statesForMenu.d3 ? msHide : msShow)
									]);
							} else {
								return _List_Nil;
							}
						}()),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(5),
									$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
									$lucamug$elm_ui_with_context$Element$WithContext$centerX,
									$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.8)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_Utils_ap(
										$author$project$TT$Font$body3,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$white)
											])),
									$lucamug$elm_ui_with_context$Element$WithContext$text(
										A2($elm$core$Maybe$withDefault, '', accountInfo.dG))),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									A3($author$project$TT$Font$mainRegular, $author$project$TT$Color$text, 1, 0.25),
									$lucamug$elm_ui_with_context$Element$WithContext$text(
										A2($elm$core$Maybe$withDefault, '', accountInfo.cB)))
								])),
							A2($author$project$TT$IF$chevronDown, $author$project$TT$Color$white, 4)
						]));
			} else {
				return $lucamug$elm_ui_with_context$Element$WithContext$none;
			}
		}();
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$width(
					$lucamug$elm_ui_with_context$Element$WithContext$px(172)),
					$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray1),
					$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$white)
				]),
			_List_fromArray(
				[headerAndLogo, serverInfoView, mainMenuItems, loggedInMenuItems, footerItemsView, accountView]));
	});
var $mdgriffith$elm_ui$Element$map = $mdgriffith$elm_ui$Internal$Model$map;
var $lucamug$elm_ui_with_context$Element$WithContext$map = F2(
	function (f, _v0) {
		var g = _v0;
		return A2(
			$elm$core$Basics$composeR,
			g,
			$mdgriffith$elm_ui$Element$map(f));
	});
var $author$project$TT$Button$Alternate = 1;
var $author$project$Page$Home$MsgGetJobAdSummary = {$: 1};
var $author$project$Page$Home$MsgHideMenuOptions = {$: 57};
var $author$project$Page$Home$MsgShowMenuOptions = {$: 56};
var $author$project$Page$Home$MsgShowSidebar = {$: 54};
var $author$project$Page$Home$MsgUserClickGoToJobAdSerchPageButton = {$: 53};
var $author$project$Page$Home$MsgUserClickUploadCvButton = {$: 52};
var $author$project$Page$Home$MsgUserClickedBackIcon = function (a) {
	return {$: 80, a: a};
};
var $author$project$Page$Home$MsgUserPressedDismissAlertButton = {$: 114};
var $author$project$TT$Spinner$Rotation = 1;
var $author$project$TT$Button$Small = 1;
var $mdgriffith$elm_ui$Internal$Model$Below = 1;
var $mdgriffith$elm_ui$Element$below = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 1, element);
};
var $lucamug$elm_ui_with_context$Element$WithContext$below = $lucamug$elm_ui_with_context$Element$WithContext$createNearby($mdgriffith$elm_ui$Element$below);
var $author$project$TT$Font$body1 = A3($author$project$TT$Font$mainRegular, $author$project$TT$Color$text, 5, 0.5);
var $author$project$TT$Font$body2 = A3($author$project$TT$Font$mainRegular, $author$project$TT$Color$text, 4, 0.25);
var $mdgriffith$elm_ui$Internal$Flag$fontAlignment = $mdgriffith$elm_ui$Internal$Flag$flag(12);
var $mdgriffith$elm_ui$Element$Font$center = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.lb);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$center = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$center);
var $author$project$TT$IT$chevronLeft = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'chevronLeft',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M17 22 7 12 17 2'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$fill('transparent')
					]),
				_List_Nil)
			]));
};
var $author$project$TT$Button$Button = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$TT$Button$ButtonE = {$: 0};
var $author$project$TT$Button$Contained = 0;
var $author$project$TT$Button$Normal = 0;
var $author$project$TT$Button$Primary = 0;
var $author$project$TT$Button$StateDefault = {$: 0};
var $author$project$TT$Button$defaultOptions = {bF: _List_Nil, cM: $author$project$TT$Button$ButtonE, cQ: _List_Nil, bo: $elm$core$Maybe$Nothing, n: 0, kQ: 0, av: $author$project$TT$Button$StateDefault, aw: 0, bx: $elm$core$Maybe$Nothing};
var $author$project$TT$Button$default = F2(
	function (msg, label) {
		return A3($author$project$TT$Button$Button, $author$project$TT$Button$defaultOptions, msg, label);
	});
var $author$project$Page$Home$getMainContainerHeight = function (model) {
	var calculatedHeight = model.q.aR - model.a6;
	return model.p ? $elm$core$Basics$round(calculatedHeight * 0.9) : calculatedHeight;
};
var $author$project$Page$Home$getMainContainerWidth = function (model) {
	return model.p ? 650 : model.q.a8;
};
var $author$project$Page$Home$getMainContainerSize = function (model) {
	return {
		aR: $author$project$Page$Home$getMainContainerHeight(model),
		a8: $author$project$Page$Home$getMainContainerWidth(model)
	};
};
var $author$project$TT$Size$ExtraLarge2 = 8;
var $author$project$TT$Font$headline1 = A3($author$project$TT$Font$mainRegular, $author$project$TT$Color$text, 8, 0.0);
var $author$project$TT$Size$Large = 6;
var $author$project$TT$Font$headline3 = A3($author$project$TT$Font$mainMedium, $author$project$TT$Color$text, 6, 0.15);
var $author$project$TT$IT$more = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'more',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M11.75 6.5a2.758 2.758 0 0 0 2.75-2.75A2.758 2.758 0 0 0 11.75 1 2.758 2.758 0 0 0 9 3.75a2.758 2.758 0 0 0 2.75 2.75Zm0 2.75A2.758 2.758 0 0 0 9 12a2.758 2.758 0 0 0 2.75 2.75A2.758 2.758 0 0 0 14.5 12a2.758 2.758 0 0 0-2.75-2.75Zm0 8.25A2.758 2.758 0 0 0 9 20.25 2.758 2.758 0 0 0 11.75 23a2.758 2.758 0 0 0 2.75-2.75 2.758 2.758 0 0 0-2.75-2.75Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Home$referenceDataName = 'data-dropdown-id';
var $author$project$Page$Home$onBlurAttribute = F2(
	function (id, hideMsg) {
		var dataDecoder = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['relatedTarget', 'attributes', $author$project$Page$Home$referenceDataName, 'value']),
			$elm$json$Json$Decode$string);
		var attrToMsg = function (maybeAttr) {
			if (!maybeAttr.$) {
				var attr = maybeAttr.a;
				return _Utils_eq(attr, id) ? $elm$json$Json$Decode$fail('') : $elm$json$Json$Decode$succeed(hideMsg);
			} else {
				return $elm$json$Json$Decode$succeed(hideMsg);
			}
		};
		return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
			A2(
				$elm$html$Html$Events$on,
				'blur',
				A2(
					$elm$json$Json$Decode$andThen,
					attrToMsg,
					$elm$json$Json$Decode$maybe(dataDecoder))));
	});
var $author$project$TT$Button$Alternate2 = 2;
var $author$project$TT$Button$StateDisabled = {$: 2};
var $author$project$TT$Font$alternativeBold = F3(
	function (color, size, letterSpacing) {
		return _Utils_ap(
			_List_fromArray(
				[
					A2($author$project$TT$Font$fontAttr, 'Nexa Bold', $lucamug$elm_ui_with_context$Element$WithContext$Font$sansSerif),
					$lucamug$elm_ui_with_context$Element$WithContext$Font$color(color),
					$lucamug$elm_ui_with_context$Element$WithContext$Font$letterSpacing(letterSpacing)
				]),
			$author$project$TT$Size$fontSize(size));
	});
var $author$project$TT$Font$button = A3($author$project$TT$Font$alternativeBold, $author$project$TT$Color$white, 3, 1.25);
var $author$project$TT$Font$buttonSmall = A3($author$project$TT$Font$alternativeBold, $author$project$TT$Color$white, 1, 1.25);
var $author$project$TT$Button$getColor = function (role) {
	switch (role) {
		case 0:
			return $author$project$TT$Color$primary;
		case 1:
			return $author$project$TT$Color$secondary;
		case 2:
			return $author$project$TT$Color$white;
		case 4:
			return $author$project$TT$Color$gray1;
		case 5:
			return $author$project$TT$Color$error;
		case 6:
			return $author$project$TT$Color$warning;
		default:
			return $author$project$TT$Color$tertiary;
	}
};
var $author$project$TT$Util$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$svg$Svg$animateTransform = $elm$svg$Svg$trustedNode('animateTransform');
var $elm$svg$Svg$Attributes$attributeName = _VirtualDom_attribute('attributeName');
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$dur = _VirtualDom_attribute('dur');
var $elm$svg$Svg$Attributes$from = function (value) {
	return A2(
		_VirtualDom_attribute,
		'from',
		_VirtualDom_noJavaScriptUri(value));
};
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$Attributes$repeatCount = _VirtualDom_attribute('repeatCount');
var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');
var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');
var $elm$svg$Svg$Attributes$stopOpacity = _VirtualDom_attribute('stop-opacity');
var $elm$svg$Svg$Attributes$to = function (value) {
	return A2(
		_VirtualDom_attribute,
		'to',
		_VirtualDom_noJavaScriptUri(value));
};
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $elm$svg$Svg$Attributes$type_ = _VirtualDom_attribute('type');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$xmlSpace = A2(_VirtualDom_attributeNS, 'http://www.w3.org/XML/1998/namespace', 'xml:space');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$TT$Spinner$spinnerRotationHtml = F2(
	function (size, color) {
		var speed = '0.6s';
		var colorString = $author$project$TT$Color$Extra$colorToHex(color);
		var idElement = 'id' + A2($elm$core$String$dropLeft, 1, colorString);
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 38 38'),
					$elm$svg$Svg$Attributes$xmlSpace('http://www.w3.org/2000/svg'),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromInt(size)),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromInt(size))
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$defs,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$linearGradient,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id(idElement),
									$elm$svg$Svg$Attributes$x1('8%'),
									$elm$svg$Svg$Attributes$x2('65.7%'),
									$elm$svg$Svg$Attributes$y1('0%'),
									$elm$svg$Svg$Attributes$y2('23.9%')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$stop,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$offset('0%'),
											$elm$svg$Svg$Attributes$stopColor(colorString),
											$elm$svg$Svg$Attributes$stopOpacity('0')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$stop,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$offset('63.1%'),
											$elm$svg$Svg$Attributes$stopColor(colorString),
											$elm$svg$Svg$Attributes$stopOpacity('.6')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$stop,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$offset('100%'),
											$elm$svg$Svg$Attributes$stopColor(colorString)
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$fillRule('evenodd'),
							$elm$svg$Svg$Attributes$transform('translate(1 1)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M36 18C36 8 28 0 18 0'),
									$elm$svg$Svg$Attributes$stroke('url(#' + (idElement + ')')),
									$elm$svg$Svg$Attributes$strokeWidth('2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$animateTransform,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$attributeName('transform'),
											$elm$svg$Svg$Attributes$dur(speed),
											$elm$svg$Svg$Attributes$from('0 18 18'),
											$elm$svg$Svg$Attributes$repeatCount('indefinite'),
											$elm$svg$Svg$Attributes$to('360 18 18'),
											$elm$svg$Svg$Attributes$type_('rotate')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx('36'),
									$elm$svg$Svg$Attributes$cy('18'),
									$elm$svg$Svg$Attributes$fill(colorString),
									$elm$svg$Svg$Attributes$r('1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$animateTransform,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$attributeName('transform'),
											$elm$svg$Svg$Attributes$dur(speed),
											$elm$svg$Svg$Attributes$from('0 18 18'),
											$elm$svg$Svg$Attributes$repeatCount('indefinite'),
											$elm$svg$Svg$Attributes$to('360 18 18'),
											$elm$svg$Svg$Attributes$type_('rotate')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $elm$svg$Svg$animate = $elm$svg$Svg$trustedNode('animate');
var $elm$svg$Svg$Attributes$values = function (value) {
	return A2(
		_VirtualDom_attribute,
		'values',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$TT$Spinner$spinnerThreeCirclesHtml = F2(
	function (size, color) {
		var colorString = $author$project$TT$Color$Extra$colorToHex(color);
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('10 26 44 12'),
					$elm$svg$Svg$Attributes$xmlSpace('http://www.w3.org/2000/svg'),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromInt(size))
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx('16'),
									$elm$svg$Svg$Attributes$cy('32'),
									$elm$svg$Svg$Attributes$strokeWidth('0'),
									$elm$svg$Svg$Attributes$r('4.26701'),
									$elm$svg$Svg$Attributes$fill(colorString)
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$animate,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$attributeName('fill-opacity'),
											$elm$svg$Svg$Attributes$dur('750ms'),
											$elm$svg$Svg$Attributes$values('.5;.6;.8;1;.8;.6;.5;.5'),
											$elm$svg$Svg$Attributes$repeatCount('indefinite')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$animate,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$attributeName('r'),
											$elm$svg$Svg$Attributes$dur('750ms'),
											$elm$svg$Svg$Attributes$values('3;3;4;5;6;5;4;3'),
											$elm$svg$Svg$Attributes$repeatCount('indefinite')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx('32'),
									$elm$svg$Svg$Attributes$cy('32'),
									$elm$svg$Svg$Attributes$strokeWidth('0'),
									$elm$svg$Svg$Attributes$r('5.26701'),
									$elm$svg$Svg$Attributes$fill(colorString)
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$animate,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$attributeName('fill-opacity'),
											$elm$svg$Svg$Attributes$dur('750ms'),
											$elm$svg$Svg$Attributes$values('.5;.5;.6;.8;1;.8;.6;.5'),
											$elm$svg$Svg$Attributes$repeatCount('indefinite')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$animate,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$attributeName('r'),
											$elm$svg$Svg$Attributes$dur('750ms'),
											$elm$svg$Svg$Attributes$values('4;3;3;4;5;6;5;4'),
											$elm$svg$Svg$Attributes$repeatCount('indefinite')
										]),
									_List_Nil)
								])),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx('48'),
									$elm$svg$Svg$Attributes$cy('32'),
									$elm$svg$Svg$Attributes$strokeWidth('0'),
									$elm$svg$Svg$Attributes$r('5.73299'),
									$elm$svg$Svg$Attributes$fill(colorString)
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$animate,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$attributeName('fill-opacity'),
											$elm$svg$Svg$Attributes$dur('750ms'),
											$elm$svg$Svg$Attributes$values('.6;.5;.5;.6;.8;1;.8;.6'),
											$elm$svg$Svg$Attributes$repeatCount('indefinite')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$animate,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$attributeName('r'),
											$elm$svg$Svg$Attributes$dur('750ms'),
											$elm$svg$Svg$Attributes$values('5;4;3;3;4;5;6;5'),
											$elm$svg$Svg$Attributes$repeatCount('indefinite')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$TT$Spinner$spinner = F3(
	function (sp, size, color) {
		return $lucamug$elm_ui_with_context$Element$WithContext$html(
			function () {
				if (!sp) {
					return A2($author$project$TT$Spinner$spinnerThreeCirclesHtml, size, color);
				} else {
					return A2($author$project$TT$Spinner$spinnerRotationHtml, size, color);
				}
			}());
	});
var $author$project$TT$Color$transparent = $author$project$TT$Color$Extra$hexToColor('#ffffff00');
var $author$project$TT$Button$render = function (_v0) {
	var options = _v0.a;
	var msg = _v0.b;
	var label = _v0.c;
	var isButtonWithoutIcon = $author$project$TT$Util$isNothing(options.bo) && $author$project$TT$Util$isNothing(options.bx);
	var padding = function () {
		var _v14 = options.aw;
		switch (_v14) {
			case 0:
				var _v15 = options.kQ;
				if (!_v15) {
					return isButtonWithoutIcon ? {hb: 11, jf: 16, ku: 16, lz: 11} : {hb: 9, jf: 12, ku: 16, lz: 9};
				} else {
					return isButtonWithoutIcon ? {hb: 11, jf: 12, ku: 12, lz: 11} : {hb: 9, jf: 8, ku: 12, lz: 9};
				}
			case 1:
				var _v16 = options.kQ;
				if (!_v16) {
					return isButtonWithoutIcon ? {hb: 11, jf: 8, ku: 8, lz: 11} : {hb: 9, jf: 8, ku: 8, lz: 9};
				} else {
					return isButtonWithoutIcon ? {hb: 10, jf: 8, ku: 8, lz: 11} : {hb: 9, jf: 8, ku: 8, lz: 9};
				}
			default:
				var _v17 = options.kQ;
				if (!_v17) {
					return isButtonWithoutIcon ? {hb: 10, jf: 16, ku: 16, lz: 10} : {hb: 8, jf: 12, ku: 16, lz: 8};
				} else {
					return isButtonWithoutIcon ? {hb: 8, jf: 12, ku: 12, lz: 11} : {hb: 8, jf: 8, ku: 12, lz: 8};
				}
		}
	}();
	var fontStyle = function () {
		var _v13 = options.kQ;
		if (!_v13) {
			return $author$project$TT$Font$button;
		} else {
			return $author$project$TT$Font$buttonSmall;
		}
	}();
	var fontColor = function () {
		var _v12 = options.aw;
		switch (_v12) {
			case 0:
				return $author$project$TT$Color$white;
			case 1:
				return _Utils_eq(options.av, $author$project$TT$Button$StateDisabled) ? A2(
					$author$project$TT$Color$Extra$fadeOut,
					0.55,
					$author$project$TT$Button$getColor(options.n)) : $author$project$TT$Button$getColor(options.n);
			default:
				return _Utils_eq(options.av, $author$project$TT$Button$StateDisabled) ? A2(
					$author$project$TT$Color$Extra$fadeOut,
					0.55,
					$author$project$TT$Button$getColor(options.n)) : $author$project$TT$Button$getColor(options.n);
		}
	}();
	var getIconView = function (iconOption) {
		if (!iconOption.$) {
			var icon = iconOption.a;
			var iconSize = function () {
				var _v11 = options.kQ;
				if (!_v11) {
					return 18.0;
				} else {
					return 14.0;
				}
			}();
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$moveUp(iconSize * 0.1)
					]),
				$author$project$TT$IT$render(
					A2(
						$author$project$TT$IT$withColor,
						fontColor,
						A2($author$project$TT$IT$withSize, iconSize, icon))));
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$none;
		}
	};
	var leadingIconView = getIconView(options.bo);
	var spinnerIconView = function () {
		var iconSize = function () {
			var _v9 = options.kQ;
			if (!_v9) {
				return 18;
			} else {
				return 14;
			}
		}();
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_Nil,
			A3($author$project$TT$Spinner$spinner, 1, iconSize, fontColor));
	}();
	var trailingIconView = function () {
		var _v8 = options.av;
		if (_v8.$ === 1) {
			return spinnerIconView;
		} else {
			return getIconView(options.bx);
		}
	}();
	var labelView = A2(
		$lucamug$elm_ui_with_context$Element$WithContext$row,
		_List_fromArray(
			[
				A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 8, 0),
				$lucamug$elm_ui_with_context$Element$WithContext$centerX
			]),
		_List_fromArray(
			[
				leadingIconView,
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_Utils_ap(_List_Nil, options.cQ),
				$lucamug$elm_ui_with_context$Element$WithContext$text(
					$elm$core$String$toUpper(label))),
				trailingIconView
			]));
	var disabledStyles = function () {
		var _v7 = options.av;
		if (_v7.$ === 2) {
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					A2($elm$html$Html$Attributes$style, 'cursor', 'not-allowed'))
				]);
		} else {
			return _List_Nil;
		}
	}();
	var borderAttr = function () {
		var _v6 = options.aw;
		switch (_v6) {
			case 0:
				return _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(4)
					]);
			case 1:
				return _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(4)
					]);
			default:
				return _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
						$author$project$TT$Button$getColor(options.n)),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$solid,
						$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(4)
					]);
		}
	}();
	var bgColor = function () {
		var _v4 = options.aw;
		switch (_v4) {
			case 0:
				var _v5 = options.av;
				switch (_v5.$) {
					case 1:
						return A2(
							$author$project$TT$Color$Extra$darken,
							0.05,
							$author$project$TT$Button$getColor(options.n));
					case 2:
						return A2(
							$author$project$TT$Color$Extra$darken,
							0.05,
							$author$project$TT$Button$getColor(options.n));
					default:
						return $author$project$TT$Button$getColor(options.n);
				}
			case 1:
				return $author$project$TT$Color$transparent;
			default:
				return $author$project$TT$Color$white;
		}
	}();
	var backgroundMouseOverColor = function () {
		var _v3 = options.aw;
		switch (_v3) {
			case 0:
				return A2($author$project$TT$Color$Extra$lighten, 0.05, bgColor);
			case 1:
				return (options.n === 2) ? A2($author$project$TT$Color$Extra$fadeOut, 0.55, $author$project$TT$Color$white) : A2(
					$author$project$TT$Color$Extra$lighten,
					0.55,
					$author$project$TT$Button$getColor(options.n));
			default:
				return A2(
					$author$project$TT$Color$Extra$lighten,
					0.55,
					$author$project$TT$Button$getColor(options.n));
		}
	}();
	var mouseOverStyles = function () {
		var _v2 = options.av;
		if (_v2.$ === 1) {
			return _List_Nil;
		} else {
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Background$color(backgroundMouseOverColor)
				]);
		}
	}();
	var allStyles = _Utils_ap(
		fontStyle,
		_Utils_ap(
			borderAttr,
			_Utils_ap(
				disabledStyles,
				_Utils_ap(
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Font$color(fontColor),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color(bgColor),
							$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(padding),
							$lucamug$elm_ui_with_context$Element$WithContext$focused(
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
									$author$project$TT$Button$getColor(options.n))
								])),
							$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(mouseOverStyles),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'transition-duration', '.2s')),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'transition-timing-function', 'cubic-bezier(.4,0,1,1)'))
						]),
					options.bF))));
	var _v1 = options.cM;
	if (!_v1.$) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$Input$button,
			allStyles,
			{dQ: labelView, jI: msg});
	} else {
		var url = _v1.a;
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
				]),
			_List_fromArray(
				[
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$link,
					allStyles,
					{dQ: labelView, Q: url})
				]));
	}
};
var $mdgriffith$elm_ui$Element$Font$semiBold = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.ll);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$semiBold);
var $mdgriffith$elm_ui$Element$spaceEvenly = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$spacing, $mdgriffith$elm_ui$Internal$Style$classes.kU);
var $lucamug$elm_ui_with_context$Element$WithContext$spaceEvenly = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$spaceEvenly);
var $mdgriffith$elm_ui$Element$Font$underline = $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.aa);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$underline = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$underline);
var $author$project$Page$Home$MsgUserAddedOneSkill = {$: 37};
var $author$project$Page$Home$MsgUserChangedExperienceYears = function (a) {
	return {$: 39, a: a};
};
var $author$project$Page$Home$MsgUserFocusedInput = {$: 77};
var $author$project$Page$Home$MsgUserLeftInput = {$: 78};
var $author$project$Page$Home$MsgUserSkippedApplyQuestions = {$: 28};
var $author$project$Page$Home$MsgUserSubmittedApplyQuestions = {$: 41};
var $author$project$TT$Button$StateLoading = function (a) {
	return {$: 1, a: a};
};
var $author$project$TT$Button$Text = 1;
var $mdgriffith$elm_ui$Internal$Model$Left = 0;
var $mdgriffith$elm_ui$Element$alignLeft = $mdgriffith$elm_ui$Internal$Model$AlignX(0);
var $lucamug$elm_ui_with_context$Element$WithContext$alignLeft = $lucamug$elm_ui_with_context$Element$WithContext$attribute($mdgriffith$elm_ui$Element$alignLeft);
var $author$project$TT$FormField$LabelAbove = 0;
var $author$project$TT$FormField$Normal = 0;
var $author$project$TT$FormField$Outlined = 0;
var $author$project$TT$FormField$defaultOptions = {bN: _List_Nil, cL: $elm$core$Maybe$Nothing, fb: 0, cQ: _List_Nil, cS: 0, bo: $elm$core$Maybe$Nothing, aF: $elm$core$Maybe$Nothing, kQ: 0, av: 0, aw: 0, bx: $elm$core$Maybe$Nothing, dh: _List_Nil};
var $author$project$TT$FormField$default = F3(
	function (onChangeMsg, value, labelText) {
		return A4($author$project$TT$FormField$Input, $author$project$TT$FormField$defaultOptions, onChangeMsg, value, labelText);
	});
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			z: _List_Nil,
			x: 0,
			y: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.x * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						z: A2($elm$core$List$cons, mappedLeaf, builder.z),
						x: builder.x + 1,
						y: builder.y
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$TT$IT$plus = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'plus',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 5v14M5 12h14'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2')
					]),
				_List_Nil)
			]));
};
var $mdgriffith$elm_ui$Element$Input$TextInputNode = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$Input$TextArea = {$: 1};
var $mdgriffith$elm_ui$Internal$Model$LivePolite = {$: 6};
var $mdgriffith$elm_ui$Element$Region$announce = $mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$LivePolite);
var $mdgriffith$elm_ui$Element$Input$applyLabel = F3(
	function (attrs, label, input) {
		if (label.$ === 1) {
			var labelText = label.a;
			return A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asColumn,
				$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
				attrs,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[input])));
		} else {
			var position = label.a;
			var labelAttrs = label.b;
			var labelChild = label.c;
			var labelElement = A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				labelAttrs,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[labelChild])));
			switch (position) {
				case 2:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asColumn,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cN),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[labelElement, input])));
				case 3:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asColumn,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cN),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[input, labelElement])));
				case 0:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asRow,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cN),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[input, labelElement])));
				default:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asRow,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cN),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[labelElement, input])));
			}
		}
	});
var $mdgriffith$elm_ui$Element$Input$autofill = A2(
	$elm$core$Basics$composeL,
	$mdgriffith$elm_ui$Internal$Model$Attr,
	$elm$html$Html$Attributes$attribute('autocomplete'));
var $mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding = function (attrs) {
	var gatherSpacing = F2(
		function (attr, found) {
			if ((attr.$ === 4) && (attr.b.$ === 5)) {
				var _v2 = attr.b;
				var x = _v2.b;
				var y = _v2.c;
				if (found.$ === 1) {
					return $elm$core$Maybe$Just(y);
				} else {
					return found;
				}
			} else {
				return found;
			}
		});
	var _v0 = A3($elm$core$List$foldr, gatherSpacing, $elm$core$Maybe$Nothing, attrs);
	if (_v0.$ === 1) {
		return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
	} else {
		var vSpace = _v0.a;
		return $mdgriffith$elm_ui$Element$moveUp(
			$elm$core$Basics$floor(vSpace / 2));
	}
};
var $mdgriffith$elm_ui$Element$clip = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.hu);
var $mdgriffith$elm_ui$Element$rgb = F3(
	function (r, g, b) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, r, g, b, 1);
	});
var $mdgriffith$elm_ui$Element$Input$darkGrey = A3($mdgriffith$elm_ui$Element$rgb, 186 / 255, 189 / 255, 182 / 255);
var $mdgriffith$elm_ui$Element$Input$defaultTextPadding = A2($mdgriffith$elm_ui$Element$paddingXY, 12, 12);
var $mdgriffith$elm_ui$Element$Input$white = A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1);
var $mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Input$defaultTextPadding,
		$mdgriffith$elm_ui$Element$Border$rounded(3),
		$mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Element$Input$darkGrey),
		$mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$Input$white),
		$mdgriffith$elm_ui$Element$Border$width(1),
		$mdgriffith$elm_ui$Element$spacing(5),
		$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
		$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink)
	]);
var $mdgriffith$elm_ui$Element$Input$getHeight = function (attr) {
	if (attr.$ === 8) {
		var h = attr.a;
		return $elm$core$Maybe$Just(h);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Label = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute = function (label) {
	if (label.$ === 1) {
		var textLabel = label.a;
		return $mdgriffith$elm_ui$Internal$Model$Describe(
			$mdgriffith$elm_ui$Internal$Model$Label(textLabel));
	} else {
		return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
	}
};
var $mdgriffith$elm_ui$Element$Input$isConstrained = function (len) {
	isConstrained:
	while (true) {
		switch (len.$) {
			case 1:
				return false;
			case 0:
				return true;
			case 2:
				return true;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isConstrained;
			default:
				var l = len.b;
				return true;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$isHiddenLabel = function (label) {
	if (label.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Element$Input$isStacked = function (label) {
	if (!label.$) {
		var loc = label.a;
		switch (loc) {
			case 0:
				return false;
			case 1:
				return false;
			case 2:
				return true;
			default:
				return true;
		}
	} else {
		return true;
	}
};
var $mdgriffith$elm_ui$Element$Input$negateBox = function (box) {
	return {hb: -box.hb, jf: -box.jf, ku: -box.ku, lz: -box.lz};
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $mdgriffith$elm_ui$Element$Input$isFill = function (len) {
	isFill:
	while (true) {
		switch (len.$) {
			case 2:
				return true;
			case 1:
				return false;
			case 0:
				return false;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isFill;
			default:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isFill;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$isPixel = function (len) {
	isPixel:
	while (true) {
		switch (len.$) {
			case 1:
				return false;
			case 0:
				return true;
			case 2:
				return false;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isPixel;
			default:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isPixel;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$redistributeOver = F4(
	function (isMultiline, stacked, attr, els) {
		switch (attr.$) {
			case 9:
				return _Utils_update(
					els,
					{
						j: A2($elm$core$List$cons, attr, els.j)
					});
			case 7:
				var width = attr.a;
				return $mdgriffith$elm_ui$Element$Input$isFill(width) ? _Utils_update(
					els,
					{
						r: A2($elm$core$List$cons, attr, els.r),
						D: A2($elm$core$List$cons, attr, els.D),
						j: A2($elm$core$List$cons, attr, els.j)
					}) : (stacked ? _Utils_update(
					els,
					{
						r: A2($elm$core$List$cons, attr, els.r)
					}) : _Utils_update(
					els,
					{
						j: A2($elm$core$List$cons, attr, els.j)
					}));
			case 8:
				var height = attr.a;
				return (!stacked) ? _Utils_update(
					els,
					{
						r: A2($elm$core$List$cons, attr, els.r),
						j: A2($elm$core$List$cons, attr, els.j)
					}) : ($mdgriffith$elm_ui$Element$Input$isFill(height) ? _Utils_update(
					els,
					{
						r: A2($elm$core$List$cons, attr, els.r),
						j: A2($elm$core$List$cons, attr, els.j)
					}) : ($mdgriffith$elm_ui$Element$Input$isPixel(height) ? _Utils_update(
					els,
					{
						j: A2($elm$core$List$cons, attr, els.j)
					}) : _Utils_update(
					els,
					{
						j: A2($elm$core$List$cons, attr, els.j)
					})));
			case 6:
				return _Utils_update(
					els,
					{
						r: A2($elm$core$List$cons, attr, els.r)
					});
			case 5:
				return _Utils_update(
					els,
					{
						r: A2($elm$core$List$cons, attr, els.r)
					});
			case 4:
				switch (attr.b.$) {
					case 5:
						var _v1 = attr.b;
						return _Utils_update(
							els,
							{
								r: A2($elm$core$List$cons, attr, els.r),
								D: A2($elm$core$List$cons, attr, els.D),
								j: A2($elm$core$List$cons, attr, els.j),
								bB: A2($elm$core$List$cons, attr, els.bB)
							});
					case 7:
						var cls = attr.a;
						var _v2 = attr.b;
						var pad = _v2.a;
						var t = _v2.b;
						var r = _v2.c;
						var b = _v2.d;
						var l = _v2.e;
						if (isMultiline) {
							return _Utils_update(
								els,
								{
									R: A2($elm$core$List$cons, attr, els.R),
									j: A2($elm$core$List$cons, attr, els.j)
								});
						} else {
							var newTop = t - A2($elm$core$Basics$min, t, b);
							var newLineHeight = $mdgriffith$elm_ui$Element$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'line-height',
									'calc(1.0em + ' + ($elm$core$String$fromFloat(
										2 * A2($elm$core$Basics$min, t, b)) + 'px)')));
							var newHeight = $mdgriffith$elm_ui$Element$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'height',
									'calc(1.0em + ' + ($elm$core$String$fromFloat(
										2 * A2($elm$core$Basics$min, t, b)) + 'px)')));
							var newBottom = b - A2($elm$core$Basics$min, t, b);
							var reducedVerticalPadding = A2(
								$mdgriffith$elm_ui$Internal$Model$StyleClass,
								$mdgriffith$elm_ui$Internal$Flag$padding,
								A5(
									$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
									A4($mdgriffith$elm_ui$Internal$Model$paddingNameFloat, newTop, r, newBottom, l),
									newTop,
									r,
									newBottom,
									l));
							return _Utils_update(
								els,
								{
									R: A2($elm$core$List$cons, attr, els.R),
									D: A2(
										$elm$core$List$cons,
										newHeight,
										A2($elm$core$List$cons, newLineHeight, els.D)),
									j: A2($elm$core$List$cons, reducedVerticalPadding, els.j)
								});
						}
					case 6:
						var _v3 = attr.b;
						return _Utils_update(
							els,
							{
								R: A2($elm$core$List$cons, attr, els.R),
								j: A2($elm$core$List$cons, attr, els.j)
							});
					case 10:
						return _Utils_update(
							els,
							{
								R: A2($elm$core$List$cons, attr, els.R),
								j: A2($elm$core$List$cons, attr, els.j)
							});
					case 2:
						return _Utils_update(
							els,
							{
								r: A2($elm$core$List$cons, attr, els.r)
							});
					case 1:
						var _v4 = attr.b;
						return _Utils_update(
							els,
							{
								r: A2($elm$core$List$cons, attr, els.r)
							});
					default:
						var flag = attr.a;
						var cls = attr.b;
						return _Utils_update(
							els,
							{
								j: A2($elm$core$List$cons, attr, els.j)
							});
				}
			case 0:
				return els;
			case 1:
				var a = attr.a;
				return _Utils_update(
					els,
					{
						D: A2($elm$core$List$cons, attr, els.D)
					});
			case 2:
				return _Utils_update(
					els,
					{
						D: A2($elm$core$List$cons, attr, els.D)
					});
			case 3:
				return _Utils_update(
					els,
					{
						j: A2($elm$core$List$cons, attr, els.j)
					});
			default:
				return _Utils_update(
					els,
					{
						D: A2($elm$core$List$cons, attr, els.D)
					});
		}
	});
var $mdgriffith$elm_ui$Element$Input$redistribute = F3(
	function (isMultiline, stacked, attrs) {
		return function (redist) {
			return {
				R: $elm$core$List$reverse(redist.R),
				r: $elm$core$List$reverse(redist.r),
				D: $elm$core$List$reverse(redist.D),
				j: $elm$core$List$reverse(redist.j),
				bB: $elm$core$List$reverse(redist.bB)
			};
		}(
			A3(
				$elm$core$List$foldl,
				A2($mdgriffith$elm_ui$Element$Input$redistributeOver, isMultiline, stacked),
				{R: _List_Nil, r: _List_Nil, D: _List_Nil, j: _List_Nil, bB: _List_Nil},
				attrs));
	});
var $mdgriffith$elm_ui$Element$Input$renderBox = function (_v0) {
	var top = _v0.lz;
	var right = _v0.ku;
	var bottom = _v0.hb;
	var left = _v0.jf;
	return $elm$core$String$fromInt(top) + ('px ' + ($elm$core$String$fromInt(right) + ('px ' + ($elm$core$String$fromInt(bottom) + ('px ' + ($elm$core$String$fromInt(left) + 'px'))))));
};
var $mdgriffith$elm_ui$Element$Input$charcoal = A3($mdgriffith$elm_ui$Element$rgb, 136 / 255, 138 / 255, 133 / 255);
var $mdgriffith$elm_ui$Element$Input$renderPlaceholder = F3(
	function (_v0, forPlaceholder, on) {
		var placeholderAttrs = _v0.a;
		var placeholderEl = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_Utils_ap(
				forPlaceholder,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$Input$charcoal),
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.fv + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.jS)),
							$mdgriffith$elm_ui$Element$clip,
							$mdgriffith$elm_ui$Element$Border$color(
							A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0)),
							$mdgriffith$elm_ui$Element$Background$color(
							A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$alpha(
							on ? 1 : 0)
						]),
					placeholderAttrs)),
			placeholderEl);
	});
var $elm$html$Html$Attributes$spellcheck = $elm$html$Html$Attributes$boolProperty('spellcheck');
var $mdgriffith$elm_ui$Element$Input$spellcheck = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$spellcheck);
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $mdgriffith$elm_ui$Element$Input$value = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$value);
var $mdgriffith$elm_ui$Element$Input$textHelper = F3(
	function (textInput, attrs, textOptions) {
		var withDefaults = _Utils_ap($mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle, attrs);
		var redistributed = A3(
			$mdgriffith$elm_ui$Element$Input$redistribute,
			_Utils_eq(textInput.O, $mdgriffith$elm_ui$Element$Input$TextArea),
			$mdgriffith$elm_ui$Element$Input$isStacked(textOptions.dQ),
			withDefaults);
		var onlySpacing = function (attr) {
			if ((attr.$ === 4) && (attr.b.$ === 5)) {
				var _v9 = attr.b;
				return true;
			} else {
				return false;
			}
		};
		var heightConstrained = function () {
			var _v7 = textInput.O;
			if (!_v7.$) {
				var inputType = _v7.a;
				return false;
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$mdgriffith$elm_ui$Element$Input$isConstrained,
						$elm$core$List$head(
							$elm$core$List$reverse(
								A2($elm$core$List$filterMap, $mdgriffith$elm_ui$Element$Input$getHeight, withDefaults)))));
			}
		}();
		var getPadding = function (attr) {
			if ((attr.$ === 4) && (attr.b.$ === 7)) {
				var cls = attr.a;
				var _v6 = attr.b;
				var pad = _v6.a;
				var t = _v6.b;
				var r = _v6.c;
				var b = _v6.d;
				var l = _v6.e;
				return $elm$core$Maybe$Just(
					{
						hb: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(b - 3)),
						jf: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(l - 3)),
						ku: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(r - 3)),
						lz: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(t - 3))
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var parentPadding = A2(
			$elm$core$Maybe$withDefault,
			{hb: 0, jf: 0, ku: 0, lz: 0},
			$elm$core$List$head(
				$elm$core$List$reverse(
					A2($elm$core$List$filterMap, getPadding, withDefaults))));
		var inputElement = A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			function () {
				var _v3 = textInput.O;
				if (!_v3.$) {
					var inputType = _v3.a;
					return $mdgriffith$elm_ui$Internal$Model$NodeName('input');
				} else {
					return $mdgriffith$elm_ui$Internal$Model$NodeName('textarea');
				}
			}(),
			_Utils_ap(
				function () {
					var _v4 = textInput.O;
					if (!_v4.$) {
						var inputType = _v4.a;
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Internal$Model$Attr(
								$elm$html$Html$Attributes$type_(inputType)),
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.iU)
							]);
					} else {
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Element$clip,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.iQ),
								$mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding(withDefaults),
								$mdgriffith$elm_ui$Element$paddingEach(parentPadding),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								A2(
									$elm$html$Html$Attributes$style,
									'margin',
									$mdgriffith$elm_ui$Element$Input$renderBox(
										$mdgriffith$elm_ui$Element$Input$negateBox(parentPadding)))),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$style, 'box-sizing', 'content-box'))
							]);
					}
				}(),
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Input$value(textOptions.h),
							$mdgriffith$elm_ui$Internal$Model$Attr(
							$elm$html$Html$Events$onInput(textOptions.jF)),
							$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(textOptions.dQ),
							$mdgriffith$elm_ui$Element$Input$spellcheck(textInput.aj),
							A2(
							$elm$core$Maybe$withDefault,
							$mdgriffith$elm_ui$Internal$Model$NoAttribute,
							A2($elm$core$Maybe$map, $mdgriffith$elm_ui$Element$Input$autofill, textInput.ab))
						]),
					redistributed.D)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil));
		var wrappedInput = function () {
			var _v0 = textInput.O;
			if (_v0.$ === 1) {
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					_Utils_ap(
						(heightConstrained ? $elm$core$List$cons($mdgriffith$elm_ui$Element$scrollbarY) : $elm$core$Basics$identity)(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.e$),
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.iT)
								])),
						redistributed.j),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[
								A4(
								$mdgriffith$elm_ui$Internal$Model$element,
								$mdgriffith$elm_ui$Internal$Model$asParagraph,
								$mdgriffith$elm_ui$Internal$Model$div,
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
										A2(
											$elm$core$List$cons,
											$mdgriffith$elm_ui$Element$inFront(inputElement),
											A2(
												$elm$core$List$cons,
												$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.iS),
												redistributed.bB)))),
								$mdgriffith$elm_ui$Internal$Model$Unkeyed(
									function () {
										if (textOptions.h === '') {
											var _v1 = textOptions.aF;
											if (_v1.$ === 1) {
												return _List_fromArray(
													[
														$mdgriffith$elm_ui$Element$text('\u00A0')
													]);
											} else {
												var place = _v1.a;
												return _List_fromArray(
													[
														A3($mdgriffith$elm_ui$Element$Input$renderPlaceholder, place, _List_Nil, textOptions.h === '')
													]);
											}
										} else {
											return _List_fromArray(
												[
													$mdgriffith$elm_ui$Internal$Model$unstyled(
													A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Style$classes.iR)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(textOptions.h + '\u00A0')
															])))
												]);
										}
									}()))
							])));
			} else {
				var inputType = _v0.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						A2(
							$elm$core$List$cons,
							A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.e$),
							$elm$core$List$concat(
								_List_fromArray(
									[
										redistributed.j,
										function () {
										var _v2 = textOptions.aF;
										if (_v2.$ === 1) {
											return _List_Nil;
										} else {
											var place = _v2.a;
											return _List_fromArray(
												[
													$mdgriffith$elm_ui$Element$behindContent(
													A3($mdgriffith$elm_ui$Element$Input$renderPlaceholder, place, redistributed.R, textOptions.h === ''))
												]);
										}
									}()
									])))),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[inputElement])));
			}
		}();
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			A2(
				$elm$core$List$cons,
				A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.hY),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$Input$isHiddenLabel(textOptions.dQ) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Element$spacing(5),
					A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$Region$announce, redistributed.r))),
			textOptions.dQ,
			wrappedInput);
	});
var $mdgriffith$elm_ui$Element$Input$currentPassword = F2(
	function (attrs, pass) {
		return A3(
			$mdgriffith$elm_ui$Element$Input$textHelper,
			{
				ab: $elm$core$Maybe$Just('current-password'),
				aj: false,
				O: $mdgriffith$elm_ui$Element$Input$TextInputNode(
					pass.kL ? 'text' : 'password')
			},
			attrs,
			{dQ: pass.dQ, jF: pass.jF, aF: pass.aF, h: pass.h});
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$runLabel = F2(
	function (context, _v0) {
		var f = _v0;
		return f(context);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$runPlaceholder = F2(
	function (context, _v0) {
		var f = _v0;
		return f(context);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$currentPassword = A2(
	$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
	$mdgriffith$elm_ui$Element$Input$currentPassword,
	F2(
		function (context, config) {
			return {
				dQ: A2($lucamug$elm_ui_with_context$Element$WithContext$Input$runLabel, context, config.dQ),
				jF: config.jF,
				aF: A2(
					$elm$core$Maybe$map,
					$lucamug$elm_ui_with_context$Element$WithContext$Input$runPlaceholder(context),
					config.aF),
				kL: config.kL,
				h: config.h
			};
		}));
var $mdgriffith$elm_ui$Element$Input$email = $mdgriffith$elm_ui$Element$Input$textHelper(
	{
		ab: $elm$core$Maybe$Just('email'),
		aj: false,
		O: $mdgriffith$elm_ui$Element$Input$TextInputNode('email')
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$textHelper = function (f) {
	return A2(
		$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
		f,
		F2(
			function (context, config) {
				return {
					dQ: A2($lucamug$elm_ui_with_context$Element$WithContext$Input$runLabel, context, config.dQ),
					jF: config.jF,
					aF: A2(
						$elm$core$Maybe$map,
						$lucamug$elm_ui_with_context$Element$WithContext$Input$runPlaceholder(context),
						config.aF),
					h: config.h
				};
			}));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Input$email = $lucamug$elm_ui_with_context$Element$WithContext$Input$textHelper($mdgriffith$elm_ui$Element$Input$email);
var $author$project$TT$Font$formLabel = A3($author$project$TT$Font$mainRegular, $author$project$TT$Color$text, 5, 0.5);
var $author$project$TT$Font$formLabelSmall = A3($author$project$TT$Font$mainMedium, $author$project$TT$Color$text, 4, 0.25);
var $author$project$TT$Font$formHelperText = A3($author$project$TT$Font$mainMedium, $author$project$TT$Color$gray1, 3, 0.25);
var $author$project$TT$FormField$helperTextBuilder = F2(
	function (helperText, inputState) {
		if (!helperText.$) {
			var helperTextValue = helperText.a;
			var successTextAttr = _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$success)
				]);
			var onErrorTextAttr = _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$error)
				]);
			var defaultTextAttr = _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$gray1)
				]);
			var textAttr = function () {
				switch (inputState) {
					case 0:
						return defaultTextAttr;
					case 1:
						return successTextAttr;
					case 2:
						return onErrorTextAttr;
					default:
						return defaultTextAttr;
				}
			}();
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
				_Utils_ap($author$project$TT$Font$formHelperText, textAttr),
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$text(helperTextValue)
					]));
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$none;
		}
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$Label = $elm$core$Basics$identity;
var $lucamug$elm_ui_with_context$Element$WithContext$Input$buildLabel = F3(
	function (f, attrs, child) {
		return function (context) {
			return A2(
				f,
				A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$attributes, context, attrs),
				A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$run, context, child));
		};
	});
var $mdgriffith$elm_ui$Element$Input$Above = 2;
var $mdgriffith$elm_ui$Element$Input$Label = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Element$Input$labelAbove = $mdgriffith$elm_ui$Element$Input$Label(2);
var $lucamug$elm_ui_with_context$Element$WithContext$Input$labelAbove = $lucamug$elm_ui_with_context$Element$WithContext$Input$buildLabel($mdgriffith$elm_ui$Element$Input$labelAbove);
var $mdgriffith$elm_ui$Element$Input$HiddenLabel = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Element$Input$labelHidden = $mdgriffith$elm_ui$Element$Input$HiddenLabel;
var $lucamug$elm_ui_with_context$Element$WithContext$Input$labelHidden = function (content) {
	return function (_v0) {
		return $mdgriffith$elm_ui$Element$Input$labelHidden(content);
	};
};
var $mdgriffith$elm_ui$Internal$Model$MoveX = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$moveX = $mdgriffith$elm_ui$Internal$Flag$flag(25);
var $mdgriffith$elm_ui$Element$moveLeft = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveX,
		$mdgriffith$elm_ui$Internal$Model$MoveX(-x));
};
var $lucamug$elm_ui_with_context$Element$WithContext$moveLeft = function (x) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attr(
		$mdgriffith$elm_ui$Element$moveLeft(x));
};
var $mdgriffith$elm_ui$Element$Input$multiline = F2(
	function (attrs, multi) {
		return A3(
			$mdgriffith$elm_ui$Element$Input$textHelper,
			{ab: $elm$core$Maybe$Nothing, aj: multi.kX, O: $mdgriffith$elm_ui$Element$Input$TextArea},
			attrs,
			{dQ: multi.dQ, jF: multi.jF, aF: multi.aF, h: multi.h});
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$multiline = A2(
	$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
	$mdgriffith$elm_ui$Element$Input$multiline,
	F2(
		function (context, config) {
			return {
				dQ: A2($lucamug$elm_ui_with_context$Element$WithContext$Input$runLabel, context, config.dQ),
				jF: config.jF,
				aF: A2(
					$elm$core$Maybe$map,
					$lucamug$elm_ui_with_context$Element$WithContext$Input$runPlaceholder(context),
					config.aF),
				kX: config.kX,
				h: config.h
			};
		}));
var $lucamug$elm_ui_with_context$Element$WithContext$Input$Placeholder = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Element$Input$Placeholder = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$Input$placeholder = $mdgriffith$elm_ui$Element$Input$Placeholder;
var $lucamug$elm_ui_with_context$Element$WithContext$Input$placeholder = F2(
	function (attrs, child) {
		return function (context) {
			return A2(
				$mdgriffith$elm_ui$Element$Input$placeholder,
				A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$attributes, context, attrs),
				A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$run, context, child));
		};
	});
var $author$project$TT$FormField$sizeValueChooser = F3(
	function (size, valueForSmall, valueForNormal) {
		if (size === 1) {
			return valueForSmall;
		} else {
			return valueForNormal;
		}
	});
var $mdgriffith$elm_ui$Element$Input$text = $mdgriffith$elm_ui$Element$Input$textHelper(
	{
		ab: $elm$core$Maybe$Nothing,
		aj: false,
		O: $mdgriffith$elm_ui$Element$Input$TextInputNode('text')
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$text = $lucamug$elm_ui_with_context$Element$WithContext$Input$textHelper($mdgriffith$elm_ui$Element$Input$text);
var $author$project$TT$FormField$render = function (_v0) {
	var options = _v0.a;
	var onChangeMsg = _v0.b;
	var value = _v0.c;
	var labelText = _v0.d;
	var placeholder = A2(
		$elm$core$Maybe$map,
		function (pl) {
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$Input$placeholder,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$gray2)
					]),
				pl);
		},
		options.aF);
	var labelAttrs = _Utils_ap(
		A2(
			$elm$core$List$cons,
			$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
			A3($author$project$TT$FormField$sizeValueChooser, options.kQ, $author$project$TT$Font$formLabelSmall, $author$project$TT$Font$formLabel)),
		options.cQ);
	var labelEl = function () {
		var _v13 = options.cS;
		if (!_v13) {
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$Input$labelAbove,
				labelAttrs,
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
					_List_Nil,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$html(
							A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(labelText)
									])))
						])));
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$Input$labelHidden(labelText);
		}
	}();
	var inputFieldYPadding = A3($author$project$TT$FormField$sizeValueChooser, options.kQ, 8, 12);
	var inputFieldXPadding = A3($author$project$TT$FormField$sizeValueChooser, options.kQ, 8, 12);
	var inputFieldIconSize = A3($author$project$TT$FormField$sizeValueChooser, options.kQ, 22, 24);
	var leadingIconView = function () {
		var _v12 = options.bo;
		if (!_v12.$) {
			var icon = _v12.a;
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$centerY,
								$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
								{hb: 0, jf: inputFieldXPadding, ku: 0, lz: 0})
							]),
						$author$project$TT$IT$render(
							A2($author$project$TT$IT$withSize, inputFieldIconSize, icon))))
				]);
		} else {
			return _List_Nil;
		}
	}();
	var trailingIconView = function () {
		var _v11 = options.bx;
		if (!_v11.$) {
			var trailingIcon = _v11.a;
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'left', '100%')),
								$lucamug$elm_ui_with_context$Element$WithContext$centerY,
								$lucamug$elm_ui_with_context$Element$WithContext$moveLeft(inputFieldIconSize + inputFieldXPadding),
								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(trailingIcon.jG),
								$lucamug$elm_ui_with_context$Element$WithContext$pointer
							]),
						$author$project$TT$IT$render(
							A2($author$project$TT$IT$withSize, inputFieldIconSize, trailingIcon.iI))))
				]);
		} else {
			return _List_Nil;
		}
	}();
	var borderAttrs = function () {
		var baseBorderAttrs = function () {
			var _v9 = options.aw;
			var _v10 = options.av;
			switch (_v10) {
				case 0:
					return _List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$gray3)
						]);
				case 1:
					return _List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$success)
						]);
				case 2:
					return _List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$error)
						]);
				default:
					return _List_Nil;
			}
		}();
		return baseBorderAttrs;
	}();
	var fieldAttrs = function () {
		var inputHeight = function () {
			var _v8 = options.fb;
			switch (_v8) {
				case 0:
					return A3($author$project$TT$FormField$sizeValueChooser, options.kQ, 36, 44);
				case 1:
					return A3($author$project$TT$FormField$sizeValueChooser, options.kQ, 36, 44);
				case 3:
					return A3($author$project$TT$FormField$sizeValueChooser, options.kQ, 36, 44);
				default:
					return A3($author$project$TT$FormField$sizeValueChooser, options.kQ, 120, 124);
			}
		}();
		var fieldPadding = function () {
			var inputPaddingXWhenIcon = (inputFieldIconSize + inputFieldXPadding) + 8;
			var _v3 = _Utils_Tuple2(options.bo, options.bx);
			if (!_v3.a.$) {
				if (_v3.b.$ === 1) {
					var _v4 = _v3.b;
					return _List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
							{hb: inputFieldYPadding - 1, jf: inputPaddingXWhenIcon, ku: inputFieldXPadding, lz: inputFieldYPadding + 1})
						]);
				} else {
					return _List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
							{hb: inputFieldYPadding, jf: inputPaddingXWhenIcon, ku: inputPaddingXWhenIcon, lz: inputFieldYPadding})
						]);
				}
			} else {
				if (!_v3.b.$) {
					var _v5 = _v3.a;
					return _List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
							{hb: inputFieldYPadding - 1, jf: inputFieldXPadding, ku: inputPaddingXWhenIcon, lz: inputFieldYPadding + 1})
						]);
				} else {
					var _v6 = _v3.a;
					var _v7 = _v3.b;
					return _List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
							{hb: inputFieldYPadding - 1, jf: inputFieldXPadding, ku: inputFieldXPadding, lz: inputFieldYPadding + 1})
						]);
				}
			}
		}();
		var baseFieldAttrs = function () {
			var _v2 = options.aw;
			return _Utils_ap(
				$author$project$TT$Font$body2,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(4),
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						$lucamug$elm_ui_with_context$Element$WithContext$px(inputHeight)),
						$lucamug$elm_ui_with_context$Element$WithContext$centerY
					]));
		}();
		return _Utils_ap(
			baseFieldAttrs,
			_Utils_ap(
				fieldPadding,
				_Utils_ap(
					borderAttrs,
					_Utils_ap(
						options.bN,
						_Utils_ap(leadingIconView, trailingIconView)))));
	}();
	var elementInputType = function () {
		var _v1 = options.fb;
		switch (_v1) {
			case 0:
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$Input$text,
					fieldAttrs,
					{dQ: labelEl, jF: onChangeMsg, aF: placeholder, h: value});
			case 1:
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$Input$email,
					fieldAttrs,
					{dQ: labelEl, jF: onChangeMsg, aF: placeholder, h: value});
			case 3:
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$Input$currentPassword,
					fieldAttrs,
					{dQ: labelEl, jF: onChangeMsg, aF: placeholder, kL: false, h: value});
			default:
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$Input$multiline,
					fieldAttrs,
					{dQ: labelEl, jF: onChangeMsg, aF: placeholder, kX: false, h: value});
		}
	}();
	return A2(
		$lucamug$elm_ui_with_context$Element$WithContext$column,
		_Utils_ap(
			options.dh,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(4)
				])),
		_List_fromArray(
			[
				elementInputType,
				A2($author$project$TT$FormField$helperTextBuilder, options.cL, options.av)
			]));
};
var $author$project$Page$Home$MsgUserClosedCandidateInfoLoadedMessage = {$: 72};
var $author$project$TT$IT$closeOutlined = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'closeOutlined',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM15 9l-6 6M9 9l6 6'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_Nil)
			]));
};
var $mdgriffith$elm_ui$Element$moveRight = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveX,
		$mdgriffith$elm_ui$Internal$Model$MoveX(x));
};
var $lucamug$elm_ui_with_context$Element$WithContext$moveRight = function (x) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attr(
		$mdgriffith$elm_ui$Element$moveRight(x));
};
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $elm$svg$Svg$Attributes$opacity = _VirtualDom_attribute('opacity');
var $elm$svg$Svg$Attributes$strokeMiterlimit = _VirtualDom_attribute('stroke-miterlimit');
var $author$project$TT$VectorImage$talentino = function (size) {
	return $lucamug$elm_ui_with_context$Element$WithContext$html(
		A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 112 150'),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromFloat(size)),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat(size)),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$clipPath('url(#a)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M-18.504 78.168a29.28 29.28 0 0 1-.744 4.988 53.445 53.445 0 0 0 10.839 1.44 45.34 45.34 0 0 0 11.16-1.293L5.63 63.167l-4.077-1.92s-11.037-6.752-23.696 3.538a11.49 11.49 0 0 1 2.146 3.172 16.686 16.686 0 0 1 1.376 4.962c.217 1.741.256 3.5.117 5.25Z'),
									$elm$svg$Svg$Attributes$fill('#8EB700')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M74.725 110.685s3.908-7.409 3.26-18.314c0 0-8.667 8.687-3.26 18.314Z'),
									$elm$svg$Svg$Attributes$fill('#204156')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M101.467 106.208a5.714 5.714 0 0 1-1.73 3.188 5.488 5.488 0 0 1-3.269 1.451 4.155 4.155 0 0 0 1.682 1.388 1.557 1.557 0 0 0 1.391-.104c12.551-7.472 18.61-29.783 20.526-38.356h-.076c-1.995.615-4.106.72-6.15.305a12.615 12.615 0 0 1-5.571-2.684l-2.13 6.052c2.084 1.597 4.729 3.032 7.42 2.901 0 0-4.892 15.79-7.374 20.162l-4.663 3.61a5.49 5.49 0 0 1-.056 2.087Z'),
									$elm$svg$Svg$Attributes$fill('#BAD600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M93.202 106.73c.38.406.87.687 1.407.808a2.714 2.714 0 0 0 1.608-.129 2.792 2.792 0 0 0 1.267-1.022 2.894 2.894 0 0 0 .06-3.16 2.794 2.794 0 0 0-1.227-1.072 2.706 2.706 0 0 0-1.602-.193c-.54.099-1.04.36-1.436.751a2.839 2.839 0 0 0-.622.908 2.894 2.894 0 0 0-.041 2.176c.133.348.332.665.586.933Z'),
									$elm$svg$Svg$Attributes$fill('#0072A5')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M73.608 106.913 91.296 109a4.437 4.437 0 0 1-.382-.365 5.85 5.85 0 0 1-1.575-3.653h-.06l-15.187-3.177-.178-.042a16.746 16.746 0 0 0-.306 5.15Z'),
									$elm$svg$Svg$Attributes$fill('#BAD600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M96.468 110.831a5.476 5.476 0 0 0 3.268-1.451 5.712 5.712 0 0 0 1.731-3.187 5.49 5.49 0 0 0 .056-2.087c-.407-2.401-2.39-3.851-3.23-4.362a7.042 7.042 0 0 0-.378-.214v.031c.45.264.86.593 1.218.976a5.902 5.902 0 0 1 1.59 4.151 5.892 5.892 0 0 1-1.742 4.087 5.564 5.564 0 0 1-2.864 1.514c.102.198.224.37.351.542Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m106.161 77.417-7.807 22.217-.061.11c.84.521 2.823 1.962 3.231 4.362l4.673-3.637c2.481-4.372 7.373-20.161 7.373-20.161-2.68.14-5.335-1.294-7.409-2.891Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M106.161 77.417a26.33 26.33 0 0 1-4.23-4.101l-.428-.146-5.64 16.696v8.949a5.1 5.1 0 0 1 2.038.736v-.032s.142.073.377.214l.06-.11 7.823-22.206Z'),
									$elm$svg$Svg$Attributes$fill('#146823')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M97.131 106.829c-.395.39-.895.652-1.436.751-.54.1-1.097.033-1.6-.192a2.798 2.798 0 0 1-1.228-1.07 2.894 2.894 0 0 1 .056-3.159 2.79 2.79 0 0 1 1.264-1.024 2.711 2.711 0 0 1 1.607-.132 2.76 2.76 0 0 1 1.408.803 2.886 2.886 0 0 1-.071 4.023Zm-6.064-6.449a5.896 5.896 0 0 0-1.74 4.085 5.907 5.907 0 0 0 1.587 4.149c.12.129.248.251.382.365a5.482 5.482 0 0 0 2.37 1.252 5.31 5.31 0 0 0 2.43.058 5.563 5.563 0 0 0 2.864-1.514 5.896 5.896 0 0 0 1.743-4.087 5.906 5.906 0 0 0-1.59-4.151 5.455 5.455 0 0 0-1.218-.976 5.098 5.098 0 0 0-2.038-.736 5.477 5.477 0 0 0-2.188.096c-.716.18-1.391.501-1.985.948a4.923 4.923 0 0 0-.617.511Z'),
									$elm$svg$Svg$Attributes$fill('#BAD600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M111.833 69.684a10.05 10.05 0 0 1-2.416-1.466l-.051.057-1.075 3.069a12.615 12.615 0 0 0 5.571 2.683 12.45 12.45 0 0 0 6.149-.304h.077c.469-2.124.693-3.407.693-3.407-2.213.46-4.492.475-6.711.047a10.886 10.886 0 0 1-2.237-.679Z'),
									$elm$svg$Svg$Attributes$fill('#437B00')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m91.653 99.8-16.124-3.025a25.99 25.99 0 0 0-1.605 4.988l.179.042 15.175 3.167h.061a5.934 5.934 0 0 1 .364-2.496 5.812 5.812 0 0 1 1.364-2.101c.193-.191.4-.366.622-.522l-.036-.052Z'),
									$elm$svg$Svg$Attributes$fill('#4B9600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M120.76 70.352a20.089 20.089 0 0 0-4.03-4.67l-.057-.177c-.331.1-.673.16-1.019.177v.032l-1.6 4.695c2.218.425 4.496.406 6.706-.057Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m106.161 77.417 2.13-6.052a17.93 17.93 0 0 1-4.418-5.218l-2.37 7.033.428.146a26.324 26.324 0 0 0 4.23 4.091Z'),
									$elm$svg$Svg$Attributes$fill('#8EB700')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m119.538 63.595.891.324a1.137 1.137 0 0 0-.234-1.205.181.181 0 0 0-.066-.058 5.272 5.272 0 0 1-.591.94Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M118.936 64.602c.287.11.604.101.884-.027a1.18 1.18 0 0 0 .609-.656l-.892-.324a4.25 4.25 0 0 1-.479.522c-.13.128-.268.248-.412.36l.29.125ZM120.21 62.484c.223-.013.438-.09.618-.225.181-.134.32-.319.401-.532l-.688-.25a4.797 4.797 0 0 1-.331 1.007Z'),
									$elm$svg$Svg$Attributes$fill('#8EB700')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M120.128 62.656a.578.578 0 0 0 .082-.172c-.15.009-.3-.01-.443-.058a.801.801 0 0 1 .361.23Z'),
									$elm$svg$Svg$Attributes$fill('#4B9600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m120.557 61.477-3.766-1.383 1.529 1.81 1.095.402.332.12c.143.047.293.067.443.058.159-.32.283-.658.367-1.007Z'),
									$elm$svg$Svg$Attributes$fill('#8EB700')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M121.005 60.512a1.018 1.018 0 0 0-.275-.21 4.9 4.9 0 0 1-.173 1.175l.688.25c.077-.205.095-.428.053-.643a1.158 1.158 0 0 0-.293-.572Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M75.53 96.775a29.383 29.383 0 0 1 2.328-4.451 54.3 54.3 0 0 0-9.748-5.056 45.57 45.57 0 0 0-10.93-2.609l-9.275 17.996 3.2 3.199s8.21 10.153 23.497 4.779a11.592 11.592 0 0 1-.984-3.72 16.747 16.747 0 0 1 .316-5.15 26.02 26.02 0 0 1 1.595-4.988ZM118.365 61.93l1.076.376-1.101-.401.025.026Z'),
									$elm$svg$Svg$Attributes$fill('#8EB700')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M115.649 65.682a5.433 5.433 0 0 1-2.379-.35l-1.437 4.352c.713.31 1.456.543 2.216.694l1.6-4.696Z'),
									$elm$svg$Svg$Attributes$fill('#4B9600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M120.735 60.052c.206-.03.402-.113.567-.243a1.24 1.24 0 0 0 .376-.498l-1.055-.407c.075.378.113.763.112 1.148Z'),
									$elm$svg$Svg$Attributes$fill('#8EB700')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m120.623 58.904 1.055.407c.085-.202.11-.426.071-.643a1.139 1.139 0 0 0-.285-.578 1.019 1.019 0 0 0-.449-.281l-.866-.334c.214.455.374.935.474 1.43Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M118.365 61.93h-.025l-4.377-1.617a2.867 2.867 0 0 0-.622-.26c.317.215.66.39 1.019.521l4.005 1.357Z'),
									$elm$svg$Svg$Attributes$fill('#8EB700')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m116.791 60.094-1.391-1.617-2.263.276 3.654 1.341Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M119.12 55.993a5.65 5.65 0 0 0-3.848-1.8l-.733 1.137c.247.067.485.165.708.293l4.902 1.852a6.134 6.134 0 0 0-1.029-1.482ZM111.114 63.882a6.686 6.686 0 0 1-.795-1.043l-1.254 5.103c.11.11.229.21.357.297a10.053 10.053 0 0 0 2.416 1.466l1.437-4.372a5.717 5.717 0 0 1-2.161-1.45Z'),
									$elm$svg$Svg$Attributes$fill('#C9C918')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M109.06 67.942a11.972 11.972 0 0 1-3.659-6.33l-1.528 4.524a17.913 17.913 0 0 0 4.418 5.218l1.075-3.068.051-.058a2.381 2.381 0 0 1-.357-.286Z'),
									$elm$svg$Svg$Attributes$fill('#4B9600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M109.973 62.124a15.688 15.688 0 0 0-4.587-.522 11.972 11.972 0 0 0 3.659 6.33l1.254-5.104a4.924 4.924 0 0 1-.326-.704Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M111.771 60.647c-.509 1.341 1.779 2.087 1.779 2.087l5.096 1.79c.144-.112.282-.232.412-.36a4.25 4.25 0 0 0 .479-.522l-7.643-2.807-.123-.188Z'),
									$elm$svg$Svg$Attributes$fill('#8EB700')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m111.909 60.814 7.644 2.807c.229-.29.427-.605.591-.939a.8.8 0 0 0-.362-.23l-.331-.12-1.07-.375-4.031-1.43a4.613 4.613 0 0 1-1.019-.522c-.54-.161-1.269-.198-1.57.621l.148.188Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m116.791 60.094-3.659-1.367-.622.078c.032.255.124.497.269.706.145.21.338.38.562.494.216.062.425.15.622.261l4.377 1.618-1.549-1.79Z'),
									$elm$svg$Svg$Attributes$fill('#8EB700')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m112.51 58.826-2.925.355h-.056a5.891 5.891 0 0 0 .444 2.948c.097.245.212.483.346.71.231.374.497.723.795 1.043a5.723 5.723 0 0 0 2.156 1.45 5.433 5.433 0 0 0 2.379.35 4.266 4.266 0 0 0 1.02-.177 5.222 5.222 0 0 0 1.972-1.002l-5.096-1.79s-2.278-.725-1.779-2.087c.301-.819 1.02-.782 1.57-.62a1.535 1.535 0 0 1-.554-.486 1.591 1.591 0 0 1-.272-.694Z'),
									$elm$svg$Svg$Attributes$fill('#4B9600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m113.132 58.727 2.268-.276 1.391 1.622 3.766 1.383c.105-.383.163-.777.173-1.174l-.153-.068-5.794-2.129s-1.707-1.002-2.196.35a.913.913 0 0 0-.072.376l.617-.084Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M113.015 56.05c-.367 1.284 1.793 1.988 1.793 1.988l5.361 1.941c.18.07.374.095.566.073 0-.385-.037-.77-.112-1.148l-7.501-2.822-.107-.032Z'),
									$elm$svg$Svg$Attributes$fill('#8EB700')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m113.122 56.082 7.501 2.822c-.1-.494-.26-.974-.474-1.43l-4.902-1.851a3.038 3.038 0 0 0-.709-.293 1.077 1.077 0 0 0-1.247.24 1.13 1.13 0 0 0-.241.386c0 .032-.025.068-.035.094l.107.032Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m117.28 48.886-3.949 5.568a5.133 5.133 0 0 1 1.967-.261l2.267-3.465a1.33 1.33 0 0 0-.091-1.695 1.182 1.182 0 0 0-.194-.147Z'),
									$elm$svg$Svg$Attributes$fill('#8EB700')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M114.809 58.038s-2.161-.704-1.794-1.988c0-.026 0-.062.036-.094a1.127 1.127 0 0 1 .611-.644 1.076 1.076 0 0 1 .877.018l.733-1.137a5.135 5.135 0 0 0-1.967.26 5.351 5.351 0 0 0-2.843 2.14.295.295 0 0 0-.041.073 5.702 5.702 0 0 0-.892 2.51h.056l2.925-.355a.912.912 0 0 1 .072-.376c.509-1.351 2.196-.35 2.196-.35l5.794 2.13.153.067a2.006 2.006 0 0 0 0-.245 1.188 1.188 0 0 1-.566-.073l-5.35-1.936Z'),
									$elm$svg$Svg$Attributes$fill('#C9C918')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m113.331 54.454 3.975-5.568a1.237 1.237 0 0 0-1.432-.072 1.28 1.28 0 0 0-.367.354l-5.02 7.425a5.354 5.354 0 0 1 2.844-2.14Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M74.74 110.727s-3.944-6.063 3.19-18.346l-3.119-2.014s-6.655 10.436-3.506 21.304l3.435-.944Z'),
									$elm$svg$Svg$Attributes$fill('#006385')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m101.36 103.98 4.816-3.558s2.818-5.74 7.302-20.088c0 0-5.473.579-12.011-7.227l.174-.464s6.349 7.753 12.49 7.305c0 0-2.874 11.348-7.644 20.87l-5.04 3.825'),
									$elm$svg$Svg$Attributes$fill('#183443')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m46.657 12.77.025-.074s-10.35-4.889-14.549-9.532l-.25-.183c-1.864 1.69-3.25 3.845-4.473 5.599-2.788 3.996-13.392 20.025-19.064 35.48-1.478 4.05-.194 7.743 2.44 10.957C17.514 63.261 32.98 68.37 32.98 68.37a142.987 142.987 0 0 0 16.17 5.265c2.079-2.927 2.42-6.992 2.476-8.213-10.655-2.165-24.924-6.856-34.254-17.13 0 0 9.519-23.912 12.984-27.476 0 0 15.14-4.43 31.085 5.275 1.187-2.718 1.019-7.748 1.019-7.748l.035-.125a98.494 98.494 0 0 1-15.837-5.448ZM8.952 60.13C1.06 64.666-1.535 77.35-10.254 103.298c-3.124 9.303-5.05 18.742-5.565 27.268a100.576 100.576 0 0 0 11.868 7.096C3.53 100.714 20.683 68.849 21.33 67.649A96.459 96.459 0 0 1 9.1 59.948l-.148.183Z'),
									$elm$svg$Svg$Attributes$fill('#BAD600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M21.33 67.65a106.56 106.56 0 0 0 25.907 9.584c3.42.81 6.887 1.39 10.38 1.738h.062l1.814-4.425c-2.676.82-5.983.24-10.345-.944a142.987 142.987 0 0 1-16.169-5.265S17.513 63.23 10.787 54.986l-1.738 4.9c.014.015.03.029.046.041A96.46 96.46 0 0 0 21.33 67.65Z'),
									$elm$svg$Svg$Attributes$fill('url(#b)')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M32.133 3.163c4.2 4.644 14.55 9.533 14.55 9.533l-.026.073a98.492 98.492 0 0 0 15.848 5.437c2.91.752 6.069 1.461 9.504 2.087a17.122 17.122 0 0 0-4.587-9.125s-5.957.6-14.125-2.296A47.819 47.819 0 0 1 38.203.137a10.281 10.281 0 0 0-6.32 2.844l.25.182Z'),
									$elm$svg$Svg$Attributes$fill('#568900')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M61.44 26.08c-15.945-9.705-31.085-5.275-31.085-5.275C26.89 24.368 17.37 48.28 17.37 48.28c9.32 10.284 23.588 14.975 34.254 17.114A90.173 90.173 0 0 0 66 67.185a47.165 47.165 0 0 0 1.789-5.155c2.843-9.658 3.567-19.436 3.94-27.498a48.44 48.44 0 0 0-10.29-8.452Z'),
									$elm$svg$Svg$Attributes$fill('#5FA600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M21.33 67.65c-.647 1.2-17.8 33.064-25.28 70.011a85.618 85.618 0 0 0 21.937 7.79c19.242-25.797 28.42-65.68 28.42-65.68l.83-2.537A106.56 106.56 0 0 1 21.33 67.65Z'),
									$elm$svg$Svg$Attributes$fill('#BAD600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M-4.45 140.176a184.442 184.442 0 0 0-1.819 11.573 84.569 84.569 0 0 0 13.87 5.097 68.842 68.842 0 0 0 8.95-9.532 79.18 79.18 0 0 1-21-7.138Z'),
									$elm$svg$Svg$Attributes$fill('#EAE333')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M-6.269 151.749a159.314 159.314 0 0 0-.785 8.051 13.783 13.783 0 0 0 3.267 1.701c1.21.433 2.471.707 3.75.814a47.458 47.458 0 0 0 7.644-5.469 84.62 84.62 0 0 1-13.876-5.097Z'),
									$elm$svg$Svg$Attributes$fill('#0072A5')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m51.279 3.315 2.038 5.447-.041.11c8.153 2.87 14.141 2.3 14.141 2.3a14.167 14.167 0 0 0-2.252-1.904c-1.906-1.294-7.761-3.82-13.902-5.974l.016.02Z'),
									$elm$svg$Svg$Attributes$fill('#006385')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M16.887 146.907a78.207 78.207 0 0 1-21.23-7.305c-.03.198-.066.391-.107.589a79.181 79.181 0 0 0 21 7.138l.337-.422Z'),
									$elm$svg$Svg$Attributes$fill('#E3DE60')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M38.203.137a47.82 47.82 0 0 0 15.094 8.735l.04-.11L51.3 3.315c-3.134-1.096-6.334-2.087-9.132-2.776a12.484 12.484 0 0 0-3.964-.402Z'),
									$elm$svg$Svg$Attributes$fill('#0072A5')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M16.902 146.87a81.803 81.803 0 0 1-21.204-7.477.677.677 0 0 1-.04.193 78.207 78.207 0 0 0 21.229 7.305s.01.016.015-.021Z'),
									$elm$svg$Svg$Attributes$fill('#E3DE60')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M-4.052 138.12a84.128 84.128 0 0 0 21.718 7.743c.107-.136.21-.282.321-.417a85.694 85.694 0 0 1-21.937-7.79l-.102.464Z'),
									$elm$svg$Svg$Attributes$fill('#006840')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M17.666 145.863a84.135 84.135 0 0 1-21.719-7.748c-.081.428-.163.85-.25 1.273a81.84 81.84 0 0 0 21.205 7.477c.26-.329.51-.663.764-1.002Z'),
									$elm$svg$Svg$Attributes$fill('#006840')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M7.602 156.846a47.458 47.458 0 0 1-7.644 5.469c4.418.381 9.142-1.133 13.942-4.065l-.046-.078a49.126 49.126 0 0 1-6.252-1.326Z'),
									$elm$svg$Svg$Attributes$fill('#006385')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m62.505 18.206-.036.125s.158 5.03-1.02 7.749a48.443 48.443 0 0 1 10.3 8.463c.178-3.449.285-6.58.473-9.261a21.264 21.264 0 0 0-.214-4.983 139.002 139.002 0 0 1-9.503-2.093Z'),
									$elm$svg$Svg$Attributes$fill('#5FA600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M16.886 146.907c.357.057.709.125 1.065.177-.341-.068-.688-.12-1.05-.193-.005.016-.005.016-.015.016Z'),
									$elm$svg$Svg$Attributes$fill('#E3DE60')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M17.951 147.063c.08.018.163.03.245.037 2.564.428 5.15.699 7.746.814h.259c.082-.094.179-.193.27-.292l.046-.047.51-.621a49.402 49.402 0 0 1-9.376-1.096l-.765 1.002c.377.083.724.135 1.065.203Z'),
									$elm$svg$Svg$Attributes$fill('#006840')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M59.493 74.552c2.66-.814 4.704-3 6.528-7.357a90.173 90.173 0 0 1-14.376-1.79c-.056 1.222-.397 5.286-2.476 8.213 4.342 1.174 7.649 1.754 10.324.934Z'),
									$elm$svg$Svg$Attributes$fill('#5FA600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M25.942 147.914a64.336 64.336 0 0 1-7.746-.814 47.98 47.98 0 0 0 7.746.814Z'),
									$elm$svg$Svg$Attributes$fill('#0051AA')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M25.942 147.914a47.98 47.98 0 0 1-7.746-.814 1.835 1.835 0 0 1-.244-.037c-.357-.052-.709-.12-1.065-.177l-.337.428c3.032.566 6.095.932 9.173 1.095l.459-.49h-.22l-.02-.005Z'),
									$elm$svg$Svg$Attributes$fill('#E3DE60')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M25.682 148.409a70.204 70.204 0 0 1-9.173-1.095 68.845 68.845 0 0 1-8.948 9.532 49.179 49.179 0 0 0 6.268 1.326l.046.078c4.076-2.505 8.24-6.047 12.286-10.326h-.04l-.44.485Z'),
									$elm$svg$Svg$Attributes$fill('#C1BB2A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M26.472 147.632c-.092.099-.189.198-.27.292l.27-.292Z'),
									$elm$svg$Svg$Attributes$fill('#607B00')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m27.042 146.964-.51.621c.184-.204.378-.402.561-.616l-.05-.005Z'),
									$elm$svg$Svg$Attributes$fill('#0051AA')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m27.389 146.557-.347.407h.036c5.962-6.475 11.675-14.526 16.679-23.214 13.759-23.897 13.855-44.71 13.855-44.71v-.073a78.89 78.89 0 0 1-10.38-1.738l-.83 2.536s-9.173 39.884-28.42 65.681a48.599 48.599 0 0 0 9.407 1.111Z'),
									$elm$svg$Svg$Attributes$fill('#5FA600')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M27.389 146.557a48.545 48.545 0 0 1-9.402-1.106c-.112.136-.214.282-.321.417a49.402 49.402 0 0 0 9.376 1.096l.347-.407Z'),
									$elm$svg$Svg$Attributes$fill('#006840')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M71.845 34.485S57.011 15.576 30.268 20.56c0 0-4.199 3.825-13.086 27.654 0 0 11.924 16.634 48.874 18.935l.587-1.523s-30.983-1.232-47.774-17.74c0 0 8.067-20.548 12.26-25.672 0 0 22.555-6.37 40.518 14.234l.198-1.962Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M71.86 34.506S57.95 15.331 30.34 20.251c0 0-4.775 5.004-13.25 27.92 0 0 10.905 16.546 48.87 19.155l.25-.574S32.066 65.427 17.528 48.01c0 0 7.373-19.671 13.025-27.132 0 0 23.44-5.886 41.25 14.181l.057-.553Z'),
									$elm$svg$Svg$Attributes$fill('#D3D354')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M57.547 78.977s-24.65-1.8-48.488-19.024a14.405 14.405 0 0 0-2.833 2.244S27.72 79.598 57.424 81.71c.094-.908.135-1.82.123-2.734Z'),
									$elm$svg$Svg$Attributes$fill('#008209'),
									$elm$svg$Svg$Attributes$style('mix-blend-mode:multiply'),
									$elm$svg$Svg$Attributes$opacity('.31')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M59.63 74.678s-2.797.6-4.887.172a129.31 129.31 0 0 1-34.651-12.32s-6.498-3.834-9.132-7.403l-.918 2.42s4.74 5.881 24.231 13.202c19.492 7.32 24.532 5.718 24.532 5.718l.825-1.79Z'),
									$elm$svg$Svg$Attributes$fill('#08551A'),
									$elm$svg$Svg$Attributes$style('mix-blend-mode:multiply'),
									$elm$svg$Svg$Attributes$opacity('.67')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M57.684 78.977S32.53 77.161 9.059 59.953'),
									$elm$svg$Svg$Attributes$stroke('#08551A'),
									$elm$svg$Svg$Attributes$strokeWidth('.5'),
									$elm$svg$Svg$Attributes$strokeMiterlimit('10')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M28.423 145.117s-19.96.224-44.155-16.368l-.087 1.774s18.157 14.808 43.055 15.956l1.187-1.362Z'),
									$elm$svg$Svg$Attributes$fill('#34B4C5'),
									$elm$svg$Svg$Attributes$style('mix-blend-mode:soft-light')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M71.845 34.485S57.011 15.576 30.268 20.56c0 0-4.199 3.825-13.086 27.654 0 0 11.924 16.634 48.874 18.935l.587-1.523s-30.983-1.232-47.774-17.74c0 0 8.067-20.548 12.26-25.672 0 0 22.555-6.37 40.518 14.234l.198-1.962Z'),
									$elm$svg$Svg$Attributes$fill('#08551A')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M71.86 34.506S57.95 15.331 30.34 20.251c0 0-4.775 5.004-13.25 27.92 0 0 10.905 16.546 48.87 19.155l.25-.574S32.066 65.427 17.528 48.01c0 0 7.373-19.671 13.025-27.132 0 0 23.44-5.886 41.25 14.181l.057-.553Z'),
									$elm$svg$Svg$Attributes$fill('#D3D354')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M57.547 78.977s-24.65-1.8-48.488-19.024a14.405 14.405 0 0 0-2.833 2.244S27.72 79.598 57.424 81.71c.094-.908.135-1.82.123-2.734Z'),
									$elm$svg$Svg$Attributes$fill('#008209'),
									$elm$svg$Svg$Attributes$style('mix-blend-mode:multiply'),
									$elm$svg$Svg$Attributes$opacity('.31')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M59.63 74.678s-2.797.6-4.887.172a129.31 129.31 0 0 1-34.651-12.32s-6.498-3.834-9.132-7.403l-.918 2.42s4.74 5.881 24.231 13.202c19.492 7.32 24.532 5.718 24.532 5.718l.825-1.79Z'),
									$elm$svg$Svg$Attributes$fill('#08551A'),
									$elm$svg$Svg$Attributes$style('mix-blend-mode:multiply'),
									$elm$svg$Svg$Attributes$opacity('.67')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M57.684 78.977S32.53 77.161 9.059 59.953'),
									$elm$svg$Svg$Attributes$stroke('#08551A'),
									$elm$svg$Svg$Attributes$strokeWidth('.5'),
									$elm$svg$Svg$Attributes$strokeMiterlimit('10')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M38.86 31.997c-.56 1.565-.24 3.13.713 3.49.953.36 2.181-.631 2.742-2.202.56-1.57.24-3.13-.713-3.495-.953-.366-2.161.63-2.742 2.207Z'),
									$elm$svg$Svg$Attributes$fill('#103D16')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M28.423 145.117s-19.96.224-44.155-16.368l-.087 1.774s18.157 14.808 43.055 15.956l1.187-1.362Z'),
									$elm$svg$Svg$Attributes$fill('#34B4C5'),
									$elm$svg$Svg$Attributes$style('mix-blend-mode:soft-light')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M19.388 81.1c1.616 4.112-1.31 9.19-6.528 11.339-5.218 2.15-10.762.558-12.377-3.553-1.616-4.112 1.31-9.189 6.533-11.339 5.223-2.15 10.762-.558 12.372 3.554Z'),
									$elm$svg$Svg$Attributes$fill('#006385'),
									$elm$svg$Svg$Attributes$stroke('#2A435F'),
									$elm$svg$Svg$Attributes$strokeWidth('.1'),
									$elm$svg$Svg$Attributes$strokeMiterlimit('10')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M18.415 81.518c1.483 3.788-1.095 8.416-5.768 10.336s-9.682.413-11.15-3.37C.03 84.7 2.593 80.068 7.266 78.147c4.673-1.92 9.661-.412 11.15 3.371Z'),
									$elm$svg$Svg$Attributes$fill('#D8D825'),
									$elm$svg$Svg$Attributes$stroke('#005C6C'),
									$elm$svg$Svg$Attributes$strokeWidth('.1'),
									$elm$svg$Svg$Attributes$strokeMiterlimit('10')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M9.039 90.89a3.151 3.151 0 0 1-1.14-.618 3.238 3.238 0 0 1-.807-1.032 3.653 3.653 0 0 1 .092-2.723l1.172-3.267-1.02-.39.587-1.655 1.019.391.805-2.264 1.967.73-.81 2.27 1.748.652-.591 1.654-1.743-.652-1.162 3.272c-.18.391-.215.836-.097 1.252.08.171.196.323.338.446a1.3 1.3 0 0 0 .488.263c.097.037.195.069.295.094.1.027.203.046.306.058l-.601 1.706-.403-.084a2.725 2.725 0 0 1-.443-.104Z'),
									$elm$svg$Svg$Attributes$fill('#D8D821')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M9.477 90.555a3.17 3.17 0 0 1-1.141-.616 3.258 3.258 0 0 1-.81-1.027 3.653 3.653 0 0 1 .096-2.724l1.157-3.261-1.045-.397.592-1.654 1.044.392.805-2.265 1.967.736-.81 2.264 1.748.647-.586 1.644-1.748-.647-1.162 3.256c-.177.392-.21.837-.091 1.252.078.173.193.327.336.45.142.124.31.214.489.265a3.394 3.394 0 0 0 .596.151l-.611 1.717c-.117 0-.255-.047-.403-.084a2.199 2.199 0 0 1-.423-.099Z'),
									$elm$svg$Svg$Attributes$fill('#006385')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('M20.337 80.736c1.768 4.502-1.458 10.07-7.206 12.433-5.748 2.364-11.838.637-13.611-3.871-1.773-4.508 1.462-10.07 7.21-12.434 5.749-2.364 11.818-.631 13.607 3.871Z'),
									$elm$svg$Svg$Attributes$stroke('#009BBC'),
									$elm$svg$Svg$Attributes$strokeWidth('.1'),
									$elm$svg$Svg$Attributes$strokeMiterlimit('10')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d('m60.481 37.794-6.212.292 5.637 4.19M54.27 38.086l7.495 2.535'),
									$elm$svg$Svg$Attributes$stroke('#103D16'),
									$elm$svg$Svg$Attributes$strokeLinecap('round'),
									$elm$svg$Svg$Attributes$strokeLinejoin('round')
								]),
							_List_Nil)
						]))
				])));
};
var $author$project$Page$Home$MsgUserClosedCandidateNotLoggedInMessage = {$: 81};
var $elm$svg$Svg$Attributes$version = _VirtualDom_attribute('version');
var $author$project$TT$VectorImage$logo = function (size) {
	return $lucamug$elm_ui_with_context$Element$WithContext$html(
		A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat(size)),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromFloat(size)),
					$elm$svg$Svg$Attributes$viewBox('0 0 22 22'),
					$elm$svg$Svg$Attributes$version('1.1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('Page-1'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$strokeWidth('1'),
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$fillRule('evenodd')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('Oval'),
									$elm$svg$Svg$Attributes$fill('#789C48'),
									$elm$svg$Svg$Attributes$cx('11'),
									$elm$svg$Svg$Attributes$cy('11'),
									$elm$svg$Svg$Attributes$r('11')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('Group-2'),
									$elm$svg$Svg$Attributes$transform('translate(6.600000, 4.400000)'),
									$elm$svg$Svg$Attributes$fill('#FFFFFE')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M1.17764601,1.60185859 C1.17764601,0.957818182 1.50377711,0.388363636 2,0.0475151515 C1.87523353,0.0166464646 1.74469986,0 1.61026724,0 C0.720981236,0 0,0.717171717 0,1.60185859 C0,2.45139394 0.664852571,3.14610101 1.50515799,3.2 C1.62310129,3.14012121 1.75006092,3.09527273 1.8840874,3.0699798 C1.45365933,2.72363636 1.17764601,2.19434343 1.17764601,1.60185859'),
											$elm$svg$Svg$Attributes$id('Fill-38')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M1.4988178,11.7357389 L1.4988178,8.41009377 L1.03876191,8.41009377 L1.03876191,4.26426113 C1.03876191,3.82944095 1.23679874,3.44338991 1.54159203,3.2 L1.00379738,3.2 C0.449380239,3.2 0,3.67652463 0,4.26426113 L0,8.14117982 L0.460127535,8.14117982 L0.460127535,11.7357389 C0.460127535,12.3235513 0.909507774,12.8 1.46392491,12.8 L2,12.8 C1.69585154,12.5564582 1.4988178,12.1701033 1.4988178,11.7357389'),
											$elm$svg$Svg$Attributes$id('Fill-39')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M3.43857157,1.59995964 C3.43857157,1.06976064 3.65394101,0.590248947 3.99960541,0.247383156 C3.75787708,0.0908820339 3.47163855,0 3.16440762,0 C2.30040446,0 1.6,0.716321538 1.6,1.59995964 C1.6,2.48367846 2.30040446,3.2 3.16440762,3.2 C3.47179639,3.2 3.75819276,3.10895654 4,2.95237471 C3.65425668,2.60950892 3.43857157,2.13023936 3.43857157,1.59995964'),
											$elm$svg$Svg$Attributes$id('Fill-40')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M3.54297781,11.7357389 L3.54297781,8.41009377 L3.03668206,8.41009377 L3.03668206,4.26426113 C3.03668206,3.82944095 3.25458948,3.44338991 3.59004392,3.2 L2.30451627,3.2 C1.69454894,3.2 1.2,3.67652463 1.2,4.26426113 L1.2,8.14117982 L1.70629575,8.14117982 L1.70629575,11.7357389 C1.70629575,12.3235513 2.20076585,12.8 2.81081203,12.8 L3.59398581,12.8 C3.73754927,12.8 3.87417502,12.7728047 4,12.7248712 C3.71957428,12.4807217 3.54297781,12.1277151 3.54297781,11.7357389'),
											$elm$svg$Svg$Attributes$id('Fill-41')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M4.94427791,1.59995964 C4.94427791,0.999056675 5.20115798,0.463288521 5.6,0.117759225 C5.43114075,0.042051101 5.24652424,0 5.05289311,0 C4.25044523,0 3.6,0.716321538 3.6,1.59995964 C3.6,2.48367846 4.25044523,3.2 5.05289311,3.2 C5.12376415,3.2 5.19338928,3.194108 5.2616219,3.18329256 C5.36180879,3.1296996 5.46917806,3.08990844 5.5816776,3.06634045 C5.1932427,2.7204076 4.94427791,2.19174212 4.94427791,1.59995964'),
											$elm$svg$Svg$Attributes$id('Fill-42')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M5.07634022,11.7357389 L5.07634022,8.41009377 L4.58980868,8.41009377 L4.58980868,4.26426113 C4.58980868,3.82944095 4.79924228,3.44338991 5.12157606,3.2 L4.26156469,3.2 C3.67524152,3.2 3.2,3.67652463 3.2,4.26426113 L3.2,8.14117982 L3.68653154,8.14117982 L3.68653154,11.7357389 C3.68653154,12.3235513 4.16184884,12.8 4.74809623,12.8 L5.50089032,12.8 C5.53438151,12.8 5.5673423,12.7980249 5.6,12.7949864 C5.28198522,12.5512166 5.07634022,12.1672166 5.07634022,11.7357389'),
											$elm$svg$Svg$Attributes$id('Fill-43')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M6.8,3.2 C7.68361582,3.2 8.4,2.48367846 8.4,1.59995964 C8.4,0.716321538 7.68361582,0 6.8,0 C5.91638418,0 5.2,0.716321538 5.2,1.59995964 C5.2,2.48367846 5.91638418,3.2 6.8,3.2'),
											$elm$svg$Svg$Attributes$id('Fill-44')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M7.69680696,3.2 L5.90319304,3.2 C5.29395645,3.2 4.8,3.67652463 4.8,4.26426113 L4.8,8.14117982 L5.3056892,8.14117982 L5.3056892,11.7357389 C5.3056892,12.3235513 5.79956691,12.8 6.40888224,12.8 L7.19111776,12.8 C7.80043309,12.8 8.2943108,12.3235513 8.2943108,11.7357389 L8.2943108,8.14117982 L8.8,8.14117982 L8.8,4.26426113 C8.8,3.67652463 8.30612229,3.2 7.69680696,3.2 Z'),
											$elm$svg$Svg$Attributes$id('Fill-45')
										]),
									_List_Nil)
								]))
						]))
				])));
};
var $author$project$TT$Button$withButtonAttrs = F2(
	function (buttonAttrs, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var label = _v0.c;
		return A3(
			$author$project$TT$Button$Button,
			_Utils_update(
				options,
				{bF: buttonAttrs}),
			msg,
			label);
	});
var $author$project$TT$Button$withRole = F2(
	function (role, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var label = _v0.c;
		return A3(
			$author$project$TT$Button$Button,
			_Utils_update(
				options,
				{n: role}),
			msg,
			label);
	});
var $author$project$TT$Button$withSize = F2(
	function (size, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var label = _v0.c;
		return A3(
			$author$project$TT$Button$Button,
			_Utils_update(
				options,
				{kQ: size}),
			msg,
			label);
	});
var $author$project$TT$Button$withState = F2(
	function (state, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var label = _v0.c;
		var _v1 = function () {
			switch (state.$) {
				case 0:
					return _Utils_Tuple2(msg, label);
				case 2:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, label);
				default:
					var labelForLoading = state.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2($elm$core$Maybe$withDefault, 'Cargando...', labelForLoading));
			}
		}();
		var actionMessage = _v1.a;
		var newLabel = _v1.b;
		return A3(
			$author$project$TT$Button$Button,
			_Utils_update(
				options,
				{av: state}),
			actionMessage,
			newLabel);
	});
var $author$project$Page$Home$viewCandidateNotLoggedInTalentecaDialog = function (model) {
	if (model.f.W) {
		var continueAsMessage = 'Continuar ' + A2(
			$elm$core$Maybe$withDefault,
			'con Talenteca',
			A2(
				$elm$core$Maybe$map,
				function (f) {
					return 'como ' + A2(
						$elm$core$Maybe$withDefault,
						f,
						$elm$core$List$head(
							A2($elm$core$String$split, ' ', f)));
				},
				model.C.$9));
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
					$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
					{hc: 0, hd: 0, lA: 10, lB: 10}),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class('sentry-mask'))
				]),
			_List_fromArray(
				[
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Border$widthEach(
							{hb: 1, jf: 0, ku: 0, lz: 0}),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$gray3),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(12),
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12)
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							_Utils_ap(
								$author$project$TT$Font$body2,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
									])),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text('... o inicia sesión en Talenteca')
								])),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
									$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClosedCandidateNotLoggedInMessage),
									$lucamug$elm_ui_with_context$Element$WithContext$pointer,
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('close-modal'))
								]),
							$author$project$TT$IT$render(
								A2(
									$author$project$TT$IT$withSize,
									16,
									A2(
										$author$project$TT$IT$withColor,
										$author$project$TT$Color$gray2,
										$author$project$TT$IT$close(_List_Nil)))))
						])),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(16),
							$lucamug$elm_ui_with_context$Element$WithContext$padding(12)
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$spacing(4),
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(25),
											$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$primaryLight)
										]),
									$author$project$TT$VectorImage$logo(28)),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_Utils_ap(
										$author$project$TT$Font$body3,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
												A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 4, 0),
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
												$lucamug$elm_ui_with_context$Element$WithContext$spacing(4)
											])),
									_List_fromArray(
										[
											function () {
											var _v0 = model.C.$9;
											if (!_v0.$) {
												var fullname = _v0.a;
												return A2(
													$lucamug$elm_ui_with_context$Element$WithContext$el,
													_List_fromArray(
														[$lucamug$elm_ui_with_context$Element$WithContext$Font$bold]),
													$lucamug$elm_ui_with_context$Element$WithContext$text(fullname));
											} else {
												return $lucamug$elm_ui_with_context$Element$WithContext$none;
											}
										}(),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											_List_Nil,
											$lucamug$elm_ui_with_context$Element$WithContext$text(model.C.cB))
										]))
								])),
							$author$project$TT$Button$render(
							A2(
								$author$project$TT$Button$withState,
								model.f.t ? $author$project$TT$Button$StateLoading(
									$elm$core$Maybe$Just('Cargando')) : $author$project$TT$Button$StateDefault,
								A2(
									$author$project$TT$Button$withButtonAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$centerX,
											$lucamug$elm_ui_with_context$Element$WithContext$pointer,
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$class('login-not-with-google-button'))
										]),
									A2(
										$author$project$TT$Button$withSize,
										1,
										A2(
											$author$project$TT$Button$withRole,
											0,
											A2(
												$author$project$TT$Button$default,
												$elm$core$Maybe$Just(
													$author$project$Page$Home$MsgUserClickedSendMagicLink(model.C.cB)),
												continueAsMessage))))))
						]))
				]));
	} else {
		return $lucamug$elm_ui_with_context$Element$WithContext$none;
	}
};
var $author$project$Page$Home$viewSnackBarMessage = F2(
	function (message, color) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
					$lucamug$elm_ui_with_context$Element$WithContext$centerX,
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 20, 0),
					$lucamug$elm_ui_with_context$Element$WithContext$moveUp(76),
					$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$shrink)
				]),
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(color),
						$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$white),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(4),
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 8)
					]),
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('alert-message'))
						]),
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$text(message)
						]))));
	});
var $author$project$Page$Home$viewSnackBarError = function (maybeErrorMessage) {
	if (!maybeErrorMessage.$) {
		var errorMessage = maybeErrorMessage.a;
		return A2($author$project$Page$Home$viewSnackBarMessage, errorMessage, $author$project$TT$Color$error);
	} else {
		return $lucamug$elm_ui_with_context$Element$WithContext$none;
	}
};
var $author$project$Page$Home$viewChatContainer = F5(
	function (model, showTalentecaLogoWaterMark, chatMessagesEl, bottomEl, maybeErrorMessage) {
		var talentecaLogoWaterMark = showTalentecaLogoWaterMark ? _List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$centerX,
							$lucamug$elm_ui_with_context$Element$WithContext$centerY,
							$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.2)
						]),
					$author$project$TT$VectorImage$talenteca(50)))
			]) : _List_Nil;
		var chatContainerHeight = (!model.p) ? model.q.aR : $elm$core$Basics$round(model.q.aR * 0.9);
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_Utils_ap(
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width(
						$lucamug$elm_ui_with_context$Element$WithContext$px(
							$author$project$Page$Home$getMainContainerSize(model).a8)),
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						$lucamug$elm_ui_with_context$Element$WithContext$px(
							(chatContainerHeight - ((!model.p) ? (model.a0 ? model.bn : model.a6) : 0)) - model.ae)),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2(
							$elm$html$Html$Attributes$style,
							'min-height',
							$elm$core$String$fromInt(
								(chatContainerHeight - ((!model.p) ? (model.a0 ? model.bn : model.a6) : 0)) - model.ae) + 'px')),
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray4),
						(!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(0) : $lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
						{hc: 8, hd: 8, lA: 0, lB: 0}),
						$lucamug$elm_ui_with_context$Element$WithContext$inFront(
						$author$project$Page$Home$viewSnackBarError(maybeErrorMessage)),
						$lucamug$elm_ui_with_context$Element$WithContext$inFront(
						model.a.b3 ? A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.5),
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray3),
									$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClosedCandidateInfoLoadedMessage)
								]),
							$lucamug$elm_ui_with_context$Element$WithContext$none) : $lucamug$elm_ui_with_context$Element$WithContext$none),
						$lucamug$elm_ui_with_context$Element$WithContext$inFront(
						model.a.b3 ? A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
									$lucamug$elm_ui_with_context$Element$WithContext$moveUp(5),
									$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClosedCandidateInfoLoadedMessage)
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$moveLeft(20)
										]),
									$author$project$TT$VectorImage$talentino(150)),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$padding(12),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$class('elevation-1')),
											$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
											$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
											$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
											$lucamug$elm_ui_with_context$Element$WithContext$moveLeft(20),
											$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
											{hc: 0, hd: 8, lA: 8, lB: 8}),
											$lucamug$elm_ui_with_context$Element$WithContext$inFront(
											A2(
												$lucamug$elm_ui_with_context$Element$WithContext$el,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
														$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
														$lucamug$elm_ui_with_context$Element$WithContext$moveUp(7),
														$lucamug$elm_ui_with_context$Element$WithContext$moveRight(7),
														$lucamug$elm_ui_with_context$Element$WithContext$pointer,
														$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClosedCandidateInfoLoadedMessage),
														$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
														$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(25),
														$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
														$elm$html$Html$Attributes$class('close-talentino-help'))
													]),
												$author$project$TT$IT$render(
													A2(
														$author$project$TT$IT$withSize,
														20,
														A2(
															$author$project$TT$IT$withColor,
															$author$project$TT$Color$black,
															$author$project$TT$IT$closeOutlined(_List_Nil))))))
										]),
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$text('Hola ' + (model.a.b.dG.cO + ', hemos cargado los datos de tu perfil de candidato. Puedes editarlos antes de enviar.'))
										]))
								])) : $lucamug$elm_ui_with_context$Element$WithContext$none)
					]),
				talentecaLogoWaterMark),
			_List_fromArray(
				[
					chatMessagesEl,
					bottomEl,
					$author$project$Page$Home$viewCandidateNotLoggedInTalentecaDialog(model)
				]));
	});
var $author$project$TT$Dropdown$DropdownChanged = $elm$core$Basics$identity;
var $author$project$TT$Dropdown$OnChange = function (a) {
	return {$: 4, a: a};
};
var $author$project$TT$Dropdown$OnKeyDown = function (a) {
	return {$: 2, a: a};
};
var $author$project$TT$Dropdown$OnOpened = {$: 0};
var $author$project$TT$Dropdown$OnSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$TT$Dropdown$filterSelectedFromOption = F2(
	function (maybeSelected, options) {
		return A2(
			$elm$core$Maybe$andThen,
			function (item) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (optionType) {
							if (!optionType.$) {
								var _v1 = optionType.a;
								var option_ = _v1.c;
								return _Utils_eq(option_, item);
							} else {
								var _v2 = optionType.a;
								var option_ = _v2.c;
								return _Utils_eq(option_, item);
							}
						},
						options));
			},
			maybeSelected);
	});
var $author$project$TT$Dropdown$referenceDataName = 'data-dropdown-id';
var $author$project$TT$Dropdown$referenceAttr = function (model) {
	return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
		A2($elm$html$Html$Attributes$attribute, $author$project$TT$Dropdown$referenceDataName, model.iJ));
};
var $author$project$TT$Dropdown$tabIndexAttr = function (tabIndex) {
	return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
		$elm$html$Html$Attributes$tabindex(tabIndex));
};
var $author$project$TT$Dropdown$itemView = F5(
	function (config, selectedItem, state, i, item) {
		var highlighed = _Utils_eq(i, state.ad);
		var filterSelected = A2($author$project$TT$Dropdown$filterSelectedFromOption, selectedItem, state.jP);
		var selected = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(item),
				filterSelected));
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
					config.eN(
						$author$project$TT$Dropdown$OnSelected(item))),
					$author$project$TT$Dropdown$referenceAttr(state),
					$author$project$TT$Dropdown$tabIndexAttr(-1)
				]),
			A3(config.fj, selected, highlighed, item));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Lazy$apply1 = F3(
	function (context, fn, a) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$Internal$run,
			context,
			fn(a));
	});
var $mdgriffith$elm_ui$Element$Lazy$embed = function (x) {
	switch (x.$) {
		case 0:
			var html = x.a;
			return html;
		case 1:
			var styled = x.a;
			return styled.iH(
				A2(
					$mdgriffith$elm_ui$Internal$Model$OnlyDynamic,
					{
						ii: {g$: $elm$core$Maybe$Nothing, g7: $elm$core$Maybe$Nothing, kK: $elm$core$Maybe$Nothing},
						iG: 1,
						ju: 0
					},
					styled.k1));
		case 2:
			var text = x.a;
			return $elm$core$Basics$always(
				$elm$virtual_dom$VirtualDom$text(text));
		default:
			return $elm$core$Basics$always(
				$elm$virtual_dom$VirtualDom$text(''));
	}
};
var $mdgriffith$elm_ui$Element$Lazy$apply3 = F4(
	function (fn, a, b, c) {
		return $mdgriffith$elm_ui$Element$Lazy$embed(
			A3(fn, a, b, c));
	});
var $elm$virtual_dom$VirtualDom$lazy5 = _VirtualDom_lazy5;
var $mdgriffith$elm_ui$Element$Lazy$lazy3 = F4(
	function (fn, a, b, c) {
		return $mdgriffith$elm_ui$Internal$Model$Unstyled(
			A5($elm$virtual_dom$VirtualDom$lazy5, $mdgriffith$elm_ui$Element$Lazy$apply3, fn, a, b, c));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Lazy$lazy = F2(
	function (fn, a) {
		return function (context) {
			return A4($mdgriffith$elm_ui$Element$Lazy$lazy3, $lucamug$elm_ui_with_context$Element$WithContext$Lazy$apply1, context, fn, a);
		};
	});
var $author$project$TT$Dropdown$bodyView = F4(
	function (config, selectedItem, state, data) {
		if (state.L) {
			if ($elm$core$List$isEmpty(data)) {
				return config.eO;
			} else {
				var items = function (data_) {
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						config.cT,
						A2(
							$elm$core$List$indexedMap,
							A3($author$project$TT$Dropdown$itemView, config, selectedItem, state),
							data_));
				};
				var body = A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
						]),
					A2($lucamug$elm_ui_with_context$Element$WithContext$Lazy$lazy, items, data));
				return body;
			}
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$none;
		}
	});
var $author$project$TT$IT$chevronDown = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'chevronDown',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m2 7 10 10L22 7'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$fill('transparent')
					]),
				_List_Nil)
			]));
};
var $author$project$TT$Dropdown$getValueFromOption = function (selected) {
	return A2(
		$elm$core$Maybe$map,
		function (optionType) {
			if (!optionType.$) {
				var _v1 = optionType.a;
				var value = _v1.b;
				return value;
			} else {
				var _v2 = optionType.a;
				var value = _v2.b;
				return value;
			}
		},
		selected);
};
var $author$project$TT$Dropdown$OnBlur = {$: 3};
var $author$project$TT$Dropdown$onBlurAttribute = F2(
	function (config, state) {
		var dataDecoder = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['relatedTarget', 'attributes', $author$project$TT$Dropdown$referenceDataName, 'value']),
			$elm$json$Json$Decode$string);
		var attrToMsg = function (maybeAttr) {
			if (!maybeAttr.$) {
				var attr = maybeAttr.a;
				return _Utils_eq(attr, state.iJ) ? $elm$json$Json$Decode$fail('') : $elm$json$Json$Decode$succeed(
					config.eN($author$project$TT$Dropdown$OnBlur));
			} else {
				return $elm$json$Json$Decode$succeed(
					config.eN($author$project$TT$Dropdown$OnBlur));
			}
		};
		return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
			A2(
				$elm$html$Html$Events$on,
				'blur',
				A2(
					$elm$json$Json$Decode$andThen,
					attrToMsg,
					$elm$json$Json$Decode$maybe(dataDecoder))));
	});
var $author$project$TT$Dropdown$onClick = function (message) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(message);
};
var $author$project$TT$Dropdown$ArrowDown = 0;
var $author$project$TT$Dropdown$ArrowUp = 1;
var $author$project$TT$Dropdown$Enter = 2;
var $author$project$TT$Dropdown$Esc = 3;
var $author$project$TT$Dropdown$onKeyDown = function (msg) {
	var stringToKey = function (str) {
		switch (str) {
			case 'ArrowDown':
				return $elm$json$Json$Decode$succeed(0);
			case 'ArrowUp':
				return $elm$json$Json$Decode$succeed(1);
			case 'Enter':
				return $elm$json$Json$Decode$succeed(2);
			case 'Escape':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('not used key');
		}
	};
	var keyDecoder = A2(
		$elm$json$Json$Decode$andThen,
		stringToKey,
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
		A2(
			$elm$html$Html$Events$on,
			'keydown',
			A2($elm$json$Json$Decode$map, msg, keyDecoder)));
};
var $mdgriffith$elm_ui$Internal$Model$OnLeft = 3;
var $mdgriffith$elm_ui$Element$onLeft = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 3, element);
};
var $lucamug$elm_ui_with_context$Element$WithContext$onLeft = $lucamug$elm_ui_with_context$Element$WithContext$createNearby($mdgriffith$elm_ui$Element$onLeft);
var $mdgriffith$elm_ui$Internal$Model$OnRight = 2;
var $mdgriffith$elm_ui$Element$onRight = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 2, element);
};
var $lucamug$elm_ui_with_context$Element$WithContext$onRight = $lucamug$elm_ui_with_context$Element$WithContext$createNearby($mdgriffith$elm_ui$Element$onRight);
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$TT$Dropdown$view = F3(
	function (_v0, model, _v1) {
		var config = _v0;
		var state = _v1;
		var triggerAttrs = _Utils_ap(
			_List_fromArray(
				[
					$author$project$TT$Dropdown$tabIndexAttr(0),
					$author$project$TT$Dropdown$referenceAttr(state),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$author$project$TT$Dropdown$onClick(
					config.eN($author$project$TT$Dropdown$OnOpened)),
					$author$project$TT$Dropdown$onKeyDown(
					A2(
						$elm$core$Basics$composeL,
						config.eN,
						A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$TT$Dropdown$OnKeyDown))),
					A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 8, 0),
					$lucamug$elm_ui_with_context$Element$WithContext$centerX,
					A2($author$project$TT$Dropdown$onBlurAttribute, config, state)
				]),
			config.c9);
		var selectedItem = config.f4;
		var trigger = function () {
			var _v7 = A2($author$project$TT$Dropdown$filterSelectedFromOption, selectedItem, state.jP);
			if (!_v7.$) {
				var option = _v7.a;
				return config.d1(option);
			} else {
				return config.fN;
			}
		}();
		var value_ = function () {
			var _v6 = $author$project$TT$Dropdown$getValueFromOption(
				A2($author$project$TT$Dropdown$filterSelectedFromOption, selectedItem, state.jP));
			if (!_v6.$) {
				var value = _v6.a;
				return value;
			} else {
				return '';
			}
		}();
		var placement = function () {
			var _v5 = state.c0;
			switch (_v5) {
				case 1:
					return $lucamug$elm_ui_with_context$Element$WithContext$below;
				case 0:
					return $lucamug$elm_ui_with_context$Element$WithContext$above;
				case 2:
					return $lucamug$elm_ui_with_context$Element$WithContext$onLeft;
				default:
					return $lucamug$elm_ui_with_context$Element$WithContext$onRight;
			}
		}();
		var items = function () {
			var _v3 = config.fb;
			if (!_v3.$) {
				return state.jP;
			} else {
				if (config.b1) {
					return $elm$core$String$isEmpty(config.eJ) ? state.jP : state.Z;
				} else {
					var _v4 = config.fo;
					if (!_v4.$) {
						var limitOptions = _v4.a;
						return A2($elm$core$List$take, limitOptions, state.Z);
					} else {
						return state.Z;
					}
				}
			}
		}();
		var body = A4($author$project$TT$Dropdown$bodyView, config, selectedItem, state, items);
		var containerAttrs = A2(
			$elm$core$List$cons,
			placement(body),
			config.cs);
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			containerAttrs,
			_List_fromArray(
				[
					function () {
					var _v2 = config.fb;
					if (!_v2.$) {
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							triggerAttrs,
							_List_fromArray(
								[
									trigger,
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$moveUp(16.0 * 0.1),
											$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
											$lucamug$elm_ui_with_context$Element$WithContext$pointer
										]),
									$author$project$TT$IT$render(
										A2(
											$author$project$TT$IT$withColor,
											$author$project$TT$Color$gray2,
											A2(
												$author$project$TT$IT$withSize,
												16,
												$author$project$TT$IT$chevronDown(_List_Nil)))))
								]));
					} else {
						var cmdMsg = _v2.a;
						var label = _v2.b;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							$author$project$TT$FormField$render(
								A2(
									$author$project$TT$FormField$withFieldAttrs,
									_List_fromArray(
										[
											A2($author$project$TT$Dropdown$onBlurAttribute, config, state),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Events$onFocus(
												config.eN($author$project$TT$Dropdown$OnOpened))),
											$author$project$TT$Dropdown$onKeyDown(
											A2(
												$elm$core$Basics$composeL,
												config.eN,
												A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$TT$Dropdown$OnKeyDown)))
										]),
									config.df(
										A3(
											$author$project$TT$FormField$default,
											function (e) {
												return A2(
													cmdMsg,
													$author$project$TT$Dropdown$OnChange(e),
													e);
											},
											config.eJ,
											label)))));
					}
				}()
				]));
	});
var $author$project$Page$Home$viewDropdownQuestion = F8(
	function (model, questionTitle, question, dropdownModel, dropdownChangedMsg, dropdownSelectChangedMsg, dropdownContainerClass, dropdownOptionsListClass) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
				]),
			_List_fromArray(
				[
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
					_Utils_ap(
						$author$project$TT$Font$body1,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Font$color(
								_Utils_eq(question.bM, $elm$core$Maybe$Nothing) ? $author$project$TT$Color$text : $author$project$TT$Color$error)
							])),
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$text(questionTitle)
						])),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('sentry-mask'))
						]),
					A3(
						$author$project$TT$Dropdown$view,
						A6(
							$author$project$Page$Home$commonSelectDropdown,
							question.g,
							!_Utils_eq(question.bM, $elm$core$Maybe$Nothing),
							dropdownChangedMsg,
							dropdownSelectChangedMsg,
							dropdownContainerClass,
							dropdownOptionsListClass),
						model,
						dropdownModel)),
					function () {
					var _v0 = question.bM;
					if (!_v0.$) {
						var errorMessage = _v0.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							_Utils_ap(
								$author$project$TT$Font$body3,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$error),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('sentry-mask'))
									])),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text(errorMessage)
								]));
					} else {
						return $lucamug$elm_ui_with_context$Element$WithContext$none;
					}
				}()
				]));
	});
var $author$project$Page$Home$MsgUserChangedSkill = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Page$Home$MsgUserDeletedSkill = function (a) {
	return {$: 38, a: a};
};
var $author$project$TT$FormField$withTrailingIcon = F2(
	function (icon, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var value = _v0.c;
		var label = _v0.d;
		return A4(
			$author$project$TT$FormField$Input,
			_Utils_update(
				options,
				{
					bx: $elm$core$Maybe$Just(icon)
				}),
			msg,
			value,
			label);
	});
var $author$project$Page$Home$viewSkillTextField = F2(
	function (index, skill) {
		var placeholder = (!index) ? 'Ej. Ventas' : ((index === 1) ? 'Ej. Atención telefónica' : '');
		var finalTextField = function (baseTextField) {
			return (index > 1) ? $author$project$TT$FormField$render(
				A2(
					$author$project$TT$FormField$withTrailingIcon,
					{
						iI: A2(
							$author$project$TT$IT$withColor,
							$author$project$TT$Color$gray1,
							$author$project$TT$IT$closeOutlined(_List_Nil)),
						jG: $author$project$Page$Home$MsgUserDeletedSkill(index)
					},
					baseTextField)) : $author$project$TT$FormField$render(baseTextField);
		};
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(8)
				]),
			_List_fromArray(
				[
					finalTextField(
					A2(
						$author$project$TT$FormField$withPlaceholder,
						$lucamug$elm_ui_with_context$Element$WithContext$text(placeholder),
						A2(
							$author$project$TT$FormField$withState,
							(!_Utils_eq(skill.bM, $elm$core$Maybe$Nothing)) ? 2 : 0,
							A2(
								$author$project$TT$FormField$withFieldAttrs,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$id(
											'skill-' + $elm$core$String$fromInt(index))),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Events$onFocus($author$project$Page$Home$MsgUserFocusedInput)),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Events$onBlur($author$project$Page$Home$MsgUserLeftInput)),
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$tabindex(5 + index))
									]),
								A2(
									$author$project$TT$FormField$withLabelType,
									1,
									A2(
										$author$project$TT$FormField$withWrapperAttrs,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
											]),
										A3(
											$author$project$TT$FormField$default,
											$author$project$Page$Home$MsgUserChangedSkill(index),
											skill.g,
											''))))))),
					function () {
					var _v0 = skill.bM;
					if (!_v0.$) {
						var errorMessage = _v0.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							_Utils_ap(
								$author$project$TT$Font$body3,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$error)
									])),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text(errorMessage)
								]));
					} else {
						return $lucamug$elm_ui_with_context$Element$WithContext$none;
					}
				}()
				]));
	});
var $author$project$Page$Home$viewTalentinoActiveQuestionBubble = F3(
	function (model, extraAttrs, contentEl) {
		var bubbleBaseWidth = $author$project$Page$Home$getMainContainerWidth(model);
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$row,
			A2(
				$elm$core$List$cons,
				$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
				extraAttrs),
			_List_fromArray(
				[
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(50),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('elevation-2')),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray3),
							$lucamug$elm_ui_with_context$Element$WithContext$padding(8)
						]),
					$author$project$TT$VectorImage$talentino(36)),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 12),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('elevation-2 bubble')),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(8),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$primaryLight),
							$lucamug$elm_ui_with_context$Element$WithContext$width(
							A3(
								$elm$core$Basics$apL,
								$lucamug$elm_ui_with_context$Element$WithContext$maximum,
								$elm$core$Basics$ceiling(((bubbleBaseWidth - 32) * 80) / 100),
								$lucamug$elm_ui_with_context$Element$WithContext$fill))
						]),
					contentEl)
				]));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Border$widthXY = F2(
	function (x, y) {
		return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
			A2($mdgriffith$elm_ui$Element$Border$widthXY, x, y));
	});
var $author$project$TT$Button$withLeadingIcon = F2(
	function (icon, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var label = _v0.c;
		return A3(
			$author$project$TT$Button$Button,
			_Utils_update(
				options,
				{
					bo: $elm$core$Maybe$Just(icon),
					bx: $elm$core$Maybe$Nothing
				}),
			msg,
			label);
	});
var $author$project$TT$Button$withStyle = F2(
	function (style, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var label = _v0.c;
		return A3(
			$author$project$TT$Button$Button,
			_Utils_update(
				options,
				{aw: style}),
			msg,
			label);
	});
var $author$project$Page$Home$viewApplyQuestionsStage = function (model) {
	var applyQuestionsStageModel = model.e;
	return A5(
		$author$project$Page$Home$viewChatContainer,
		model,
		true,
		A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(28),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 0, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
					$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$id('chatContainer'))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Page$Home$viewTalentinoActiveQuestionBubble,
					model,
					_List_Nil,
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						_Utils_ap(
							$author$project$TT$Font$body2,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
								])),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text('Por favor, escoge 5 opciones rápidas para entender mejor tu perfil')
							]))),
					A8($author$project$Page$Home$viewDropdownQuestion, model, '¿En qué area de las empresas tienes más experiencia o interés?', applyQuestionsStageModel.d.du, applyQuestionsStageModel.cn, $author$project$Page$Home$MsgCategoryDropdownChanged, $author$project$Page$Home$MsgCategoryDropdownSelectChanged, 'category-container', 'category-options'),
					A8($author$project$Page$Home$viewDropdownQuestion, model, '¿Cuál es tu nivel de experiencia profesional?', applyQuestionsStageModel.d.dB, applyQuestionsStageModel.cD, $author$project$Page$Home$MsgExperienceDropdownChanged, $author$project$Page$Home$MsgExperienceDropdownSelectChanged, 'experience_level-container', 'experience_level-options'),
					A8($author$project$Page$Home$viewDropdownQuestion, model, '¿Cuál es tu último nivel de estudios alcanzado?', applyQuestionsStageModel.d.dz, applyQuestionsStageModel.cA, $author$project$Page$Home$MsgEducationLevelDropdownChanged, $author$project$Page$Home$MsgEducationLevelDropdownSelectChanged, 'education_level-container', 'education_level-options'),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							$author$project$TT$FormField$render(
								A2(
									$author$project$TT$FormField$withFieldAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$id('experience_years')),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Events$onFocus($author$project$Page$Home$MsgUserFocusedInput)),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Events$onBlur($author$project$Page$Home$MsgUserLeftInput)),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$tabindex(4))
										]),
									A2(
										$author$project$TT$FormField$withPlaceholder,
										$lucamug$elm_ui_with_context$Element$WithContext$text(''),
										A2(
											$author$project$TT$FormField$withState,
											(!_Utils_eq(applyQuestionsStageModel.d.dC.bM, $elm$core$Maybe$Nothing)) ? 2 : 0,
											A2(
												$author$project$TT$FormField$withWrapperAttrs,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
													]),
												A3($author$project$TT$FormField$default, $author$project$Page$Home$MsgUserChangedExperienceYears, applyQuestionsStageModel.d.dC.g, '¿Cuántos años de experiencia profesional tienes?'))))))),
							function () {
							var _v0 = applyQuestionsStageModel.d.dC.bM;
							if (!_v0.$) {
								var errorMessage = _v0.a;
								return A2(
									$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
									_Utils_ap(
										$author$project$TT$Font$body3,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$error),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Attributes$class('sentry-mask'))
											])),
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$html(
											A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(errorMessage)
													])))
										]));
							} else {
								var _v1 = $elm$core$String$toInt(applyQuestionsStageModel.d.dC.g);
								if (!_v1.$) {
									var experiencesYearsAsInt = _v1.a;
									return A2(
										$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
										_Utils_ap(
											$author$project$TT$Font$body3,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$gray1),
													$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
													$elm$html$Html$Attributes$class('sentry-mask'))
												])),
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$html(
												A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															'Experiencia desde: ' + $elm$core$String$fromInt(model.cx - experiencesYearsAsInt))
														])))
											]));
								} else {
									return $lucamug$elm_ui_with_context$Element$WithContext$none;
								}
							}
						}()
						])),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							_Utils_ap(
								$author$project$TT$Font$body1,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
									])),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text('¿Cuáles son tus principales conocimientos/habilidades?')
								])),
						_Utils_ap(
							$elm$core$Array$toList(
								A2(
									$elm$core$Array$indexedMap,
									F2(
										function (index, skill) {
											return A2($author$project$Page$Home$viewSkillTextField, index, skill);
										}),
									applyQuestionsStageModel.d.kS)),
							_List_fromArray(
								[
									function () {
									var currentSkillsFilled = A3(
										$elm$core$Array$foldl,
										F2(
											function (skill, acc) {
												return ($elm$core$String$trim(skill.g) !== '') && acc;
											}),
										true,
										applyQuestionsStageModel.d.kS);
									return $author$project$TT$Button$render(
										A2(
											$author$project$TT$Button$withState,
											currentSkillsFilled ? $author$project$TT$Button$StateDefault : $author$project$TT$Button$StateDisabled,
											A2(
												$author$project$TT$Button$withLeadingIcon,
												A2(
													$author$project$TT$IT$withColor,
													$author$project$TT$Color$white,
													$author$project$TT$IT$plus(_List_Nil)),
												A2(
													$author$project$TT$Button$withButtonAttrs,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$centerX,
															$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
															$elm$html$Html$Attributes$class('add-skill'))
														]),
													A2(
														$author$project$TT$Button$withStyle,
														1,
														A2(
															$author$project$TT$Button$withRole,
															1,
															A2(
																$author$project$TT$Button$default,
																$elm$core$Maybe$Just($author$project$Page$Home$MsgUserAddedOneSkill),
																'Agregar nueva habilidad')))))));
								}()
								]))))
				])),
		A2(
			$lucamug$elm_ui_with_context$Element$WithContext$row,
			_List_fromArray(
				[
					A2($lucamug$elm_ui_with_context$Element$WithContext$Border$widthXY, 0, 1),
					$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$gray3),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12),
					$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
					{
						g5: 20,
						hz: $author$project$TT$Color$gray2,
						jE: _Utils_Tuple2(0, 3),
						kQ: -3
					})
				]),
			_List_fromArray(
				[
					$author$project$TT$Button$render(
					A2(
						$author$project$TT$Button$withButtonAttrs,
						_List_fromArray(
							[$lucamug$elm_ui_with_context$Element$WithContext$alignLeft]),
						A2(
							$author$project$TT$Button$withStyle,
							1,
							A2(
								$author$project$TT$Button$withSize,
								0,
								A2(
									$author$project$TT$Button$withRole,
									1,
									A2(
										$author$project$TT$Button$default,
										$elm$core$Maybe$Just($author$project$Page$Home$MsgUserSkippedApplyQuestions),
										'Saltar paso')))))),
					$author$project$TT$Button$render(
					A2(
						$author$project$TT$Button$withState,
						model.e.bP ? $author$project$TT$Button$StateLoading(
							$elm$core$Maybe$Just('Enviando')) : $author$project$TT$Button$StateDefault,
						A2(
							$author$project$TT$Button$withButtonAttrs,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('talapoin-submit-stage-2'))
								]),
							A2(
								$author$project$TT$Button$withSize,
								0,
								A2(
									$author$project$TT$Button$withRole,
									1,
									A2(
										$author$project$TT$Button$default,
										$elm$core$Maybe$Just($author$project$Page$Home$MsgUserSubmittedApplyQuestions),
										'Enviar'))))))
				])),
		model.e.G);
};
var $author$project$TT$IconButton$Contained = 0;
var $author$project$TT$IconButton$Gray2 = 1;
var $author$project$TT$FormField$InputMultiline = 2;
var $author$project$Page$Home$MsgCvFileFromCandidateApplySelected = {$: 101};
var $author$project$Page$Home$MsgUserChangedMessage = function (a) {
	return {$: 43, a: a};
};
var $author$project$Page$Home$MsgUserChangedPublicCvCheckbox = function (a) {
	return {$: 45, a: a};
};
var $author$project$Page$Home$MsgUserChangedSubscribeToNotificationsCheckbox = function (a) {
	return {$: 44, a: a};
};
var $author$project$Page$Home$MsgUserPressedApproveCurrentCv = {$: 106};
var $author$project$Page$Home$MsgUserPressedCvUploadButton = {$: 103};
var $author$project$Page$Home$MsgUserPressedDownloadCv = function (a) {
	return {$: 105, a: a};
};
var $author$project$Page$Home$MsgUserSubmittedCandidateCvInfo = {$: 47};
var $author$project$Page$Home$MsgUserSubmittedMessage = {$: 46};
var $author$project$TT$IconButton$Small = 1;
var $elm$html$Html$Attributes$accept = $elm$html$Html$Attributes$stringProperty('accept');
var $author$project$TT$Checkbox$Checkbox = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$TT$Checkbox$Normal = 0;
var $author$project$TT$Checkbox$StateEnabled = 0;
var $author$project$TT$Checkbox$defaultOptions = {cR: $elm$core$Maybe$Nothing, kQ: 0, av: 0, dh: _List_Nil};
var $author$project$TT$Checkbox$default = F3(
	function (label, isChecked, msg) {
		return A4($author$project$TT$Checkbox$Checkbox, $author$project$TT$Checkbox$defaultOptions, label, isChecked, msg);
	});
var $author$project$TT$IconButton$IconButton = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$TT$IconButton$JustIcon = 1;
var $author$project$TT$IconButton$Normal = 0;
var $author$project$TT$IconButton$StateEnabled = 0;
var $author$project$TT$IconButton$defaultOptions = {bF: _List_Nil, hz: 1, kQ: 0, av: 0, aw: 1};
var $author$project$TT$IconButton$default = F3(
	function (msg, label, icon) {
		return A4($author$project$TT$IconButton$IconButton, $author$project$TT$IconButton$defaultOptions, msg, label, icon);
	});
var $author$project$TT$IT$editPencil = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'edit-pencil',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$Attributes$hidden = $elm$html$Html$Attributes$boolProperty('hidden');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $mdgriffith$elm_ui$Element$Input$tabindex = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$tabindex);
var $mdgriffith$elm_ui$Element$Input$checkbox = F2(
	function (attrs, _v0) {
		var label = _v0.dQ;
		var icon = _v0.iI;
		var checked = _v0.hs;
		var onChange = _v0.jF;
		var attributes = _Utils_ap(
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Input$isHiddenLabel(label) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Element$spacing(6),
					$mdgriffith$elm_ui$Internal$Model$Attr(
					$elm$html$Html$Events$onClick(
						onChange(!checked))),
					$mdgriffith$elm_ui$Element$Region$announce,
					$mdgriffith$elm_ui$Element$Input$onKeyLookup(
					function (code) {
						return _Utils_eq(code, $mdgriffith$elm_ui$Element$Input$enter) ? $elm$core$Maybe$Just(
							onChange(!checked)) : (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space) ? $elm$core$Maybe$Just(
							onChange(!checked)) : $elm$core$Maybe$Nothing);
					}),
					$mdgriffith$elm_ui$Element$Input$tabindex(0),
					$mdgriffith$elm_ui$Element$pointer,
					$mdgriffith$elm_ui$Element$alignLeft,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			attrs);
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Attr(
					A2($elm$html$Html$Attributes$attribute, 'role', 'checkbox')),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$Attr(
						A2(
							$elm$html$Html$Attributes$attribute,
							'aria-checked',
							checked ? 'true' : 'false')),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(label),
						attributes))),
			label,
			A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerY,
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink)
					]),
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[
							icon(checked)
						]))));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$checkbox = A2(
	$lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs,
	$mdgriffith$elm_ui$Element$Input$checkbox,
	F2(
		function (context, _v0) {
			var label = _v0.dQ;
			var icon = _v0.iI;
			var checked = _v0.hs;
			var onChange = _v0.jF;
			return {
				hs: checked,
				iI: A2(
					$elm$core$Basics$composeR,
					icon,
					$lucamug$elm_ui_with_context$Element$WithContext$Internal$run(context)),
				dQ: A2($lucamug$elm_ui_with_context$Element$WithContext$Input$runLabel, context, label),
				jF: onChange
			};
		}));
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$degrees = function (angleInDegrees) {
	return (angleInDegrees * $elm$core$Basics$pi) / 180;
};
var $mdgriffith$elm_ui$Internal$Model$Rotate = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$rotate = $mdgriffith$elm_ui$Internal$Flag$flag(24);
var $mdgriffith$elm_ui$Element$rotate = function (angle) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$rotate,
		A2(
			$mdgriffith$elm_ui$Internal$Model$Rotate,
			_Utils_Tuple3(0, 0, 1),
			angle));
};
var $lucamug$elm_ui_with_context$Element$WithContext$rotate = function (angle) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attr(
		$mdgriffith$elm_ui$Element$rotate(angle));
};
var $mdgriffith$elm_ui$Element$transparent = function (on) {
	return on ? A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2($mdgriffith$elm_ui$Internal$Model$Transparency, 'transparent', 1.0)) : A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2($mdgriffith$elm_ui$Internal$Model$Transparency, 'visible', 0.0));
};
var $lucamug$elm_ui_with_context$Element$WithContext$transparent = function (on) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attr(
		$mdgriffith$elm_ui$Element$transparent(on));
};
var $author$project$TT$Checkbox$customCheckboxIcon = F2(
	function (options, isChecked) {
		var size = function () {
			var _v2 = options.kQ;
			if (!_v2) {
				return 20;
			} else {
				return 30;
			}
		}();
		var checkWidth = function () {
			var _v1 = options.kQ;
			if (!_v1) {
				return 9;
			} else {
				return 18;
			}
		}();
		var checkHeight = function () {
			var _v0 = options.kQ;
			if (!_v0) {
				return 6;
			} else {
				return 11;
			}
		}();
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width(
					$lucamug$elm_ui_with_context$Element$WithContext$px(size)),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(size)),
					$lucamug$elm_ui_with_context$Element$WithContext$centerY,
					$lucamug$elm_ui_with_context$Element$WithContext$padding(2)
				]),
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(2),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$width(2),
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(
						isChecked ? $author$project$TT$Color$primaryLight : $author$project$TT$Color$transparent),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
						isChecked ? $author$project$TT$Color$primaryLight : $author$project$TT$Color$gray3),
						$lucamug$elm_ui_with_context$Element$WithContext$inFront(
						A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$white),
									$lucamug$elm_ui_with_context$Element$WithContext$height(
									$lucamug$elm_ui_with_context$Element$WithContext$px(checkHeight)),
									$lucamug$elm_ui_with_context$Element$WithContext$width(
									$lucamug$elm_ui_with_context$Element$WithContext$px(checkWidth)),
									$lucamug$elm_ui_with_context$Element$WithContext$rotate(
									$elm$core$Basics$degrees(-45)),
									$lucamug$elm_ui_with_context$Element$WithContext$centerX,
									$lucamug$elm_ui_with_context$Element$WithContext$centerY,
									$lucamug$elm_ui_with_context$Element$WithContext$moveUp(
									(!options.kQ) ? 1 : 3),
									$lucamug$elm_ui_with_context$Element$WithContext$transparent(!isChecked),
									$lucamug$elm_ui_with_context$Element$WithContext$Border$widthEach(
									{
										hb: (!options.kQ) ? 2 : 4,
										jf: (!options.kQ) ? 2 : 4,
										ku: 0,
										lz: 0
									})
								]),
							$lucamug$elm_ui_with_context$Element$WithContext$none))
					]),
				$lucamug$elm_ui_with_context$Element$WithContext$none));
	});
var $mdgriffith$elm_ui$Element$Input$OnRight = 0;
var $mdgriffith$elm_ui$Element$Input$labelRight = $mdgriffith$elm_ui$Element$Input$Label(0);
var $lucamug$elm_ui_with_context$Element$WithContext$Input$labelRight = $lucamug$elm_ui_with_context$Element$WithContext$Input$buildLabel($mdgriffith$elm_ui$Element$Input$labelRight);
var $author$project$TT$Checkbox$render = function (_v0) {
	var options = _v0.a;
	var label = _v0.b;
	var isChecked = _v0.c;
	var msg = _v0.d;
	var labelAttrs = function () {
		var _v3 = options.av;
		if (!_v3) {
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$black)
				]);
		} else {
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$gray2)
				]);
		}
	}();
	var cursor = function () {
		var _v2 = options.av;
		if (!_v2) {
			return _List_Nil;
		} else {
			return _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					A2($elm$html$Html$Attributes$style, 'cursor', 'not-allowed'))
				]);
		}
	}();
	return A2(
		$lucamug$elm_ui_with_context$Element$WithContext$Input$checkbox,
		_Utils_ap(
			cursor,
			A2(
				$elm$core$List$cons,
				$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
				options.dh)),
		{
			hs: isChecked,
			iI: $author$project$TT$Checkbox$customCheckboxIcon(options),
			dQ: A2(
				$lucamug$elm_ui_with_context$Element$WithContext$Input$labelRight,
				_Utils_ap(
					labelAttrs,
					_Utils_ap(
						$author$project$TT$Font$body2,
						_List_fromArray(
							[$lucamug$elm_ui_with_context$Element$WithContext$centerY]))),
				function () {
					var _v1 = options.cR;
					if (!_v1.$) {
						var labelElement = _v1.a;
						return labelElement;
					} else {
						return $lucamug$elm_ui_with_context$Element$WithContext$text(label);
					}
				}()),
			jF: msg
		});
};
var $mdgriffith$elm_ui$Element$Region$description = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Describe, $mdgriffith$elm_ui$Internal$Model$Label);
var $lucamug$elm_ui_with_context$Element$WithContext$Region$description = function (desc) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute(
		$mdgriffith$elm_ui$Element$Region$description(desc));
};
var $author$project$TT$Color$gray3Light = $author$project$TT$Color$Extra$hexToColor('#ebecee');
var $author$project$TT$IconButton$renderWithTheme = F2(
	function (theme, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var label = _v0.c;
		var icon = _v0.d;
		var paddingValue = function () {
			var _v16 = options.aw;
			if (!_v16) {
				var _v17 = options.kQ;
				if (!_v17) {
					return 12;
				} else {
					return 8;
				}
			} else {
				var _v18 = options.kQ;
				if (!_v18) {
					return 8;
				} else {
					return 6;
				}
			}
		}();
		var iconColor = function () {
			var _v13 = options.aw;
			if (!_v13) {
				var _v14 = options.hz;
				switch (_v14) {
					case 3:
						return $author$project$TT$Color$white;
					case 6:
						return $author$project$TT$Color$secondary;
					case 7:
						return $author$project$TT$Color$tertiary;
					case 0:
						return $author$project$TT$Color$white;
					case 1:
						return $author$project$TT$Color$white;
					case 2:
						return $author$project$TT$Color$white;
					case 4:
						return $author$project$TT$Color$gray1;
					default:
						return $author$project$TT$Color$white;
				}
			} else {
				var _v15 = options.hz;
				switch (_v15) {
					case 3:
						return $author$project$TT$Color$primary;
					case 6:
						return $author$project$TT$Color$secondary;
					case 7:
						return $author$project$TT$Color$tertiary;
					case 0:
						return $author$project$TT$Color$gray1;
					case 1:
						return $author$project$TT$Color$gray2;
					case 2:
						return $author$project$TT$Color$gray3;
					case 4:
						return $author$project$TT$Color$white;
					default:
						return $author$project$TT$Color$error;
				}
			}
		}();
		var iconView = function () {
			var _v11 = options.av;
			switch (_v11) {
				case 0:
					return icon;
				case 1:
					var iconSize = function () {
						var _v12 = options.kQ;
						if (!_v12) {
							return 18;
						} else {
							return 14;
						}
					}();
					return A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_Nil,
						A3($author$project$TT$Spinner$spinner, 1, iconSize, iconColor));
				default:
					return icon;
			}
		}();
		var disabledStyles = function () {
			var _v10 = options.av;
			if (_v10 === 2) {
				return _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'cursor', 'not-allowed'))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var borderRoundedValue = paddingValue * 3;
		var borderAttr = function () {
			var _v9 = options.aw;
			if (!_v9) {
				return _List_Nil;
			} else {
				return _List_Nil;
			}
		}();
		var bgColorBase = function () {
			var _v7 = options.aw;
			if (!_v7) {
				var _v8 = options.hz;
				switch (_v8) {
					case 3:
						return $author$project$TT$Color$primary;
					case 6:
						return $author$project$TT$Color$secondary;
					case 7:
						return $author$project$TT$Color$tertiary;
					case 0:
						return $author$project$TT$Color$gray1;
					case 1:
						return $author$project$TT$Color$gray2;
					case 2:
						return $author$project$TT$Color$gray3;
					case 4:
						return $author$project$TT$Color$white;
					default:
						return $author$project$TT$Color$error;
				}
			} else {
				return $author$project$TT$Color$transparent;
			}
		}();
		var bgColor = function () {
			switch (theme) {
				case 0:
					return bgColorBase;
				case 1:
					return $author$project$TT$Color$white;
				default:
					return bgColorBase;
			}
		}();
		var bgColorAttr = _List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$Background$color(bgColor)
			]);
		var backgroundMouseOverColor = function () {
			switch (theme) {
				case 0:
					var _v3 = options.aw;
					if (!_v3) {
						return A2($author$project$TT$Color$Extra$lighten, 0.12, bgColor);
					} else {
						return A2($author$project$TT$Color$Extra$fadeOut, 0.8, iconColor);
					}
				case 1:
					var _v4 = options.aw;
					if (!_v4) {
						return A2($author$project$TT$Color$Extra$lighten, 0.12, $author$project$TT$Color$gray3);
					} else {
						return A2($author$project$TT$Color$Extra$fadeOut, 0.2, $author$project$TT$Color$gray3Light);
					}
				default:
					var _v5 = options.aw;
					if (!_v5) {
						return A2($author$project$TT$Color$Extra$lighten, 0.12, bgColor);
					} else {
						return A2($author$project$TT$Color$Extra$fadeOut, 0.8, iconColor);
					}
			}
		}();
		var mouseOverStyles = function () {
			var _v1 = options.aw;
			if (!_v1) {
				return _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(backgroundMouseOverColor)
					]);
			} else {
				return _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(backgroundMouseOverColor)
					]);
			}
		}();
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$Input$button,
			_Utils_ap(
				bgColorAttr,
				_Utils_ap(
					borderAttr,
					_Utils_ap(
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$padding(paddingValue),
								$lucamug$elm_ui_with_context$Element$WithContext$centerX,
								$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(borderRoundedValue),
								$lucamug$elm_ui_with_context$Element$WithContext$Font$color(iconColor),
								$lucamug$elm_ui_with_context$Element$WithContext$mouseOver(mouseOverStyles),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'transition-duration', '.15s')),
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'transition-timing-function', 'cubic-bezier(.4,0,1,1)')),
								$lucamug$elm_ui_with_context$Element$WithContext$Region$description(label)
							]),
						_Utils_ap(options.bF, disabledStyles)))),
			{
				dQ: iconView,
				jI: $elm$core$Maybe$Just(msg)
			});
	});
var $lucamug$elm_ui_with_context$Element$WithContext$withContext = function (f) {
	return function (context) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$Internal$run,
			context,
			f(context));
	};
};
var $author$project$TT$IconButton$render = function (iconButton) {
	return $lucamug$elm_ui_with_context$Element$WithContext$withContext(
		function (context) {
			return A2($author$project$TT$IconButton$renderWithTheme, context.lo, iconButton);
		});
};
var $author$project$TT$IconButton$withColor = F2(
	function (color, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var label = _v0.c;
		var icon = _v0.d;
		return A4(
			$author$project$TT$IconButton$IconButton,
			_Utils_update(
				options,
				{hz: color}),
			msg,
			label,
			icon);
	});
var $author$project$TT$IconButton$withSize = F2(
	function (size, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var label = _v0.c;
		var icon = _v0.d;
		return A4(
			$author$project$TT$IconButton$IconButton,
			_Utils_update(
				options,
				{kQ: size}),
			msg,
			label,
			icon);
	});
var $author$project$TT$IconButton$withStyle = F2(
	function (style, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var label = _v0.c;
		var icon = _v0.d;
		return A4(
			$author$project$TT$IconButton$IconButton,
			_Utils_update(
				options,
				{aw: style}),
			msg,
			label,
			icon);
	});
var $author$project$TT$Checkbox$withWrapperAttrs = F2(
	function (wrapperAttrs, _v0) {
		var options = _v0.a;
		var label = _v0.b;
		var isChecked = _v0.c;
		var msg = _v0.d;
		return A4(
			$author$project$TT$Checkbox$Checkbox,
			_Utils_update(
				options,
				{dh: wrapperAttrs}),
			label,
			isChecked,
			msg);
	});
var $author$project$Page$Home$viewCandidateCvStage = function (model) {
	var candidateCvStageModel = model.k;
	var cvExists = function () {
		var _v8 = candidateCvStageModel.u.hm;
		if (!_v8.$) {
			return true;
		} else {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (_v9) {
						return true;
					},
					candidateCvStageModel.u.hg));
		}
	}();
	var isCurrentCvFromProfile = function () {
		var _v7 = candidateCvStageModel.u.hm;
		if (!_v7.$) {
			return false;
		} else {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (currentCandidateApplyInfo) {
						return currentCandidateApplyInfo.ff;
					},
					model.X));
		}
	}();
	var candidateAlreadyApplied = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (currentCandidateApplyInfo) {
				return currentCandidateApplyInfo.er;
			},
			model.X));
	var showButtonForApproval = (isCurrentCvFromProfile || (candidateAlreadyApplied && cvExists)) && (!model.cy);
	return A5(
		$author$project$Page$Home$viewChatContainer,
		model,
		true,
		A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(28),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 0, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
					$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$id('chatContainer')),
					$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'display', 'none'))
							]),
						$lucamug$elm_ui_with_context$Element$WithContext$html(
							A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('file'),
										$elm$html$Html$Attributes$id($author$project$Page$Home$cvInputFieldIdForApply),
										$elm$html$Html$Attributes$name('cvFile'),
										A2(
										$elm$html$Html$Events$on,
										'change',
										$elm$json$Json$Decode$succeed($author$project$Page$Home$MsgCvFileFromCandidateApplySelected)),
										$elm$html$Html$Attributes$hidden(true),
										$elm$html$Html$Attributes$accept('application/pdf,application/x-pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/rtf,application/vnd.ms-word.document.12,application/vnd.oasis.opendocument.text')
									]),
								_List_Nil))))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A3(
						$author$project$Page$Home$viewTalentinoActiveQuestionBubble,
						model,
						_List_Nil,
						A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							_Utils_ap(
								$author$project$TT$Font$body2,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
									])),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text('¿Quieres enviarle un mensaje al reclutador? (opcional)')
								]))),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
							]),
						$author$project$TT$FormField$render(
							A2(
								$author$project$TT$FormField$withPlaceholder,
								$lucamug$elm_ui_with_context$Element$WithContext$text('Ingresa tu mensaje. Ej: ¿Por qué eres un buen candidato para este puesto?'),
								A2(
									$author$project$TT$FormField$withFieldAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$id('message')),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Events$onFocus($author$project$Page$Home$MsgUserFocusedInput)),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Events$onBlur($author$project$Page$Home$MsgUserLeftInput))
										]),
									A2(
										$author$project$TT$FormField$withInputType,
										2,
										A2(
											$author$project$TT$FormField$withLabelType,
											1,
											A2(
												$author$project$TT$FormField$withWrapperAttrs,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
													]),
												A3($author$project$TT$FormField$default, $author$project$Page$Home$MsgUserChangedMessage, candidateCvStageModel.u.js, '')))))))),
						$author$project$TT$Checkbox$render(
						A2(
							$author$project$TT$Checkbox$withWrapperAttrs,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('alerts-checkbox')),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('sentry-mask'))
								]),
							A3($author$project$TT$Checkbox$default, 'Quiero enterarme de empleos similares', candidateCvStageModel.u.k3, $author$project$Page$Home$MsgUserChangedSubscribeToNotificationsCheckbox)))
					]),
				_Utils_ap(
					model.aC ? _List_Nil : _List_fromArray(
						[
							$author$project$TT$Checkbox$render(
							A2(
								$author$project$TT$Checkbox$withWrapperAttrs,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('sentry-mask'))
									]),
								A3($author$project$TT$Checkbox$default, 'Permitir que otros reclutadores vean mi CV', candidateCvStageModel.u.j1, $author$project$Page$Home$MsgUserChangedPublicCvCheckbox)))
						]),
					candidateCvStageModel.br ? _List_fromArray(
						[
							function () {
							var label = isCurrentCvFromProfile ? 'Cargamos el último CV/hoja de vida que tenemos de ti. Revísalo y actualízalo si es necesario.' : ((candidateAlreadyApplied && cvExists) ? 'Revisa el CV/hoja de vida que has agregado en caso de que desees actualizarlo.' : 'Aumenta tus probabilidades para conseguir este puesto! Incluye tu CV/hoja de vida.');
							return A3(
								$author$project$Page$Home$viewTalentinoActiveQuestionBubble,
								model,
								_List_Nil,
								A2(
									$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
									_Utils_ap(
										$author$project$TT$Font$body2,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
											])),
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$text(label)
										])));
						}(),
							function () {
							var msgForDownloadCv = function () {
								var _v6 = candidateCvStageModel.u.hm;
								if (!_v6.$) {
									return $elm$core$Maybe$Nothing;
								} else {
									return A2(
										$elm$core$Maybe$andThen,
										function (currentCandidateApplyInfo) {
											return A2(
												$elm$core$Maybe$map,
												function (cvDownloadLink) {
													return $author$project$Page$Home$MsgUserPressedDownloadCv(cvDownloadLink);
												},
												currentCandidateApplyInfo.eH);
										},
										model.X);
								}
							}();
							var fileNameMaybe = function () {
								var _v5 = candidateCvStageModel.u.hm;
								if (!_v5.$) {
									var candidateCurrentCv = _v5.a;
									return $elm$core$Maybe$Just(candidateCurrentCv.ie);
								} else {
									return A2(
										$elm$core$Maybe$andThen,
										function (candidateCurrentCv) {
											return $elm$core$List$head(
												$elm$core$List$reverse(
													A2($elm$core$String$split, '/', candidateCurrentCv.dq)));
										},
										candidateCvStageModel.u.hg);
								}
							}();
							var fileNameShrinkedMaybe = A2(
								$elm$core$Maybe$map,
								function (fileName) {
									var _v3 = A2($elm$core$String$split, '.', fileName);
									if ((_v3.b && _v3.b.b) && (!_v3.b.b.b)) {
										var name = _v3.a;
										var _v4 = _v3.b;
										var ext = _v4.a;
										return ($elm$core$String$length(name) > 25) ? (A3($elm$core$String$slice, 0, 10, name) + ('...' + (A3(
											$elm$core$String$slice,
											-9,
											$elm$core$String$length(name),
											name) + ('.' + ext)))) : fileName;
									} else {
										return fileName;
									}
								},
								fileNameMaybe);
							var cvFromProfileDate = isCurrentCvFromProfile ? A2(
								$elm$core$Maybe$andThen,
								function (c) {
									return c.eG;
								},
								model.X) : $elm$core$Maybe$Nothing;
							if (!fileNameShrinkedMaybe.$) {
								var fileNameShrinked = fileNameShrinkedMaybe.a;
								var bubbleBaseWidth = $author$project$Page$Home$getMainContainerWidth(model);
								return A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$spacing(28),
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									_List_fromArray(
										[
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$column,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
													$lucamug$elm_ui_with_context$Element$WithContext$spacing(8)
												]),
											_List_fromArray(
												[
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$row,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$spacing(4),
															$lucamug$elm_ui_with_context$Element$WithContext$alignRight
														]),
													_List_fromArray(
														[
															A2(
															$lucamug$elm_ui_with_context$Element$WithContext$el,
															_List_fromArray(
																[$lucamug$elm_ui_with_context$Element$WithContext$centerY]),
															$author$project$TT$IconButton$render(
																A2(
																	$author$project$TT$IconButton$withSize,
																	1,
																	A2(
																		$author$project$TT$IconButton$withStyle,
																		0,
																		A2(
																			$author$project$TT$IconButton$withColor,
																			1,
																			A3(
																				$author$project$TT$IconButton$default,
																				$author$project$Page$Home$MsgUserPressedCvUploadButton,
																				'Editar',
																				$author$project$TT$IT$render(
																					A2(
																						$author$project$TT$IT$withSize,
																						12,
																						A2(
																							$author$project$TT$IT$withColor,
																							$author$project$TT$Color$white,
																							$author$project$TT$IT$editPencil(_List_Nil)))))))))),
															A2(
															$lucamug$elm_ui_with_context$Element$WithContext$el,
															_List_fromArray(
																[
																	A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 8),
																	$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$class('elevation-1')),
																	$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
																	{hc: 8, hd: 8, lA: 8, lB: 0}),
																	$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
																	$lucamug$elm_ui_with_context$Element$WithContext$width(
																	A3(
																		$elm$core$Basics$apL,
																		$lucamug$elm_ui_with_context$Element$WithContext$maximum,
																		$elm$core$Basics$ceiling(((bubbleBaseWidth - 32) * 80) / 100),
																		$lucamug$elm_ui_with_context$Element$WithContext$fill))
																]),
															A2(
																$lucamug$elm_ui_with_context$Element$WithContext$row,
																_List_fromArray(
																	[
																		$lucamug$elm_ui_with_context$Element$WithContext$spacing(8)
																	]),
																_List_fromArray(
																	[
																		$author$project$TT$IT$render(
																		A2(
																			$author$project$TT$IT$withSize,
																			36,
																			A2(
																				$author$project$TT$IT$withColor,
																				$author$project$TT$Color$gray2,
																				$author$project$TT$IT$upload(_List_Nil)))),
																		A2(
																		$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																		_Utils_ap(
																			$author$project$TT$Font$body2,
																			_Utils_ap(
																				_List_fromArray(
																					[
																						$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
																						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
																						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																						$elm$html$Html$Attributes$class('uploaded-cv-file-name')),
																						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																						$elm$html$Html$Attributes$class('sentry-mask'))
																					]),
																				function () {
																					if (!msgForDownloadCv.$) {
																						var downloadMsg = msgForDownloadCv.a;
																						return _List_fromArray(
																							[
																								$lucamug$elm_ui_with_context$Element$WithContext$pointer,
																								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(downloadMsg),
																								$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$secondary)
																							]);
																					} else {
																						return _List_Nil;
																					}
																				}())),
																		_List_fromArray(
																			[
																				$lucamug$elm_ui_with_context$Element$WithContext$text(fileNameShrinked)
																			]))
																	])))
														])),
													function () {
													if (!cvFromProfileDate.$) {
														var date = cvFromProfileDate.a;
														return A2(
															$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
															_Utils_ap(
																$author$project$TT$Font$linkSmall,
																_List_fromArray(
																	[
																		$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$gray2),
																		$lucamug$elm_ui_with_context$Element$WithContext$alignRight
																	])),
															_List_fromArray(
																[
																	A2(
																	$lucamug$elm_ui_with_context$Element$WithContext$el,
																	_List_fromArray(
																		[$lucamug$elm_ui_with_context$Element$WithContext$alignRight]),
																	$lucamug$elm_ui_with_context$Element$WithContext$text(date))
																]));
													} else {
														return $lucamug$elm_ui_with_context$Element$WithContext$none;
													}
												}()
												])),
											showButtonForApproval ? $lucamug$elm_ui_with_context$Element$WithContext$none : A3(
											$author$project$Page$Home$viewTalentinoActiveQuestionBubble,
											model,
											_List_Nil,
											A2(
												$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
												_Utils_ap(
													$author$project$TT$Font$body2,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
														])),
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$text('¡Genial! Ahora puedes finalizar tu postulación')
													])))
										]));
							} else {
								return A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$spacing(4)
										]),
									_List_fromArray(
										[
											$author$project$TT$Button$render(
											A2(
												$author$project$TT$Button$withState,
												model.ap ? $author$project$TT$Button$StateLoading(
													$elm$core$Maybe$Just('Cargando archivo...')) : $author$project$TT$Button$StateDefault,
												A2(
													$author$project$TT$Button$withButtonAttrs,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$centerX,
															$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
															$elm$html$Html$Attributes$class('upload-cv'))
														]),
													A2(
														$author$project$TT$Button$withSize,
														1,
														A2(
															$author$project$TT$Button$withRole,
															0,
															A2(
																$author$project$TT$Button$default,
																$elm$core$Maybe$Just($author$project$Page$Home$MsgUserPressedCvUploadButton),
																'Subir archivo')))))),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
											_Utils_ap(
												$author$project$TT$Font$body3,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$gray1),
														$lucamug$elm_ui_with_context$Element$WithContext$centerX,
														$lucamug$elm_ui_with_context$Element$WithContext$Font$center
													])),
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$text('(recuerda que puedes subir un archivo de hasta '),
													A2(
													$lucamug$elm_ui_with_context$Element$WithContext$el,
													_List_fromArray(
														[$lucamug$elm_ui_with_context$Element$WithContext$Font$bold]),
													$lucamug$elm_ui_with_context$Element$WithContext$text('10MB'))
												]))
										]));
							}
						}(),
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, 80)
								]),
							$lucamug$elm_ui_with_context$Element$WithContext$none)
						]) : _List_Nil))),
		(candidateCvStageModel.br && (!showButtonForApproval)) ? A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					A2($lucamug$elm_ui_with_context$Element$WithContext$Border$widthXY, 0, 1),
					$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$gray3),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12),
					$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
					{
						g5: 20,
						hz: $author$project$TT$Color$gray2,
						jE: _Utils_Tuple2(0, 3),
						kQ: -3
					})
				]),
			_List_fromArray(
				[
					$author$project$TT$Button$render(
					A2(
						$author$project$TT$Button$withState,
						candidateCvStageModel.bm ? $author$project$TT$Button$StateLoading(
							$elm$core$Maybe$Just('Enviando')) : $author$project$TT$Button$StateDefault,
						A2(
							$author$project$TT$Button$withButtonAttrs,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$centerX,
									$lucamug$elm_ui_with_context$Element$WithContext$centerY,
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$class('talapoin-submit-stage-3'))
								]),
							A2(
								$author$project$TT$Button$withSize,
								0,
								A2(
									$author$project$TT$Button$withRole,
									1,
									A2(
										$author$project$TT$Button$default,
										$elm$core$Maybe$Just($author$project$Page$Home$MsgUserSubmittedCandidateCvInfo),
										'Finalizar aplicación'))))))
				])) : A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					A2($lucamug$elm_ui_with_context$Element$WithContext$Border$widthXY, 0, 1),
					$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$gray3),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12),
					$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
					{
						g5: 20,
						hz: $author$project$TT$Color$gray2,
						jE: _Utils_Tuple2(0, 3),
						kQ: -3
					})
				]),
			_List_fromArray(
				[
					$author$project$TT$Button$render(
					A2(
						$author$project$TT$Button$withButtonAttrs,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$centerX,
								$lucamug$elm_ui_with_context$Element$WithContext$centerY,
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$class('continue-cv'))
							]),
						A2(
							$author$project$TT$Button$withSize,
							0,
							A2(
								$author$project$TT$Button$withRole,
								1,
								A2(
									$author$project$TT$Button$default,
									$elm$core$Maybe$Just(
										(candidateCvStageModel.br && showButtonForApproval) ? $author$project$Page$Home$MsgUserPressedApproveCurrentCv : $author$project$Page$Home$MsgUserSubmittedMessage),
									'Continuar')))))
				])),
		candidateCvStageModel.aJ);
};
var $author$project$Page$Home$getCandidateInfoStageErrorMessage = function (model) {
	var _v0 = model.a.l;
	switch (_v0) {
		case 0:
			return model.a.b.cB.bM;
		case 1:
			return model.a.b.dG.bM;
		case 2:
			return model.a.b.jT.bM;
		case 3:
			return model.a.b.hT.bM;
		case 4:
			return model.a.b.cU.bM;
		case 5:
			return model.a.b.dK.bM;
		default:
			return model.a.G;
	}
};
var $author$project$Page$Home$MsgUserChangedEmail = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Home$MsgUserChangedFullname = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Home$MsgUserChangedHeadline = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$Home$MsgUserChangedPhone = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Page$Home$MsgUserLeftEmailInput = {$: 14};
var $author$project$Page$Home$MsgUserLeftFullnameInput = {$: 15};
var $author$project$Page$Home$MsgUserLeftHeadlineInput = {$: 18};
var $author$project$Page$Home$MsgUserLeftPhoneInput = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$Home$MsgUserPressedCloseCountryOptionalStep = {$: 120};
var $author$project$Page$Home$MsgUserSubmittedCandidateInfo = function (a) {
	return {$: 20, a: a};
};
var $author$project$Page$Home$MsgUserSubmittedCountry = {$: 117};
var $author$project$Page$Home$MsgUserSubmittedEmail = {$: 7};
var $author$project$Page$Home$MsgUserSubmittedFullname = {$: 9};
var $author$project$Page$Home$MsgUserSubmittedHeadline = {$: 19};
var $author$project$Page$Home$MsgUserSubmittedLocation = {$: 12};
var $author$project$Page$Home$MsgUserSubmittedPhone = function (a) {
	return {$: 11, a: a};
};
var $author$project$TT$IconButton$Secondary = 6;
var $author$project$Page$Home$onEnter = function (msg) {
	return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
		A2(
			$elm$html$Html$Events$on,
			'keyup',
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return (key === 'Enter') ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('Not the enter key');
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
};
var $author$project$TT$IT$send = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'send',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_Nil)
			]));
};
var $author$project$TT$IconButton$withButtonAttrs = F2(
	function (buttonAttrs, _v0) {
		var options = _v0.a;
		var msg = _v0.b;
		var label = _v0.c;
		var icon = _v0.d;
		return A4(
			$author$project$TT$IconButton$IconButton,
			_Utils_update(
				options,
				{bF: buttonAttrs}),
			msg,
			label,
			icon);
	});
var $author$project$Page$Home$viewCommonInputAndButton = F8(
	function (model, tkCommonField, inputPlaceholder, inputType, inputMsg, inputOnBlurMsg, btnMsg, inputId) {
		var hasError = !_Utils_eq(tkCommonField.bM, $elm$core$Maybe$Nothing);
		var buttonActive = !((!_Utils_eq(tkCommonField.bM, $elm$core$Maybe$Nothing)) || (tkCommonField.cO === ''));
		var buttonColor = buttonActive ? 6 : 1;
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$row,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
					$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray3Light),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12),
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
					(!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(0) : $lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
					{hc: 8, hd: 8, lA: 0, lB: 0})
				]),
			_List_fromArray(
				[
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
						]),
					$author$project$TT$FormField$render(
						A2(
							$author$project$TT$FormField$withState,
							hasError ? 2 : 0,
							A2(
								$author$project$TT$FormField$withInputType,
								inputType,
								A2(
									$author$project$TT$FormField$withPlaceholder,
									$lucamug$elm_ui_with_context$Element$WithContext$text(inputPlaceholder),
									A2(
										$author$project$TT$FormField$withFieldAttrs,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(16),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Events$onBlur(inputOnBlurMsg)),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Attributes$id(inputId)),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Attributes$autocomplete(false)),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Attributes$spellcheck(false)),
												$author$project$Page$Home$onEnter(btnMsg),
												$lucamug$elm_ui_with_context$Element$WithContext$focused(
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
														hasError ? $author$project$TT$Color$error : $author$project$TT$Color$primary)
													]))
											]),
										A2(
											$author$project$TT$FormField$withWrapperAttrs,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
												]),
											A2(
												$author$project$TT$FormField$withLabelType,
												1,
												A3($author$project$TT$FormField$default, inputMsg, tkCommonField.cO, ''))))))))),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_Nil,
					$author$project$TT$IconButton$render(
						A2(
							$author$project$TT$IconButton$withStyle,
							0,
							A2(
								$author$project$TT$IconButton$withColor,
								buttonColor,
								A2(
									$author$project$TT$IconButton$withButtonAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$class('talapoin-submit-intermedite-step'))
										]),
									A3(
										$author$project$TT$IconButton$default,
										btnMsg,
										'Enviar',
										$author$project$TT$IT$render(
											A2(
												$author$project$TT$IT$withSize,
												20,
												A2(
													$author$project$TT$IT$withColor,
													$author$project$TT$Color$white,
													$author$project$TT$IT$send(_List_Nil))))))))))
				]));
	});
var $author$project$TT$IconButton$Gray3 = 2;
var $author$project$Page$Home$viewCountryInputAndButton = F9(
	function (model, tkCountryField, dropdownModel, dropdownChangedMsg, dropdownSelectChangedMsg, dropdownContainerClass, dropdownOptionsListClass, btnMsg, btnCloseOptionalStep) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$row,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
					$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray3Light),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12),
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
					(!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(0) : $lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
					{hc: 8, hd: 8, lA: 0, lB: 0}),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class('sentry-mask'))
				]),
			_List_fromArray(
				[
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
						]),
					A3(
						$author$project$TT$Dropdown$view,
						A6(
							$author$project$Page$Home$commonSelectDropdown,
							tkCountryField.g,
							!_Utils_eq(tkCountryField.bM, $elm$core$Maybe$Nothing),
							dropdownChangedMsg,
							dropdownSelectChangedMsg,
							dropdownContainerClass,
							dropdownOptionsListClass),
						model,
						dropdownModel)),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_Nil,
					$author$project$TT$IconButton$render(
						A2(
							$author$project$TT$IconButton$withStyle,
							0,
							A2(
								$author$project$TT$IconButton$withButtonAttrs,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('talapoin-cancel-country-step'))
									]),
								A2(
									$author$project$TT$IconButton$withColor,
									2,
									A3(
										$author$project$TT$IconButton$default,
										btnCloseOptionalStep,
										'Cancelar',
										$author$project$TT$IT$render(
											A2(
												$author$project$TT$IT$withSize,
												20,
												A2(
													$author$project$TT$IT$withStrokeWidth,
													2,
													A2(
														$author$project$TT$IT$withColor,
														$author$project$TT$Color$grayDark,
														$author$project$TT$IT$close(_List_Nil))))))))))),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_Nil,
					$author$project$TT$IconButton$render(
						A2(
							$author$project$TT$IconButton$withStyle,
							0,
							A2(
								$author$project$TT$IconButton$withButtonAttrs,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('talapoin-submit-country-step'))
									]),
								A2(
									$author$project$TT$IconButton$withColor,
									6,
									A3(
										$author$project$TT$IconButton$default,
										btnMsg,
										'Enviar',
										$author$project$TT$IT$render(
											A2(
												$author$project$TT$IT$withSize,
												20,
												A2(
													$author$project$TT$IT$withColor,
													$author$project$TT$Color$white,
													$author$project$TT$IT$send(_List_Nil))))))))))
				]));
	});
var $author$project$Page$Home$MsgCitiesListSearchReceived = function (a) {
	return {$: 121, a: a};
};
var $author$project$Page$Home$MsgUserPressedChangeCountry = {$: 115};
var $author$project$TT$Dropdown$isItemSelected = function (_v0) {
	var config = _v0;
	return !_Utils_eq(config.f4, $elm$core$Maybe$Nothing);
};
var $author$project$TT$Dropdown$isMatchedOptionsEmpty = function (_v0) {
	var state = _v0;
	return $elm$core$List$isEmpty(state.Z);
};
var $lucamug$elm_ui_with_context$Element$WithContext$Lazy$apply3 = F5(
	function (context, fn, a, b, c) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$Internal$run,
			context,
			A3(fn, a, b, c));
	});
var $mdgriffith$elm_ui$Element$Lazy$apply5 = F6(
	function (fn, a, b, c, d, e) {
		return $mdgriffith$elm_ui$Element$Lazy$embed(
			A5(fn, a, b, c, d, e));
	});
var $elm$virtual_dom$VirtualDom$lazy7 = _VirtualDom_lazy7;
var $mdgriffith$elm_ui$Element$Lazy$lazy5 = F6(
	function (fn, a, b, c, d, e) {
		return $mdgriffith$elm_ui$Internal$Model$Unstyled(
			A7($elm$virtual_dom$VirtualDom$lazy7, $mdgriffith$elm_ui$Element$Lazy$apply5, fn, a, b, c, d, e));
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Lazy$lazy3 = F4(
	function (fn, a, b, c) {
		return function (context) {
			return A6($mdgriffith$elm_ui$Element$Lazy$lazy5, $lucamug$elm_ui_with_context$Element$WithContext$Lazy$apply3, context, fn, a, b, c);
		};
	});
var $author$project$Model$TkCityDo = F4(
	function (region_name, region_id, city_name, city_id) {
		return {ht: city_id, ez: city_name, kp: region_id, fT: region_name};
	});
var $author$project$Model$cityApiResponseDoJsonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'city_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'city_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'region_id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'region_name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$TkCityDo)))));
var $author$project$Model$cityListApiResponseDoJsonDecoder = $elm$json$Json$Decode$list($author$project$Model$cityApiResponseDoJsonDecoder);
var $author$project$Model$citiesListDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail']),
	$author$project$Model$cityListApiResponseDoJsonDecoder);
var $author$project$Page$Home$viewCityFuseJsElement = F4(
	function (msgCitiesListSearchReceived, versionedAssetsUrl, countryCode, value) {
		return $lucamug$elm_ui_with_context$Element$WithContext$html(
			A3(
				$elm$html$Html$node,
				'fuse-js',
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'value', value),
						A2($elm$html$Html$Attributes$attribute, 'url', versionedAssetsUrl + ('country/' + (countryCode + '.json'))),
						A2($elm$html$Html$Attributes$attribute, 'refresh', 'false'),
						A2($elm$html$Html$Attributes$attribute, 'keys', 'city_name,city_name_normalized,region_name,region_name_normalized,city_region'),
						A2($elm$html$Html$Attributes$attribute, 'id', 'city'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'threshold',
						$elm$core$String$fromFloat(0.3)),
						A2(
						$elm$html$Html$Events$on,
						'change',
						A2($elm$json$Json$Decode$map, msgCitiesListSearchReceived, $author$project$Model$citiesListDecoder))
					]),
				_List_Nil));
	});
var $author$project$Page$Home$viewLocationInputAndButton = F3(
	function (model, tkLocationField, btnMsg) {
		var locationDropdownConfig = $author$project$Page$Home$citiesDropdown(model);
		var buttonActive = !((!_Utils_eq(tkLocationField.bM, $elm$core$Maybe$Nothing)) || (tkLocationField.cO === ''));
		var buttonColor = buttonActive ? 6 : 1;
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
				]),
			_List_fromArray(
				[
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$row,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray3Light),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12),
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
							(!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(0) : $lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
							{hc: 8, hd: 8, lA: 0, lB: 0}),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('sentry-mask'))
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								]),
							A3($author$project$TT$Dropdown$view, locationDropdownConfig, model, model.a.ak)),
							($author$project$TT$Dropdown$isMatchedOptionsEmpty(model.a.ak) && ((!(tkLocationField.cO === '')) && (!$author$project$TT$Dropdown$isItemSelected(locationDropdownConfig)))) ? $author$project$TT$Button$render(
							A2(
								$author$project$TT$Button$withButtonAttrs,
								_List_fromArray(
									[$lucamug$elm_ui_with_context$Element$WithContext$centerX]),
								A2(
									$author$project$TT$Button$withSize,
									1,
									A2(
										$author$project$TT$Button$withStyle,
										1,
										A2(
											$author$project$TT$Button$withRole,
											1,
											A2(
												$author$project$TT$Button$default,
												$elm$core$Maybe$Just($author$project$Page$Home$MsgUserPressedChangeCountry),
												'Cambiar país')))))) : $lucamug$elm_ui_with_context$Element$WithContext$none,
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$el,
							_List_Nil,
							$author$project$TT$IconButton$render(
								A2(
									$author$project$TT$IconButton$withStyle,
									0,
									A2(
										$author$project$TT$IconButton$withButtonAttrs,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												$elm$html$Html$Attributes$class('talapoin-submit-location-step'))
											]),
										A2(
											$author$project$TT$IconButton$withColor,
											buttonColor,
											A3(
												$author$project$TT$IconButton$default,
												btnMsg,
												'Enviar',
												$author$project$TT$IT$render(
													A2(
														$author$project$TT$IT$withSize,
														20,
														A2(
															$author$project$TT$IT$withColor,
															$author$project$TT$Color$white,
															$author$project$TT$IT$send(_List_Nil))))))))))
						])),
					A4(
					$lucamug$elm_ui_with_context$Element$WithContext$Lazy$lazy3,
					$author$project$Page$Home$viewCityFuseJsElement($author$project$Page$Home$MsgCitiesListSearchReceived),
					model.J.gl,
					A2($elm$core$Maybe$withDefault, 'mx', model.hU),
					model.a.b.cU.cO)
				]));
	});
var $author$project$Page$Home$viewBottomImput = F2(
	function (model, tkJobAdSummaryDo) {
		var _v0 = model.a.l;
		switch (_v0) {
			case 0:
				return A8($author$project$Page$Home$viewCommonInputAndButton, model, model.a.b.cB, 'Ingresa tu correo electrónico', 0, $author$project$Page$Home$MsgUserChangedEmail, $author$project$Page$Home$MsgUserLeftEmailInput, $author$project$Page$Home$MsgUserSubmittedEmail, 'email');
			case 1:
				return A8($author$project$Page$Home$viewCommonInputAndButton, model, model.a.b.dG, 'Ingresa tu nombre y apellido', 0, $author$project$Page$Home$MsgUserChangedFullname, $author$project$Page$Home$MsgUserLeftFullnameInput, $author$project$Page$Home$MsgUserSubmittedFullname, 'fullname');
			case 2:
				var phoneInputLabel = (tkJobAdSummaryDo.hU === 'mx') ? 'Ingresa tu número celular' : 'Ingresa tu código de país + número de celular';
				return A8(
					$author$project$Page$Home$viewCommonInputAndButton,
					model,
					model.a.b.jT,
					phoneInputLabel,
					0,
					$author$project$Page$Home$MsgUserChangedPhone(tkJobAdSummaryDo),
					$author$project$Page$Home$MsgUserLeftPhoneInput(tkJobAdSummaryDo),
					$author$project$Page$Home$MsgUserSubmittedPhone(tkJobAdSummaryDo),
					'phonenumber');
			case 3:
				return A9($author$project$Page$Home$viewCountryInputAndButton, model, model.a.b.hT, model.a.be, $author$project$Page$Home$MsgCountryDropdownChanged, $author$project$Page$Home$MsgCountryDropdownSelectChanged, 'country-container', 'country-options', $author$project$Page$Home$MsgUserSubmittedCountry, $author$project$Page$Home$MsgUserPressedCloseCountryOptionalStep);
			case 4:
				return A3($author$project$Page$Home$viewLocationInputAndButton, model, model.a.b.cU, $author$project$Page$Home$MsgUserSubmittedLocation);
			case 5:
				return A8($author$project$Page$Home$viewCommonInputAndButton, model, model.a.b.dK, 'Ej: \"Analista de Marketing con experiencia en la Industria Automotriz\"  o \"Graduado de Ingeniería Mecánica, experto en motores eléctricos\"', 0, $author$project$Page$Home$MsgUserChangedHeadline, $author$project$Page$Home$MsgUserLeftHeadlineInput, $author$project$Page$Home$MsgUserSubmittedHeadline, 'headline');
			default:
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
							{
								g5: 20,
								hz: $author$project$TT$Color$gray2,
								jE: _Utils_Tuple2(0, 3),
								kQ: -3
							}),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray4),
							A2($lucamug$elm_ui_with_context$Element$WithContext$Border$widthXY, 0, 1),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$gray3)
						]),
					$author$project$TT$Button$render(
						A2(
							$author$project$TT$Button$withState,
							model.a.bQ ? $author$project$TT$Button$StateLoading(
								$elm$core$Maybe$Just('Enviando')) : $author$project$TT$Button$StateDefault,
							A2(
								$author$project$TT$Button$withButtonAttrs,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$centerX,
										$lucamug$elm_ui_with_context$Element$WithContext$centerY,
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('talapoin-submit-stage-1'))
									]),
								A2(
									$author$project$TT$Button$withSize,
									0,
									A2(
										$author$project$TT$Button$withRole,
										1,
										A2(
											$author$project$TT$Button$default,
											$elm$core$Maybe$Just(
												$author$project$Page$Home$MsgUserSubmittedCandidateInfo(tkJobAdSummaryDo)),
											'Enviar mis datos')))))));
		}
	});
var $author$project$Page$Home$MsgUserClosedCandidateAlreadyAppliedMessage = {$: 82};
var $author$project$Page$Home$viewCandidateAlreadyAppliedMessage = function (model) {
	return model.b2 ? A2(
		$lucamug$elm_ui_with_context$Element$WithContext$el,
		_List_fromArray(
			[
				A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 8, 16),
				$lucamug$elm_ui_with_context$Element$WithContext$alignBottom,
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
			]),
		A2(
			$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$padding(8),
					$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
					$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(7),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class('elevation-4')),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class('talapoin-candidate-already-applied-message')),
					$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClosedCandidateAlreadyAppliedMessage),
					$lucamug$elm_ui_with_context$Element$WithContext$inFront(
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
								$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
								$lucamug$elm_ui_with_context$Element$WithContext$moveUp(7),
								$lucamug$elm_ui_with_context$Element$WithContext$moveRight(7),
								$lucamug$elm_ui_with_context$Element$WithContext$pointer,
								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClosedCandidateAlreadyAppliedMessage),
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
								$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(25)
							]),
						$author$project$TT$IT$render(
							A2(
								$author$project$TT$IT$withSize,
								20,
								A2(
									$author$project$TT$IT$withColor,
									$author$project$TT$Color$black,
									$author$project$TT$IT$closeOutlined(_List_Nil))))))
				]),
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$text('Ya te postulaste a este anuncio de empleo. Si deseas puedes continuar para actualizar tus datos'),
					$lucamug$elm_ui_with_context$Element$WithContext$text(' o puedes buscar anuncios similares '),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Font$underline,
							$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$secondary),
							$lucamug$elm_ui_with_context$Element$WithContext$Font$bold,
							$lucamug$elm_ui_with_context$Element$WithContext$pointer,
							$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClickGoToJobAdSerchPageButton)
						]),
					$lucamug$elm_ui_with_context$Element$WithContext$text('aquí'))
				]))) : $lucamug$elm_ui_with_context$Element$WithContext$none;
};
var $author$project$Page$Home$MsgUserEditAnswer = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$Home$viewCandidateAnswerBubble = F3(
	function (model, question, contentEl) {
		var bubbleBaseWidth = $author$project$Page$Home$getMainContainerWidth(model);
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$row,
			_Utils_ap(
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$spacing(4),
						$lucamug$elm_ui_with_context$Element$WithContext$alignRight
					]),
				(model.a.s && (!_Utils_eq(question, model.a.l))) ? _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.5)
					]) : _List_Nil),
			_List_fromArray(
				[
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[$lucamug$elm_ui_with_context$Element$WithContext$centerY]),
					$author$project$TT$IconButton$render(
						A2(
							$author$project$TT$IconButton$withSize,
							1,
							A2(
								$author$project$TT$IconButton$withStyle,
								0,
								A2(
									$author$project$TT$IconButton$withColor,
									1,
									A3(
										$author$project$TT$IconButton$default,
										$author$project$Page$Home$MsgUserEditAnswer(question),
										'Editar',
										$author$project$TT$IT$render(
											A2(
												$author$project$TT$IT$withSize,
												12,
												A2(
													$author$project$TT$IT$withColor,
													$author$project$TT$Color$white,
													$author$project$TT$IT$editPencil(_List_Nil)))))))))),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 8),
							$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
							$elm$html$Html$Attributes$class('elevation-1')),
							$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
							$author$project$Page$Home$MsgUserEditAnswer(question)),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
							{hc: 8, hd: 8, lA: 8, lB: 0}),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
							$lucamug$elm_ui_with_context$Element$WithContext$width(
							A3(
								$elm$core$Basics$apL,
								$lucamug$elm_ui_with_context$Element$WithContext$maximum,
								$elm$core$Basics$ceiling(((bubbleBaseWidth - 32) * 80) / 100),
								$lucamug$elm_ui_with_context$Element$WithContext$fill))
						]),
					contentEl)
				]));
	});
var $author$project$Page$Home$viewCandidateNotLoggedInTalentecaButton = function (model) {
	if (model.f.V) {
		var continueAsMessage = 'Continuar ' + A2(
			$elm$core$Maybe$withDefault,
			'con Talenteca',
			A2(
				$elm$core$Maybe$map,
				function (f) {
					return 'como ' + A2(
						$elm$core$Maybe$withDefault,
						f,
						$elm$core$List$head(
							A2($elm$core$String$split, ' ', f)));
				},
				model.C.$9));
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$centerX,
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					A2($elm$html$Html$Attributes$style, 'position', 'sticky')),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					A2($elm$html$Html$Attributes$style, 'top', '0')),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					A2($elm$html$Html$Attributes$style, 'z-index', '1')),
					$lucamug$elm_ui_with_context$Element$WithContext$pointer,
					$lucamug$elm_ui_with_context$Element$WithContext$width(
					(!model.f.cw) ? $lucamug$elm_ui_with_context$Element$WithContext$shrink : $lucamug$elm_ui_with_context$Element$WithContext$px(model.f.cw)),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class('sentry-mask'))
				]),
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$row,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$primary),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(25),
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 4, 8),
						$lucamug$elm_ui_with_context$Element$WithContext$spacing(4),
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
						$author$project$Page$Home$MsgUserClickedSendMagicLink(model.C.cB)),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$class('login-not-with-google-button'))
					]),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(25),
								$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$primaryLight)
							]),
						$author$project$TT$VectorImage$logo(28)),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_Utils_ap(
							$author$project$TT$Font$body3,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$white),
									A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 4, 0),
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
								])),
						model.f.t ? _List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$Font$bold]),
								$lucamug$elm_ui_with_context$Element$WithContext$text('Cargando...'))
							]) : _List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[$lucamug$elm_ui_with_context$Element$WithContext$Font$bold]),
								$lucamug$elm_ui_with_context$Element$WithContext$text(continueAsMessage)),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_Nil,
								$lucamug$elm_ui_with_context$Element$WithContext$text(model.C.cB))
							]))
					])));
	} else {
		return $lucamug$elm_ui_with_context$Element$WithContext$none;
	}
};
var $author$project$Page$Home$viewTalentinoQuestionBubble = F3(
	function (model, question, contentEl) {
		var bubbleBaseWidth = $author$project$Page$Home$getMainContainerWidth(model);
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_Utils_ap(
				_List_fromArray(
					[
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 8),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$class('elevation-1')),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
						{hc: 8, hd: 8, lA: 0, lB: 8}),
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray3),
						$lucamug$elm_ui_with_context$Element$WithContext$width(
						A3(
							$elm$core$Basics$apL,
							$lucamug$elm_ui_with_context$Element$WithContext$maximum,
							$elm$core$Basics$ceiling(((bubbleBaseWidth - 32) * 80) / 100),
							$lucamug$elm_ui_with_context$Element$WithContext$shrink))
					]),
				(model.a.s && (!_Utils_eq(question, model.a.l))) ? _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.5)
					]) : _List_Nil),
			contentEl);
	});
var $author$project$Page$Home$viewCandidateInfoStage = F2(
	function (model, tkJobAdSummaryDo) {
		return A5(
			$author$project$Page$Home$viewChatContainer,
			model,
			true,
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
						{
							hb: 16,
							jf: 16,
							ku: 16,
							lz: (model.f.V || model.f.b4) ? 4 : 16
						}),
						$lucamug$elm_ui_with_context$Element$WithContext$spacing(12),
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 0, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
						$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$id('chatContainer')),
						$lucamug$elm_ui_with_context$Element$WithContext$inFront(
						$author$project$Page$Home$viewCandidateAlreadyAppliedMessage(model)),
						(!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(0) : $lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
						{hc: 8, hd: 8, lA: 0, lB: 0})
					]),
				function () {
					var viewQuestionAndAnswer = F3(
						function (question, questionEl, answerEl) {
							var extraAttrs = (model.a.s && (!_Utils_eq(question, model.a.l))) ? _List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.3)
								]) : _List_Nil;
							return _List_fromArray(
								[
									(_Utils_eq(model.a.l, question) ? A2($author$project$Page$Home$viewTalentinoActiveQuestionBubble, model, extraAttrs) : A2($author$project$Page$Home$viewTalentinoQuestionBubble, model, question))(questionEl),
									A3($author$project$Page$Home$viewCandidateAnswerBubble, model, question, answerEl)
								]);
						});
					var candidateInfoDo = model.a.b;
					return A2(
						$elm$core$List$cons,
						$author$project$Page$Home$viewCandidateNotLoggedInTalentecaButton(model),
						_Utils_ap(
							function () {
								var _v0 = candidateInfoDo.cB.g;
								if (!_v0.$) {
									var email = _v0.a;
									return _Utils_ap(
										A3(
											viewQuestionAndAnswer,
											0,
											A2(
												$lucamug$elm_ui_with_context$Element$WithContext$column,
												_Utils_ap(
													$author$project$TT$Font$body2,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
														])),
												_List_fromArray(
													[
														A2(
														$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
														_List_Nil,
														_List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$text('Soy Talentino y te ayudaré con este empleo.')
															])),
														A2(
														$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
														_List_Nil,
														_List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$text('Inicia sesión con Google o escribe tu correo electrónico')
															]))
													])),
											A2(
												$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
												_Utils_ap(
													$author$project$TT$Font$body2,
													_List_fromArray(
														[
															$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
															$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
															$elm$html$Html$Attributes$class('sentry-mask'))
														])),
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$text(email)
													]))),
										function () {
											var _v1 = candidateInfoDo.dG.g;
											if (!_v1.$) {
												var fullname = _v1.a;
												return _Utils_ap(
													A3(
														viewQuestionAndAnswer,
														1,
														A2(
															$lucamug$elm_ui_with_context$Element$WithContext$wrappedRow,
															_Utils_ap(
																$author$project$TT$Font$body2,
																_List_fromArray(
																	[
																		$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
																	])),
															_List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$text('¿Cuál es tu nombre completo?')
																])),
														A2(
															$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
															_Utils_ap(
																$author$project$TT$Font$body2,
																_List_fromArray(
																	[
																		$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
																		$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																		$elm$html$Html$Attributes$class('sentry-mask'))
																	])),
															_List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$text(fullname)
																]))),
													_Utils_ap(
														function () {
															var _v2 = candidateInfoDo.jT.g;
															if (!_v2.$) {
																var phone = _v2.a;
																return A3(
																	viewQuestionAndAnswer,
																	2,
																	A2(
																		$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																		_Utils_ap(
																			$author$project$TT$Font$body2,
																			_List_fromArray(
																				[
																					$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
																					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																					$elm$html$Html$Attributes$class('sentry-mask'))
																				])),
																		_List_fromArray(
																			[
																				$lucamug$elm_ui_with_context$Element$WithContext$text('Hola ' + (fullname + '. Por favor, ¿cuál es tu número celular?'))
																			])),
																	A2(
																		$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																		_Utils_ap(
																			$author$project$TT$Font$body2,
																			_List_fromArray(
																				[
																					$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
																					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																					$elm$html$Html$Attributes$class('sentry-mask'))
																				])),
																		_List_fromArray(
																			[
																				$lucamug$elm_ui_with_context$Element$WithContext$text(phone)
																			])));
															} else {
																return _List_Nil;
															}
														}(),
														_Utils_ap(
															function () {
																var _v3 = candidateInfoDo.cU.g;
																if (!_v3.$) {
																	return A3(
																		viewQuestionAndAnswer,
																		4,
																		A2(
																			$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																			_Utils_ap(
																				$author$project$TT$Font$body2,
																				_List_fromArray(
																					[
																						$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
																					])),
																			_List_fromArray(
																				[
																					$lucamug$elm_ui_with_context$Element$WithContext$text('¿En qué municipio, delegación o ciudad vives?')
																				])),
																		A2(
																			$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																			_Utils_ap(
																				$author$project$TT$Font$body2,
																				_List_fromArray(
																					[
																						$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
																						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																						$elm$html$Html$Attributes$class('sentry-mask'))
																					])),
																			_List_fromArray(
																				[
																					$lucamug$elm_ui_with_context$Element$WithContext$text(candidateInfoDo.cU.cO)
																				])));
																} else {
																	return _List_Nil;
																}
															}(),
															function () {
																var _v4 = candidateInfoDo.dK.g;
																if (!_v4.$) {
																	var headline = _v4.a;
																	return A3(
																		viewQuestionAndAnswer,
																		5,
																		A2(
																			$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																			_Utils_ap(
																				$author$project$TT$Font$body2,
																				_List_fromArray(
																					[
																						$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
																					])),
																			_List_fromArray(
																				[
																					$lucamug$elm_ui_with_context$Element$WithContext$text('En una sola línea, ¿cómo resumes tu perfil profesional?')
																				])),
																		A2(
																			$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
																			_Utils_ap(
																				$author$project$TT$Font$body2,
																				_List_fromArray(
																					[
																						$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
																						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																						$elm$html$Html$Attributes$class('sentry-mask'))
																					])),
																			_List_fromArray(
																				[
																					$lucamug$elm_ui_with_context$Element$WithContext$text(headline)
																				])));
																} else {
																	return _List_Nil;
																}
															}())));
											} else {
												return _List_Nil;
											}
										}());
								} else {
									return _List_Nil;
								}
							}(),
							_List_fromArray(
								[
									function () {
									var questionToShow = model.a.s ? model.a.aq : model.a.l;
									var questionTitle = function () {
										switch (questionToShow) {
											case 0:
												return '¿cuál es tu correo electrónico?';
											case 1:
												return '¿Cuál es tu nombre completo?';
											case 2:
												return 'Hola ' + (A2($elm$core$Maybe$withDefault, '', candidateInfoDo.dG.g) + '. Por favor, ¿cuál es tu número celular?');
											case 3:
												return '¿En qué país vives?';
											case 4:
												return '¿En qué municipio, delegación o ciudad vives?';
											case 5:
												return 'En una sola línea, ¿cómo resumes tu perfil profesional?';
											default:
												return '¡Excelente! Tus datos serán visibles para que el reclutador te pueda contactar, revísalos antes de continuar.';
										}
									}();
									var extraAttrs = (model.a.s && (!_Utils_eq(questionToShow, model.a.l))) ? _List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.3)
										]) : _List_Nil;
									return A3(
										$author$project$Page$Home$viewTalentinoActiveQuestionBubble,
										model,
										extraAttrs,
										A2(
											$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
											_Utils_ap(
												$author$project$TT$Font$body2,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
													])),
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$text(questionTitle)
												])));
								}()
								])));
				}()),
			A2($author$project$Page$Home$viewBottomImput, model, tkJobAdSummaryDo),
			$author$project$Page$Home$getCandidateInfoStageErrorMessage(model));
	});
var $author$project$Page$Home$MsgUserClickedCloseIcon = {$: 79};
var $author$project$TT$IT$checkCircle = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'checkCircle',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M22 11.08V12a10 10 0 1 1-5.93-9.14'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M22 4 12 14.01l-3-3'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_Nil)
			]));
};
var $mdgriffith$elm_ui$Element$Font$justify = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.lf);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$justify = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$justify);
var $author$project$Page$Home$viewCompleteApplyStage = F2(
	function (model, tkJobAd) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width(
					$lucamug$elm_ui_with_context$Element$WithContext$px(
						$author$project$Page$Home$getMainContainerSize(model).a8)),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(
						$author$project$Page$Home$getMainContainerSize(model).aR - model.ae)),
					$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white)
				]),
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$padding(24),
						$lucamug$elm_ui_with_context$Element$WithContext$spacing(28),
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$centerY
					]),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[$lucamug$elm_ui_with_context$Element$WithContext$centerX]),
						$author$project$TT$IT$render(
							A2(
								$author$project$TT$IT$withSize,
								110,
								A2(
									$author$project$TT$IT$withColor,
									$author$project$TT$Color$tertiary,
									$author$project$TT$IT$checkCircle(_List_Nil))))),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						_Utils_ap(
							$author$project$TT$Font$headline2,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
									$lucamug$elm_ui_with_context$Element$WithContext$Font$justify
								])),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$id('success-message'))
									]),
								$lucamug$elm_ui_with_context$Element$WithContext$text(
									'¡tu postulación para ' + ($elm$core$String$toUpper(tkJobAd.jY) + ' ha sido enviada!')))
							])),
						$author$project$TT$Button$render(
						A2(
							$author$project$TT$Button$withButtonAttrs,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$centerX]),
							A2(
								$author$project$TT$Button$withSize,
								1,
								A2(
									$author$project$TT$Button$withRole,
									1,
									A2(
										$author$project$TT$Button$default,
										$elm$core$Maybe$Just($author$project$Page$Home$MsgUserClickedCloseIcon),
										'Cerrar')))))
					])));
	});
var $author$project$Page$Home$viewExternalApplyStage = F2(
	function (model, tkJobAdSummaryDo) {
		return A5(
			$author$project$Page$Home$viewChatContainer,
			model,
			true,
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
						$lucamug$elm_ui_with_context$Element$WithContext$spacing(20),
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 0, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
						$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$id('chatContainer'))
					]),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						_Utils_ap(
							$author$project$TT$Font$headline3,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
									$lucamug$elm_ui_with_context$Element$WithContext$Font$center,
									$lucamug$elm_ui_with_context$Element$WithContext$centerY
								])),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text('Te enviaremos a un sitio externo para continuar con tu postulación a:')
							])),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						_Utils_ap(
							$author$project$TT$Font$headline3,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
									$lucamug$elm_ui_with_context$Element$WithContext$Font$center,
									$lucamug$elm_ui_with_context$Element$WithContext$centerY
								])),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text(
								$elm$core$String$toUpper(tkJobAdSummaryDo.jY))
							])),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$centerY]),
						A3($author$project$TT$Spinner$spinner, 1, 70, $author$project$TT$Color$primary))
					])),
			$lucamug$elm_ui_with_context$Element$WithContext$none,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Page$Home$MsgUserChangedSingleChoiceFilterQuestionAnswer = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Page$Home$MsgUserLeftOpenFilterQuestionInput = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Page$Home$MsgUserPressedEnterKeyInFilterQuestionInput = function (a) {
	return {$: 83, a: a};
};
var $author$project$Page$Home$MsgUserSkippedFilterQuestions = {$: 25};
var $author$project$Page$Home$MsgUserSubmittedFilterQuestions = {$: 26};
var $author$project$TT$RadioButtonGroup$RadioButton = F5(
	function (value, label, state, subLabel, _class) {
		return {bG: _class, dQ: label, av: state, gb: subLabel, g: value};
	});
var $author$project$TT$RadioButtonGroup$StateEnabled = 0;
var $author$project$TT$RadioButtonGroup$RadioButtomGroup = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$TT$RadioButtonGroup$Column = 0;
var $author$project$TT$RadioButtonGroup$defaultOptions = function (items) {
	return {cI: _List_Nil, dO: items, cY: 0, c2: _List_Nil, c3: 20.0, c4: _List_Nil};
};
var $author$project$TT$RadioButtonGroup$default = F4(
	function (groupLabel, onChangeMsg, items, selectedItem) {
		return A4(
			$author$project$TT$RadioButtonGroup$RadioButtomGroup,
			$author$project$TT$RadioButtonGroup$defaultOptions(items),
			groupLabel,
			onChangeMsg,
			selectedItem);
	});
var $mdgriffith$elm_ui$Element$Input$Column = 1;
var $mdgriffith$elm_ui$Element$Input$AfterFound = 2;
var $mdgriffith$elm_ui$Element$Input$BeforeFound = 1;
var $mdgriffith$elm_ui$Element$Input$Idle = 0;
var $mdgriffith$elm_ui$Element$Input$NotFound = 0;
var $mdgriffith$elm_ui$Element$Input$Selected = 2;
var $mdgriffith$elm_ui$Element$Input$column = F2(
	function (attributes, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					attributes)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Element$Input$downArrow = 'ArrowDown';
var $mdgriffith$elm_ui$Internal$Model$filter = function (attrs) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (x, _v0) {
				var found = _v0.a;
				var has = _v0.b;
				switch (x.$) {
					case 0:
						return _Utils_Tuple2(found, has);
					case 3:
						var key = x.a;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 1:
						var attr = x.a;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 4:
						var style = x.b;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 7:
						var width = x.a;
						return A2($elm$core$Set$member, 'width', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'width', has));
					case 8:
						var height = x.a;
						return A2($elm$core$Set$member, 'height', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'height', has));
					case 2:
						var description = x.a;
						return A2($elm$core$Set$member, 'described', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'described', has));
					case 9:
						var location = x.a;
						var elem = x.b;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 6:
						return A2($elm$core$Set$member, 'align-x', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'align-x', has));
					case 5:
						return A2($elm$core$Set$member, 'align-y', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'align-y', has));
					default:
						return A2($elm$core$Set$member, 'transform', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'transform', has));
				}
			}),
		_Utils_Tuple2(_List_Nil, $elm$core$Set$empty),
		attrs).a;
};
var $mdgriffith$elm_ui$Internal$Model$get = F2(
	function (attrs, isAttr) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, found) {
					return isAttr(x) ? A2($elm$core$List$cons, x, found) : found;
				}),
			_List_Nil,
			$mdgriffith$elm_ui$Internal$Model$filter(attrs));
	});
var $mdgriffith$elm_ui$Element$Input$leftArrow = 'ArrowLeft';
var $mdgriffith$elm_ui$Element$Input$rightArrow = 'ArrowRight';
var $mdgriffith$elm_ui$Element$Input$row = F2(
	function (attributes, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asRow,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				attributes),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Element$Input$upArrow = 'ArrowUp';
var $mdgriffith$elm_ui$Element$Input$radioHelper = F3(
	function (orientation, attrs, input) {
		var track = F2(
			function (opt, _v14) {
				var found = _v14.a;
				var prev = _v14.b;
				var nxt = _v14.c;
				var val = opt.a;
				switch (found) {
					case 0:
						return _Utils_eq(
							$elm$core$Maybe$Just(val),
							input.kH) ? _Utils_Tuple3(1, prev, nxt) : _Utils_Tuple3(found, val, nxt);
					case 1:
						return _Utils_Tuple3(2, prev, val);
					default:
						return _Utils_Tuple3(found, prev, nxt);
				}
			});
		var renderOption = function (_v11) {
			var val = _v11.a;
			var view = _v11.b;
			var status = _Utils_eq(
				$elm$core$Maybe$Just(val),
				input.kH) ? 2 : 0;
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$pointer,
						function () {
						if (!orientation) {
							return $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink);
						} else {
							return $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill);
						}
					}(),
						$mdgriffith$elm_ui$Element$Events$onClick(
						input.jF(val)),
						function () {
						if (status === 2) {
							return $mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$attribute, 'aria-checked', 'true'));
						} else {
							return $mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$attribute, 'aria-checked', 'false'));
						}
					}(),
						$mdgriffith$elm_ui$Internal$Model$Attr(
						A2($elm$html$Html$Attributes$attribute, 'role', 'radio'))
					]),
				view(status));
		};
		var prevNext = function () {
			var _v5 = input.jP;
			if (!_v5.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v6 = _v5.a;
				var val = _v6.a;
				return function (_v7) {
					var found = _v7.a;
					var b = _v7.b;
					var a = _v7.c;
					switch (found) {
						case 0:
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(b, val));
						case 1:
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(b, val));
						default:
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(b, a));
					}
				}(
					A3(
						$elm$core$List$foldl,
						track,
						_Utils_Tuple3(0, val, val),
						input.jP));
			}
		}();
		var optionArea = function () {
			if (!orientation) {
				return A2(
					$mdgriffith$elm_ui$Element$Input$row,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(input.dQ),
						attrs),
					A2($elm$core$List$map, renderOption, input.jP));
			} else {
				return A2(
					$mdgriffith$elm_ui$Element$Input$column,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(input.dQ),
						attrs),
					A2($elm$core$List$map, renderOption, input.jP));
			}
		}();
		var events = A2(
			$mdgriffith$elm_ui$Internal$Model$get,
			attrs,
			function (attr) {
				_v3$3:
				while (true) {
					switch (attr.$) {
						case 7:
							if (attr.a.$ === 2) {
								return true;
							} else {
								break _v3$3;
							}
						case 8:
							if (attr.a.$ === 2) {
								return true;
							} else {
								break _v3$3;
							}
						case 1:
							return true;
						default:
							break _v3$3;
					}
				}
				return false;
			});
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just($mdgriffith$elm_ui$Element$alignLeft),
							$elm$core$Maybe$Just(
							$mdgriffith$elm_ui$Element$Input$tabindex(0)),
							$elm$core$Maybe$Just(
							$mdgriffith$elm_ui$Internal$Model$htmlClass('focus')),
							$elm$core$Maybe$Just($mdgriffith$elm_ui$Element$Region$announce),
							$elm$core$Maybe$Just(
							$mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$attribute, 'role', 'radiogroup'))),
							function () {
							if (prevNext.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var _v1 = prevNext.a;
								var prev = _v1.a;
								var next = _v1.b;
								return $elm$core$Maybe$Just(
									$mdgriffith$elm_ui$Element$Input$onKeyLookup(
										function (code) {
											if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$leftArrow)) {
												return $elm$core$Maybe$Just(
													input.jF(prev));
											} else {
												if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$upArrow)) {
													return $elm$core$Maybe$Just(
														input.jF(prev));
												} else {
													if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$rightArrow)) {
														return $elm$core$Maybe$Just(
															input.jF(next));
													} else {
														if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$downArrow)) {
															return $elm$core$Maybe$Just(
																input.jF(next));
														} else {
															if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space)) {
																var _v2 = input.kH;
																if (_v2.$ === 1) {
																	return $elm$core$Maybe$Just(
																		input.jF(prev));
																} else {
																	return $elm$core$Maybe$Nothing;
																}
															} else {
																return $elm$core$Maybe$Nothing;
															}
														}
													}
												}
											}
										}));
							}
						}()
						])),
				events),
			input.dQ,
			optionArea);
	});
var $mdgriffith$elm_ui$Element$Input$radio = $mdgriffith$elm_ui$Element$Input$radioHelper(1);
var $lucamug$elm_ui_with_context$Element$WithContext$Input$runOption = F2(
	function (context, _v0) {
		var f = _v0;
		return f(context);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$radioHelper = F2(
	function (context, config) {
		return {
			dQ: A2($lucamug$elm_ui_with_context$Element$WithContext$Input$runLabel, context, config.dQ),
			jF: config.jF,
			jP: A2(
				$elm$core$List$map,
				$lucamug$elm_ui_with_context$Element$WithContext$Input$runOption(context),
				config.jP),
			kH: config.kH
		};
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$radio = A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs, $mdgriffith$elm_ui$Element$Input$radio, $lucamug$elm_ui_with_context$Element$WithContext$Input$radioHelper);
var $mdgriffith$elm_ui$Element$Input$Row = 0;
var $mdgriffith$elm_ui$Element$Input$radioRow = $mdgriffith$elm_ui$Element$Input$radioHelper(0);
var $lucamug$elm_ui_with_context$Element$WithContext$Input$radioRow = A2($lucamug$elm_ui_with_context$Element$WithContext$Internal$wrapAttrs, $mdgriffith$elm_ui$Element$Input$radioRow, $lucamug$elm_ui_with_context$Element$WithContext$Input$radioHelper);
var $lucamug$elm_ui_with_context$Element$WithContext$Input$Focused = 1;
var $lucamug$elm_ui_with_context$Element$WithContext$Input$Idle = 0;
var $lucamug$elm_ui_with_context$Element$WithContext$Input$Option = $elm$core$Basics$identity;
var $lucamug$elm_ui_with_context$Element$WithContext$Input$Selected = 2;
var $mdgriffith$elm_ui$Element$Input$Option = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$Input$optionWith = F2(
	function (val, view) {
		return A2($mdgriffith$elm_ui$Element$Input$Option, val, view);
	});
var $lucamug$elm_ui_with_context$Element$WithContext$Input$optionWith = F2(
	function (val, view) {
		var optionStateConverter = function (optionState) {
			switch (optionState) {
				case 0:
					return 0;
				case 1:
					return 1;
				default:
					return 2;
			}
		};
		var viewConverted = function (optionState) {
			return view(
				optionStateConverter(optionState));
		};
		return function (context) {
			return A2(
				$mdgriffith$elm_ui$Element$Input$optionWith,
				val,
				A2(
					$elm$core$Basics$composeL,
					$lucamug$elm_ui_with_context$Element$WithContext$Internal$run(context),
					viewConverted));
		};
	});
var $author$project$TT$IT$radioButtonCircle = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'radioButtonCircle',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$TT$IT$radioButtonCircleFill = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'radioButtonCircleFill',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$TT$RadioButtonGroup$withOptionConstructor = F4(
	function (item, selectedItem, radioSize, radioOptionAttrs) {
		var itemValue = item.g;
		var itemState = item.av;
		var color = function () {
			if (!itemState) {
				return $author$project$TT$Color$black;
			} else {
				return $author$project$TT$Color$gray3;
			}
		}();
		var labelAttrs = function () {
			if (!itemState) {
				return _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Font$color(color)
					]);
			} else {
				return _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Font$color(color),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'cursor', 'not-allowed'))
					]);
			}
		}();
		var classAttrs = function () {
			var _v1 = item.bG;
			if (!_v1.$) {
				var _class = _v1.a;
				return _List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$class(_class))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var circleIcon = _Utils_eq(
			selectedItem,
			$elm$core$Maybe$Just(itemValue)) ? $author$project$TT$IT$render(
			A2(
				$author$project$TT$IT$withSize,
				radioSize,
				A2(
					$author$project$TT$IT$withColor,
					$author$project$TT$Color$primaryLight,
					$author$project$TT$IT$radioButtonCircleFill(_List_Nil)))) : $author$project$TT$IT$render(
			A2(
				$author$project$TT$IT$withSize,
				radioSize,
				A2(
					$author$project$TT$IT$withColor,
					$author$project$TT$Color$primaryLight,
					$author$project$TT$IT$radioButtonCircle(_List_Nil))));
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$Input$optionWith,
			itemValue,
			function (_v0) {
				return A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					radioOptionAttrs,
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							_Utils_ap(
								labelAttrs,
								_Utils_ap(
									classAttrs,
									_Utils_ap(
										$author$project$TT$Font$body2,
										_List_fromArray(
											[
												A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 8, 0),
												$lucamug$elm_ui_with_context$Element$WithContext$centerY,
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
											])))),
							_List_fromArray(
								[
									circleIcon,
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$wrappedRow,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									_List_fromArray(
										[item.dQ]))
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$lucamug$elm_ui_with_context$Element$WithContext$none,
							A2(
								$elm$core$Maybe$map,
								function (subLabel) {
									return A2(
										$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
										$author$project$TT$Font$linkTiny,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$text(subLabel)
											]));
								},
								item.gb))
						]));
			});
	});
var $author$project$TT$RadioButtonGroup$render = function (_v0) {
	var options = _v0.a;
	var groupLabel = _v0.b;
	var onChangeMsg = _v0.c;
	var selectedItem = _v0.d;
	var radioButtonItems = A2(
		$elm$core$List$map,
		function (item) {
			return A4($author$project$TT$RadioButtonGroup$withOptionConstructor, item, selectedItem, options.c3, options.c2);
		},
		options.dO);
	var inputOrientation = function () {
		var _v1 = options.cY;
		if (!_v1) {
			return $lucamug$elm_ui_with_context$Element$WithContext$Input$radio;
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$Input$radioRow;
		}
	}();
	var inputGroupSpacing = $elm$core$String$isEmpty(groupLabel) ? _List_Nil : _List_fromArray(
		[
			A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, 6)
		]);
	return A2(
		inputOrientation,
		A2(
			$elm$core$List$cons,
			A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 0, 8),
			_Utils_ap(options.c4, inputGroupSpacing)),
		{
			dQ: A2(
				$lucamug$elm_ui_with_context$Element$WithContext$Input$labelAbove,
				options.cI,
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
					_List_Nil,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$text(groupLabel)
						]))),
			jF: onChangeMsg,
			jP: radioButtonItems,
			kH: selectedItem
		});
};
var $author$project$TT$RadioButtonGroup$withGroupLabelAttrs = F2(
	function (groupLabelAttrs, _v0) {
		var options = _v0.a;
		var groupLabel = _v0.b;
		var onChangeMsg = _v0.c;
		var selectedItem = _v0.d;
		return A4(
			$author$project$TT$RadioButtonGroup$RadioButtomGroup,
			_Utils_update(
				options,
				{cI: groupLabelAttrs}),
			groupLabel,
			onChangeMsg,
			selectedItem);
	});
var $author$project$Page$Home$viewFilterQuestionsStage = function (model) {
	var viewSingleChoiceQuestion = function (question) {
		var answer = A2($elm$core$Dict$get, question.iJ, model.o.gS);
		var answerErrorMessage = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.bM;
			},
			answer);
		var answerValue = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.g;
				},
				answer));
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class('sentry-mask'))
				]),
			_List_fromArray(
				[
					$author$project$TT$RadioButtonGroup$render(
					A2(
						$author$project$TT$RadioButtonGroup$withGroupLabelAttrs,
						_Utils_ap(
							$author$project$TT$Font$formLabel,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
									$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
									{hb: 8, jf: 0, ku: 0, lz: 0})
								])),
						A4(
							$author$project$TT$RadioButtonGroup$default,
							question.lu,
							$author$project$Page$Home$MsgUserChangedSingleChoiceFilterQuestionAnswer(question),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (l) {
										return A2(
											$elm$core$List$map,
											function (e) {
												return A5(
													$author$project$TT$RadioButtonGroup$RadioButton,
													e.lt,
													A2(
														$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
														_List_Nil,
														_List_fromArray(
															[
																$lucamug$elm_ui_with_context$Element$WithContext$text(e.lt)
															])),
													0,
													$elm$core$Maybe$Nothing,
													$elm$core$Maybe$Nothing);
											},
											l);
									},
									question.gS)),
							$elm$core$Maybe$Just(answerValue)))),
					function () {
					if (!answerErrorMessage.$) {
						var errorMessage = answerErrorMessage.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							_Utils_ap(
								$author$project$TT$Font$body3,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$error)
									])),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text(errorMessage)
								]));
					} else {
						return $lucamug$elm_ui_with_context$Element$WithContext$none;
					}
				}()
				]));
	};
	var viewOpenQuestion = function (question) {
		var answer = A2($elm$core$Dict$get, question.iJ, model.o.gS);
		var answerErrorMessage = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.bM;
			},
			answer);
		var answerValue = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.g;
				},
				answer));
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 0),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class('sentry-mask'))
				]),
			_List_fromArray(
				[
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
						]),
					$author$project$TT$FormField$render(
						A2(
							$author$project$TT$FormField$withFieldAttrs,
							_List_fromArray(
								[
									$author$project$Page$Home$onEnter(
									$author$project$Page$Home$MsgUserPressedEnterKeyInFilterQuestionInput('question-' + question.iJ)),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Events$onFocus($author$project$Page$Home$MsgUserFocusedInput)),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$id('question-' + question.iJ)),
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Events$onBlur(
										A2($author$project$Page$Home$MsgUserLeftOpenFilterQuestionInput, question, answerValue)))
								]),
							A2(
								$author$project$TT$FormField$withPlaceholder,
								$lucamug$elm_ui_with_context$Element$WithContext$text(''),
								A2(
									$author$project$TT$FormField$withState,
									(!_Utils_eq(answerErrorMessage, $elm$core$Maybe$Nothing)) ? 2 : 0,
									A2(
										$author$project$TT$FormField$withWrapperAttrs,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
											]),
										A3(
											$author$project$TT$FormField$default,
											$author$project$Page$Home$MsgUserChangedOpenFilterQuestionAnswer(question),
											answerValue,
											question.lu))))))),
					function () {
					if (!answerErrorMessage.$) {
						var errorMessage = answerErrorMessage.a;
						return A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							_Utils_ap(
								$author$project$TT$Font$body3,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$error)
									])),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text(errorMessage)
								]));
					} else {
						return $lucamug$elm_ui_with_context$Element$WithContext$none;
					}
				}()
				]));
	};
	var viewQuestion = function (question) {
		return (question.lH === 'SINGLE_CHOICE_QUESTION_TYPE') ? viewSingleChoiceQuestion(question) : viewOpenQuestion(question);
	};
	var numberOfQuestions = $elm$core$List$length(model.aD);
	return A5(
		$author$project$Page$Home$viewChatContainer,
		model,
		false,
		A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(28),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					A2($lucamug$elm_ui_with_context$Element$WithContext$minimum, 0, $lucamug$elm_ui_with_context$Element$WithContext$fill)),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$id('chatContainer'))
				]),
			A2(
				$elm$core$List$cons,
				A3(
					$author$project$Page$Home$viewTalentinoActiveQuestionBubble,
					model,
					_List_Nil,
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						_Utils_ap(
							$author$project$TT$Font$body2,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
								])),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text(
								(numberOfQuestions === 1) ? 'Ahora por favor responde esta pregunta del reclutador' : ('Ahora por favor responde estas ' + ($elm$core$String$fromInt(numberOfQuestions) + ' preguntas del reclutador')))
							]))),
				A2($elm$core$List$map, viewQuestion, model.aD))),
		A2(
			$lucamug$elm_ui_with_context$Element$WithContext$row,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(72)),
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 12),
					A2($lucamug$elm_ui_with_context$Element$WithContext$Border$widthXY, 0, 1),
					$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$gray3),
					$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
					{
						g5: 20,
						hz: $author$project$TT$Color$gray2,
						jE: _Utils_Tuple2(0, 3),
						kQ: -3
					})
				]),
			_List_fromArray(
				[
					$author$project$TT$Button$render(
					A2(
						$author$project$TT$Button$withButtonAttrs,
						_List_fromArray(
							[$lucamug$elm_ui_with_context$Element$WithContext$alignLeft]),
						A2(
							$author$project$TT$Button$withStyle,
							1,
							A2(
								$author$project$TT$Button$withSize,
								0,
								A2(
									$author$project$TT$Button$withRole,
									1,
									A2(
										$author$project$TT$Button$default,
										$elm$core$Maybe$Just($author$project$Page$Home$MsgUserSkippedFilterQuestions),
										'Saltar paso')))))),
					$author$project$TT$Button$render(
					A2(
						$author$project$TT$Button$withState,
						model.o.bR ? $author$project$TT$Button$StateLoading(
							$elm$core$Maybe$Just('Enviando')) : $author$project$TT$Button$StateDefault,
						A2(
							$author$project$TT$Button$withButtonAttrs,
							_List_fromArray(
								[$lucamug$elm_ui_with_context$Element$WithContext$alignRight]),
							A2(
								$author$project$TT$Button$withSize,
								0,
								A2(
									$author$project$TT$Button$withRole,
									1,
									A2(
										$author$project$TT$Button$default,
										$elm$core$Maybe$Just($author$project$Page$Home$MsgUserSubmittedFilterQuestions),
										'Enviar'))))))
				])),
		model.o.G);
};
var $author$project$Route$RouteTonkeanUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$TT$Button$LinkE = function (a) {
	return {$: 1, a: a};
};
var $author$project$TT$Button$asLink = F2(
	function (url, label) {
		return A3(
			$author$project$TT$Button$Button,
			_Utils_update(
				$author$project$TT$Button$defaultOptions,
				{
					cM: $author$project$TT$Button$LinkE(url)
				}),
			$elm$core$Maybe$Nothing,
			label);
	});
var $author$project$Route$homePath = '/' + $author$project$Route$baseSegment;
var $author$project$Route$path = function (route) {
	if (!route.$) {
		return $author$project$Route$homePath;
	} else {
		var url = route.a;
		return url;
	}
};
var $author$project$TT$Color$grayDarkTransparent = $author$project$TT$Color$Extra$hexToColor('#45454550');
var $author$project$Page$Home$viewCommonErrorContainer = F2(
	function (model, content) {
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(
						$author$project$Page$Home$getMainContainerSize(model).aR)),
					$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray3),
					(!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(0) : $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(8)
				]),
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$centerX,
						$lucamug$elm_ui_with_context$Element$WithContext$centerY,
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 30, 40),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
						{
							g5: 4,
							hz: $author$project$TT$Color$grayDarkTransparent,
							jE: _Utils_Tuple2(0, 4),
							kQ: 0
						}),
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white)
					]),
				content));
	});
var $author$project$Page$Home$viewCommonErrorMessage = F4(
	function (model, title, caption, actionButton) {
		return A2(
			$author$project$Page$Home$viewCommonErrorContainer,
			model,
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 0, 20),
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								$author$project$TT$Font$headline1,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text(title)
									])),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								_Utils_ap(
									$author$project$TT$Font$headline3,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$grayDark)
										])),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text(caption)
									])),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[$lucamug$elm_ui_with_context$Element$WithContext$alignLeft]),
								actionButton)
							]))
					])));
	});
var $author$project$Page$Home$viewGeneralErrorMessageWithLink = F5(
	function (model, title, caption, actionText, actionLink) {
		var actionButton = $author$project$TT$Button$render(
			A2(
				$author$project$TT$Button$asLink,
				$author$project$Route$path(
					$author$project$Route$RouteTonkeanUrl(actionLink)),
				actionText));
		return A4($author$project$Page$Home$viewCommonErrorMessage, model, title, caption, actionButton);
	});
var $author$project$Page$Home$viewGeneralErrorMessageWithMsg = F5(
	function (model, title, caption, actionText, msg) {
		var actionButton = $author$project$TT$Button$render(
			A2(
				$author$project$TT$Button$default,
				$elm$core$Maybe$Just(msg),
				actionText));
		return A4($author$project$Page$Home$viewCommonErrorMessage, model, title, caption, actionButton);
	});
var $author$project$Page$Home$viewLoginErrorMessage = function (model) {
	return $author$project$Page$Home$viewSnackBarError(model.f.af);
};
var $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputOne = function (a) {
	return {$: 85, a: a};
};
var $author$project$Page$Home$MsgUserClosedLoginModal = {$: 69};
var $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputFive = {$: 93};
var $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputFour = {$: 91};
var $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputSix = {$: 95};
var $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputThree = {$: 89};
var $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputTwo = {$: 87};
var $author$project$Page$Home$onBackspace = function (msg) {
	return $lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
		A2(
			$elm$html$Html$Events$on,
			'keydown',
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return (key === 'Backspace') ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('Not the Backspace key');
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
};
var $author$project$Page$Home$viewLoginModal = function (model) {
	if ((model.C.ix && model.c.aI) || model.K) {
		var viewCodeTextField = F4(
			function (onChangeMsg, onBackspaceMsg, value, inputId) {
				return $author$project$TT$FormField$render(
					A2(
						$author$project$TT$FormField$withState,
						model.c.cJ ? 2 : 0,
						A2(
							$author$project$TT$FormField$withFieldAttrs,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Font$center,
									$lucamug$elm_ui_with_context$Element$WithContext$Font$bold,
									$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
									$elm$html$Html$Attributes$id(inputId)),
									$author$project$Page$Home$onBackspace(
									(value === '') ? onBackspaceMsg : $author$project$Page$Home$PassThrough)
								]),
							A2(
								$author$project$TT$FormField$withLabelType,
								1,
								A2(
									$author$project$TT$FormField$withWrapperAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$shrink)
										]),
									A3($author$project$TT$FormField$default, onChangeMsg, value, ''))))));
			});
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width(
					$lucamug$elm_ui_with_context$Element$WithContext$px(
						$author$project$Page$Home$getMainContainerSize(model).a8)),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(
						$author$project$Page$Home$getMainContainerSize(model).aR)),
					$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
					$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$grayDarkTransparent),
								$lucamug$elm_ui_with_context$Element$WithContext$width(
								$lucamug$elm_ui_with_context$Element$WithContext$px(
									$author$project$Page$Home$getMainContainerSize(model).a8)),
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								$lucamug$elm_ui_with_context$Element$WithContext$px(
									$author$project$Page$Home$getMainContainerSize(model).aR)),
								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgUserClosedLoginModal)
							]),
						$lucamug$elm_ui_with_context$Element$WithContext$none))
				]),
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$shrink),
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
						$lucamug$elm_ui_with_context$Element$WithContext$centerY,
						$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
						$lucamug$elm_ui_with_context$Element$WithContext$spacing(8),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$id('verification-code-modal'))
					]),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						_Utils_ap(
							$author$project$TT$Font$body1,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
								])),
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text('Te enviamos un código a ' + (model.C.cB + '. Introdúcelo para llenar tus datos.'))
							])),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$row,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$spacing(4),
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$padding(8)
							]),
						_List_fromArray(
							[
								A4(viewCodeTextField, $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputOne, $author$project$Page$Home$PassThrough, model.c.aU, 'magic-link-input-1'),
								A4(viewCodeTextField, $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputTwo, $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputTwo, model.c.aX, 'magic-link-input-2'),
								A4(viewCodeTextField, $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputThree, $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputThree, model.c.aW, 'magic-link-input-3'),
								A4(viewCodeTextField, $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputFour, $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputFour, model.c.aT, 'magic-link-input-4'),
								A4(viewCodeTextField, $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputFive, $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputFive, model.c.aS, 'magic-link-input-5'),
								A4(viewCodeTextField, $author$project$Page$Home$MsgUserChangeMagicLinkValidationInputSix, $author$project$Page$Home$MsgUserErasedMagicLinkValidationInputSix, model.c.aV, 'magic-link-input-6'),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
										$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$white)
									]),
								$lucamug$elm_ui_with_context$Element$WithContext$text('.'))
							])),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$row,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$spaceEvenly,
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$alignLeft
							]),
						_List_fromArray(
							[
								$author$project$TT$Button$render(
								A2(
									$author$project$TT$Button$withButtonAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$id('cancel-login-with-verification-code-button'))
										]),
									A2(
										$author$project$TT$Button$withStyle,
										1,
										A2(
											$author$project$TT$Button$withRole,
											1,
											A2(
												$author$project$TT$Button$default,
												$elm$core$Maybe$Just($author$project$Page$Home$MsgUserClosedLoginModal),
												'Ahora no')))))
							]))
					])));
	} else {
		return $lucamug$elm_ui_with_context$Element$WithContext$none;
	}
};
var $author$project$Page$Home$MsgShowSendToFriendModal = {$: 58};
var $author$project$Page$Home$MsgUserPressedSaveJobAd = function (a) {
	return {$: 111, a: a};
};
var $mdgriffith$elm_ui$Element$moveDown = function (y) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveY,
		$mdgriffith$elm_ui$Internal$Model$MoveY(y));
};
var $lucamug$elm_ui_with_context$Element$WithContext$moveDown = function (y) {
	return $lucamug$elm_ui_with_context$Element$WithContext$attr(
		$mdgriffith$elm_ui$Element$moveDown(y));
};
var $author$project$Page$Home$viewMoreOptions = F2(
	function (model, position) {
		return model.bs ? A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$moveLeft(210),
					$lucamug$elm_ui_with_context$Element$WithContext$moveDown(20),
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$class('elevation-3'))
				]),
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, 8),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$gray3),
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
					]),
				model.aC ? _List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$link,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$pointer
							]),
						{
							dQ: A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 16),
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
									]),
								$lucamug$elm_ui_with_context$Element$WithContext$text('Ver todas las ofertas de empleo')),
							Q: '/empleos'
						})
					]) : _List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 16),
								$lucamug$elm_ui_with_context$Element$WithContext$pointer,
								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
								$author$project$Page$Home$MsgUserPressedSaveJobAd(position)),
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
							]),
						$lucamug$elm_ui_with_context$Element$WithContext$text('Añadir a favoritos')),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 16),
								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgShowSendToFriendModal),
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$pointer,
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								$elm$html$Html$Attributes$class('send-to-friend-option'))
							]),
						$lucamug$elm_ui_with_context$Element$WithContext$text('Enviar a un amigo')),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$link,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$pointer
							]),
						{
							dQ: A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 16, 16),
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
									]),
								$lucamug$elm_ui_with_context$Element$WithContext$text('Ver todas las ofertas de empleo')),
							Q: '/empleos'
						})
					]))) : $lucamug$elm_ui_with_context$Element$WithContext$none;
	});
var $author$project$Page$Home$viewNotificationMessages = function (model) {
	var viewNotification = F3(
		function (messageEl, colorBackground, colorFont) {
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$alignRight,
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color(colorBackground),
						$lucamug$elm_ui_with_context$Element$WithContext$Font$color(colorFont),
						$lucamug$elm_ui_with_context$Element$WithContext$padding(20),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(5)
					]),
				messageEl);
		});
	var viewSuccessNotification = function (message) {
		return A3(viewNotification, message.b, $author$project$TT$Color$success, $author$project$TT$Color$white);
	};
	var viewWarningNotification = function (message) {
		return A3(
			viewNotification,
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$text(message.b)
					])),
			$author$project$TT$Color$warning,
			$author$project$TT$Color$white);
	};
	var viewErrorNotification = function (message) {
		return A3(
			viewNotification,
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$text(message.b)
					])),
			$author$project$TT$Color$error,
			$author$project$TT$Color$white);
	};
	var hasMessages = ($elm$core$Array$length(model.dd) > 0) || (($elm$core$Array$length(model.ac) > 0) || ($elm$core$Array$length(model.a7) > 0));
	return hasMessages ? A2(
		$lucamug$elm_ui_with_context$Element$WithContext$column,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$centerX,
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'position', 'fixed')),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'top', '0')),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'right', '0')),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'z-index', '2')),
				A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 28, 12),
				A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 0, 16)
			]),
		_Utils_ap(
			($elm$core$Array$length(model.dd) > 0) ? $elm$core$Array$toList(
				A2($elm$core$Array$map, viewSuccessNotification, model.dd)) : _List_Nil,
			_Utils_ap(
				($elm$core$Array$length(model.ac) > 0) ? $elm$core$Array$toList(
					A2($elm$core$Array$map, viewErrorNotification, model.ac)) : _List_Nil,
				($elm$core$Array$length(model.a7) > 0) ? $elm$core$Array$toList(
					A2($elm$core$Array$map, viewWarningNotification, model.a7)) : _List_Nil))) : $lucamug$elm_ui_with_context$Element$WithContext$none;
};
var $author$project$TT$IconButton$White = 4;
var $author$project$Model$viewPageLevelAlert = F4(
	function (dismissAlert, alertBody, alertColor, fontColor) {
		if (!alertBody.$) {
			var body = alertBody.a;
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$row,
				_Utils_ap(
					$author$project$TT$Font$body1,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color(alertColor),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 32, 16),
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(44),
							$lucamug$elm_ui_with_context$Element$WithContext$Font$color(fontColor)
						])),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
						_List_Nil,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$text(body)
							])),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[$lucamug$elm_ui_with_context$Element$WithContext$alignRight]),
						$author$project$TT$IconButton$render(
							A2(
								$author$project$TT$IconButton$withColor,
								4,
								A3(
									$author$project$TT$IconButton$default,
									dismissAlert,
									'cerrar',
									$author$project$TT$IT$render(
										A2(
											$author$project$TT$IT$withColor,
											fontColor,
											A2(
												$author$project$TT$IT$withSize,
												16,
												$author$project$TT$IT$close(_List_Nil))))))))
					]));
		} else {
			return $lucamug$elm_ui_with_context$Element$WithContext$none;
		}
	});
var $author$project$TT$FormField$InputEmail = 1;
var $author$project$Page$Home$MsgBotChangedSendToFriendSpamControl = function (a) {
	return {$: 64, a: a};
};
var $author$project$Page$Home$MsgHideSendToFriendModal = {$: 59};
var $author$project$Page$Home$MsgUserChangedSendToFriendEmail = function (a) {
	return {$: 60, a: a};
};
var $author$project$Page$Home$MsgUserChangedSendToFriendEmailFriend = function (a) {
	return {$: 62, a: a};
};
var $author$project$Page$Home$MsgUserChangedSendToFriendName = function (a) {
	return {$: 61, a: a};
};
var $author$project$Page$Home$MsgUserChangedSendToFriendNameFriend = function (a) {
	return {$: 63, a: a};
};
var $author$project$Page$Home$MsgUserSentSendToFriendForm = {$: 65};
var $author$project$TT$Button$Terniary = 3;
var $author$project$Page$Home$viewSnackBarSuccess = function (maybeErrorMessage) {
	if (!maybeErrorMessage.$) {
		var errorMessage = maybeErrorMessage.a;
		return A2($author$project$Page$Home$viewSnackBarMessage, errorMessage, $author$project$TT$Color$success);
	} else {
		return $lucamug$elm_ui_with_context$Element$WithContext$none;
	}
};
var $author$project$Page$Home$viewSendToFriendModal = function (model) {
	return model.b5 ? A2(
		$lucamug$elm_ui_with_context$Element$WithContext$column,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
				$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
			]),
		_List_fromArray(
			[
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$row,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						$lucamug$elm_ui_with_context$Element$WithContext$px(64)),
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$grayDark),
						$lucamug$elm_ui_with_context$Element$WithContext$padding(8)
					]),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$alignLeft,
								$lucamug$elm_ui_with_context$Element$WithContext$pointer,
								$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgHideSendToFriendModal)
							]),
						$author$project$TT$IT$render(
							A2(
								$author$project$TT$IT$withSize,
								20,
								A2(
									$author$project$TT$IT$withColor,
									$author$project$TT$Color$white,
									$author$project$TT$IT$close(_List_Nil))))),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$centerX,
								$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$white),
								$lucamug$elm_ui_with_context$Element$WithContext$Font$center
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								$author$project$TT$Font$headline3,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text('Enviar por email')
									]))
							])),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[$lucamug$elm_ui_with_context$Element$WithContext$alignRight]),
						$author$project$TT$Button$render(
							A2(
								$author$project$TT$Button$withButtonAttrs,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$class('submit-form'))
									]),
								A2(
									$author$project$TT$Button$withState,
									model.i.t ? $author$project$TT$Button$StateLoading(
										$elm$core$Maybe$Just('Enviando')) : $author$project$TT$Button$StateDefault,
									A2(
										$author$project$TT$Button$withStyle,
										1,
										A2(
											$author$project$TT$Button$withRole,
											3,
											A2(
												$author$project$TT$Button$default,
												$elm$core$Maybe$Just($author$project$Page$Home$MsgUserSentSendToFriendForm),
												'Enviar')))))))
					])),
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$height(
						$lucamug$elm_ui_with_context$Element$WithContext$px(
							$author$project$Page$Home$getMainContainerSize(model).aR - model.ae)),
						$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
						$lucamug$elm_ui_with_context$Element$WithContext$padding(28),
						$lucamug$elm_ui_with_context$Element$WithContext$spacing(20),
						$lucamug$elm_ui_with_context$Element$WithContext$inFront(
						$author$project$Page$Home$viewSnackBarError(model.i.G)),
						$lucamug$elm_ui_with_context$Element$WithContext$inFront(
						$author$project$Page$Home$viewSnackBarSuccess(
							model.i.de ? $elm$core$Maybe$Just('Se envió correctamente.') : $elm$core$Maybe$Nothing))
					]),
				_List_fromArray(
					[
						$author$project$TT$FormField$render(
						A2(
							$author$project$TT$FormField$withState,
							(!_Utils_eq(model.i.at.bM, $elm$core$Maybe$Nothing)) ? 2 : 0,
							A2(
								$author$project$TT$FormField$withFieldAttrs,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$id('name'))
									]),
								A2(
									$author$project$TT$FormField$withWrapperAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									A3($author$project$TT$FormField$default, $author$project$Page$Home$MsgUserChangedSendToFriendName, model.i.at.g, 'Tu nombre *'))))),
						function () {
						var _v0 = model.i.at.bM;
						if (!_v0.$) {
							var errorMessage = _v0.a;
							return A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								_Utils_ap(
									$author$project$TT$Font$body3,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$error)
										])),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text(errorMessage)
									]));
						} else {
							return $lucamug$elm_ui_with_context$Element$WithContext$none;
						}
					}(),
						$author$project$TT$FormField$render(
						A2(
							$author$project$TT$FormField$withState,
							(!_Utils_eq(model.i.cB.bM, $elm$core$Maybe$Nothing)) ? 2 : 0,
							A2(
								$author$project$TT$FormField$withFieldAttrs,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$id('my-email'))
									]),
								A2(
									$author$project$TT$FormField$withInputType,
									1,
									A2(
										$author$project$TT$FormField$withWrapperAttrs,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
											]),
										A3($author$project$TT$FormField$default, $author$project$Page$Home$MsgUserChangedSendToFriendEmail, model.i.cB.g, 'Tu email *')))))),
						function () {
						var _v1 = model.i.cB.bM;
						if (!_v1.$) {
							var errorMessage = _v1.a;
							return A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								_Utils_ap(
									$author$project$TT$Font$body3,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$error)
										])),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text(errorMessage)
									]));
						} else {
							return $lucamug$elm_ui_with_context$Element$WithContext$none;
						}
					}(),
						$author$project$TT$FormField$render(
						A2(
							$author$project$TT$FormField$withState,
							(!_Utils_eq(model.i.ao.bM, $elm$core$Maybe$Nothing)) ? 2 : 0,
							A2(
								$author$project$TT$FormField$withFieldAttrs,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
										$elm$html$Html$Attributes$id('friendName'))
									]),
								A2(
									$author$project$TT$FormField$withWrapperAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									A3($author$project$TT$FormField$default, $author$project$Page$Home$MsgUserChangedSendToFriendNameFriend, model.i.ao.g, 'Nombre de tu amigo *'))))),
						function () {
						var _v2 = model.i.ao.bM;
						if (!_v2.$) {
							var errorMessage = _v2.a;
							return A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								_Utils_ap(
									$author$project$TT$Font$body3,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$error)
										])),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text(errorMessage)
									]));
						} else {
							return $lucamug$elm_ui_with_context$Element$WithContext$none;
						}
					}(),
						$author$project$TT$FormField$render(
						A2(
							$author$project$TT$FormField$withState,
							(!_Utils_eq(model.i.an.bM, $elm$core$Maybe$Nothing)) ? 2 : 0,
							A2(
								$author$project$TT$FormField$withInputType,
								1,
								A2(
									$author$project$TT$FormField$withFieldAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$id('friendEmail'))
										]),
									A2(
										$author$project$TT$FormField$withWrapperAttrs,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
											]),
										A3($author$project$TT$FormField$default, $author$project$Page$Home$MsgUserChangedSendToFriendEmailFriend, model.i.an.g, 'Email de tu amigo *')))))),
						function () {
						var _v3 = model.i.an.bM;
						if (!_v3.$) {
							var errorMessage = _v3.a;
							return A2(
								$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
								_Utils_ap(
									$author$project$TT$Font$body3,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$error)
										])),
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$text(errorMessage)
									]));
						} else {
							return $lucamug$elm_ui_with_context$Element$WithContext$none;
						}
					}(),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'display', 'none'))
							]),
						$author$project$TT$FormField$render(
							A2(
								$author$project$TT$FormField$withInputType,
								0,
								A2(
									$author$project$TT$FormField$withWrapperAttrs,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									A3($author$project$TT$FormField$default, $author$project$Page$Home$MsgBotChangedSendToFriendSpamControl, model.i.db, '')))))
					]))
			])) : $lucamug$elm_ui_with_context$Element$WithContext$none;
};
var $author$project$Page$Home$MsgHideSidebar = {$: 55};
var $author$project$Page$Home$MsgUserClickJobAdLink = function (a) {
	return {$: 84, a: a};
};
var $mdgriffith$elm_ui$Element$Font$alignLeft = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.lg);
var $lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft = $lucamug$elm_ui_with_context$Element$WithContext$Internal$attribute($mdgriffith$elm_ui$Element$Font$alignLeft);
var $author$project$TT$IT$externalLink = function (svgAttributes) {
	return A3(
		$author$project$TT$IT$makeBuilder,
		'externalLink',
		svgAttributes,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14 21 3'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_Nil)
			]));
};
var $mdgriffith$elm_ui$Element$Border$innerShadow = function (almostShade) {
	var shade = {g5: almostShade.g5, hz: almostShade.hz, fc: true, jE: almostShade.jE, kQ: almostShade.kQ};
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$shadows,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			$mdgriffith$elm_ui$Internal$Model$boxShadowClass(shade),
			'box-shadow',
			$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(shade)));
};
var $lucamug$elm_ui_with_context$Element$WithContext$Border$innerShadow = function (almostShade) {
	return $lucamug$elm_ui_with_context$Element$WithContext$Internal$attr(
		$mdgriffith$elm_ui$Element$Border$innerShadow(almostShade));
};
var $lucamug$elm_ui_with_context$Element$WithContext$rgba = $mdgriffith$elm_ui$Element$rgba;
var $author$project$Page$Home$viewSidebarInfo = F2(
	function (model, tkJobAdSummaryDo) {
		var viewUploadCvInfo = _List_fromArray(
			[
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
				_Utils_ap(
					$author$project$TT$Font$body2,
					_List_fromArray(
						[$lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, $lucamug$elm_ui_with_context$Element$WithContext$Font$center])),
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$text(
						$elm$core$String$toUpper('Sube tu CV'))
					])),
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
				_Utils_ap(
					$author$project$TT$Font$body2,
					_List_fromArray(
						[$lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft])),
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$text('Estás compartiendo tus datos de contacto con empresas para que puedan ofrecerte trabajo si tu perfil se ajusta a sus vacantes disponibles.')
					])),
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
				_Utils_ap(
					$author$project$TT$Font$body2,
					_List_fromArray(
						[$lucamug$elm_ui_with_context$Element$WithContext$Font$alignLeft])),
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$text('Si tienes alguna duda o comentario puedes ir a '),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$link,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								$lucamug$elm_ui_with_context$Element$WithContext$Font$underline
							]),
						{
							dQ: A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_Nil,
								$lucamug$elm_ui_with_context$Element$WithContext$text('preguntas frecuentes')),
							Q: '/preguntas-frecuentes?section=candidatos'
						})
					]))
			]);
		var viewSkillBubble = function (skill) {
			return A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 8, 4),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(24),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
						$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$tertiary)
					]),
				$lucamug$elm_ui_with_context$Element$WithContext$text(skill));
		};
		var viewJobAdInfo = _List_fromArray(
			[
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
				_Utils_ap(
					$author$project$TT$Font$body2,
					_List_fromArray(
						[$lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold, $lucamug$elm_ui_with_context$Element$WithContext$Font$center])),
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$text(
						$elm$core$String$toUpper(tkJobAdSummaryDo.jY))
					])),
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
				_Utils_ap(
					$author$project$TT$Font$body2,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$Font$underline,
							$lucamug$elm_ui_with_context$Element$WithContext$Font$center,
							$lucamug$elm_ui_with_context$Element$WithContext$pointer,
							$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
							$author$project$Page$Home$MsgUserClickJobAdLink(tkJobAdSummaryDo.jd))
						])),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$el,
						_List_fromArray(
							[
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 4, 0)
							]),
						$author$project$TT$IT$render(
							A2(
								$author$project$TT$IT$withSize,
								16,
								A2(
									$author$project$TT$IT$withColor,
									$author$project$TT$Color$white,
									$author$project$TT$IT$externalLink(_List_Nil))))),
						$lucamug$elm_ui_with_context$Element$WithContext$text('ver anuncio completo')
					])),
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
				_Utils_ap(
					$author$project$TT$Font$body2,
					_List_fromArray(
						[$lucamug$elm_ui_with_context$Element$WithContext$Font$center])),
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$text(tkJobAdSummaryDo.hK + (' - ' + tkJobAdSummaryDo.cU))
					])),
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
				_Utils_ap(
					$author$project$TT$Font$body2,
					_List_fromArray(
						[$lucamug$elm_ui_with_context$Element$WithContext$Font$center])),
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$text(tkJobAdSummaryDo.kx + (' | ' + tkJobAdSummaryDo.j4))
					])),
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$row,
				_List_fromArray(
					[
						A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, 8),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'justify-content', 'center')),
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'gap', '8px'))
					]),
				A2($elm$core$List$map, viewSkillBubble, tkJobAdSummaryDo.d4)),
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
				_Utils_ap(
					$author$project$TT$Font$body2,
					_List_fromArray(
						[$lucamug$elm_ui_with_context$Element$WithContext$Font$justify])),
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$text(tkJobAdSummaryDo.h3)
					]))
			]);
		return A2(
			$lucamug$elm_ui_with_context$Element$WithContext$row,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(
						$author$project$Page$Home$getMainContainerSize(model).aR)),
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
				]),
			_List_fromArray(
				[
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$scrollbarY,
							$lucamug$elm_ui_with_context$Element$WithContext$width(
							$lucamug$elm_ui_with_context$Element$WithContext$px(
								(($author$project$Page$Home$getMainContainerSize(model).a8 / 4) | 0) * 3)),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray1),
							$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$white),
							$lucamug$elm_ui_with_context$Element$WithContext$padding(16),
							$lucamug$elm_ui_with_context$Element$WithContext$spacing(
							model.aC ? 32 : 8)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$warning),
									$lucamug$elm_ui_with_context$Element$WithContext$Font$center
								]),
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$text(tkJobAdSummaryDo.iF)
								])),
						model.aC ? viewUploadCvInfo : viewJobAdInfo)),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgHideSidebar),
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$grayDarkTransparent),
							$lucamug$elm_ui_with_context$Element$WithContext$Border$innerShadow(
							{
								g5: 30,
								hz: A4($lucamug$elm_ui_with_context$Element$WithContext$rgba, 0, 0, 0, 0.2),
								jE: _Utils_Tuple2(10, 0),
								kQ: 10
							})
						]),
					$lucamug$elm_ui_with_context$Element$WithContext$none)
				]));
	});
var $author$project$TT$IconButton$Primary = 3;
var $author$project$Page$Home$viewCandidateNotLoggedInGoogleButton = function (model) {
	return model.f.b4 ? A2(
		$lucamug$elm_ui_with_context$Element$WithContext$el,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$centerX,
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'position', 'sticky')),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'top', '0')),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'z-index', '1')),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				$elm$html$Html$Attributes$class('sentry-mask')),
				$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
				{hb: 0, jf: 0, ku: 44, lz: 0})
			]),
		A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
					$elm$html$Html$Attributes$id('candidate_google_button_container'))
				]),
			A2(
				$lucamug$elm_ui_with_context$Element$WithContext$el,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
						$elm$html$Html$Attributes$id('candidate_google_button'))
					]),
				$lucamug$elm_ui_with_context$Element$WithContext$none))) : $author$project$Page$Home$viewCandidateNotLoggedInTalentecaButton(model);
};
var $author$project$Page$Home$viewWelcomeQuestion = function (model) {
	var viewHeightAttr = (!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$height(
		$lucamug$elm_ui_with_context$Element$WithContext$px(
			$author$project$Page$Home$getMainContainerSize(model).aR - model.ae)) : $lucamug$elm_ui_with_context$Element$WithContext$height(
		$lucamug$elm_ui_with_context$Element$WithContext$px(
			$author$project$Page$Home$getMainContainerSize(model).aR - model.ae));
	return A2(
		$lucamug$elm_ui_with_context$Element$WithContext$column,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
				$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
				{hb: 16, jf: 16, ku: 16, lz: 16}),
				viewHeightAttr,
				$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray4),
				$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
				$elm$html$Html$Attributes$id('chatContainer')),
				(!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(0) : $lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
				{hc: 8, hd: 8, lA: 0, lB: 0}),
				$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
				A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$centerX,
							$lucamug$elm_ui_with_context$Element$WithContext$centerY,
							$lucamug$elm_ui_with_context$Element$WithContext$alpha(0.2)
						]),
					$author$project$TT$VectorImage$talenteca(50)))
			]),
		_List_fromArray(
			[
				A2(
				$lucamug$elm_ui_with_context$Element$WithContext$column,
				_List_fromArray(
					[
						$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
						$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
						$lucamug$elm_ui_with_context$Element$WithContext$spacing(24)
					]),
				_List_fromArray(
					[
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$row,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
								A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 0, 0)
							]),
						_List_fromArray(
							[
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										(!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$moveLeft(30) : $lucamug$elm_ui_with_context$Element$WithContext$moveLeft(0),
										$lucamug$elm_ui_with_context$Element$WithContext$alignLeft
									]),
								$author$project$TT$VectorImage$talentino(100)),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$column,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										A2($lucamug$elm_ui_with_context$Element$WithContext$spacingXY, 0, 8),
										$lucamug$elm_ui_with_context$Element$WithContext$centerX
									]),
								_List_fromArray(
									[
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
												$lucamug$elm_ui_with_context$Element$WithContext$width(
												$lucamug$elm_ui_with_context$Element$WithContext$px(210)),
												A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 8),
												$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
												{hc: 0, hd: 8, lA: 8, lB: 8}),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												A2($elm$html$Html$Attributes$style, 'box-shadow', '0px 3px 1px -2px rgba(0,0,0,0.20), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)'))
											]),
										A2(
											$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
											_Utils_ap(
												$author$project$TT$Font$body2,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
													])),
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$text(
													model.aC ? 'Soy Talentino y te ayudaré a subir tu CV en 5 minutos.' : 'Soy Talentino y te ayudaré con este empleo.')
												]))),
										A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
												$lucamug$elm_ui_with_context$Element$WithContext$width(
												$lucamug$elm_ui_with_context$Element$WithContext$px(210)),
												A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 8),
												$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
												{hc: 0, hd: 8, lA: 8, lB: 8}),
												$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
												A2($elm$html$Html$Attributes$style, 'box-shadow', '0px 3px 1px -2px rgba(0,0,0,0.20), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)'))
											]),
										A2(
											$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
											_Utils_ap(
												$author$project$TT$Font$body2,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text)
													])),
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$text('Inicia sesión con Google o escribe tu correo electrónico')
												])))
									]))
							])),
						A2(
						$lucamug$elm_ui_with_context$Element$WithContext$column,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$shrink),
								$lucamug$elm_ui_with_context$Element$WithContext$centerX,
								$lucamug$elm_ui_with_context$Element$WithContext$spacing(12),
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 0, 16),
								$lucamug$elm_ui_with_context$Element$WithContext$moveRight(22)
							]),
						_List_fromArray(
							[
								$author$project$Page$Home$viewCandidateNotLoggedInGoogleButton(model),
								A2(
								$lucamug$elm_ui_with_context$Element$WithContext$el,
								_List_fromArray(
									[
										$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
										$lucamug$elm_ui_with_context$Element$WithContext$paddingEach(
										{hb: 0, jf: 0, ku: 44, lz: 0})
									]),
								A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
											A2(
												$lucamug$elm_ui_with_context$Element$WithContext$el,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Border$width(1),
														$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
														$lucamug$elm_ui_with_context$Element$WithContext$centerY,
														$lucamug$elm_ui_with_context$Element$WithContext$Border$color($author$project$TT$Color$gray3)
													]),
												$lucamug$elm_ui_with_context$Element$WithContext$none))
										]),
									A2(
										$lucamug$elm_ui_with_context$Element$WithContext$el,
										_List_fromArray(
											[
												A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 12, 0),
												$lucamug$elm_ui_with_context$Element$WithContext$centerX,
												$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray4)
											]),
										$lucamug$elm_ui_with_context$Element$WithContext$text('o')))),
								function () {
								var hasError = !_Utils_eq(model.a.b.cB.bM, $elm$core$Maybe$Nothing);
								return A2(
									$lucamug$elm_ui_with_context$Element$WithContext$row,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
											$lucamug$elm_ui_with_context$Element$WithContext$height(
											$lucamug$elm_ui_with_context$Element$WithContext$px(44))
										]),
									_List_fromArray(
										[
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
												]),
											$author$project$TT$FormField$render(
												A2(
													$author$project$TT$FormField$withState,
													hasError ? 2 : 0,
													A2(
														$author$project$TT$FormField$withInputType,
														0,
														A2(
															$author$project$TT$FormField$withPlaceholder,
															$lucamug$elm_ui_with_context$Element$WithContext$text('Ingresa tu correo electrónico'),
															A2(
																$author$project$TT$FormField$withFieldAttrs,
																_List_fromArray(
																	[
																		$lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
																		{hc: 4, hd: 25, lA: 4, lB: 25}),
																		$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																		$elm$html$Html$Events$onBlur($author$project$Page$Home$MsgUserLeftEmailInput)),
																		$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																		$elm$html$Html$Attributes$id('email')),
																		$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																		$elm$html$Html$Attributes$autocomplete(false)),
																		$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																		$elm$html$Html$Attributes$spellcheck(false)),
																		$author$project$Page$Home$onEnter($author$project$Page$Home$MsgUserSubmittedEmail),
																		$lucamug$elm_ui_with_context$Element$WithContext$focused(
																		_List_fromArray(
																			[
																				$lucamug$elm_ui_with_context$Element$WithContext$Border$color(
																				hasError ? $author$project$TT$Color$error : $author$project$TT$Color$primary)
																			]))
																	]),
																A2(
																	$author$project$TT$FormField$withWrapperAttrs,
																	_List_fromArray(
																		[
																			$lucamug$elm_ui_with_context$Element$WithContext$width(
																			$lucamug$elm_ui_with_context$Element$WithContext$px(245))
																		]),
																	A2(
																		$author$project$TT$FormField$withLabelType,
																		1,
																		A3($author$project$TT$FormField$default, $author$project$Page$Home$MsgUserChangedEmail, model.a.b.cB.cO, ''))))))))),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$moveLeft(42)
												]),
											$author$project$TT$IconButton$render(
												A2(
													$author$project$TT$IconButton$withStyle,
													0,
													A2(
														$author$project$TT$IconButton$withColor,
														3,
														A2(
															$author$project$TT$IconButton$withButtonAttrs,
															_List_fromArray(
																[
																	$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
																	$elm$html$Html$Attributes$class('talapoin-submit-intermedite-step'))
																]),
															A3(
																$author$project$TT$IconButton$default,
																$author$project$Page$Home$MsgUserSubmittedEmail,
																'Enviar',
																$author$project$TT$IT$render(
																	A2(
																		$author$project$TT$IT$withSize,
																		15,
																		A2(
																			$author$project$TT$IT$withColor,
																			$author$project$TT$Color$white,
																			$author$project$TT$IT$send(_List_Nil))))))))))
										]));
							}(),
								function () {
								var _v0 = model.a.b.cB.bM;
								if (!_v0.$) {
									var message = _v0.a;
									return A2(
										$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
										_Utils_ap(
											$author$project$TT$Font$body2,
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$error)
												])),
										_List_fromArray(
											[
												$lucamug$elm_ui_with_context$Element$WithContext$text(message)
											]));
								} else {
									return $lucamug$elm_ui_with_context$Element$WithContext$none;
								}
							}()
							]))
					]))
			]));
};
var $author$project$Page$Home$viewElement = function (model) {
	var viewLoading = A2(
		$lucamug$elm_ui_with_context$Element$WithContext$el,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
				$lucamug$elm_ui_with_context$Element$WithContext$height(
				$lucamug$elm_ui_with_context$Element$WithContext$px(
					$author$project$Page$Home$getMainContainerSize(model).aR)),
				(!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(0) : $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(8),
				$lucamug$elm_ui_with_context$Element$WithContext$inFront(
				$author$project$Page$Home$viewNotificationMessages(model))
			]),
		A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$centerX,
					$lucamug$elm_ui_with_context$Element$WithContext$centerY,
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(20)
				]),
			_List_fromArray(
				[
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[$lucamug$elm_ui_with_context$Element$WithContext$centerX]),
					A3($author$project$TT$Spinner$spinner, 1, 50, $author$project$TT$Color$text)),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					$author$project$TT$Font$headline3,
					$lucamug$elm_ui_with_context$Element$WithContext$text('Cargando...'))
				])));
	var viewJobAdNotFound = A2(
		$lucamug$elm_ui_with_context$Element$WithContext$el,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
				$lucamug$elm_ui_with_context$Element$WithContext$height(
				$lucamug$elm_ui_with_context$Element$WithContext$px(
					$author$project$Page$Home$getMainContainerSize(model).aR)),
				$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
				$lucamug$elm_ui_with_context$Element$WithContext$inFront(
				$author$project$Page$Home$viewNotificationMessages(model)),
				(!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(0) : $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(8)
			]),
		A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$centerX,
					$lucamug$elm_ui_with_context$Element$WithContext$centerY,
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 30, 40),
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(24)
				]),
			_List_fromArray(
				[
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[$lucamug$elm_ui_with_context$Element$WithContext$centerX]),
					$author$project$TT$IT$render(
						A2(
							$author$project$TT$IT$withSize,
							82,
							A2(
								$author$project$TT$IT$withColor,
								$author$project$TT$Color$gray2,
								A2($author$project$TT$IT$briefcase, false, _List_Nil))))),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
					_Utils_ap(
						$author$project$TT$Font$headline1,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
								$lucamug$elm_ui_with_context$Element$WithContext$centerX,
								$lucamug$elm_ui_with_context$Element$WithContext$Font$center
							])),
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$text('¡la vacante de empleo no se encuentra disponible')
						])),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
					_Utils_ap(
						$author$project$TT$Font$body1,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
								A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 4, 24)
							])),
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$text('Como alternativa puedes subir tu CV para que te escriban las empresas\ncuando se abran nuevas vacantes o ver todos los empleos y postularte a\nuno nuevo')
						])),
					$author$project$TT$Button$render(
					A2(
						$author$project$TT$Button$withButtonAttrs,
						_List_fromArray(
							[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$pointer]),
						A2(
							$author$project$TT$Button$withSize,
							1,
							A2(
								$author$project$TT$Button$withRole,
								1,
								A2(
									$author$project$TT$Button$default,
									$elm$core$Maybe$Just($author$project$Page$Home$MsgUserClickUploadCvButton),
									'Sube tu Cv'))))),
					$author$project$TT$Button$render(
					A2(
						$author$project$TT$Button$withButtonAttrs,
						_List_fromArray(
							[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$pointer]),
						A2(
							$author$project$TT$Button$withSize,
							1,
							A2(
								$author$project$TT$Button$withRole,
								1,
								A2(
									$author$project$TT$Button$default,
									$elm$core$Maybe$Just($author$project$Page$Home$MsgUserClickGoToJobAdSerchPageButton),
									'Ver todos los empleos')))))
				])));
	var viewInactiveJobAd = A2(
		$lucamug$elm_ui_with_context$Element$WithContext$el,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
				$lucamug$elm_ui_with_context$Element$WithContext$height(
				$lucamug$elm_ui_with_context$Element$WithContext$px(
					$author$project$Page$Home$getMainContainerSize(model).aR)),
				$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
				$lucamug$elm_ui_with_context$Element$WithContext$inFront(
				$author$project$Page$Home$viewNotificationMessages(model)),
				(!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(0) : $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(8)
			]),
		A2(
			$lucamug$elm_ui_with_context$Element$WithContext$column,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$centerX,
					$lucamug$elm_ui_with_context$Element$WithContext$centerY,
					A2($lucamug$elm_ui_with_context$Element$WithContext$paddingXY, 30, 40),
					$lucamug$elm_ui_with_context$Element$WithContext$spacing(24)
				]),
			_List_fromArray(
				[
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$el,
					_List_fromArray(
						[$lucamug$elm_ui_with_context$Element$WithContext$centerX]),
					$author$project$TT$IT$render(
						A2(
							$author$project$TT$IT$withSize,
							90,
							A2(
								$author$project$TT$IT$withColor,
								$author$project$TT$Color$gray2,
								A2($author$project$TT$IT$briefcase, false, _List_Nil))))),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
					_Utils_ap(
						$author$project$TT$Font$headline1,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$text),
								$lucamug$elm_ui_with_context$Element$WithContext$centerX,
								$lucamug$elm_ui_with_context$Element$WithContext$Font$center
							])),
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$text('¡la vacante de empleo no se encuentra activa')
						])),
					$author$project$TT$Button$render(
					A2(
						$author$project$TT$Button$withButtonAttrs,
						_List_fromArray(
							[$lucamug$elm_ui_with_context$Element$WithContext$centerX, $lucamug$elm_ui_with_context$Element$WithContext$pointer]),
						A2(
							$author$project$TT$Button$withSize,
							1,
							A2(
								$author$project$TT$Button$withRole,
								1,
								A2(
									$author$project$TT$Button$default,
									$elm$core$Maybe$Just($author$project$Page$Home$MsgUserClickGoToJobAdSerchPageButton),
									'Buscar empleos')))))
				])));
	var _v0 = model.fl;
	if (!_v0.$) {
		var _v1 = model.bS;
		switch (_v1.$) {
			case 0:
				return A5($author$project$Page$Home$viewGeneralErrorMessageWithMsg, model, 'Algo falló de nuestro lado', 'No fue posible iniciar el proceso de postulación automáticamente', 'INICIAR POSTULACIÓN', $author$project$Page$Home$MsgGetJobAdSummary);
			case 2:
				var httpError = _v1.a;
				if (httpError.$ === 3) {
					var status = httpError.a;
					return ((status >= 500) && (status <= 599)) ? A5($author$project$Page$Home$viewGeneralErrorMessageWithLink, model, 'Algo falló de nuestro lado', 'No fue posible cargar los candidatos de tu vacante. Por favor intenta nuevamente.', 'REGRESAR AL HOME', model.c5) : viewJobAdNotFound;
				} else {
					return A5($author$project$Page$Home$viewGeneralErrorMessageWithLink, model, 'Algo falló de nuestro lado', 'No fue posible cargar los candidatos de tu vacante. Por favor intenta nuevamente.', 'REGRESAR AL HOME', model.c5);
				}
			case 1:
				return viewLoading;
			default:
				var tkJobAdSummaryDo = _v1.a;
				return tkJobAdSummaryDo.iX ? A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray4),
							$lucamug$elm_ui_with_context$Element$WithContext$inFront(
							$author$project$Page$Home$viewNotificationMessages(model)),
							$lucamug$elm_ui_with_context$Element$WithContext$inFront(
							model.b6 ? A2($author$project$Page$Home$viewSidebarInfo, model, tkJobAdSummaryDo) : $lucamug$elm_ui_with_context$Element$WithContext$none),
							$lucamug$elm_ui_with_context$Element$WithContext$inFront(
							$author$project$Page$Home$viewSendToFriendModal(model)),
							$lucamug$elm_ui_with_context$Element$WithContext$inFront(
							$author$project$Page$Home$viewLoginModal(model)),
							$lucamug$elm_ui_with_context$Element$WithContext$inFront(
							$author$project$Page$Home$viewLoginErrorMessage(model)),
							(!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(0) : $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(8)
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$row,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
									$lucamug$elm_ui_with_context$Element$WithContext$height(
									$lucamug$elm_ui_with_context$Element$WithContext$px(64)),
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$grayDark),
									$lucamug$elm_ui_with_context$Element$WithContext$padding(8),
									$lucamug$elm_ui_with_context$Element$WithContext$spaceEvenly,
									(!model.p) ? $lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(0) : $lucamug$elm_ui_with_context$Element$WithContext$Border$roundEach(
									{hc: 0, hd: 0, lA: 8, lB: 8})
								]),
							_List_fromArray(
								[
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width(
											$lucamug$elm_ui_with_context$Element$WithContext$px(25)),
											$lucamug$elm_ui_with_context$Element$WithContext$pointer,
											$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
											$author$project$Page$Home$MsgUserClickedBackIcon(tkJobAdSummaryDo.is))
										]),
									$author$project$TT$IT$render(
										A2(
											$author$project$TT$IT$withSize,
											20,
											A2(
												$author$project$TT$IT$withColor,
												$author$project$TT$Color$white,
												$author$project$TT$IT$chevronLeft(_List_Nil))))),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$column,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$Font$color($author$project$TT$Color$white),
											$lucamug$elm_ui_with_context$Element$WithContext$Font$center,
											$lucamug$elm_ui_with_context$Element$WithContext$spaceEvenly,
											$lucamug$elm_ui_with_context$Element$WithContext$pointer,
											$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick($author$project$Page$Home$MsgShowSidebar),
											model.p ? $lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill) : $lucamug$elm_ui_with_context$Element$WithContext$width(
											$lucamug$elm_ui_with_context$Element$WithContext$px(model.q.a8 - 80)),
											$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									_List_fromArray(
										[
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$el,
											_Utils_ap(
												$author$project$TT$Font$headline3,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Font$semiBold,
														$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
														$lucamug$elm_ui_with_context$Element$WithContext$Font$center,
														$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
														$elm$html$Html$Attributes$class('truncate-text'))
													])),
											$lucamug$elm_ui_with_context$Element$WithContext$text(tkJobAdSummaryDo.jY)),
											A2(
											$lucamug$elm_ui_with_context$Element$WithContext$paragraph,
											_Utils_ap(
												$author$project$TT$Font$body2,
												_List_fromArray(
													[
														$lucamug$elm_ui_with_context$Element$WithContext$Font$underline,
														$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
														$elm$html$Html$Attributes$id('scroll_reference'))
													])),
											_List_fromArray(
												[
													$lucamug$elm_ui_with_context$Element$WithContext$text(
													model.aC ? 'por qué estoy aquí' : 'ver vacante')
												]))
										])),
									A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$width(
											$lucamug$elm_ui_with_context$Element$WithContext$px(25)),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$tabindex(0)),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											A2($elm$html$Html$Attributes$attribute, $author$project$Page$Home$referenceDataName, 'job-ad-actions')),
											A2($author$project$Page$Home$onBlurAttribute, 'job-ad-actions', $author$project$Page$Home$MsgHideMenuOptions),
											$lucamug$elm_ui_with_context$Element$WithContext$htmlAttribute(
											$elm$html$Html$Attributes$class('dropdown-menu')),
											$lucamug$elm_ui_with_context$Element$WithContext$pointer,
											$lucamug$elm_ui_with_context$Element$WithContext$Events$onClick(
											model.bs ? $author$project$Page$Home$MsgHideMenuOptions : $author$project$Page$Home$MsgShowMenuOptions),
											$lucamug$elm_ui_with_context$Element$WithContext$below(
											A2($author$project$Page$Home$viewMoreOptions, model, tkJobAdSummaryDo.jY))
										]),
									$author$project$TT$IT$render(
										A2(
											$author$project$TT$IT$withSize,
											20,
											A2(
												$author$project$TT$IT$withColor,
												$author$project$TT$Color$white,
												$author$project$TT$IT$more(_List_Nil)))))
								])),
							function () {
							var _v3 = model.bY;
							if (!_v3.$) {
								var _v4 = _v3.a;
								var alertText = _v4.a;
								var alertColor = _v4.b;
								var fontColor = _v4.c;
								return A2(
									$lucamug$elm_ui_with_context$Element$WithContext$el,
									_List_fromArray(
										[
											$lucamug$elm_ui_with_context$Element$WithContext$alignTop,
											$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill)
										]),
									A4(
										$author$project$Model$viewPageLevelAlert,
										$author$project$Page$Home$MsgUserPressedDismissAlertButton,
										$elm$core$Maybe$Just(alertText),
										alertColor,
										fontColor));
							} else {
								return $lucamug$elm_ui_with_context$Element$WithContext$none;
							}
						}(),
							function () {
							var _v5 = model.gV;
							switch (_v5) {
								case 0:
									return $author$project$Page$Home$viewWelcomeQuestion(model);
								case 1:
									return A2($author$project$Page$Home$viewCandidateInfoStage, model, tkJobAdSummaryDo);
								case 2:
									return A2($author$project$Page$Home$viewExternalApplyStage, model, tkJobAdSummaryDo);
								case 3:
									return $author$project$Page$Home$viewFilterQuestionsStage(model);
								case 4:
									return $author$project$Page$Home$viewApplyQuestionsStage(model);
								case 5:
									return $author$project$Page$Home$viewCandidateCvStage(model);
								case 6:
									return A2($author$project$Page$Home$viewCompleteApplyStage, model, tkJobAdSummaryDo);
								default:
									return $lucamug$elm_ui_with_context$Element$WithContext$none;
							}
						}()
						])) : viewInactiveJobAd;
		}
	} else {
		return viewJobAdNotFound;
	}
};
var $author$project$Main$viewHomePage = function (model) {
	return A2(
		$lucamug$elm_ui_with_context$Element$WithContext$map,
		$author$project$Main$MsgHome,
		$author$project$Page$Home$viewElement(model.as));
};
var $author$project$Main$viewRouteExternalPage = function (url) {
	return A2(
		$lucamug$elm_ui_with_context$Element$WithContext$el,
		_List_Nil,
		$lucamug$elm_ui_with_context$Element$WithContext$text('Navegando a ' + url));
};
var $author$project$Main$viewPageContent = function (model) {
	return A2(
		$lucamug$elm_ui_with_context$Element$WithContext$el,
		_List_fromArray(
			[
				$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
				$lucamug$elm_ui_with_context$Element$WithContext$height($lucamug$elm_ui_with_context$Element$WithContext$fill)
			]),
		function () {
			var _v0 = $author$project$Route$fromUrl(model.Q);
			if (!_v0.$) {
				return $author$project$Main$viewHomePage(model);
			} else {
				var url = _v0.a;
				return $author$project$Main$viewRouteExternalPage(url);
			}
		}());
};
var $author$project$Main$viewBody = function (model) {
	var specificToastWrapper = F2(
		function (attrs, position) {
			return A6($author$project$TT$Alerts$toastWrapper, model.aO, attrs, position, 320, $author$project$Main$MsgBrowserDeleteToast, $author$project$Main$MsgBrowserHideToast);
		});
	var specificBubbleWrapper = F2(
		function (localBubbles, position) {
			return A5($author$project$TT$Alerts$bubbleAlertsWrapper, localBubbles, $author$project$Main$MsgBrowserHideToast, position, model.q.a8 - ((model.q.a8 / 4) | 0), 10.0);
		});
	var counterForFavoritesNotifications = $elm$core$List$length(model.bw.dE.fP);
	return A4(
		$lucamug$elm_ui_with_context$Element$WithContext$layoutWith,
		model.bI,
		{
			jP: _List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$focusStyle(
					{
						g$: $elm$core$Maybe$Nothing,
						g7: $elm$core$Maybe$Just($author$project$TT$Color$primary),
						kK: $elm$core$Maybe$Nothing
					})
				])
		},
		_Utils_ap(
			A2(
				$elm$core$List$cons,
				$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white),
				$author$project$TT$Font$text),
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(model.q.aR - model.a6))
				])),
		$author$project$TT$Util$isMediumScreenOrLarger(model.q) ? A2(
			$lucamug$elm_ui_with_context$Element$WithContext$row,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width(
					$lucamug$elm_ui_with_context$Element$WithContext$px(model.q.a8)),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(model.q.aR)),
					$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$gray4),
					$lucamug$elm_ui_with_context$Element$WithContext$inFront(
					A2(specificToastWrapper, _List_Nil, -40)),
					$lucamug$elm_ui_with_context$Element$WithContext$inFront(
					A2(specificBubbleWrapper, model.aB, 10)),
					$lucamug$elm_ui_with_context$Element$WithContext$behindContent(
					A2(
						$lucamug$elm_ui_with_context$Element$WithContext$image,
						_List_fromArray(
							[
								$lucamug$elm_ui_with_context$Element$WithContext$width(
								$lucamug$elm_ui_with_context$Element$WithContext$px(model.q.a8)),
								$lucamug$elm_ui_with_context$Element$WithContext$height(
								$lucamug$elm_ui_with_context$Element$WithContext$px(model.q.aR)),
								$lucamug$elm_ui_with_context$Element$WithContext$centerX,
								$lucamug$elm_ui_with_context$Element$WithContext$centerY
							]),
						{h3: 'background-image', kY: model.J.gl + 'images/defaults/default-job-ad-background-light2.webp'}))
				]),
			_List_fromArray(
				[
					A6(
					$author$project$TT$SideBarMenu$viewDesktopSidebar,
					model.da,
					model.J.f6,
					model.a1,
					counterForFavoritesNotifications,
					$elm$core$Maybe$Just($author$project$Main$MsgUserPressedShowAccountInfoDropdown),
					$elm$core$Maybe$Just($author$project$Main$MsgUserPressedHideAccountInfoDropdown)),
					A2(
					$lucamug$elm_ui_with_context$Element$WithContext$column,
					_List_fromArray(
						[
							$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
							$lucamug$elm_ui_with_context$Element$WithContext$height(
							$lucamug$elm_ui_with_context$Element$WithContext$px(
								$elm$core$Basics$round((model.q.aR - model.a6) * 0.9)))
						]),
					_List_fromArray(
						[
							A2(
							$lucamug$elm_ui_with_context$Element$WithContext$column,
							_List_fromArray(
								[
									$lucamug$elm_ui_with_context$Element$WithContext$width(
									A2(
										$lucamug$elm_ui_with_context$Element$WithContext$minimum,
										320,
										A2($lucamug$elm_ui_with_context$Element$WithContext$maximum, 650, $lucamug$elm_ui_with_context$Element$WithContext$fill))),
									$lucamug$elm_ui_with_context$Element$WithContext$centerY,
									$lucamug$elm_ui_with_context$Element$WithContext$centerX,
									$lucamug$elm_ui_with_context$Element$WithContext$Border$rounded(8),
									$lucamug$elm_ui_with_context$Element$WithContext$Border$shadow(
									{
										g5: 4,
										hz: A2($author$project$TT$Color$Extra$fadeOut, 0.75, $author$project$TT$Color$black),
										jE: _Utils_Tuple2(0, 4),
										kQ: 1
									}),
									$lucamug$elm_ui_with_context$Element$WithContext$Background$color($author$project$TT$Color$white)
								]),
							_List_fromArray(
								[
									$author$project$Main$viewPageContent(model)
								]))
						]))
				])) : A2(
			$lucamug$elm_ui_with_context$Element$WithContext$el,
			_List_fromArray(
				[
					$lucamug$elm_ui_with_context$Element$WithContext$width($lucamug$elm_ui_with_context$Element$WithContext$fill),
					$lucamug$elm_ui_with_context$Element$WithContext$height(
					$lucamug$elm_ui_with_context$Element$WithContext$px(model.q.aR - model.a6)),
					$lucamug$elm_ui_with_context$Element$WithContext$inFront(
					A2(specificToastWrapper, _List_Nil, -90)),
					$lucamug$elm_ui_with_context$Element$WithContext$inFront(
					A2(specificBubbleWrapper, model.aB, 10))
				]),
			$author$project$Main$viewPageContent(model)));
};
var $author$project$Main$view = function (model) {
	return {
		ch: _List_fromArray(
			[
				$author$project$Main$viewBody(model)
			]),
		ls: 'Postularse | Talenteca · Aplicación Web para Candidatos'
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{iP: $author$project$Main$init, jK: $author$project$Main$MsgUrlChanged, jL: $author$project$Main$MsgUrlRequested, k4: $author$project$Main$subscriptions, lI: $author$project$Main$update, lL: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (windowSize) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (versionedAssetsUrl) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (tonkeanBaseUrl) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (themeString) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (serverInfoLabelMaybe) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (serverCookieIdMaybe) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (recruiterPrivateHomeUrl) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (recruiterLoggedInInfo) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (marmosetApiBaseUrl) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (isWebShareSupported) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (isProductionTestServer) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (isProductionRealServer) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (isProductionFakeServer) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (isProduction) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (isDevelopment) {
																															return A2(
																																$elm$json$Json$Decode$andThen,
																																function (enableNewBrandingThemes) {
																																	return A2(
																																		$elm$json$Json$Decode$andThen,
																																		function (countryCode) {
																																			return A2(
																																				$elm$json$Json$Decode$andThen,
																																				function (candidatePrivateHomeUrl) {
																																					return A2(
																																						$elm$json$Json$Decode$andThen,
																																						function (candidateLoggedInInfo) {
																																							return $elm$json$Json$Decode$succeed(
																																								{dt: candidateLoggedInInfo, hn: candidatePrivateHomeUrl, hU: countryCode, h7: enableNewBrandingThemes, i_: isDevelopment, i3: isProduction, i4: isProductionFakeServer, i5: isProductionRealServer, i6: isProductionTestServer, jb: isWebShareSupported, cV: marmosetApiBaseUrl, fQ: recruiterLoggedInInfo, c5: recruiterPrivateHomeUrl, kJ: serverCookieIdMaybe, f6: serverInfoLabelMaybe, lp: themeString, ly: tonkeanBaseUrl, gl: versionedAssetsUrl, q: windowSize});
																																						},
																																						A2(
																																							$elm$json$Json$Decode$field,
																																							'candidateLoggedInInfo',
																																							A2(
																																								$elm$json$Json$Decode$andThen,
																																								function (candidateLoggedInNameMaybe) {
																																									return A2(
																																										$elm$json$Json$Decode$andThen,
																																										function (candidateLoggedInEmailMaybe) {
																																											return A2(
																																												$elm$json$Json$Decode$andThen,
																																												function (candidateIsLoggedIn) {
																																													return A2(
																																														$elm$json$Json$Decode$andThen,
																																														function (candidateCloseSessionUrl) {
																																															return $elm$json$Json$Decode$succeed(
																																																{hf: candidateCloseSessionUrl, eu: candidateIsLoggedIn, hk: candidateLoggedInEmailMaybe, hl: candidateLoggedInNameMaybe});
																																														},
																																														A2($elm$json$Json$Decode$field, 'candidateCloseSessionUrl', $elm$json$Json$Decode$string));
																																												},
																																												A2($elm$json$Json$Decode$field, 'candidateIsLoggedIn', $elm$json$Json$Decode$bool));
																																										},
																																										A2(
																																											$elm$json$Json$Decode$field,
																																											'candidateLoggedInEmailMaybe',
																																											$elm$json$Json$Decode$oneOf(
																																												_List_fromArray(
																																													[
																																														$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																														A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																																													]))));
																																								},
																																								A2(
																																									$elm$json$Json$Decode$field,
																																									'candidateLoggedInNameMaybe',
																																									$elm$json$Json$Decode$oneOf(
																																										_List_fromArray(
																																											[
																																												$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																																											]))))));
																																				},
																																				A2($elm$json$Json$Decode$field, 'candidatePrivateHomeUrl', $elm$json$Json$Decode$string));
																																		},
																																		A2($elm$json$Json$Decode$field, 'countryCode', $elm$json$Json$Decode$string));
																																},
																																A2($elm$json$Json$Decode$field, 'enableNewBrandingThemes', $elm$json$Json$Decode$bool));
																														},
																														A2($elm$json$Json$Decode$field, 'isDevelopment', $elm$json$Json$Decode$bool));
																												},
																												A2($elm$json$Json$Decode$field, 'isProduction', $elm$json$Json$Decode$bool));
																										},
																										A2($elm$json$Json$Decode$field, 'isProductionFakeServer', $elm$json$Json$Decode$bool));
																								},
																								A2($elm$json$Json$Decode$field, 'isProductionRealServer', $elm$json$Json$Decode$bool));
																						},
																						A2($elm$json$Json$Decode$field, 'isProductionTestServer', $elm$json$Json$Decode$bool));
																				},
																				A2($elm$json$Json$Decode$field, 'isWebShareSupported', $elm$json$Json$Decode$bool));
																		},
																		A2($elm$json$Json$Decode$field, 'marmosetApiBaseUrl', $elm$json$Json$Decode$string));
																},
																A2(
																	$elm$json$Json$Decode$field,
																	'recruiterLoggedInInfo',
																	A2(
																		$elm$json$Json$Decode$andThen,
																		function (recruiterLoggedInNameMaybe) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (recruiterLoggedInIdMaybe) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (recruiterLoggedInEmailMaybe) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (recruiterIsLoggedIn) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (recruiterIsCorporateAdmin) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (recruiterIsAdmin) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (recruiterCloseSessionUrl) {
																															return $elm$json$Json$Decode$succeed(
																																{ka: recruiterCloseSessionUrl, kc: recruiterIsAdmin, kd: recruiterIsCorporateAdmin, ke: recruiterIsLoggedIn, kf: recruiterLoggedInEmailMaybe, kg: recruiterLoggedInIdMaybe, kh: recruiterLoggedInNameMaybe});
																														},
																														A2($elm$json$Json$Decode$field, 'recruiterCloseSessionUrl', $elm$json$Json$Decode$string));
																												},
																												A2($elm$json$Json$Decode$field, 'recruiterIsAdmin', $elm$json$Json$Decode$bool));
																										},
																										A2($elm$json$Json$Decode$field, 'recruiterIsCorporateAdmin', $elm$json$Json$Decode$bool));
																								},
																								A2($elm$json$Json$Decode$field, 'recruiterIsLoggedIn', $elm$json$Json$Decode$bool));
																						},
																						A2(
																							$elm$json$Json$Decode$field,
																							'recruiterLoggedInEmailMaybe',
																							$elm$json$Json$Decode$oneOf(
																								_List_fromArray(
																									[
																										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																									]))));
																				},
																				A2(
																					$elm$json$Json$Decode$field,
																					'recruiterLoggedInIdMaybe',
																					$elm$json$Json$Decode$oneOf(
																						_List_fromArray(
																							[
																								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																							]))));
																		},
																		A2(
																			$elm$json$Json$Decode$field,
																			'recruiterLoggedInNameMaybe',
																			$elm$json$Json$Decode$oneOf(
																				_List_fromArray(
																					[
																						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																					]))))));
														},
														A2($elm$json$Json$Decode$field, 'recruiterPrivateHomeUrl', $elm$json$Json$Decode$string));
												},
												A2(
													$elm$json$Json$Decode$field,
													'serverCookieIdMaybe',
													$elm$json$Json$Decode$oneOf(
														_List_fromArray(
															[
																$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
															]))));
										},
										A2(
											$elm$json$Json$Decode$field,
											'serverInfoLabelMaybe',
											$elm$json$Json$Decode$oneOf(
												_List_fromArray(
													[
														$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
														A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
													]))));
								},
								A2($elm$json$Json$Decode$field, 'themeString', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'tonkeanBaseUrl', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'versionedAssetsUrl', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'windowSize',
			A2(
				$elm$json$Json$Decode$andThen,
				function (width) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (height) {
							return $elm$json$Json$Decode$succeed(
								{aR: height, a8: width});
						},
						A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
				},
				A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int)))))(0)}});}(this));